import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ComponentFactoryResolver, ViewContainerRef, Renderer2, NgZone, Pipe, Input, Inject, NgModule, ErrorHandler, TemplateRef } from '@angular/core';
import * as xml2js from 'xml2js';
import { tap, shareReplay, of, switchMap, interval, Observable, forkJoin, Subject, mergeWith, concatMap, mergeAll, takeUntil, fromEvent, from, merge, timer, animationFrames, ReplaySubject, BehaviorSubject, throwError, defer, auditTime, filter, startWith, AsyncSubject } from 'rxjs';
import { repeat, delay, take, tap as tap$1, map, catchError, finalize, switchMap as switchMap$1, last, concatMap as concatMap$1, retryWhen, mergeMap, debounceTime } from 'rxjs/operators';
import Hls from 'hls.js';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i12 from '@egjs/ngx-flicking';
import { FlickingError, NgxFlickingModule } from '@egjs/ngx-flicking';
import * as i2$1 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import * as i4 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i6 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i7 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i3 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import * as i1 from 'angularx-qrcode';
import { QRCodeModule } from 'angularx-qrcode';
import { use, init } from 'echarts/core';
import { LineChart, BarChart, PieChart, ScatterChart, GaugeChart, RadarChart, FunnelChart, TreemapChart, SunburstChart, HeatmapChart, CandlestickChart, BoxplotChart, ParallelChart, SankeyChart, PictorialBarChart, GraphChart, EffectScatterChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent, RadarComponent, PolarComponent, VisualMapComponent, ParallelComponent, DataZoomComponent, TimelineComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import * as i11 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i1$4 from '@angular/material/icon';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import * as i1$1 from '@angular/router';
import { NavigationStart, Router } from '@angular/router';
import { transition, style, animate, trigger } from '@angular/animations';
import * as mobile from 'is-mobile';
import * as i1$2 from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i1$3 from '@angular/material/dialog';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as i9 from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import * as i10 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i4$1 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as websocket from 'websocket';
import * as i6$1 from '@angular/material/form-field';
import * as i7$1 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as i1$5 from '@angular/forms';
import { Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i10$1 from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
import * as i11$1 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i7$2 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import html2canvas from 'html2canvas';
import * as uuid from 'uuid';
let SignageLibsService = /*#__PURE__*/(() => {
  class SignageLibsService {
    constructor() {}
    static ɵfac = function SignageLibsService_Factory(t) {
      return new (t || SignageLibsService)();
    };
    static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: SignageLibsService,
      factory: SignageLibsService.ɵfac,
      providedIn: 'root'
    });
  }
  return SignageLibsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SignageLibsComponent = /*#__PURE__*/(() => {
  class SignageLibsComponent {
    constructor() {}
    ngOnInit() {}
    static ɵfac = function SignageLibsComponent_Factory(t) {
      return new (t || SignageLibsComponent)();
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SignageLibsComponent,
      selectors: [["lib-SignageLibs"]],
      decls: 0,
      vars: 0,
      template: function SignageLibsComponent_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return SignageLibsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ScheduleEvents {
  playerService;
  scheduleId;
  eventName;
  schedule;
  buffer = [];
  today;
  curPoint;
  nextPoint;
  channels;
  curPriority; // 0-once 1-yearly 2-monthly 3-weekly 4-daily
  fireItem;
  utcOffset;
  initialized = false;
  sHour = 60 * 60;
  sDAY = 24 * 60 * 60;
  constructor(playerService, scheduleId) {
    this.playerService = playerService;
    this.scheduleId = scheduleId;
    //
    const now = new Date();
    this.utcOffset = now.getTimezoneOffset() * 60;
    const time = now.getTime() / 1000 - this.utcOffset;
    this.today = Math.floor(time / this.sDAY);
    this.today--;
  }
  load() {
    return this.playerService.caching.getRecord("schedules", this.scheduleId).pipe(tap(res => {
      this.schedule = res.schedules;
      this.eventName = "event_schedule_" + this.scheduleId;
    }), shareReplay(1));
  }
  play() {
    return of("schedule").pipe(switchMap(r => this.playNext()), repeat()).pipe(shareReplay(1));
  }
  removeItem(channel, item) {
    for (let i = 0; i < channel.length; i++) {
      if (channel[i] === item) {
        channel.splice(i, 1);
        break;
      }
    }
  }
  playNext() {
    this.curPoint = this.nextPoint;
    if (this.curPoint != null) {
      let channel = this.channels[this.curPoint.item.priority];
      if (this.curPoint.state == 1) {
        channel.push(this.curPoint.item);
        if (this.curPoint.item.priority <= this.curPriority) {
          this.curPriority = this.curPoint.item.priority;
        }
      } else {
        //state==0
        this.removeItem(channel, this.curPoint.item);
        channel = null;
        while (this.curPriority < 5) {
          channel = this.channels[this.curPriority];
          if (channel.length > 0) {
            break;
          }
          this.curPriority++;
        }
      }
    }
    let t1 = new Date().getTime() / 1000 - this.utcOffset;
    let t2;
    if (this.buffer.length == 0) {
      this.today++;
      t2 = this.today * this.sDAY;
      this.buildBuffer();
    } else {
      this.nextPoint = this.buffer.shift();
      t2 = this.nextPoint.time;
    }
    const duration = t2 - t1;
    if (this.initialized == false && duration >= 0) {
      this.initialized = true;
    }
    if (this.initialized) {
      const channel = this.channels[this.curPriority];
      if (channel.length > 0) {
        const item = channel[channel.length - 1];
        if (this.fireItem != item) {
          this.fireItem = item;
          //Log.d(this, LogTag.SCHEDULE, 'Schedule: ' + new Date().toLocaleTimeString() +  ' event=' + this.fireItem.event_value);
          let param = "";
          try {
            param = JSON.parse(this.fireItem.event_value);
          } catch (e) {
            param = this.fireItem.event_value;
          }
          this.playerService.eventParams.dispatch(this.eventName, param, false);
        }
      } else {
        this.playerService.eventParams.dispatch(this.eventName, {}, false);
      }
    }
    let timeout = Math.max(1, duration * 1000);
    //??? timeout = 5000; // TEST ???
    return of("next").pipe(delay(timeout));
  }
  buildBuffer() {
    const date = new Date((this.today * this.sDAY + this.utcOffset) * 1000);
    const tm = date.getTime();
    const h = date.getHours();
    const day = Math.pow(2, date.getDay());
    const mt = date.getMonth();
    this.buffer = [];
    this.schedule.forEach(item => {
      const t1 = new Date(item.start_date).getTime() / 1000 - this.utcOffset;
      const d1 = Math.floor(t1 / this.sDAY);
      const matchStartDate = this.today >= d1;
      const t2 = new Date(item.end_date).getTime() / 1000 - this.utcOffset;
      const d2 = Math.floor(t2 / this.sDAY);
      const matchEndDate = item.repeat_forever || this.today <= d2;
      let exist = false;
      item.priority = item.repeat_type;
      switch (item.repeat_type) {
        case 0:
          // once
          exist = this.today == d1;
          break;
        case 1:
          {
            // yearly
            const dt = date.getDate();
            exist = matchStartDate && matchEndDate && item.yearly_offset == mt && item.monthly_offset == dt;
            break;
          }
        case 2:
          {
            // monthly
            const mt1 = date.getMonth();
            if (item.monthly_offset == 28) {
              // end of month
              const tomorrow = new Date(date.getTime() + this.sDAY * 1000);
              const mt2 = tomorrow.getMonth();
              exist = matchStartDate && matchEndDate && mt1 != mt2;
            } else {
              //1-27
              const dt = date.getDate();
              exist = matchStartDate && matchEndDate && item.monthly_offset == dt;
            }
            break;
          }
        case 3:
          // weekly
          exist = matchStartDate && matchEndDate && (day & item.weekly_days) != 0;
          break;
        case 4:
          // hourly
          exist = matchStartDate && matchEndDate;
          break;
        case 5:
          // daily
          exist = matchStartDate && matchEndDate;
          break;
      }
      if (exist) {
        if (item.repeat_type == 4) {
          // hourly
          for (let h = 0; h < 24; h++) {
            const point1 = {};
            point1.time = this.today * this.sDAY + h * this.sHour + +item.hourly_offset;
            point1.state = 1;
            point1.item = item;
            this.buffer.push(point1);
            const point2 = {};
            point2.time = point1.time + +item.duration;
            point2.state = 0;
            point2.item = item;
            this.buffer.push(point2);
          }
        } else {
          const point1 = {};
          point1.time = this.today * this.sDAY + +item.time;
          point1.state = 1;
          point1.item = item;
          this.buffer.push(point1);
          const point2 = {};
          point2.time = point1.time + +item.duration;
          point2.state = 0;
          point2.item = item;
          this.buffer.push(point2);
        }
      }
    });
    this.buffer.sort((a, b) => {
      // if points has the same time then pick the point with state==1 as the next one.
      return a.time - a.state - (b.time - b.state);
    });
    this.curPoint = null;
    this.nextPoint = null;
    this.channels = [[], [], [], [], [], []];
    this.curPriority = 5;
    this.fireItem = null;
  }
  destroy() {}
}
class ColorUtils {
  static format(value) {
    let color = value.toString(16);
    const count = 6 - color.length;
    for (let i = 0; i < count; i++) {
      color = '0' + color;
    }
    return color;
  }
}
var LogPriority = /*#__PURE__*/function (LogPriority) {
  LogPriority[LogPriority["ERROR"] = 0] = "ERROR";
  LogPriority[LogPriority["WARNING"] = 1] = "WARNING";
  LogPriority[LogPriority["INFO"] = 2] = "INFO";
  LogPriority[LogPriority["DEBUG"] = 3] = "DEBUG";
  return LogPriority;
}(LogPriority || {});
var LogTag = /*#__PURE__*/function (LogTag) {
  LogTag["GLOBAL_ERROR"] = "global_error";
  LogTag["INIT"] = "init";
  LogTag["DISPOSE"] = "dispose";
  LogTag["SERVICE_WORKER"] = "service_worker";
  LogTag["WEBSOCKET"] = "websocket";
  LogTag["TRANSITION"] = "transition";
  LogTag["PLAYER_SERVICE"] = "player_service";
  LogTag["PLAYER"] = "player";
  LogTag["SIGNAGE_PLAYER"] = "signage_player";
  LogTag["REGISTRATION"] = "registration";
  LogTag["CACHE"] = "cache";
  LogTag["TASKBAR"] = "taskbar";
  LogTag["SCENE_UPDATE"] = "scene_update";
  LogTag["PIXI"] = "pixi";
  LogTag["PROGRESS"] = "progress";
  LogTag["MAIN"] = "main";
  LogTag["CHROME_EXTENSION"] = "chrome_extension";
  LogTag["SCHEDULE"] = "schedule";
  return LogTag;
}(LogTag || {});
let Log = /*#__PURE__*/(() => {
  class Log {
    static playerService;
    static devMode = false;
    static config;
    static init(playerService) {
      Log.playerService = playerService;
      if (localStorage["logConfig"] != null) {
        Log.config = JSON.parse(localStorage["logConfig"]);
        if (Array.isArray(Log.config.tags) == false) {
          Log.updateConfig(false, 0, []);
        }
      } else {
        Log.updateConfig(false, 0, []);
      }
    }
    static updateConfig(enabled, priority, tags) {
      Log.config = {
        enabled: enabled,
        priority: priority,
        tags: tags
      };
      if (Array.isArray(Log.config.tags) == false) {
        Log.config.tags = [];
      }
      localStorage["logConfig"] = JSON.stringify(Log.config);
    }
    static getSceneId(sender) {
      if (sender?.parentPlayer?.playerObject?.$?.id) {
        return "sceneId=" + sender.parentPlayer.playerObject.$.id + " ";
      }
      return "";
    }
    static getLogInfo(className, fncName, fncArgs) {
      let args = "";
      try {
        args = JSON.stringify(fncArgs);
      } catch (e) {}
      return {
        className: className,
        fncName: fncName,
        fncArgs: args
      };
    }
    static format(sender, tag, msg) {
      return tag + " " + sender?.className + "." + sender?.fncName + sender?.fncArgs + " " + msg;
    }
    static e(sender, tag, msg) {
      const message = this.getSceneId(sender) + ": " + msg;
      console.error(Log.format(sender, tag, msg));
      if (Log.playerService != null && Log.config.enabled && Log.config.priority >= LogPriority.ERROR) {
        Log.playerService.log(LogPriority.ERROR, sender, tag, message);
      }
    }
    static w(sender, tag, msg) {
      const message = this.getSceneId(sender) + ": " + msg;
      console.warn(Log.format(sender, tag, msg));
      if (Log.playerService != null && Log.config.enabled && Log.config.priority >= LogPriority.WARNING) {
        Log.playerService.log(LogPriority.WARNING, sender, tag, message);
      }
    }
    static i(sender, tag, msg) {
      const message = this.getSceneId(sender) + ": " + msg;
      console.log(Log.format(sender, tag, msg));
      if (Log.playerService != null && Log.config.enabled && Log.config.priority >= LogPriority.INFO) {
        Log.playerService.log(LogPriority.INFO, sender, tag, message);
      }
    }
    static d(sender, tag, msg) {
      const message = this.getSceneId(sender) + " " + msg;
      let containTag = false;
      for (let i = 0; i < Log.config.tags.length; i++) {
        if (Log.config.tags[i] == tag) {
          containTag = true;
          break;
        }
      }
      //if (tag==LogTag.PLAYER) {
      // console.log(Log.format(sender, tag, msg));
      //}
      containTag = true; // debug ????
      if (containTag) {
        if (Log.playerService != null && Log.config.enabled && Log.config.priority >= LogPriority.DEBUG) {
          console.log(Log.format(sender, tag, msg));
          Log.playerService.log(LogPriority.DEBUG, sender, tag, message);
        }
      }
    }
    static debug() {
      /*
      if (Log.playerService!=null && Log.playerService.runInStudio()==false) {
      debugger;
      }
        */
    }
  }
  return Log;
})();
class MsgElm {
  component;
  divMsg;
  pixiMsg;
  pixiMsg1;
  pixiMsg2;
  msg1;
  msg2;
  constructor(component) {
    this.component = component;
  }
  setText(title, description, actualWidth, actualHeight) {
    if (this.component != null) {
      if (this.divMsg == null) {
        this.divMsg = document.createElement("DIV");
        this.divMsg.style.width = '100%';
        this.divMsg.style.height = '100%';
        this.divMsg.style.position = 'absolute';
        this.divMsg.style.top = '0px';
        this.divMsg.style.left = '0px';
        this.divMsg.style.margin = "0px 0px 0px 0px";
        this.divMsg.style.background = 'white';
        //this.divMsg.style.zIndex = '999';
        this.component.nativeElement.appendChild(this.divMsg);
        this.msg1 = document.createElement("H1");
        this.msg1.style.fontSize = '16px';
        this.msg1.style.fontWeight = 'bold';
        this.msg1.style.width = '100%';
        this.msg1.style.color = 'black';
        this.msg1.style.textAlign = 'center';
        this.divMsg.appendChild(this.msg1);
        this.msg2 = document.createElement("P");
        this.msg2.style.fontSize = '10px';
        this.msg2.style.width = '100%';
        this.msg2.style.color = 'black';
        this.msg2.style.textAlign = 'center';
        this.divMsg.appendChild(this.msg2);
      }
      this.msg1.innerHTML = title;
      this.msg2.innerHTML = description;
    }
  }
  destroy() {
    if (this.component != null && this.component.nativeElement && this.divMsg != null) {
      try {
        this.component.nativeElement.removeChild(this.divMsg);
      } catch (e) {}
      this.divMsg = null;
    }
  }
}
class StatusElm {
  component;
  divStatus;
  iconDiv;
  textDiv;
  spinnerDiv;
  constructor(component) {
    this.component = component;
  }
  setStatus(status, message = '') {
    if (this.component != null) {
      if (this.divStatus == null) {
        this.divStatus = document.createElement("DIV");
        this.divStatus.style.width = '100%';
        this.divStatus.style.height = '100%';
        this.divStatus.style.position = 'absolute';
        this.divStatus.style.top = '0px';
        this.divStatus.style.left = '0px';
        this.divStatus.style.display = 'flex';
        this.divStatus.style.flexDirection = 'column';
        this.divStatus.style.alignItems = 'center';
        this.divStatus.style.justifyContent = 'center';
        this.divStatus.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        this.divStatus.style.zIndex = '1000';
        this.component.nativeElement.appendChild(this.divStatus);
        this.iconDiv = document.createElement("DIV");
        this.divStatus.appendChild(this.iconDiv);
        this.textDiv = document.createElement("DIV");
        this.textDiv.style.marginTop = '16px';
        this.textDiv.style.color = '#ffffff';
        this.textDiv.style.fontSize = '16px';
        this.textDiv.style.fontFamily = 'Arial, sans-serif';
        this.textDiv.style.textAlign = 'center';
        this.textDiv.style.padding = '0 20px';
        this.textDiv.style.maxWidth = '80%';
        this.textDiv.style.opacity = '0.9';
        this.divStatus.appendChild(this.textDiv);
      }
      if (status === 'loading') {
        // Create spinner
        if (this.spinnerDiv == null) {
          this.spinnerDiv = document.createElement("DIV");
          this.spinnerDiv.style.width = '50px';
          this.spinnerDiv.style.height = '50px';
          this.spinnerDiv.style.border = '4px solid rgba(255, 255, 255, 0.3)';
          this.spinnerDiv.style.borderTopColor = '#ffffff';
          this.spinnerDiv.style.borderRadius = '50%';
          this.spinnerDiv.style.animation = 'spin 1s linear infinite';
        }
        this.iconDiv.innerHTML = '';
        this.iconDiv.appendChild(this.spinnerDiv);
        this.textDiv.innerHTML = message || 'Loading';
        // Add keyframes animation if not already added
        if (!document.getElementById('status-spin-keyframes')) {
          const style = document.createElement('style');
          style.id = 'status-spin-keyframes';
          style.textContent = `
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `;
          document.head.appendChild(style);
        }
      } else if (status === 'error') {
        // Show error icon
        this.iconDiv.innerHTML = '⚠';
        this.iconDiv.style.fontSize = '48px';
        this.iconDiv.style.color = '#ffffff';
        this.iconDiv.style.opacity = '0.8';
        this.textDiv.innerHTML = message || 'Fail loading';
      }
    }
  }
  destroy() {
    if (this.component != null && this.component.nativeElement && this.divStatus != null) {
      try {
        this.component.nativeElement.removeChild(this.divStatus);
      } catch (e) {
        // Ignore error if element already removed
      }
      this.divStatus = null;
      this.iconDiv = null;
      this.textDiv = null;
      this.spinnerDiv = null;
    }
  }
}
class PlayerAnim {
  player;
  scaleX = 1;
  scaleY = 1;
  anim;
  animIn;
  animOut;
  animPlay;
  animTouch;
  mousedown;
  mouseup;
  mouseleave;
  mouseenter;
  mouseleaveHover;
  constructor(player, animInfo) {
    this.player = player;
    let parentLayout;
    if (this.player.parentPlayer != null && this.player.parentPlayer instanceof PlayerBase && this.player.playerObject.$.autoScaling == "1") {
      parentLayout = this.player.parentPlayer.playerObject.Data[0].Layout[0].$;
    }
    if (parentLayout != null) {
      this.scaleX = this.player.parentPlayer.scaleX;
      this.scaleY = this.player.parentPlayer.scaleY;
    }
    const infoIn = animInfo?.In != null ? animInfo.In[0].$ : {};
    const infoOut = animInfo?.Out != null ? animInfo.Out[0].$ : {};
    const infoPlay = animInfo?.Play != null ? animInfo.Play[0].$ : {};
    const infoTouch = animInfo?.Touch != null ? animInfo?.Touch[0].$ : {};
    // In
    if (infoIn.enabled == '1') {
      this.animIn = {};
      //delay
      this.animIn.delay = Number(infoIn.delay);
      // duration
      this.animIn.duration = Number(infoIn.duration);
      // fade
      if (this.player.component != null) {
        const opacity = this.player.component.nativeElement.style.opacity;
        if (opacity == '' || opacity == '1') {
          this.animIn.fade = this.getBool(infoIn.fadeFrq);
        }
      }
      // move
      this.animIn.move = this.getBool(infoIn.moveFrq);
      if (this.animIn.move) {
        const a = infoIn.moveDir == 'fixed' ? Number(infoIn.moveAngle) * 0.01745329252 : Math.random() * Math.PI * 2;
        const w = (this.player.parentPlayer != null ? this.player.parentPlayer.actualWidth : this.player.actualWidth) * Number(infoIn.moveIntense);
        const h = (this.player.parentPlayer != null ? this.player.parentPlayer.actualHeight : this.player.actualHeight) * Number(infoIn.moveIntense);
        this.animIn.hoz = w * Math.cos(a);
        this.animIn.ver = h * Math.sin(a);
      }
      // scale
      this.animIn.scale = this.getBool(infoIn.scaleFrq);
      // rotate
      this.animIn.rotate = this.getBool(infoIn.rotateFrq);
      if (this.animIn.rotate) {
        if (infoIn.rotateType == 'fixed') {
          this.animIn.rotateAngle = Number(infoIn.rotations) * 360;
        } else {
          this.animIn.rotateAngle = (Math.random() * 20 - 10) * 360;
        }
      }
      // blur
      if (this.player.component != null) {
        if (this.player.component.nativeElement.style.filter == '') {
          if (this.getBool(infoIn.blurFrq)) {
            this.animIn.blurValue = Number(infoIn.blurValue);
          }
        }
      }
      // textTyping
      this.animIn.textTyping = this.getBool(infoIn.textTypingFrq);
    }
    // Out
    if (infoOut.enabled == '1') {
      this.animOut = {};
      // delay
      this.animOut.delay = Number(infoOut.delay);
      // duration
      this.animOut.duration = Number(infoOut.duration);
      // fade
      if (this.player.component != null) {
        const opacity = this.player.component.nativeElement.style.opacity;
        if (opacity == '' || opacity == '1') {
          this.animOut.fade = this.getBool(infoOut.fadeFrq);
        }
      }
      // move
      this.animOut.move = this.getBool(infoOut.moveFrq);
      if (this.animOut.move) {
        let a;
        if (infoOut.moveDir == 'revert') {
          if (this.animOut.hoz != null) {
            this.animOut.hoz = -this.animIn.hoz;
            this.animOut.ver = -this.animIn.ver;
          }
        } else {
          if (infoOut.moveDir == 'fixed') {
            a = Number(infoOut.moveAngle) * 0.01745329252;
          } else if (infoOut.moveDir == 'random') {
            a = Math.random() * Math.PI * 2;
          }
          const w = (this.player.parentPlayer != null ? this.player.parentPlayer.actualWidth : this.player.actualWidth) * Number(infoOut.moveIntense);
          const h = (this.player.parentPlayer != null ? this.player.parentPlayer.actualHeight : this.player.actualHeight) * Number(infoOut.moveIntense);
          this.animOut.hoz = w * Math.cos(a);
          this.animOut.ver = h * Math.sin(a);
        }
      }
      // scale
      this.animOut.scale = this.getBool(infoOut.scaleFrq);
      // rotate
      this.animOut.rotate = this.getBool(infoOut.rotateFrq);
      if (this.animOut.rotate) {
        if (infoOut.rotateType == 'fixed') {
          this.animOut.rotateAngle = Number(infoOut.rotations) * 360;
        } else if (infoOut.rotateType == 'rand') {
          this.animOut.rotateAngle = (Math.random() * 20 - 10) * 360;
        } else if (infoOut.rotateType == 'revert') {
          if (this.animIn.rotateAngle != null) {
            this.animOut.rotateAngle = -this.animIn.rotateAngle;
          }
        }
      }
      // blur
      if (this.player.component != null) {
        if (this.player.component.nativeElement.style.filter == '') {
          if (this.getBool(infoOut.blurFrq)) {
            this.animOut.blurValue = Number(infoOut.blurValue);
          }
        }
      }
      // textTyping
      this.animOut.textTyping = this.getBool(infoOut.textTypingFrq);
    }
    // Play
    if (infoPlay?.enabled == '1') {
      this.animPlay = {};
      // duration
      const duration = Number(infoPlay.duration);
      // frequency
      const frequency = Number(infoPlay.frequency);
      this.animPlay.duration = 1000 / frequency;
      this.animPlay.iterations = duration * frequency / 1000;
      // rotate
      if (this.getBool(infoPlay.rotateFrq)) {
        this.animPlay.rotate = Number(infoPlay.rotateValue);
      }
      //scale
      if (this.getBool(infoPlay.scaleFrq)) {
        this.animPlay.scale = Number(infoPlay.scaleValue);
      }
      // fade
      if (this.player.component != null) {
        const opacity = this.player.component.nativeElement.style.opacity;
        if (opacity == '' || opacity == '1') {
          this.animPlay.fade = this.getBool(infoPlay.fadeFrq);
        }
      }
    }
    // Touch
    if (infoTouch.enabled == '1') {
      this.animTouch = {};
      // duration
      this.animTouch.duration = Number(infoTouch.duration);
      if (this.animTouch.duration > 1000) {
        this.animTouch.duration /= 1000; // fix bug in studio save
      }
      // scale
      this.animTouch.scale = Number(infoTouch.scaleValue);
      // outAlpha
      if (infoTouch.outAlpha != null) {
        this.animTouch.outAlpha = Number(infoTouch.outAlpha);
      }
    }
  }
  getBool(str) {
    return Math.random() < Number(str);
  }
  in() {
    this.cancelAnim();
    if (this.animIn == null) {
      this.player.display(true);
      return of(null);
    }
    const list = [];
    if (this.player.component == null) {
      const speed = this.animIn.duration / 10;
      if (this.player.filter != null) {
        this.player.filter.alpha = 0;
      }
      list.push(interval(speed).pipe(take(10), tap$1(i => {
        this.player.filter.alpha = i / 10;
      })));
    } else {
      if (this.player.genericElm?.label != null && this.animIn.textTyping) {
        const str = this.player.genericElm.label;
        if (str.length > 0) {
          let i = 0;
          const speed = this.animIn.duration / str.length;
          list.push(interval(speed).pipe(take(str.length), tap$1(() => {
            i++;
            this.player.genericElm.labelAnchor.innerText = str.substring(0, i);
          })));
        }
      }
      list.push(new Observable(sub => {
        const frame1 = {};
        const frame2 = {};
        frame1.transform = '';
        frame2.transform = '';
        if (this.animIn.hoz != null) {
          frame1.transform += ' translateX(' + -this.animIn.hoz * this.scaleX + 'px)';
          frame2.transform += ' translateX(0px)';
        }
        if (this.animIn.ver != null) {
          frame1.transform += ' translateY(' + -this.animIn.ver * this.scaleY + 'px)';
          frame2.transform += ' translateY(0px)';
        }
        if (this.animIn.rotateAngle != null) {
          frame1.transform += ' rotate(' + this.animIn.rotateAngle + 'deg)';
          frame2.transform += ' rotate(0)';
        }
        if (this.animIn.fade) {
          frame1.opacity = 0;
          frame2.opacity = 1;
        }
        if (this.animIn.scale) {
          frame1.scale = 0;
          frame2.scale = 1;
        }
        if (this.animIn.blurValue != null) {
          frame1.filter = ' blur(' + this.animIn.blurValue + 'px)';
          frame2.filter = ' blur(0px)';
        }
        const options = {
          iterations: 1,
          duration: this.animIn.duration,
          easing: "ease-in-out"
        };
        this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
        this.anim.onfinish = event => {
          this.anim = null;
          sub.next("completed");
          sub.complete();
        };
      }));
    }
    return of('anim').pipe(delay(this.animIn.delay), switchMap(a => {
      this.player.display(true);
      return forkJoin(list);
    }));
  }
  out() {
    this.cancelAnim();
    if (this.animOut == null) {
      return of(null);
    }
    const list = [];
    if (this.player.component == null) {
      const speed = this.animOut.duration / 10;
      list.push(interval(speed).pipe(take(10), tap$1(i => {
        if (this.player.filter != null) {
          this.player.filter.alpha = (9 - i) / 10;
        }
      })));
    } else {
      if (this.player.genericElm?.label != null && this.animOut.textTyping) {
        const str = this.player.genericElm.label;
        if (str.length == 0) {
          return of('label');
        }
        let i = str.length - 1;
        const speed = this.animOut.duration / str.length;
        list.push(interval(speed).pipe(take(str.length), tap$1(() => {
          this.player.genericElm.labelAnchor.innerText = str.substring(0, i);
          i--;
        })));
      }
      list.push(new Observable(sub => {
        const frame1 = {};
        const frame2 = {};
        frame1.transform = '';
        frame2.transform = '';
        if (this.animOut.hoz != null) {
          frame1.transform += ' translateX(0px)';
          frame2.transform += ' translateX(' + this.animOut.hoz * this.scaleY + 'px)';
        }
        if (this.animOut.ver != null) {
          frame1.transform += ' translateY(0px)';
          frame2.transform += ' translateY(' + this.animOut.ver * this.scaleY + 'px)';
        }
        if (this.animOut.rotateAngle != null) {
          frame1.transform += ' rotate(0)';
          frame2.transform += ' rotate(' + -this.animOut.rotateAngle + 'deg)';
        }
        if (this.animOut.fade) {
          frame1.opacity = 1;
          frame2.opacity = 0;
        }
        if (this.animOut.scale) {
          frame1.scale = 1;
          frame2.scale = 0;
        }
        if (this.animOut.blurValue != null) {
          frame1.filter = ' blur(0px)';
          frame2.filter = ' blur(' + this.animOut.blurValue + 'px)';
        }
        const options = {
          iterations: 1,
          duration: this.animOut.duration,
          easing: "ease-in-out"
        };
        this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
        this.anim.onfinish = event => {
          this.anim = null;
          this.player.component.nativeElement.style.left = "8192px";
          sub.next("completed");
          sub.complete();
        };
      }));
    }
    return of('anim').pipe(delay(this.animOut.delay), switchMap(a => {
      //??? this.player.display(true);
      return forkJoin(list);
    }));
  }
  play() {
    this.cancelAnim();
    if (this.animPlay != null && this.player.component != null) {
      const frame1 = {};
      const frame2 = {};
      const frame3 = {};
      const frame4 = {};
      const frame5 = {};
      if (this.animPlay.rotate) {
        frame1.transform = 'rotate(0deg)';
        frame2.transform = 'rotate(' + this.animPlay.rotate + 'deg)';
        frame3.transform = 'rotate(0deg)';
        frame4.transform = 'rotate(-' + this.animPlay.rotate + 'deg)';
        frame5.transform = 'rotate(0deg)';
      }
      if (this.animPlay.fade) {
        frame1.opacity = 1;
        frame2.opacity = 0;
        frame3.opacity = 1;
        frame4.opacity = 0;
        frame5.opacity = 1;
      }
      if (this.animPlay.scale) {
        frame1.scale = 1;
        frame2.scale = this.animPlay.scale;
        frame3.scale = 1;
        frame4.scale = this.animPlay.scale;
        frame5.scale = 1;
      }
      const options = {
        duration: this.animPlay.duration,
        iterations: this.animPlay.iterations
      };
      this.anim = this.player.component.nativeElement.animate([frame1, frame2, frame3, frame4, frame5], options);
    }
    return of('anim');
  }
  touchIn() {
    this.cancelAnim();
    if (this.animTouch != null) {
      const currentScale = this.player.component.nativeElement.style.scale || '1';
      const frame1 = {};
      const frame2 = {};
      frame1.scale = currentScale;
      frame2.scale = this.animTouch.scale;
      const options = {
        iterations: 1,
        duration: this.animTouch.duration,
        easing: "ease-in-out"
      };
      this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
      this.anim.onfinish = () => {
        this.player.component.nativeElement.style.scale = this.animTouch.scale;
        this.anim = null;
      };
    }
  }
  touchOut() {
    this.cancelAnim();
    if (this.animTouch != null) {
      const currentScale = this.player.component.nativeElement.style.scale || this.animTouch.scale;
      const frame1 = {};
      const frame2 = {};
      frame1.scale = currentScale;
      frame2.scale = 1;
      const options = {
        iterations: 1,
        duration: this.animTouch.duration,
        easing: "ease-in-out"
      };
      this.anim = this.player.component.nativeElement.animate([frame1, frame2], options);
      this.anim.onfinish = () => {
        this.player.component.nativeElement.style.scale = 1;
        this.anim = null;
      };
    }
  }
  touchCancel() {
    this.cancelAnim();
    this.player.component.nativeElement.style.scale = 1;
  }
  cancelAnim() {
    if (this.anim != null) {
      this.anim.cancel();
      this.anim = null;
    }
  }
  hoverIn() {
    if (this.animTouch != null && this.animTouch.outAlpha != null) {
      this.player.component.nativeElement.style.opacity = 1.0;
    }
  }
  hoverOut() {
    if (this.animTouch != null && this.animTouch.outAlpha != null) {
      this.player.component.nativeElement.style.opacity = this.animTouch.outAlpha;
    }
  }
  addTouchListeners() {
    /*
      //  this line cause memory leak !!!!
      this.component.nativeElement.ondragstart = () => {
        return false;
      };
    */
    this.mousedown = () => {
      this.touchBegin();
    };
    this.player.component.nativeElement.addEventListener('mousedown', this.mousedown);
    // Add hover listeners for outAlpha
    if (this.animTouch != null && this.animTouch.outAlpha != null) {
      // Set initial opacity to outAlpha
      this.player.component.nativeElement.style.opacity = this.animTouch.outAlpha;
      this.mouseenter = () => {
        this.hoverIn();
      };
      this.player.component.nativeElement.addEventListener('mouseenter', this.mouseenter);
      this.mouseleaveHover = () => {
        this.hoverOut();
      };
      this.player.component.nativeElement.addEventListener('mouseleave', this.mouseleaveHover);
    }
  }
  touchBegin() {
    this.touchIn();
    this.mouseup = () => {
      this.touchOut();
      this.touchEnd();
    };
    this.player.component.nativeElement.addEventListener('mouseup', this.mouseup);
    this.mouseleave = () => {
      this.touchCancel();
      this.touchEnd();
    };
    this.player.component.nativeElement.addEventListener('mouseleave', this.mouseleave);
  }
  touchEnd() {
    if (this.mouseup != null) {
      this.player.component.nativeElement.removeEventListener('mouseup', this.mouseup);
      this.mouseup = null;
    }
    if (this.mouseleave != null) {
      this.player.component.nativeElement.removeEventListener('mouseleave', this.mouseleave);
      this.mouseleave = null;
    }
  }
  removeTouchListeners() {
    this.cancelAnim();
    if (this.mousedown != null) {
      this.player.component.nativeElement.removeEventListener('mousedown', this.mousedown);
      this.mousedown = null;
    }
    if (this.mouseup != null) {
      this.player.component.nativeElement.removeEventListener('mouseup', this.mouseup);
      this.mouseup = null;
    }
    if (this.mouseleave != null) {
      this.player.component.nativeElement.removeEventListener('mouseleave', this.mouseleave);
      this.mouseleave = null;
    }
  }
}
const _c0$p = ["component"];
let PlayerBase = /*#__PURE__*/(() => {
  class PlayerBase {
    injector;
    static defaultGpu = false;
    editMode = false;
    playerService;
    changeDetectorRef;
    hostView; // use to remove from parent
    component;
    angle = 0.0;
    parentPlayer;
    providerData;
    fieldName;
    usePlayerLayoutX = true;
    usePlayerLayoutY = true;
    playing = false;
    playerObject;
    //data: IPlayerData;
    posX = 0;
    posY = 0;
    actualWidth;
    actualHeight;
    scaleX = 1.0;
    scaleY = 1.0;
    originalSize;
    playValue = 5000;
    msgElm;
    statusElm;
    NO_PREVIEW = 'will display in deployed SignagePlayer<br>(preview coming soon)';
    PREVIEW = 'preview to play content';
    DEPLOYMENT = 'Content can be shown only in the Deployed SignPlayer';
    loadError = false;
    finish$;
    animation;
    statEnabled = false;
    statTag;
    statFiled;
    minThreshold;
    maxThreshold;
    statStart;
    constructor(injector) {
      this.injector = injector;
      this.playerService = injector.get('playerService');
      this.changeDetectorRef = injector.get(ChangeDetectorRef);
      this.changeDetectorRef.detach();
      this.finish$ = new Subject();
    }
    ngOnInit() {}
    init(parentPlayer, editMode, blockingTime) {
      this.parentPlayer = parentPlayer;
      this.editMode = editMode;
      if (this.editMode == false && blockingTime != -1) {
        setTimeout(() => {
          if (this.playerService.resellerId == 1) {
            this.showMsg("Enterprise Component", "Requires subscription");
          } else {
            this.showMsg("Service Interruption", "Contact admin");
          }
        }, blockingTime);
      }
    }
    load(playerObject) {
      const logInfo = Log.getLogInfo("PlayerBase", "load", []);
      // update from studio:
      if (this.playerObject != null) {
        this.clearEffects();
      }
      if (this.editMode) {
        this.playerObject = JSON.parse(JSON.stringify(playerObject));
      } else {
        this.playerObject = playerObject;
      }
      const data = this.playerObject.Data[0];
      Log.d(logInfo, LogTag.PLAYER, this.constructor.name);
      this.loadPosAndSize();
      this.loadEffects();
      this.loadAnimation();
      if (this.component != null && data.Layout != null) {
        if (data.Layout[0].$.locked == "true") {
          this.component.nativeElement.classList.add("locked");
        } else {
          this.component.nativeElement.classList.remove("locked");
        }
        //this.component.nativeElement.style.visibility = (this.data.Layout[0].$.invisible == "true") ? "hidden" : "visible";
      }
      if (this.component != null) {
        this.component.nativeElement.style.overflow = "hidden";
        if (this.playerObject.$.clickEventName != null && this.playerObject.$.clickEventName != "") {
          this.component.nativeElement.style.cursor = "pointer";
        }
      }
      return of(this);
    }
    registerCommands() {
      if (this.editMode) {
        return of('commands');
      }
      const data = this.playerObject.Data[0];
      const obsList = [];
      if (data.EventCommands != null && data.EventCommands[0] != null && data.EventCommands[0].EventCommand != null) {
        data.EventCommands[0].EventCommand.forEach(command => {
          const from = command.$.from;
          const obs2$ = of('cmd').pipe(switchMap(a => this.playerService.eventParams.getEventParam(from)), switchMap(param => this.onCommand(command, param)));
          obsList.push(obs2$);
        });
      }
      if (obsList.length == 0) {
        return of('commands');
      }
      return forkJoin(obsList);
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      const obsList = [];
      if (this.animation != null) {
        if (this.playerObject.$.clickEventName != null && this.playerObject.$.clickEventName != "") {
          this.animation.addTouchListeners();
        }
        obsList.push(this.animation.play());
      }
      if (this.animation != null) {
        const anim$ = this.animation.in();
        obsList.push(anim$);
      } else {
        this.display(true);
      }
      if (obsList.length == 0) {
        return of('play');
      }
      return forkJoin(obsList);
    }
    display(show) {
      if (this.editMode) {
        return;
      }
      this.component.nativeElement.style.display = show ? '' : 'none';
    }
    loadAnimation() {
      let animInfo = this.getAnimInfo();
      if (animInfo != null) {
        this.animation = new PlayerAnim(this, animInfo);
      }
    }
    getAnimInfo() {
      if (this.editMode) {
        return null;
      }
      const data = this.playerObject.Data[0];
      if (data.Animation != null) {
        return data.Animation[0];
      } else if (this.parentPlayer != null) {
        return this.parentPlayer.getAnimInfo();
      } else {
        return null;
      }
    }
    unload() {
      const self = this;
      if (this.animation != null) {
        return this.animation.out().pipe(map(a => self));
      } else {
        return of(self);
      }
    }
    stop() {
      this.playing = false;
    }
    loadPosAndSize() {
      let parentLayout;
      const data = this.playerObject.Data[0];
      if (this.parentPlayer != null && this.parentPlayer instanceof PlayerBase && this.playerObject.$.autoScaling == "1") {
        parentLayout = this.parentPlayer.playerObject.Data[0].Layout[0].$;
      }
      let layout;
      if (data.Layout != null && data.Layout[0].Actions != null) {
        layout = data.Layout[0];
        this.actualWidth = Math.floor(Number(layout.$.width));
        this.actualHeight = Math.floor(Number(layout.$.height));
        let scaleX = 1;
        let scaleY = 1;
        if (parentLayout != null) {
          scaleX = this.parentPlayer.scaleX;
          scaleY = this.parentPlayer.scaleY;
        }
        if (this.component != null) {
          this.component.nativeElement.style.position = 'absolute';
        }
      } else {
        layout = null;
        if (data.Layout != null) {
          layout = data.Layout[0];
        }
        if (this.component != null) {
          this.component.nativeElement.style.position = 'absolute';
        }
        if (layout != null && this.usePlayerLayoutX) {
          if (layout.$.x != null) {
            if (parentLayout == null) {
              this.posX = Math.floor(Number(layout.$.x));
              if (this.component != null) {
                this.component.nativeElement.style.left = this.posX + 'px';
              }
            } else {
              this.posX = Math.floor(Number(layout.$.x) * this.parentPlayer.scaleX);
              if (this.component != null) {
                this.component.nativeElement.style.left = this.posX + 'px';
              }
            }
          }
          if (layout.$.left != null) {
            this.posX = Math.floor(Number(layout.$.left));
            if (this.component != null) {
              this.component.nativeElement.style.left = this.posX + 'px';
            }
            if (layout.$.right) {
              this.actualWidth = Math.floor(Number(this.parentPlayer.actualWidth) - Number(layout.$.left) - Number(layout.$.right));
              if (this.component != null) {
                this.component.nativeElement.style.width = this.actualWidth + 'px';
              }
            }
          } else if (layout.$.right) {
            this.posX = Math.floor(Number(this.parentPlayer.actualWidth) - Number(layout.$.width) - Number(layout.$.right));
            if (this.component != null) {
              this.component.nativeElement.style.left = this.posX + 'px';
            }
          }
          if (layout.$.horizontalCenter) {
            this.posX = Math.floor((Number(this.parentPlayer.actualWidth) - Number(layout.$.width)) * 0.5 + Number(layout.$.horizontalCenter));
            if (this.component != null) {
              this.component.nativeElement.style.left = this.posX + 'px';
            }
          }
          if (layout.$.width != null) {
            if (parentLayout == null) {
              this.actualWidth = Math.floor(Number(layout.$.width));
              if (this.component != null) {
                this.component.nativeElement.style.width = this.actualWidth + 'px';
              }
            } else {
              this.actualWidth = Math.floor(Number(layout.$.width) * this.parentPlayer.scaleX);
              if (this.component != null) {
                this.component.nativeElement.style.width = this.actualWidth + 'px';
              }
            }
          }
        } else {
          this.actualWidth = this.parentPlayer != null ? this.parentPlayer.actualWidth : window.innerWidth;
          if (this.component != null) {
            this.component.nativeElement.style.width = this.actualWidth + 'px';
          }
        }
        if (layout != null && this.usePlayerLayoutY) {
          if (layout.$.y != null) {
            if (parentLayout == null) {
              this.posY = Math.floor(Number(layout.$.y));
              if (this.component != null) {
                this.component.nativeElement.style.top = this.posY + 'px';
              }
            } else {
              this.posY = Math.floor(Number(layout.$.y) * this.parentPlayer.scaleY);
              if (this.component != null) {
                this.component.nativeElement.style.top = this.posY + 'px';
              }
            }
          }
          if (layout.$.top != null) {
            this.posY = Math.floor(Number(layout.$.top));
            if (this.component != null) {
              this.component.nativeElement.style.top = this.posY + 'px';
            }
            if (layout.$.bottom) {
              this.actualHeight = Math.floor(Number(this.parentPlayer.actualHeight) - Number(layout.$.top) - Number(layout.$.bottom));
              if (this.component != null) {
                this.component.nativeElement.style.height = this.actualHeight + 'px';
              }
            }
          } else if (layout.$.bottom) {
            this.posY = Math.floor(Number(this.parentPlayer.actualHeight) - Number(layout.$.height) - Number(layout.$.bottom));
            if (this.component != null) {
              this.component.nativeElement.style.top = this.posY + 'px';
            }
          }
          if (layout.$.verticalCenter) {
            this.posY = Math.floor((Number(this.parentPlayer.actualHeight) - Number(layout.$.height)) * 0.5 + Number(layout.$.verticalCenter));
            if (this.component != null) {
              this.component.nativeElement.style.top = this.posY + 'px';
            }
          }
          if (layout.$.height != null) {
            if (parentLayout == null) {
              this.actualHeight = Math.floor(Number(layout.$.height));
              if (this.component != null) {
                this.component.nativeElement.style.height = this.actualHeight + 'px';
              }
            } else {
              this.actualHeight = Math.floor(Number(layout.$.height) * this.parentPlayer.scaleY);
              if (this.component != null) {
                this.component.nativeElement.style.height = this.actualHeight + 'px';
              }
            }
          }
        } else {
          this.actualHeight = this.parentPlayer != null ? this.parentPlayer.actualHeight : window.innerHeight;
          if (this.component != null) {
            this.component.nativeElement.style.height = this.actualHeight + 'px';
          }
        }
        if (layout != null && Number(layout.$.rotation) != this.angle) {
          this.angle = Math.floor(Number(layout.$.rotation));
          if (this.component != null) {
            this.component.nativeElement.style.transform = "rotate(" + this.angle + "deg)";
          }
        }
      }
    }
    invalidateSize() {}
    createBackgroundAction() {
      const data = this.playerObject.Data[0];
      const color = Number(data.Background[0].$.color);
      const r = color & 0xff;
      const g = color >> 8 & 0xff;
      const b = color >> 16 & 0xff;
      const alpha = Number(data.Background[0].$.alpha);
      this.component.nativeElement.style.backgroundColor = 'rgba(' + b + ',' + g + ',' + r + ',' + alpha + ')';
    }
    clearEffects() {
      this.component.nativeElement.style.backgroundColor = '';
      this.component.nativeElement.style.border = '';
      this.component.nativeElement.style.boxSizing = '';
      this.component.nativeElement.style.opacity = '';
      this.component.nativeElement.style.filter = '';
    }
    loadEffects() {
      if (this.component == null) {
        return;
      }
      const data = this.playerObject.Data[0];
      if (data.Background != null) {
        this.createBackgroundAction();
      }
      if (data.Border != null) {
        const borderColor = ColorUtils.format(Number(data.Border[0].$.borderColor));
        let borderThickness = Number(data.Border[0].$.borderThickness);
        // Scale border thickness if autoScaling is enabled
        if (this.parentPlayer != null && this.playerObject.$.autoScaling == "1") {
          borderThickness *= Math.min(this.parentPlayer.scaleX, this.parentPlayer.scaleY);
        }
        this.component.nativeElement.style.boxSizing = "border-box";
        this.component.nativeElement.style.border = "solid";
        this.component.nativeElement.style.borderColor = '#' + borderColor;
        this.component.nativeElement.style.borderWidth = borderThickness + 'px';
      }
      if (data.Appearance != null) {
        this.component.nativeElement.style.opacity = data.Appearance[0].$.alpha;
      }
      if (data.Glow != null) {
        const color = Number(data.Glow[0].$.color);
        const r = color & 0xff;
        const g = color >> 8 & 0xff;
        const b = color >> 16 & 0xff;
        const blur = data.Glow[0].$.blur;
        const alpha = data.Glow[0].$.alpha;
        this.component.nativeElement.style.filter = 'drop-shadow(0px 0px ' + blur + 'px rgba(' + b + ',' + g + ',' + r + ',' + alpha + '))';
      }
      if (data.Blur != null) {
        const blurX = data.Blur[0].$.blurX;
        this.component.nativeElement.style.filter = 'blur(' + blurX + 'px)';
      }
      if (data.Shadow != null) {
        const alpha = +data.Shadow[0].$.alpha;
        const rotation = +data.Shadow[0].$.angle;
        const blur = +data.Shadow[0].$.blur;
        const color = Number(data.Shadow[0].$.color);
        const distance = +data.Shadow[0].$.distance;
        const r = color & 0xff;
        const g = color >> 8 & 0xff;
        const b = color >> 16 & 0xff;
        const k = 0.01745329252;
        const hShadow = distance * Math.cos(rotation * k);
        const vShadow = distance * Math.sin(rotation * k);
        this.component.nativeElement.style.filter = 'drop-shadow(' + hShadow + 'px ' + vShadow + 'px ' + blur + 'px rgba(' + b + ',' + g + ',' + r + ',' + alpha + '))';
      }
    }
    loadStat() {
      const data = this.playerObject.Data[0];
      if (data.Stat != null) {
        const stat = data.Stat[0].$;
        this.statEnabled = stat.enabled == '1';
        this.statTag = stat.tag;
        this.statFiled = stat.field;
        if (stat.minThreshold != null && stat.maxThreshold != null) {
          this.minThreshold = Number(stat.minThreshold);
          this.maxThreshold = Number(stat.maxThreshold);
        }
      }
    }
    getFontStyle(font) {
      let fontSize = Number(font.fontSize);
      if (font.autoScaling == '1') {
        fontSize *= Math.min(this.parentPlayer.scaleX, this.parentPlayer.scaleY);
      }
      const color = '#' + ColorUtils.format(Number(font.fontColor));
      let fontFamily = font.fontFamily;
      if (font.fontWeight != "Normal" && font.fontWeight != "none" && font.fontWeight != "normal" && font.fontWeight != "bold") {
        fontFamily += font.fontWeight == "bold" ? "Bold" : font.fontWeight;
      }
      if (font.fontStyle != "Normal" && font.fontStyle != "normal" && font.fontStyle != "italic") {
        fontFamily += font.fontStyle == "italic" ? "Italic" : font.fontStyle;
      }
      fontFamily = fontFamily.replace(/[\s\[\]\-!•™&:.,()`'?]/g, '');
      const wrap = font.wrap == "1";
      return {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fill: color,
        textDecoration: font.textDecoration,
        wrap: wrap,
        wordWrapWidth: this.actualWidth,
        align: font.textAlign,
        alignSelf: font.alignSelf
      };
    }
    onClick(event) {
      const logInfo = Log.getLogInfo("PlayerBase", "onClick", [event]);
      Log.d(logInfo, LogTag.PLAYER, 'SendEvent ' + this.playerObject.$.clickEventName + " " + this.playerObject.$.clickEventParam);
      const clickEventName = this.playerObject.$.clickEventName;
      const clickEventParam = this.playerObject.$.clickEventParam;
      let param = "";
      try {
        param = JSON.parse(clickEventParam);
      } catch (e) {
        param = clickEventParam;
      }
      this.playerService.eventParams.dispatch(clickEventName, param, false);
    }
    getGlobalPos() {
      console.log('getGlobalPos not supported');
      return null;
    }
    onCommand(command, param) {
      return of(null);
    }
    showMsg(title, description) {
      if (title != null) {
        if (this.msgElm == null) {
          this.msgElm = new MsgElm(this.component);
        }
        this.msgElm.setText(title, description, this.actualWidth, this.actualHeight);
      } else {
        if (this.msgElm != null) {
          this.msgElm.destroy();
          this.msgElm = null;
        }
      }
    }
    componentStatus(status, message = '') {
      if (status === 'ready') {
        if (this.statusElm != null) {
          this.statusElm.destroy();
          this.statusElm = null;
        }
      } else {
        if (this.statusElm == null) {
          this.statusElm = new StatusElm(this.component);
        }
        this.statusElm.setStatus(status, message);
      }
    }
    addContent(statTag, statField, duration) {}
    logError(err) {
      Log.debug();
      const logInfo = Log.getLogInfo("PlayerBase", "logError", []);
      this.loadError = true;
      let errMsg = "";
      if (err.constructor.name == 'TypeError') {
        errMsg = err.message;
      } else {
        try {
          errMsg = JSON.stringify(err);
        } catch (e) {
          errMsg = err;
        }
      }
      Log.e(logInfo, LogTag.PLAYER, errMsg);
      this.showMsg(this.constructor.name, "Error: " + err);
      return of(null);
    }
    destroy() {
      const logInfo = Log.getLogInfo("PlayerBase", "destroy", []);
      Log.d(logInfo, LogTag.PLAYER, this.constructor.name);
      if (this.finish$ != null) {
        this.finish$.next("finish");
        this.finish$.complete();
        this.finish$ = null;
      }
      if (this.msgElm != null) {
        this.msgElm.destroy();
        this.msgElm = null;
      }
      if (this.statusElm != null) {
        this.statusElm.destroy();
        this.statusElm = null;
      }
      if (this.animation != null) {
        this.animation.removeTouchListeners();
        this.animation = null;
      }
      this.playerService = null;
      this.changeDetectorRef = null;
      this.playerObject = null;
    }
    static ɵfac = function PlayerBase_Factory(t) {
      return new (t || PlayerBase)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PlayerBase,
      selectors: [["app-player"]],
      viewQuery: function PlayerBase_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$p, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.component = _t.first);
        }
      },
      decls: 0,
      vars: 0,
      template: function PlayerBase_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return PlayerBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$o = ["playercontainer"];
let SceneComponent = /*#__PURE__*/(() => {
  class SceneComponent extends PlayerBase {
    injector;
    resolver;
    script;
    childMap = {};
    entry;
    childProviderData;
    static globalPlayerId = 10000000; // workaround to support catalog that saved in legacy studio
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.resolver = injector.get(ComponentFactoryResolver);
    }
    display(show) {}
    update(playerObject, action, itemIds) {
      const logInfo = Log.getLogInfo("SceneComponent", "update", []);
      return of('update').pipe(switchMap(r1 => {
        this.playerObject = playerObject;
        let data = playerObject.Data[0];
        let childPlayer;
        if (action == "rebuild") {
          Log.d(logInfo, LogTag.SCENE_UPDATE, "rebuild");
          this.cleanChildren(); // this line cause a crash in studio
          this.childMap = {};
          this.playerObject = playerObject;
          //??? data = playerObject.Data[0];
          this.playerService = this.injector.get('playerService');
          this.component.nativeElement.className = "root-scene";
          return this.load(playerObject).pipe(mergeWith(of('update-ready')));
        } else {
          const id = this.playerObject.$.id;
          if (itemIds.includes(id)) {
            // root scene
            Log.d(logInfo, LogTag.SCENE_UPDATE, "root scene: " + action);
            return this.load(playerObject);
          } else {
            // child
            if (action == "reorder") {
              Log.d(logInfo, LogTag.SCENE_UPDATE, "reorder");
              let index = 0;
              for (let player of data.Scene[0].Players[0].Player) {
                const id = player.$.id;
                childPlayer = this.childMap[id];
                if (childPlayer != null) {
                  this.entry.insert(childPlayer.hostView, index);
                  index++;
                }
              }
              return of('update-ready');
            } else if (action == "delete") {
              Log.d(logInfo, LogTag.SCENE_UPDATE, "delete items");
              itemIds.forEach(id => {
                childPlayer = this.childMap[id];
                if (childPlayer != null) {
                  this.removeComponent(childPlayer);
                  childPlayer.destroy();
                  delete this.childMap[id];
                }
              });
              return of('update-ready');
            } else if (action == "update") {
              Log.d(logInfo, LogTag.SCENE_UPDATE, "update items");
              if (data.Scene[0].Players[0].Player.length > 0) {
                const obsList = [];
                for (let player of data.Scene[0].Players[0].Player) {
                  const id = player.$.id;
                  if (itemIds.includes(id)) {
                    childPlayer = this.childMap[id];
                    if (childPlayer != null) {
                      this.updateMovable(childPlayer, player); //???
                      if (player.$.src) {
                        const player2 = JSON.parse(JSON.stringify(childPlayer.playerObject));
                        player2.Data[0].Layout = player.Data[0].Layout;
                        obsList.push(childPlayer.load(player2));
                      } else {
                        obsList.push(childPlayer.load(player));
                      }
                    }
                  }
                }
                return forkJoin(obsList).pipe(switchMap(r => of('update-ready')));
              }
            } else if (action == "add") {
              Log.d(logInfo, LogTag.SCENE_UPDATE, "add");
              const obsList = [];
              for (let player of data.Scene[0].Players[0].Player) {
                const id = player.$.id;
                if (itemIds.includes(id)) {
                  obsList.push(this.addPlayer(player));
                }
              }
              return forkJoin(obsList).pipe(mergeWith(of('update-ready')), tap$1({
                complete: () => {
                  Log.d(logInfo, LogTag.SCENE_UPDATE, "reorder");
                  let index = 0;
                  for (let player of data.Scene[0].Players[0].Player) {
                    const id = player.$.id;
                    childPlayer = this.childMap[id];
                    if (childPlayer != null) {
                      this.entry.insert(childPlayer.hostView, index);
                      index++;
                    }
                  }
                }
              }));
            }
          }
        }
      }));
    }
    cleanChildren() {
      for (const key in this.childMap) {
        const childPlayer = this.childMap[key];
        if (childPlayer.component != null) {
          childPlayer.component.nativeElement.classList.remove("moveable");
        }
        childPlayer.destroy();
      }
      this.childMap = null;
      while (this.entry.length > 0) {
        this.entry.remove(0);
      }
    }
    addPlayer(p) {
      const logInfo = Log.getLogInfo("SceneComponent", "addPlayer", []);
      return of(p).pipe(concatMap(player => {
        let childPlayer;
        if (player.$.src) {
          const sceneId = player.$.src;
          return this.playerService.caching.getRecord("scenes", sceneId).pipe(switchMap(scene => {
            if (scene != null && scene.changelist_id != null) {
              childPlayer = this.createComponent(SceneComponent, null, this.editMode, -1);
              this.updateMovable(childPlayer, player);
              childPlayer.originalSize = scene.json.Player.Data[0].Layout[0].$;
              const player2 = JSON.parse(JSON.stringify(scene.json.Player));
              player2.Data[0].Layout = player.Data[0].Layout;
              this.childMap[player.$.id] = childPlayer;
              return childPlayer.load(player2);
            } else {
              // Scene was deleted
              return of('deleted');
            }
          }));
        } else {
          const playerId = player.$.player;
          const componentClass = this.playerService.getComponentClasses(playerId);
          const blockingTime = this.playerService.getComponentBlockingTime(playerId);
          if (componentClass == null) {
            Log.e(logInfo, LogTag.PLAYER, "Error: playerId=" + playerId);
          } else {
            childPlayer = this.createComponent(componentClass, player, this.editMode, blockingTime);
            this.updateMovable(childPlayer, player);
            this.childMap[player.$.id] = childPlayer;
            return childPlayer.load(player);
          }
        }
      }));
    }
    checkCircular() {
      const sceneId = this.playerObject.$.id;
      if (sceneId == null) {
        return false; //???
      }
      let player = this.parentPlayer;
      while (player != null) {
        if (sceneId == player.playerObject.$.id) {
          this.playerService.circularSceneId = Number(sceneId); //???
          return true;
        }
        player = player.parentPlayer;
      }
      return false;
    }
    loadScript() {
      /* not supported
      if (this.parentPlayer == null && this.playerObject.$.scheduleId != null) { //??? temp
          const className = "HomeHeater";
          const params = '{"eventName":"knx"}'; // '{"eventName":"knx"}' // item.$.params;
          return this.playerService.loadScript(1).pipe(
              switchMap(r => {
                  this.script = <IPlugin>this.playerService.createScriptClass(className, params);
                  const data = JSON.parse(params);
                  return this.script.load(<any>this.injector, data, this.actualWidth, this.actualHeight).pipe(
                      switchMap(r => {
                          return of("a");
                      })
                  )
              })
          )
      }
      */
      return of('???');
    }
    load(playerObject) {
      const logInfo = Log.getLogInfo("SceneComponent", "load", []);
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        if (this.checkCircular()) {
          Log.w(logInfo, LogTag.PLAYER, 'Circular Dependencies in sceneId:' + this.playerService.circularSceneId);
          this.showMsg("Circular ERROR", "scene id: " + +this.playerObject.$.id);
          return of(null);
        } else {
          return of(self);
        }
      }), switchMap(res => {
        if (res == null) {
          return of(null);
        }
        const obsList = [];
        if (this.originalSize != null) {
          this.scaleX = this.actualWidth / this.originalSize.width;
          this.scaleY = this.actualHeight / this.originalSize.height;
        }
        let childPlayer;
        const data = this.playerObject.Data[0];
        if (data.Scene[0].Players[0].Player?.length > 0) {
          for (let player of data.Scene[0].Players[0].Player) {
            const id = player.$.id;
            childPlayer = this.childMap[id];
            if (childPlayer == null) {
              if (player.$.src) {
                const childPlayer = this.createComponent(SceneComponent, null, this.editMode, -1);
                this.childMap[player.$.id] = childPlayer;
                obsList.push(this.loadNestedScene(childPlayer, player));
              } else {
                const playerId = player.$.player;
                const componentClass = this.playerService.getComponentClasses(playerId);
                const blockingTime = this.playerService.getComponentBlockingTime(playerId);
                if (componentClass == null) {
                  Log.e(logInfo, LogTag.MAIN, "Error: playerId=" + playerId);
                  continue;
                }
                childPlayer = this.createComponent(componentClass, player, this.editMode, blockingTime);
                childPlayer.display(false);
                // workaround to support catalog that saved in legacy studio
                if (player.$.id == null) {
                  player.$.id = String(SceneComponent.globalPlayerId);
                  SceneComponent.globalPlayerId++;
                }
                this.childMap[player.$.id] = childPlayer;
                this.updateMovable(childPlayer, player);
                const load$ = childPlayer.load(player).pipe(switchMap(child => child.play(false)), mergeWith(childPlayer.registerCommands()));
                obsList.push(load$);
              }
            } else {
              // in case we do update to the scene, we don't rebuild children
              if (player.$.src) {
                const sceneId = player.$.src;
                childPlayer.playerObject.Data[0].Layout = player.Data[0].Layout; //???
                childPlayer.loadPosAndSize();
              } else {
                obsList.push(childPlayer.load(player));
              }
            }
          }
        }
        const load$ = obsList.length > 0 ? forkJoin(obsList) : of('empty');
        return of(load$, this.registerCommands()).pipe(mergeAll());
        //return load$;
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    loadAnimation() {}
    unload() {
      const self = this;
      const list = [];
      for (const key in this.childMap) {
        const childPlayer = this.childMap[key];
        list.push(childPlayer.unload());
      }
      if (list.length > 0) {
        return forkJoin(list).pipe(map(a => self));
      } else {
        return of(self);
      }
    }
    createComponent(cmpClass, playerObject, editMode, blockingTime) {
      const logInfo = Log.getLogInfo("SceneComponent", "createComponent", []);
      let childComponent;
      const useComponent = cmpClass.prototype.constructor.useComponent; // only false in case of RSS
      let gpu = false; // if it's run in studio it will always use html.
      if (this.editMode == false && playerObject != null) {
        //if (playerObject?.$?.gpu != null) {
        //  gpu = playerObject.$.gpu == '1';
        //} else {
        gpu = cmpClass.prototype.constructor.defaultGpu;
        //}
      }
      if (gpu) {
        childComponent = new cmpClass(this.injector, this.resolver);
      } else {
        Log.d(logInfo, LogTag.PIXI, 'create Angular class: ' + cmpClass.name);
        const factory = this.resolver.resolveComponentFactory(cmpClass);
        const componentRef = this.entry.createComponent(factory);
        childComponent = componentRef.instance;
        childComponent.hostView = componentRef.hostView;
      }
      childComponent.init(this, editMode, blockingTime);
      return childComponent;
    }
    removeComponent(player) {
      if (this.entry != null) {
        const i = this.entry.indexOf(player.hostView);
        if (i != -1) {
          this.entry.remove(i);
          this.changeDetectorRef?.detectChanges();
        }
      }
    }
    updateMovable(childPlayer, player) {
      if (childPlayer != null && childPlayer.component != null && this.component.nativeElement.classList.contains("root-scene")) {
        const invisible = player.Data[0].Layout[0].$.invisible == "true";
        const lock = player.Data[0].Layout[0].$.locked == "true";
        if (lock || invisible) {
          childPlayer.component.nativeElement.classList.remove("moveable");
          childPlayer.component.nativeElement.style.pointerEvents = "none";
        } else {
          childPlayer.component.nativeElement.classList.add("moveable");
          childPlayer.component.nativeElement.style.pointerEvents = "";
        }
        childPlayer.component.nativeElement.style.visibility = invisible ? "hidden" : "visible";
        childPlayer.component.nativeElement.id = player.$.id;
      }
    }
    makeRequest() {
      return new Observable(sub => {
        sub.next('1');
        sub.complete();
      });
    }
    loadNestedScene(childPlayer, linkedScene) {
      const logInfo = Log.getLogInfo("SceneComponent", "loadNestedScene", []);
      return of(linkedScene).pipe(switchMap(linkedScene => {
        const sceneId = linkedScene.$.src;
        return this.playerService.caching.getRecord("scenes", Number(sceneId)).pipe(switchMap(scene => {
          if (scene != null && scene.changelist_id != null) {
            this.updateMovable(childPlayer, linkedScene);
            childPlayer.originalSize = scene.json.Player.Data[0].Layout[0].$;
            const player2 = JSON.parse(JSON.stringify(scene.json.Player));
            player2.Data[0].Layout = linkedScene.Data[0].Layout;
            return childPlayer.load(player2);
          } else {
            return new Observable(sub => {
              Log.w(logInfo, LogTag.PLAYER, 'Scene was deleted');
              childPlayer.component.nativeElement.id = linkedScene.$.id;
              childPlayer.component.nativeElement.classList.add("moveable");
              childPlayer.effectActions = [];
              childPlayer.playerObject = linkedScene;
              childPlayer.data = childPlayer.playerObject.Data[0];
              childPlayer.loadPosAndSize();
              //childPlayer.component.nativeElement.style.position='absolute';
              //childPlayer.component.nativeElement.style.width='100px';
              //childPlayer.component.nativeElement.style.height='100px';
              childPlayer.showMsg('Scene ERROR', 'Scene ' + linkedScene.$.src + ' was deleted');
              sub.next('delete');
              sub.complete();
            });
          }
        }));
      }));
    }
    getObsList() {
      const obsList = [];
      for (const key in this.childMap) {
        const p = this.childMap[key];
        obsList.push(p.registerCommands()); //???
      }
      return obsList;
    }
    stop() {
      super.stop();
      for (const key in this.childMap) {
        const p = this.childMap[key];
        p.stop();
      }
    }
    /*???
    invalidateData(providerData: any): Observable<any> {
      this.providerData = providerData;
      const obsList = [];
      for (const key in this.childMap) {
        const p = this.childMap[key];
        obsList.push(p.invalidateData(providerData));
      }
      return forkJoin(obsList);
    }
     */
    onSelect() {
      //??? event.stopPropagation();
      //??? this.playerService.eventParams.dispatch('sceneClicked', this, false);
    }
    addContent(statTag, statField, duration) {
      if (this.childProviderData == null) {
        this.playerService.stats.addContent(statTag, 1, this.playerObject.$.id, duration);
      } else {
        let contentId = String(this.childProviderData[statField]);
        contentId = contentId.substring(0, 16);
        contentId = contentId.replace(/[^a-zA-Z0-9]/g, '_');
        this.playerService.stats.addContent(statTag, 2, contentId, duration);
      }
    }
    destroy() {
      for (const key in this.childMap) {
        const childPlayer = this.childMap[key];
        if (childPlayer.component != null) {
          childPlayer.component.nativeElement.classList.remove("moveable");
        }
        childPlayer.destroy();
      }
      this.childMap = null;
      while (this.entry.length > 0) {
        this.entry.remove(0);
      }
      if (this.script != null) {
        this.script.destroy();
      }
      super.destroy();
    }
    static ɵfac = function SceneComponent_Factory(t) {
      return new (t || SceneComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SceneComponent,
      selectors: [["app-scene"]],
      viewQuery: function SceneComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$o, 7, ViewContainerRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.entry = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""], [3, "click"]],
      template: function SceneComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵlistener("click", function SceneComponent_Template_div_click_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onSelect());
          });
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return SceneComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GenericElm {
  component;
  fontStyle;
  label;
  labelGrid;
  labelAnchor;
  aspectRatio;
  playing = false;
  img;
  image;
  gif;
  gifPath;
  video;
  hls;
  svg;
  emptyIcon;
  iframe;
  constructor(component) {
    this.component = component;
  }
  setTextStyle() {
    this.labelAnchor.style.fontSize = this.fontStyle.fontSize + 'px';
    this.labelAnchor.style.color = this.fontStyle.fill;
    this.labelAnchor.style.fontFamily = this.fontStyle.fontFamily;
    this.labelAnchor.style.textDecoration = this.fontStyle.textDecoration;
    this.labelAnchor.style.textAlign = this.fontStyle.align; // hoz
    this.labelAnchor.style.alignSelf = this.fontStyle.alignSelf != null ? this.fontStyle.alignSelf : "center"; // ver
    this.labelAnchor.style.whiteSpace = this.fontStyle.wrap ? "normal" : "nowrap";
    //??? this.component.nativeElement.style.pointerEvents = "none"; // prevent the keyboard in android. cause the keyboard resize the windows and that restart the presentation.
  }
  setText(label, animate = false, editable = false) {
    this.label = String(label);
    if (this.component != null) {
      if (this.labelGrid == null) {
        this.labelGrid = document.createElement("div");
        this.labelGrid.style.display = 'grid';
        this.labelGrid.style.width = '100%';
        this.labelGrid.style.height = '100%';
        this.component.nativeElement.appendChild(this.labelGrid);
        this.labelAnchor = document.createElement("div");
        this.labelAnchor.style.overflow = 'hidden';
        this.labelGrid.appendChild(this.labelAnchor);
        if (editable) {
          this.labelAnchor.contentEditable = 'true';
          this.labelAnchor.style.margin = '0px';
          this.labelAnchor.style.background = 'none';
          this.labelAnchor.style.outline = 'none';
          this.labelAnchor.style.border = 'none';
          this.labelAnchor.style.overflow = 'hidden';
          this.labelAnchor.style.caretColor = 'white';
          this.labelAnchor.style.userSelect = 'none';
          this.labelAnchor.style.resize = 'none';
          this.labelAnchor.style.whiteSpace = 'pre-wrap';
          this.labelAnchor.spellcheck = false;
        }
      }
      this.setTextStyle();
      if (animate == false) {
        this.labelAnchor.innerText = label;
      }
    }
  }
  setEmptyIcon(renderer) {
    this.emptyIcon = document.createElement('mat-icon');
    this.emptyIcon.innerHTML = 'extension';
    this.emptyIcon.style.fontSize = '64px';
    this.emptyIcon.style.width = '80px';
    this.emptyIcon.style.height = '80px';
    this.emptyIcon.style.color = 'white';
    renderer.addClass(this.emptyIcon, 'mat-icon');
    renderer.addClass(this.emptyIcon, 'material-icons');
    this.component.nativeElement.appendChild(this.emptyIcon);
  }
  setMedia(path, aspectRatio, width, height, autoRewind, volume, ext = null) {
    if (ext == null) {
      if (path.indexOf('.m3u8') != -1) {
        ext = 'm3u8';
      } else if (path.indexOf('.mp4') != -1) {
        ext = 'mp4';
      }
    }
    if (ext == 'mp4' || ext == 'm3u8') {
      return this.setVideo(path, aspectRatio, width, height, autoRewind, volume, ext);
    } else {
      return this.setImage(path, aspectRatio, width, height);
    }
  }
  setImage(path, aspectRatio, width, height) {
    return new Observable(sub => {
      this.clear();
      this.aspectRatio = aspectRatio;
      sub.next('setImage');
      sub.complete();
    }).pipe(switchMap(r1 => {
      if (this.component != null) {
        // html
        //Log.d("DIV: setImage");
        if (path.lastIndexOf('.svg') != -1 && this.svg != null) {
          return new Observable(sub => {
            fetch(path).then(response => {
              response.text().then(svg => {
                this.component.nativeElement.innerHTML = svg;
                const svgElm = this.component.nativeElement.firstElementChild;
                svgElm.style.width = '100%';
                svgElm.style.height = '100%';
                svgElm.setAttribute("preserveAspectRatio", "none");
                if (this.svg != null) {
                  for (let path in this.svg) {
                    const item = this.svg[path];
                    let elm = svgElm;
                    path.split('.').forEach(index => {
                      if (elm != null) {
                        elm = elm.children[index];
                      }
                    });
                    if (item != null && elm != null) {
                      if (item.fill != null) {
                        elm.style.fill = item.fill;
                      }
                      if (item.stroke != null) {
                        elm.style.stroke = item.stroke;
                      }
                    }
                  }
                }
                sub.next('svg');
                sub.complete();
              });
            });
          });
        } else {
          let url = path;
          if (url == "") {
            return of(null);
          }
          this.img = document.createElement("img");
          this.img.style.width = '100%';
          this.img.style.height = '100%';
          if (this.aspectRatio) {
            this.img.style.objectFit = 'contain';
          }
          this.component.nativeElement.appendChild(this.img);
          this.img.src = url;
          return fromEvent(this.img, 'load').pipe(take(1));
        }
      }
    }));
  }
  setVideo(path, aspectRatio, width, height, autoRewind, volume, ext = null) {
    return new Observable(sub => {
      this.clear();
      this.aspectRatio = aspectRatio;
      sub.next('setVideo');
      sub.complete();
    }).pipe(switchMap(r1 => {
      if (this.component != null) {
        this.video = document.createElement("video");
        this.video.style.width = '100%';
        this.video.style.height = '100%';
        this.video.muted = true;
        this.video.setAttribute("controlsList", "nodownload");
        this.video.setAttribute("controls", "controls");
        if (aspectRatio == false) {
          this.video.style.objectFit = "fill";
        }
        this.video.loop = autoRewind;
        this.video.volume = volume;
        this.component.nativeElement.appendChild(this.video);
        if (ext == 'm3u8') {
          this.hls = new Hls();
          this.hls.loadSource(path);
          this.hls.attachMedia(this.video);
          return fromEvent(this.hls, 'hlsManifestParsed').pipe(take(1));
        } else {
          this.video.type = "video/mp4s";
          this.video.src = path;
          return of('mp4');
        }
      }
    }));
  }
  setHtml(url, scrollbars) {
    this.iframe = document.createElement('iframe');
    this.iframe.style.width = '100%';
    this.iframe.style.height = '100%';
    this.iframe.style.border = '0px';
    if (scrollbars == false) {
      this.iframe.scrolling = 'no';
    }
    this.component.nativeElement.appendChild(this.iframe);
    this.iframe.src = url;
    return of('html');
  }
  play(playVideoInFull) {
    if (this.video == null) {
      return of('play');
    }
    let obs$ = new Observable(sub => {
      this.playing = true;
      this.video.currentTime = 0;
      this.video.muted = false;
      const promise = this.video.play();
      if (promise !== undefined) {
        promise.then(_ => {
          // Play works!
          sub.next('video_play');
          sub.complete();
        }).catch(error => {
          // Play was prevented.
          if (this.video != null) {
            this.video.muted = true;
            this.video.play();
          }
          sub.next('video_play');
          sub.complete();
        });
      }
    });
    if (playVideoInFull) {
      obs$ = obs$.pipe(switchMap(video => {
        return fromEvent(this.video, 'ended').pipe(take(1));
      }));
    }
    return obs$;
  }
  stop() {
    //const logInfo = Log.getLogInfo("GenericElm", "stop", []);
    this.playing = false;
    if (this.component != null && this.video != null) {
      this.video.pause();
      //Log.d(logInfo, LogTag.PLAYER, 'video stop: 5sec !!!');
      this.video.currentTime = 5;
    } else {}
  }
  clear() {
    if (this.component != null) {
      if (this.emptyIcon != null) {
        this.component.nativeElement.removeChild(this.emptyIcon);
        this.emptyIcon = null;
      }
      if (this.labelAnchor != null) {
        this.labelGrid.removeChild(this.labelAnchor);
        this.component.nativeElement.removeChild(this.labelGrid);
        this.labelGrid = null;
        this.labelAnchor = null;
      }
      if (this.img != null) {
        this.component.nativeElement.removeChild(this.img);
        this.img = null;
      }
      if (this.hls != null) {
        this.hls.destroy();
        this.hls = null;
      }
      if (this.video != null) {
        try {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
        } catch (e) {
          debugger;
        }
        this.component.nativeElement.removeChild(this.video);
        this.video = null;
      }
      if (this.iframe != null) {
        this.component.nativeElement.removeChild(this.iframe);
        this.iframe = null;
      }
    }
  }
  destroy() {
    this.clear();
  }
}
let ImageComponent = /*#__PURE__*/(() => {
  class ImageComponent extends PlayerBase {
    injector;
    genericElm;
    resourceId;
    onSvgClick;
    finalized = false;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getElementPath(elm) {
      const svgElm = this.component.nativeElement.firstElementChild;
      let child = elm;
      let path = "";
      while (child != svgElm) {
        const parent = child.parentElement;
        let index = Array.prototype.indexOf.call(parent.children, child);
        path = path == "" ? String(index) : index + "." + path;
        child = parent;
      }
      return path;
    }
    load(playerObject) {
      //if (this.parentPlayer.playerObject.$.id=="7" || this.parentPlayer.playerObject.$.id==16) {
      //  return of(this);
      //}
      const logInfo = Log.getLogInfo("ImageComponent", "load", []);
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        try {
          self = playerBase;
          const data = this.playerObject.Data[0];
          if (this.genericElm == null) {
            this.genericElm = new GenericElm(this.component);
          }
          if (data.Resource == null) {
            Log.debug();
          }
          this.resourceId = data.Resource[0].$.resource;
          if (data.Resource[0].Svg != null) {
            this.genericElm.svg = {};
            if (data.Resource[0].Svg[0]?.Item != null) {
              data.Resource[0].Svg[0].Item.forEach(item => {
                this.genericElm.svg[item.$.path] = {
                  fill: item.$.fill,
                  stroke: item.$.stroke
                };
              });
            }
          }
          return this.playerService.caching.getResource(this.resourceId);
        } catch (e) {
          Log.debug();
        }
      }), switchMap(path => {
        const data = this.playerObject.Data[0];
        try {
          if (data == null) {
            Log.debug();
            return of(null);
          }
          if (path == null) {
            return of('empty');
          }
          let aspectRatio = false;
          if (data.Resource == null) {
            Log.debug();
          }
          if (data.Resource[0].AspectRatio != null) {
            aspectRatio = data.Resource[0].AspectRatio[0].$.maintain == "1";
          }
          return this.genericElm.setImage(path, aspectRatio, this.actualWidth, this.actualHeight);
        } catch (e) {
          Log.debug();
        }
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    addContent(statTag, statField, duration) {
      this.playerService.stats.addContent(statTag, 0, this.resourceId, duration);
    }
    destroy() {
      if (this.onSvgClick != null) {
        this.component.nativeElement.removeEventListener('click', this.onSvgClick);
        this.onSvgClick = null;
      }
      if (this.genericElm != null) {
        this.genericElm.destroy();
      }
      super.destroy();
    }
    static ɵfac = function ImageComponent_Factory(t) {
      return new (t || ImageComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ImageComponent,
      selectors: [["app-image"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""], [3, "click"]],
      template: function ImageComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵlistener("click", function ImageComponent_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$n = ["myVideo"];
let VideoComponent = /*#__PURE__*/(() => {
  class VideoComponent extends PlayerBase {
    injector;
    myVideo;
    genericElm;
    resourceId;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.genericElm = new GenericElm(this.component);
        this.resourceId = data.Resource[0].$.resource;
        return this.playerService.caching.getResource(this.resourceId);
      }), switchMap(path => {
        let aspectRatio = false;
        const data = this.playerObject.Data[0];
        if (data.Resource[0].AspectRatio != null) {
          aspectRatio = data.Resource[0].AspectRatio[0].$.maintain == "1";
        }
        let autoRewind = false;
        let volume = 1.0;
        if (data.Resource[0].Video != null) {
          autoRewind = data.Resource[0].Video[0].$.autoRewind == "1";
          volume = Number(data.Resource[0].Video[0].$.volume);
        }
        return this.genericElm.setMedia(path, aspectRatio, this.actualWidth, this.actualHeight, autoRewind, volume).pipe(switchMap(a => this.genericElm.play(false)));
      }), switchMap(v => {
        //this.playerService?.removeLoading(this.constructor.name)
        if (this.genericElm && this.editMode) {
          this.genericElm.stop();
        }
        return of('a');
      }), catchError(err => {
        debugger;
        return this.logError(err);
      }), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    stop() {
      super.stop();
      this.genericElm.stop();
    }
    addContent(statTag, statField, duration) {
      this.playerService.stats.addContent(statTag, 0, this.resourceId, duration);
    }
    destroy() {
      if (this.genericElm != null) {
        this.genericElm.destroy();
      }
      super.destroy();
    }
    static ɵfac = function VideoComponent_Factory(t) {
      return new (t || VideoComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: VideoComponent,
      selectors: [["app-video"]],
      viewQuery: function VideoComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$n, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myVideo = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function VideoComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return VideoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LabelComponent = /*#__PURE__*/(() => {
  class LabelComponent extends PlayerBase {
    injector;
    genericElm;
    textFn;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    onTextChange() {
      console.log("onTextChange");
      if (this.editMode) {
        const data = this.playerObject.Data[0];
        const delta = this.genericElm.labelAnchor.clientHeight - this.actualHeight;
        if (delta > 0) {
          data.Layout[0].$.height = String(Number(data.Layout[0].$.height) + delta);
          this.loadPosAndSize();
          this.playerService.studioChannel$.next({
            event: "size",
            playerId: this.playerObject.$.id,
            width: this.actualWidth,
            height: this.actualHeight
          });
        }
        console.log('onTextChange: ' + this.genericElm.labelAnchor.innerText);
        this.playerService.studioChannel$.next({
          event: "input",
          playerId: this.playerObject.$.id,
          text: this.genericElm.labelAnchor.innerText
        });
      }
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        const data = this.playerObject.Data[0];
        self = playerBase;
        if (this.component != null) {
          this.component.nativeElement.classList.add("scene-label"); // used by studio
        }
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        const font = data.Label[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        const data = this.playerObject.Data[0];
        const label = String(data.Label[0].Text[0]);
        const animate = this.editMode == false && this.animation?.animIn?.textTyping;
        this.setText(label, animate);
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    setText(label, animate = false) {
      const editable = this.editMode;
      this.genericElm.setText(label, animate, editable);
      if (editable && this.textFn == null) {
        this.genericElm.labelAnchor.classList.add("editable-label");
        this.textFn = () => {
          this.onTextChange();
        };
        this.genericElm.labelAnchor.addEventListener('input', this.textFn);
      }
    }
    onCommand(command, param) {
      let value;
      const cmd = command.$.command;
      switch (cmd) {
        case 'nextPage':
          // ??? temp test only
          this.setText(param);
          break;
        case 'setParam':
          this.setText(param);
          break;
        case "addParam":
          value = Number(this.genericElm.label) + Number(param);
          this.setText(value);
          break;
        case "decParam":
          value = Number(this.genericElm.label) - Number(param);
          this.setText(value);
          break;
      }
      return of('onCmd'); //???
    }
    destroy() {
      if (this.genericElm != null) {
        if (this.textFn != null) {
          this.genericElm.labelAnchor.removeEventListener('input', this.textFn);
          this.textFn = null;
        }
        this.genericElm.destroy();
        this.genericElm = null;
      }
      super.destroy();
    }
    static ɵfac = function LabelComponent_Factory(t) {
      return new (t || LabelComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: LabelComponent,
      selectors: [["app-label"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""], [3, "click"]],
      template: function LabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵlistener("click", function LabelComponent_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return LabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonComponent = /*#__PURE__*/(() => {
  class ButtonComponent extends PlayerBase {
    injector;
    label;
    fontSize;
    color;
    bgColor;
    fontFamily;
    fontStyle;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const font = data.Button[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        //this.bgColor = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        const data = this.playerObject.Data[0];
        this.label = data.Button[0].$.label;
        this.changeDetectorRef.detectChanges();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    addTouchListeners(obsList) {
      // use button default animation
    }
    createBackgroundAction() {
      const data = this.playerObject.Data[0];
      const color = Number(data.Background[0].$.color);
      const r = color & 0xff;
      const g = color >> 8 & 0xff;
      const b = color >> 16 & 0xff;
      const alpha = Number(data.Background[0].$.alpha);
      this.bgColor = 'rgba(' + b + ',' + g + ',' + r + ',' + alpha + ')';
    }
    clearEffects() {
      super.clearEffects();
      this.bgColor = '';
    }
    static ɵfac = function ButtonComponent_Factory(t) {
      return new (t || ButtonComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ButtonComponent,
      selectors: [["app-button"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 9,
      consts: [["component", ""], ["mat-raised-button", "", 2, "width", "100%", "height", "100%", 3, "click"]],
      template: function ButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", null, 0)(2, "button", 1);
          i0.ɵɵlistener("click", function ButtonComponent_Template_button_click_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("font-size", ctx.fontSize)("color", ctx.color)("background-color", ctx.bgColor)("font-family", ctx.fontFamily);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.label);
        }
      },
      dependencies: [i2.MatButton],
      encapsulation: 2
    });
  }
  return ButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DateUtils = /*#__PURE__*/(() => {
  class DateUtils {
    static DaysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    static DaysLong = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    static MonthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    static MonthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    static showDate(date, dateFormat) {
      let str = '';
      let i = 0;
      while (i < dateFormat.length) {
        const ch0 = dateFormat.charAt(i);
        let ch = ch0;
        i++;
        while (i < dateFormat.length) {
          const ch1 = dateFormat.charAt(i);
          if (ch0 !== ch1) {
            break;
          }
          ch += ch1;
          i++;
        }
        switch (ch) {
          case 'YY':
            str += date.getFullYear() % 100;
            break;
          case 'YYYY':
            str += date.getFullYear();
            break;
          case 'M':
            str += date.getMonth() + 1;
            break;
          case 'MM':
            const MM = date.getMonth() + 1;
            if (MM < 10) {
              str += '0';
            }
            str += MM;
            break;
          case 'MMM':
            str += this.MonthsShort[date.getMonth()];
            break;
          case 'MMMM':
            str += this.MonthsLong[date.getMonth()];
            break;
          case 'D':
            str += date.getDate();
            break;
          case 'DD':
            const DD = date.getDate();
            if (DD < 10) {
              str += '0';
            }
            str += DD;
            break;
          case 'J':
            // (0-23)
            str += date.getHours();
            break;
          case 'JJ':
            // (0-23)
            const JJ = date.getHours();
            if (JJ < 10) {
              str += '0';
            }
            str += JJ;
            break;
          case 'H':
            // (1-24)
            let H = date.getHours();
            if (H === 0) {
              H = 24;
            }
            str += H;
            break;
          case 'HH':
            // (1-24)
            let HH = date.getHours();
            if (HH === 0) {
              HH = 24;
            }
            if (HH < 10) {
              str += '0';
            }
            str += HH;
            break;
          case 'A':
            str += date.getHours() / 12 < 1 ? "AM" : "PM";
            break;
          case 'K':
            // (0-11)
            str += date.getHours() % 12;
            break;
          case 'L':
            // (1-12)
            let L = date.getHours() % 12;
            if (L === 0) {
              L = 12;
            }
            str += L;
            break;
          case 'N':
            str += date.getMinutes();
            break;
          case 'NN':
            const min = date.getMinutes();
            if (min < 10) {
              str += '0';
            }
            str += min;
            break;
          case 'S':
            str += date.getSeconds();
            break;
          case 'SS':
            const sec = date.getSeconds();
            if (sec < 10) {
              str += '0';
            }
            str += sec;
            break;
          case 'E':
            str += date.getDay();
            break;
          case 'EE':
            str += '0' + date.getDay();
            break;
          case 'EEE':
            str += this.DaysShort[date.getDay()];
            break;
          case 'EEEE':
            str += this.DaysLong[date.getDay()];
            break;
          default:
            str += ch;
            break;
        }
      }
      return str;
    }
  }
  return DateUtils;
})();
let ClockComponent = /*#__PURE__*/(() => {
  class ClockComponent extends PlayerBase {
    injector;
    clockMask;
    genericElm;
    DaysShort = ["Sun", "Mon", "Tue", "Wen", "Thu", "Fri", "Sat"];
    DaysLong = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    MonthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    MonthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        const font = data.Clock[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        this.clockMask = data.Clock[0].$.clockMask;
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        if (this.editMode) {
          this.genericElm.setText(this.clockMask);
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        return of(null);
      }
      return super.play().pipe(mergeWith(of('clock').pipe(switchMap(a => this.showTime()), delay(1000), repeat())));
    }
    showTime() {
      const value = new Date();
      const str = DateUtils.showDate(value, this.clockMask);
      this.genericElm.setText(str);
      return of('time');
    }
    destroy() {
      if (this.genericElm != null) {
        this.genericElm.destroy();
      }
      super.destroy();
    }
    static ɵfac = function ClockComponent_Factory(t) {
      return new (t || ClockComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ClockComponent,
      selectors: [["app-clock"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function ClockComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ClockComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$m = ["videoElm"];
let CameraComponent = /*#__PURE__*/(() => {
  class CameraComponent extends PlayerBase {
    injector;
    videoElm;
    stream;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        return from(navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: 'user',
            width: this.actualWidth,
            height: this.actualHeight
          }
        }));
      }), switchMap(stream => {
        this.stream = stream;
        this.videoElm.nativeElement.srcObject = stream;
        this.videoElm.nativeElement.play();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    destroy() {
      if (this.stream != null) {
        const tracks = this.stream.getTracks();
        tracks[0].stop();
        this.stream = null;
        this.videoElm.nativeElement.pause();
        this.videoElm.nativeElement.src = "";
        this.videoElm.nativeElement.srcObject = null;
      }
      super.destroy();
    }
    static ɵfac = function CameraComponent_Factory(t) {
      return new (t || CameraComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CameraComponent,
      selectors: [["app-camera"]],
      viewQuery: function CameraComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$m, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.videoElm = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["videoElm", ""], [2, "position", "absolute", "width", "100%", "height", "100%", "top", "0px", "left", "0px"]],
      template: function CameraComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "video", 2, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return CameraComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$l = ["playercontainer"];
let PlayerContainer = /*#__PURE__*/(() => {
  class PlayerContainer extends PlayerBase {
    injector;
    resolver;
    childComponent;
    entry;
    url;
    childProviderData;
    playVideoInFull = false;
    volume = 1.0;
    displayMode = 'slideShow';
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.resolver = injector.get(ComponentFactoryResolver);
    }
    getItemUrl(resourceUrl) {
      if (resourceUrl != null && resourceUrl.length > 5 && resourceUrl.substring(0, 4) == 'http') {
        return resourceUrl;
      }
      if (this.url == null) {
        return null;
      }
      if (resourceUrl.substring(0, 1) == '/') {
        const i = this.url.indexOf('/', 8);
        if (i > -1) {
          return this.url.substring(0, i) + resourceUrl;
        }
      } else {
        const i = this.url.lastIndexOf('/');
        if (i > -1) {
          return this.url.substring(0, i + 1) + resourceUrl;
        }
      }
    }
    getPage() {
      return of(null);
    }
    showPage() {
      const logInfo = Log.getLogInfo("PlayerContainer", "showPage", []);
      this.loadError = false;
      const duration = Number(((new Date().getTime() - this.statStart) / 1000).toFixed(2));
      this.statStart = new Date().getTime();
      const obs$ = this.getPage();
      return obs$.pipe(switchMap(player => {
        if (player == null) {
          return of(null);
        }
        if (player.$.src != null) {
          const sceneId = player.$.src;
          if (sceneId == -1 || sceneId == "") {
            Log.w(logInfo, LogTag.PLAYER, "sceneId is not set");
            return of(null);
          }
          return this.playerService.caching.getRecord("scenes", sceneId).pipe(switchMap(scene => {
            if (scene == null) {
              Log.w(logInfo, LogTag.PLAYER, 'assignment do sceneId=' + sceneId + ' does not exist');
              this.showMsg(this.playerObject.$.label, "The assigned scene was deleted");
              this.loadError = true;
              return of(null);
            }
            const retList = [];
            let oldChildComponent = null;
            if (this.childComponent != null) {
              oldChildComponent = this.childComponent;
              const oldLoader$ = of(this.childComponent).pipe(tap$1(child => this.unloadComplete(child, duration)), switchMap(child => child.unload()), finalize(() => {
                if (oldChildComponent.finish$ != null) {
                  oldChildComponent.finish$.next("finish");
                  oldChildComponent.finish$.complete();
                  oldChildComponent.finish$ = null;
                }
                oldChildComponent.destroy();
                this.removeComponent(oldChildComponent);
              }));
              retList.push(oldLoader$);
            }
            const player2 = JSON.parse(JSON.stringify(scene.json.Player));
            this.childComponent = this.createComponent(SceneComponent, player2, this.editMode, -1);
            this.childComponent.childProviderData = this.childProviderData;
            this.childComponent.originalSize = player2.Data[0].Layout[0].$;
            const data = this.playerObject.Data[0];
            player2.Data[0].Layout = data.Layout;
            this.childComponent.usePlayerLayoutX = false;
            this.childComponent.usePlayerLayoutY = false;
            const newLoad$ = this.childComponent.load(player2);
            retList.push(newLoad$);
            return forkJoin(retList);
          }));
        } else {
          const playerId = player.$.player;
          if (playerId == '0') {
            this.loadError = true;
            console.error(this, "playerId=='0'");
            return of(null);
          }
          const retList = [];
          let oldChildComponent = null;
          if (this.childComponent != null) {
            oldChildComponent = this.childComponent;
            let oldLoader$ = of(this.childComponent).pipe(tap$1(child => {
              this.unloadComplete(child, duration);
            }), switchMap(child => child.unload()), finalize(() => {
              oldChildComponent.destroy();
              this.removeComponent(oldChildComponent);
            }));
            retList.push(oldLoader$);
          }
          let pixiClass = this.playerService.getComponentClasses(playerId);
          const blockingTime = this.playerService.getComponentBlockingTime(playerId);
          this.childComponent = this.createComponent(pixiClass, player, this.editMode, blockingTime);
          this.childComponent.display(false);
          const newLoad$ = this.childComponent.load(player).pipe(switchMap(child => {
            return child.play(false);
          }));
          retList.push(newLoad$);
          return forkJoin(retList);
        }
      }), catchError(err => {
        Log.debug();
        console.error(err);
        return of(null);
      }));
    }
    unloadComplete(child, duration) {
      if (this.playerService.stats != null && this.statEnabled) {
        if (this.displayMode == 'manual' && this.minThreshold != null && this.maxThreshold != null) {
          if (duration >= this.minThreshold) {
            child.addContent(this.statTag, this.statFiled, Math.min(duration, this.maxThreshold));
          }
        } else {
          if (this.displayMode == 'slideShow') {
            child.addContent(this.statTag, this.statFiled, duration);
          }
        }
      }
      return of(child);
    }
    display(show) {}
    loadAnimation() {}
    unload() {
      const self = this;
      if (this.childComponent == null) {
        return of(self);
      }
      return this.childComponent.unload();
    }
    createComponent(cmpClass, playerObject, editMode, blockingTime) {
      const logInfo = Log.getLogInfo("PlayerContainer", "createComponent", []);
      let childComponent;
      const useComponent = cmpClass.prototype.constructor.useComponent; // only false in case of RSS
      let gpu = false; // if it's run in studio it will always use html.
      if (this.editMode == false) {
        if (playerObject?.$?.gpu != null) {
          gpu = playerObject.$.gpu == '1';
        } else {
          gpu = cmpClass.prototype.constructor.defaultGpu;
        }
      }
      if (gpu) {
        Log.d(logInfo, LogTag.PIXI, 'create pure class: ' + cmpClass.name);
        childComponent = new cmpClass(this.injector, this.resolver);
      } else {
        Log.d(logInfo, LogTag.PIXI, 'create Angular class: ' + cmpClass.name);
        const factory = this.resolver.resolveComponentFactory(cmpClass);
        const componentRef = this.entry.createComponent(factory);
        childComponent = componentRef.instance;
        childComponent.hostView = componentRef.hostView;
      }
      childComponent.init(this, editMode, blockingTime);
      return childComponent;
    }
    removeComponent(player) {
      if (this.entry != null) {
        const i = this.entry.indexOf(player.hostView);
        if (i != -1) {
          this.entry.remove(i);
          this.changeDetectorRef?.detectChanges();
        }
      }
    }
    destroy() {
      if (this.childComponent != null) {
        console.warn("Container.destroy() childComponent ");
        this.childComponent.destroy();
        this.removeComponent(this.childComponent);
        this.childComponent = null;
      }
      this.resolver = null;
      this.entry = null;
      super.destroy();
    }
    static ɵfac = function PlayerContainer_Factory(t) {
      return new (t || PlayerContainer)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PlayerContainer,
      selectors: [["app-player-container"]],
      viewQuery: function PlayerContainer_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$l, 7, ViewContainerRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.entry = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function PlayerContainer_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return PlayerContainer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlaylistComponent = /*#__PURE__*/(() => {
  class PlaylistComponent extends PlayerContainer {
    injector;
    pages;
    index = -1;
    defaultDuration;
    duration;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap$1(playerBase => {
        self = playerBase;
        this.index = 0;
        if (this.editMode) {
          return this.showPage();
        }
        this.loadStat();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap$1(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      this.duration = 0;
      const next$ = of('next').pipe(switchMap$1(a => of('delay').pipe(delay(this.duration))), repeat());
      const loop$ = next$.pipe(switchMap$1(a => this.showPage()));
      return super.play().pipe(mergeWith(loop$));
    }
    getPage() {
      const logInfo = Log.getLogInfo("PlaylistComponent", "getPage", []);
      return new Observable(sub => {
        const data = this.playerObject.Data[0];
        this.defaultDuration = data.Playlist[0].$.duration;
        this.pages = data.Playlist[0].Page;
        if (this.pages == null || this.pages.length == 0) {
          Log.w(logInfo, LogTag.PLAYER, 'Playlist is empty');
          this.showMsg(this.playerObject.$.label, 'Playlist is empty');
          sub.next(null);
          sub.complete();
        } else {
          this.showMsg(null, null);
          const page = this.pages[this.index];
          let player = page.Player[0];
          let dur = page.$.duration;
          if (dur == null || dur == "") {
            dur = this.defaultDuration;
          }
          this.duration = Number(dur * 1000);
          this.index++;
          if (this.index >= this.pages.length) {
            this.index = 0;
          }
          sub.next(player);
          sub.complete();
        }
      });
    }
    static ɵfac = function PlaylistComponent_Factory(t) {
      return new (t || PlaylistComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PlaylistComponent,
      selectors: [["app-playlist"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function PlaylistComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return PlaylistComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$k = ["flk"];
let PlayerList = /*#__PURE__*/(() => {
  class PlayerList extends PlayerContainer {
    injector;
    refreshEnabled = false;
    refreshTime = 3600 * 1000;
    itemInterval = 10 * 1000;
    randomOrder;
    options;
    pages = [];
    page;
    lastRefresh = 0;
    index;
    invalidatePanels = true;
    flk;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getConfig() {
      return null;
    }
    getScene() {
      return null;
    }
    getPage() {
      return of(this.getScene());
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap$1(playerBase => {
        self = playerBase;
        this.scaleX = this.parentPlayer.scaleX;
        this.scaleY = this.parentPlayer.scaleY;
        this.options = {
          align: 'prev'
        };
        const config = this.getConfig();
        this.displayMode = config.displayMode != null ? config.displayMode : 'slideShow';
        this.options.horizontal = config.vertical == '0';
        this.randomOrder = config.randomOrder == '1';
        if (config.itemInterval != null && config.itemInterval != "") {
          this.itemInterval = Number(config.itemInterval) * 1000;
        }
        if (config.minRefreshTime != null && config.minRefreshTime != "") {
          this.refreshEnabled = config.refreshEnabled == '1';
          this.refreshTime = config.minRefreshTime != null ? Number(config.minRefreshTime) * 60 * 1000 : 3600 * 1000;
        }
        this.playVideoInFull = config.playVideoInFull == '1';
        if (config.volume != null) {
          this.volume = Number(config.volume);
        }
        this.loadStat();
        const src = this.getScene().$.src;
        if (src == "" || src == "-1") {
          this.showMsg(this.playerObject.$.label, 'No scene assigned');
          return of(null);
        } else {
          this.showMsg(null, null);
          if (this.editMode) {
            return this.showPage();
          }
          return of('load');
        }
      }), catchError(err => this.logError(err)), map(a => self), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      let trigger$ = super.play();
      if (this.refreshEnabled) {
        trigger$ = trigger$.pipe(mergeWith(interval(this.refreshTime)));
      }
      return trigger$.pipe(switchMap$1(r1 => {
        this.componentStatus('loading');
        return this.loadProviderData();
      }), catchError(err => of(null)),
      // fail to load url
      switchMap$1(value => {
        debugger;
        if (value == null) {
          this.componentStatus('error');
          return of(null);
        }
        this.componentStatus('ready');
        return this.shuffleList(value).pipe(switchMap$1(value => {
          this.providerData = value;
          if (this.displayMode == 'list') {
            return this.showList();
          } else if (this.displayMode == 'slideShow') {
            this.index = -1;
            return this.slideShow();
          } else {
            this.index = 0;
            return this.manual();
          }
        }));
      }));
    }
    shuffleList(list) {
      this.lastRefresh = new Date().getTime();
      if (this.randomOrder) {
        let shuffled = list.map(value => ({
          value,
          sort: Math.random()
        })).sort((a, b) => a.sort - b.sort).map(({
          value
        }) => value);
        return of(shuffled);
      } else {
        return of(list);
      }
    }
    showList() {
      this.pages = [];
      let index = 0;
      if (this.providerData == null) {
        return of(null);
      }
      this.providerData.forEach(item => {
        const pg = {
          Player: [this.getScene()],
          childProviderData: this.providerData[index++]
        };
        this.pages.push(pg);
      });
      this.changeDetectorRef.detectChanges();
      const list = [];
      this.pages.forEach(page => {
        list.push(page.$obs);
      });
      return forkJoin(list);
    }
    slideShow() {
      return of('loop').pipe(switchMap$1(a => {
        this.index = this.index < this.providerData.length - 1 ? this.index + 1 : 0;
        this.childProviderData = this.providerData[this.index];
        const interval$ = of('interval').pipe(delay(this.itemInterval));
        const showPage$ = this.showPage();
        return forkJoin(interval$, showPage$);
      }), repeat());
    }
    manual() {
      this.childProviderData = this.providerData[this.index];
      return this.showPage();
    }
    loadProviderData() {
      return of(null);
    }
    updatePanels() {
      if (this.invalidatePanels) {
        this.invalidatePanels = false;
        this.flk.moveTo(0).catch(err => {
          if (err instanceof FlickingError) return;
          throw err;
        });
      }
      this.flk.resize();
    }
    onCommand(command, param) {
      const cmd = command.$.command;
      const length = this.providerData != null ? this.providerData.length : 0;
      switch (cmd) {
        case 'firstPage':
          if (length > 0) {
            if (this.displayMode == 'list') {
              this.flk.moveTo(0).catch(err => {
                if (err instanceof FlickingError) return;
                throw err;
              });
              return of(null);
            } else {
              this.index = 0;
              this.childProviderData = this.providerData[this.index];
              return this.showPage();
            }
          } else {
            return of(null);
          }
        case 'prevPage':
          if (length > 0) {
            if (this.displayMode == 'list') {
              this.flk.prev().catch(err => {
                if (err instanceof FlickingError) return;
                throw err;
              });
              return of(null);
            } else {
              this.index = this.index > 0 ? this.index - 1 : length - 1;
              this.childProviderData = this.providerData[this.index];
              return this.showPage();
            }
          } else {
            return of(null);
          }
        case 'nextPage':
          if (length > 0) {
            if (this.displayMode == 'list') {
              this.flk.next().catch(err => {
                if (err instanceof FlickingError) return;
                throw err;
              });
              return of(null);
            } else {
              this.index = this.index < length - 1 ? this.index + 1 : 0;
              this.childProviderData = this.providerData[this.index];
              return this.showPage();
            }
          } else {
            return of(null);
          }
        case 'lastPage':
          if (length > 0) {
            if (this.displayMode == 'list') {
              this.flk.moveTo(length - 1).catch(err => {
                if (err instanceof FlickingError) return;
                throw err;
              });
              return of(null);
            } else {
              this.index = length - 1;
              this.childProviderData = this.providerData[this.index];
              return this.showPage();
            }
          } else {
            return of(null);
          }
        case 'filter':
          return of(null);
        //???
        case 'load':
          return this.loadProviderData();
        case 'save':
          const data = this.playerObject.Data[0];
          return this.playerService.saveDataProvider(data.DataProvider[0].$.eventName, this.providerData, false);
      }
      return of(null);
    }
    static ɵfac = function PlayerList_Factory(t) {
      return new (t || PlayerList)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PlayerList,
      selectors: [["app-player-list"]],
      viewQuery: function PlayerList_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$k, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.flk = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function PlayerList_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return PlayerList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DS_API_URL = 'https://secure.digitalsignage.com/';
function JsonListComponent_app_flicking_item_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flicking-item", 5);
  }
  if (rf & 2) {
    const page_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setParentPlayer", ctx_r1)("setEditMode", ctx_r1.editMode)("setPage", page_r1);
  }
}
let JsonListComponent = /*#__PURE__*/(() => {
  class JsonListComponent extends PlayerList {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getConfig() {
      const data = this.playerObject.Data[0];
      return data.Json[0].$;
    }
    getScene() {
      const data = this.playerObject.Data[0];
      return data.Json[0].Player[0];
    }
    token;
    loadProviderData() {
      const data = this.playerObject.Data[0];
      let source;
      const metadata = data.DataProvider[0].$.metadata;
      if (metadata != null && metadata != '') {
        source = 'external';
      } else {
        source = data.DataProvider[0].$.source;
      }
      let folder;
      if (source == 'ai') {
        let prompt;
        if (data.DataProvider[0].Ai?.[0].Prompt != null) {
          prompt = data.DataProvider[0].Ai[0].Prompt[0];
        } else {
          // deprecated Interface Description
          prompt = data.DataProvider[0].Ai[0].Description[0];
        }
        const language = data.DataProvider[0]?.Ai?.[0]?.$?.language || 'en';
        // Build Fields object from DataProvider.Ai.Fields
        const fields = {};
        const aiFields = data.DataProvider[0]?.Ai?.[0]?.Fields?.[0]?.Field;
        if (aiFields && aiFields.length > 0) {
          // Read fields from DataProvider
          aiFields.forEach(field => {
            const fieldName = field.$.name;
            const fieldDescription = field.$.description;
            fields[fieldName] = fieldDescription;
          });
        }
        const body = {
          dataType: 'text',
          Prompt: decodeURIComponent(prompt || ''),
          Language: language,
          Series: '',
          Fields: fields
        };
        debugger;
        const port = this.playerService.isDevOrLocal() ? ":9443" : "";
        let url = "https://ai.signage.me" + port + "/feed/request";
        // post with body - cache for 1 hour (3600000ms)
        return this.playerService.caching.postJson(url, body, 'ai-feed', 3600000).pipe(switchMap(result => {
          console.log('AI Response:', result);
          return of(result.items);
        }), catchError(err => {
          console.error('RSS AI Error:', err);
          return of(null);
        }));
      } else if (source == 'cloud') {
        folder = 'eventparams';
      } else if (source == 'external') {
        let key;
        let user;
        folder = metadata;
        switch (metadata) {
          case 'pinterest.board':
            key = data.Json[0].Data[0].$.key;
            const board = data.Json[0].Data[0].$.board;
            this.url = DS_API_URL + "PinterestBoardPins/" + key + "/" + board;
            break;
          case 'pinterest.user':
            key = data.Json[0].Data[0].$.key;
            this.url = DS_API_URL + "PinterestUserPins/" + key;
            break;
          case 'drive':
            this.token = data.Json[0].Data[0].$.token;
            const id = data.Json[0].Data[0].$.id;
            this.url = DS_API_URL + "GoogleDriveFolderFiles" + "/" + this.token + "/" + id;
            break;
          case 'dropbox':
            this.token = data.Json[0].Data[0].$.token;
            const path = data.Json[0].Data[0].$.path;
            this.url = DS_API_URL + "DropboxFiles/" + this.token + "/" + path;
            break;
          case "tumblr.posts":
            this.token = data.Json[0].Data[0].$.token;
            user = data.Json[0].Data[0].$.user;
            this.url = DS_API_URL + "TumblrAllPosts/" + this.token + "/" + user;
            break;
          case "tumblr.videos":
            this.token = data.Json[0].Data[0].$.token;
            user = data.Json[0].Data[0].$.user;
            this.url = DS_API_URL + "TumblrAllVideos/" + this.token + "/" + user;
            break;
          case "tumblr.texts":
            this.token = data.Json[0].Data[0].$.token;
            user = data.Json[0].Data[0].$.user;
            this.url = DS_API_URL + "TumblrAllText/" + this.token + "/" + user;
            break;
          case "tumblr.photos":
            this.token = data.Json[0].Data[0].$.token;
            user = data.Json[0].Data[0].$.user;
            this.url = DS_API_URL + "TumblrAllPhotos/" + this.token + "/" + user;
            break;
          case "facebook.wall":
            this.token = data.Json[0].Data[0].$.token;
            this.url = DS_API_URL + "facebook/getWall/" + this.token;
            break;
          case "facebook.album":
            this.token = data.Json[0].Data[0].$.token;
            const albumId = data.Json[0].Data[0].$.id;
            this.url = DS_API_URL + "facebook/getPhotosOfAlbums/" + this.token + "/" + albumId;
            break;
          case "facebook.videos":
            this.token = data.Json[0].Data[0].$.token;
            this.url = DS_API_URL + "facebook/getVideos/" + this.token;
            break;
          case "500px.user":
            this.token = data.Json[0].Data[0].$.token;
            user = data.Json[0].Data[0].$.user;
            this.url = DS_API_URL + "500pxPhotos/" + this.token + "/" + user + "/2048";
            break;
          case "twitter":
            this.token = data.Json[0].Data[0].$.token;
            let screenName = data.Json[0].Data[0].$.screenName;
            if (screenName == null) {
              screenName = "";
            }
            this.url = DS_API_URL + "TwitterHome/" + this.token + "/" + screenName;
            break;
          case "instagram.feed":
            this.token = data.Json[0].Data[0].$.token;
            this.url = DS_API_URL + "InstagramFeed/" + this.token;
            break;
          case "calendar":
            let d1 = new Date();
            let d2 = new Date();
            if (data.Json[0].Data[0].$.mode == "fixed") {
              d1 = new Date(Number(data.Json[0].Data[0].$.startDate) + d1.getTimezoneOffset() * 60000);
              d2 = new Date(Number(data.Json[0].Data[0].$.endDate) + d2.getTimezoneOffset() * 60000 + 1000 * 60 * 60 * 24);
            } else {
              let before = Number(data.Json[0].Data[0].$.before);
              let after = Number(data.Json[0].Data[0].$.after) + 1;
              d1 = new Date(Date.UTC(d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate()) + d1.getTimezoneOffset() * 60000 - before * 1000 * 60 * 60 * 24);
              d2 = new Date(Date.UTC(d2.getUTCFullYear(), d2.getUTCMonth(), d2.getUTCDate()) + d2.getTimezoneOffset() * 60000 + after * 1000 * 60 * 60 * 24);
            }
            this.url = DS_API_URL + "GoogleCalendarEvents/" + data.Json[0].Data[0].$.token + "/" + data.Json[0].Data[0].$.id + "/" + d1.getUTCFullYear() + "-" + (d1.getUTCMonth() + 1).toString() + "-" + d1.getUTCDate().toString() + "T" + d1.getUTCHours() + ":" + d1.getUTCMinutes() + ":" + d1.getUTCSeconds() + "Z" + "/" + d2.getUTCFullYear() + "-" + (d2.getUTCMonth() + 1).toString() + "-" + d2.getUTCDate().toString() + "T" + d2.getUTCHours() + ":" + d2.getUTCMinutes() + ":" + d2.getUTCSeconds() + "Z";
            break;
          case "spreadsheet":
            this.token = data.Json[0].Data[0].$.token;
            const sheetId = data.Json[0].Data[0].$.id;
            this.url = DS_API_URL + "GoogleSheetsValues/" + this.token + "/" + sheetId + "/0/";
            break;
          case "instagram.media":
            this.token = data.Json[0].Data[0].$.token;
            this.url = DS_API_URL + "InstagramFeed/" + this.token + "/";
            break;
          default:
            folder = "urls";
            this.url = this.getUrl();
            break;
        }
      }
      const pd = data.DataProvider[0].$;
      return this.playerService.loadProviderData(pd.eventName, source, this.url, folder);
    }
    getUrl() {
      const logInfo = Log.getLogInfo("JsonListComponent", "getUrl", []);
      const data = this.playerObject.Data[0];
      let url = data.DataProvider[0].$.url;
      if (url == null) {
        Log.w(logInfo, LogTag.PLAYER, "url is null");
        return of(null);
      }
      let i1 = 0;
      while (true) {
        i1 = url.indexOf('$[', i1);
        if (i1 == -1) {
          break;
        }
        let i2 = url.indexOf(']', i1);
        if (i2 == -1) {
          break;
        }
        const name = url.substring(i1 + 2, i2);
        let value = this.playerService.eventParams.getParam(name);
        url = url.substring(0, i1) + value + url.substring(i2 + 1);
        i1 = i2;
      }
      return url;
    }
    static ɵfac = function JsonListComponent_Factory(t) {
      return new (t || JsonListComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JsonListComponent,
      selectors: [["app-json-list"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 2,
      consts: [["component", ""], ["playercontainer", ""], ["flk", ""], [3, "options"], ["flicking-panel", "", "class", "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage", 4, "ngFor", "ngForOf"], ["flicking-panel", "", 1, "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage"]],
      template: function JsonListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementStart(4, "ngx-flicking", 3, 2);
          i0.ɵɵtemplate(6, JsonListComponent_app_flicking_item_6_Template, 1, 3, "app-flicking-item", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("options", ctx.options);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return JsonListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Expiration = /*#__PURE__*/(() => {
  class Expiration {
    static Never = -1;
    static Now = 0;
    static Minute = 60000;
    static Hour = 3600000;
    static Day = 86400000;
    static Week = 604800000;
  }
  return Expiration;
})();
let ItemComponent = /*#__PURE__*/(() => {
  class ItemComponent extends PlayerBase {
    injector;
    renderer;
    genericElm;
    fieldType;
    aspectRatio = false;
    folder;
    metadata;
    dateFormat;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.renderer = injector.get(Renderer2);
    }
    invalidateData(providerData, playVideoInFull) {
      this.providerData = providerData;
      this.genericElm.clear();
      if (providerData == null) {
        if (this.editMode) {
          if (this.fieldType === 'text' || this.fieldType === 'date') {
            this.genericElm.setText('TEXT', false);
          } else {
            this.genericElm.setEmptyIcon(this.renderer);
          }
        }
        return of(null);
      } else {
        const ar = this.fieldName.split('.');
        let value = providerData;
        try {
          ar.forEach(item => {
            value = value[item];
          });
          if (value == null) {
            value = "";
          }
        } catch (e) {
          value = "";
        }
        switch (this.fieldType) {
          case 'text':
            return this.invalidateText(value);
          case 'date':
            return this.invalidateDate(value);
          case 'resource':
            return this.invalidateResource(value);
          case 'html':
            return this.invalidateHtml(value, true);
          case 'object':
            return this.invalidateObject(value);
        }
      }
      return of('invalidate');
    }
    invalidateText(value) {
      this.genericElm.setText(value);
      return of('text');
    }
    invalidateResource(value) {
      let obs$ = null;
      value = String(value);
      if (value.length > 10 && value.substring(0, 10) == '$resource.') {
        const resourceId = value.substring(10);
        obs$ = this.playerService.caching.getResource(resourceId);
      } else {
        if (this.parentPlayer?.parentPlayer != null) {
          const url = this.parentPlayer.parentPlayer.getItemUrl(value);
          if (url == null || value == "") {
            return of('empty');
          }
          obs$ = this.playerService.caching.requestUrl(url, this.folder, Expiration.Never);
        } else {
          return of(null);
        }
      }
      return obs$.pipe(switchMap(path => {
        let volume = 1.0;
        if (this.parentPlayer?.parentPlayer != null) {
          volume = this.parentPlayer.parentPlayer.volume;
        }
        return this.genericElm.setMedia(path, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume);
      }), catchError(e => {
        debugger;
        return this.invalidateHtml(value, false);
      }) // some url have CORS issue
      );
    }
    invalidateDate(value) {
      const date = new Date(value);
      const str = DateUtils.showDate(date, this.dateFormat);
      this.genericElm.setText(str);
      return of('text');
    }
    invalidateHtml(value, scrollbars) {
      return this.genericElm.setHtml(value, scrollbars);
    }
    invalidateObject(value) {
      return of(null);
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      let playVideoInFull = false;
      if (this.parentPlayer?.parentPlayer != null) {
        playVideoInFull = this.parentPlayer.parentPlayer.playVideoInFull;
      }
      return super.play().pipe(switchMap(a => {
        if (this.genericElm != null) {
          return this.genericElm.play(playVideoInFull);
        } else {
          return of('play');
        }
      }));
    }
    destroy() {
      if (this.genericElm != null) {
        this.genericElm.destroy();
        this.genericElm = null;
      }
      super.destroy();
    }
    static ɵfac = function ItemComponent_Factory(t) {
      return new (t || ItemComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ItemComponent,
      selectors: [["app-item"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function ItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return ItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let JsonItemComponent = /*#__PURE__*/(() => {
  class JsonItemComponent extends ItemComponent {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.folder = 'json';
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.fieldType = data.XmlItem[0].$.fieldType;
        this.fieldName = data.XmlItem[0].$.fieldName;
        this.aspectRatio = data.XmlItem[0]?.$.maintainAspectRatio == "1";
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        //???
        if (this.parentPlayer.parentPlayer != null && this.parentPlayer.parentPlayer.playerObject.Data[0].DataProvider != null) {
          this.metadata = this.parentPlayer.parentPlayer.playerObject.Data[0].DataProvider[0].$.metadata;
        }
        if (this.metadata == "500px.user" && this.fieldName == "image_url") {
          this.fieldName = "image_url[0]";
        }
        this.fieldName = this.fieldName.replace(/\[/g, '.');
        this.fieldName = this.fieldName.replace(/\]/g, '');
        if (this.fieldName[0] == '$') {
          this.fieldName = this.fieldName.substring(this.fieldName[1] == '[' ? 2 : 1);
          this.fieldName = this.fieldName.replace(/\[/g, '.');
          this.fieldName = this.fieldName.replace(/\]/g, '');
        }
        if (this.fieldName[0] == '.') {
          this.fieldName = this.fieldName.substring(1);
        }
        if (this.fieldType === 'text' || this.fieldType == 'date') {
          if (this.parentPlayer.parentPlayer != null) {
            const unit = this.parentPlayer.parentPlayer.unit; //???
            if (unit != null) {
              this.fieldName = this.fieldName.replace(/@/g, unit);
            }
          }
          if (this.fieldType == 'date') {
            this.dateFormat = data.XmlItem[0].$.dateFormat;
          }
          const font = data.XmlItem[0].Font[0].$;
          this.genericElm.fontStyle = this.getFontStyle(font);
          return this.playerService.caching.requestFont(font);
        } else {
          return of(null);
        }
      }), switchMap(r => {
        let childProviderData;
        let playVideoInFull = false;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData, playVideoInFull); //???
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateObject(value) {
      let id;
      let ext;
      const token = this.parentPlayer.parentPlayer.token;
      let volume = 1.0;
      if (this.parentPlayer?.parentPlayer != null) {
        volume = this.parentPlayer.parentPlayer.volume;
      }
      if (this.metadata == 'drive') {
        id = value;
        ext = this.providerData['fileExtension'];
        console.log('id=' + id);
        return this.playerService.caching.getDriveUrl(token, id, Expiration.Minute).pipe(switchMap(url => {
          return this.genericElm.setMedia(url, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume, ext);
        }), catchError(e => {
          console.log('error=');
          return of(null);
        }));
      } else {
        // dropbox
        id = value;
        ext = value.substring(value.lastIndexOf('.') + 1);
        return this.playerService.caching.getDropboxUrl(token, id, Expiration.Minute).pipe(switchMap(url => {
          return this.genericElm.setMedia(url, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume, ext);
        }));
      }
    }
    static ɵfac = function JsonItemComponent_Factory(t) {
      return new (t || JsonItemComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JsonItemComponent,
      selectors: [["app-json-item"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function JsonItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return JsonItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let JsonViewerComponent = /*#__PURE__*/(() => {
  class JsonViewerComponent extends PlayerContainer {
    injector;
    httpClient;
    unit;
    refreshEnabled = false;
    refreshTime = 3600 * 1000;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.httpClient = injector.get(HttpClient);
      this.displayMode = 'manual';
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const providerType = data.Json[0].$?.providerType;
        if (data.Json[0].$.minRefreshTime != null && data.Json[0].$.minRefreshTime != "") {
          this.refreshEnabled = data.Json[0].$.refreshEnabled == "1";
          this.refreshTime = Number(data.Json[0].$.minRefreshTime) * 60 * 1000;
        }
        if (data.Json[0].$.volume != null) {
          this.volume = Number(data.Json[0].$.volume);
        }
        if (providerType == 'weather') {
          this.unit = data.Json[0].Data[0].$.unit;
          this.refreshEnabled = true;
        }
        //const src = (<IPlayerJsonViewer>(data.Json[0].Player[0])).$.src; //???
        const src = data.Json[0].Player[0].$.src; //???
        if (src == "" || src == "-1") {
          this.showMsg(this.playerObject.$.label, 'No scene assigned');
          return of(null);
        } else {
          this.showMsg(null, null);
          if (this.editMode) {
            return this.showPage();
          }
          this.loadStat();
          return of('a');
        }
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      let trigger$ = super.play();
      if (this.refreshEnabled) {
        trigger$ = trigger$.pipe(mergeWith(interval(this.refreshTime)));
      }
      return trigger$.pipe(switchMap(r1 => this.loadProviderData()), catchError(err => of(null)),
      // fail to load url
      switchMap(value => this.invalidateData(value)));
    }
    invalidateData(providerData) {
      if (providerData == null) {
        return of(null);
      }
      this.providerData = providerData;
      this.childProviderData = this.providerData;
      return this.showPage();
    }
    getPage() {
      return new Observable(sub => {
        const data = this.playerObject.Data[0];
        const player = data.Json[0].Player[0];
        sub.next(player);
        sub.complete();
      });
    }
    loadProviderData() {
      const data = this.playerObject.Data[0];
      const source = data.DataProvider[0].$.source;
      let folder = 'rss';
      if (data == null) {
        return of(null);
      }
      if (this.playerObject.$.player === '6010') {
        const address = data.Json[0].Data[0].$.address;
        const style = data.Json[0].Data[0].$.style;
        this.url = data.DataProvider[0].$.url;
        this.url += '/' + address + '/' + style;
        data.DataProvider[0].$.source = 'external'; // fix studio save
      } else if (this.playerObject.$.player === '6022') {
        this.url = DS_API_URL + "GoogleSheetsValues/" + data.Json[0].Data[0].$.token + "/" + data.Json[0].Data[0].$.id + "/0/";
      } else {
        if (source == 'cloud') {
          folder = 'eventparams';
        } else if (source == 'external') {
          const metadata = data.DataProvider[0].$.metadata;
          folder = metadata;
          this.url = data.DataProvider[0].$.url;
        }
      }
      const pd = data.DataProvider[0].$;
      return this.playerService.loadProviderData(pd.eventName, pd.source, this.url, folder);
    }
    onCommand(command, param) {
      const data = this.playerObject.Data[0];
      const cmd = command.$.command;
      switch (cmd) {
        case 'load':
          return this.loadProviderData().pipe(catchError(err => of(null)),
          // fail to load url
          switchMap(value => this.invalidateData(value)));
        case 'update':
          if (param == "") {
            return of(null);
          }
          return this.invalidateData(param);
        case 'save':
          if (this.playerService.stationId != -1) {
            const broadcast = command.Params[0].Param[0].$.broadcast == "1";
            return this.playerService.saveDataProvider(data.DataProvider[0].$.eventName, this.providerData, broadcast);
          } else {
            alert("For security reasons, saving is only permitted within the deployed SignPlayer");
          }
          break;
      }
      return of(null);
    }
    static ɵfac = function JsonViewerComponent_Factory(t) {
      return new (t || JsonViewerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JsonViewerComponent,
      selectors: [["app-json-viewer"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function JsonViewerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return JsonViewerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$j = ["inp"];
let TextInputComponent = /*#__PURE__*/(() => {
  class TextInputComponent extends PlayerBase {
    injector;
    inp;
    fontSize;
    color;
    bgColor;
    fontFamily;
    text;
    sprite;
    fontStyle;
    //
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const font = data.TextInput[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    onFocusIn() {
      this.component.nativeElement.style.borderBottomColor = '#000000';
      this.component.nativeElement.style.borderRightColor = '#000000';
    }
    onFocusOut() {
      this.component.nativeElement.style.borderBottomColor = '#7b7b7b';
      this.component.nativeElement.style.borderRightColor = '#7b7b7b';
    }
    createBackgroundAction() {
      const data = this.playerObject.Data[0];
      const color = Number(data.Background[0].$.color);
      const r = color & 0xff;
      const g = color >> 8 & 0xff;
      const b = color >> 16 & 0xff;
      const alpha = Number(data.Background[0].$.alpha);
      this.bgColor = 'rgba(' + b + ',' + g + ',' + r + ',' + alpha + ')';
    }
    clearEffects() {
      super.clearEffects();
      this.bgColor = '';
    }
    invalidateData(providerData) {
      this.providerData = providerData;
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        let value = this.providerData[data.TextInput[0].$.fieldName];
        if (value == null) {
          value = this.providerData[data.TextInput[0].$.fieldName] = data.TextInput[0].$.defaultValue;
        }
        this.text = value;
      } else {
        if (this.editMode) {
          this.text = "INPUT";
        }
      }
      this.changeDetectorRef.detectChanges();
      return of(null);
    }
    changeValue(event) {
      if (this.providerData != null) {
        this.text = event.target.innerText;
        const data = this.playerObject.Data[0];
        const fieldName = data.TextInput[0].$.fieldName;
        this.providerData[fieldName] = this.text;
        this.onClick(null);
      }
    }
    static ɵfac = function TextInputComponent_Factory(t) {
      return new (t || TextInputComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: TextInputComponent,
      selectors: [["app-text-input"]],
      viewQuery: function TextInputComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$j, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inp = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 6,
      vars: 13,
      consts: [["component", ""], ["inp", ""], [2, "border", "2px solid black", "border-radius", "4px", "overflow", "hidden", "border-bottom-color", "#7b7b7b", "border-right-color", "#7b7b7b"], [2, "width", "100%", "height", "100%", "display", "grid"], ["contentEditable", "true", 3, "focusin", "focusout", "input"]],
      template: function TextInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2, 0)(2, "div", 3)(3, "div", 4, 1);
          i0.ɵɵlistener("focusin", function TextInputComponent_Template_div_focusin_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFocusIn());
          })("focusout", function TextInputComponent_Template_div_focusout_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFocusOut());
          })("input", function TextInputComponent_Template_div_input_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changeValue($event));
          });
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("background-color", ctx.bgColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleMapInterpolate2("text-align:", ctx.fontStyle == null ? null : ctx.fontStyle.align, "; alignSelf: ", ctx.fontStyle == null ? null : ctx.fontStyle.alignSelf, "; margin: 0px; lineHeight: 1; background: none; outline: none; border: none; overflow: hidden; caretColor: white; userSelect: none; resize: none; whiteSpace: pre-wrap");
          i0.ɵɵstyleProp("font-size", ctx.fontSize)("color", ctx.color)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.text);
        }
      },
      encapsulation: 2
    });
  }
  return TextInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$i = ["txt"];
const _c1$b = ["checkbox"];
let CheckboxComponent = /*#__PURE__*/(() => {
  class CheckboxComponent extends PlayerBase {
    injector;
    txt;
    checkbox;
    label;
    fontSize;
    color;
    fontFamily;
    fontStyle;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const check = data.Check[0];
        const font = check.Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        const k = 0.04;
        const w = 20;
        const scale = k * this.fontStyle.fontSize;
        this.txt.nativeElement.style.paddingTop = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingBottom = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingRight = 0.3 * w * scale + 'px';
        const el1 = this.checkbox._elementRef.nativeElement.children[0].children[0];
        el1.style.transform = 'scale(' + scale + ')';
        el1.style.marginLeft = -w + w * scale + 'px';
        el1.style.marginRight = -w + w * scale + 'px';
        const data = this.playerObject.Data[0];
        const check = data.Check[0];
        this.label = check.$.label;
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateData(providerData) {
      this.providerData = providerData;
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        let value = this.providerData[data.Check[0].$.fieldName];
        if (value == null) {
          value = this.providerData[data.Check[0].$.fieldName] = data.Check[0].$.defaultValue == "true";
        }
        this.checkbox.checked = value;
      }
      this.changeDetectorRef.detectChanges();
      return of('a');
    }
    changeValue() {
      if (this.providerData != null) {
        const value = this.checkbox.checked;
        const data = this.playerObject.Data[0];
        const fieldName = data.Check[0].$.fieldName;
        this.providerData[fieldName] = value;
        this.onClick(null);
      }
    }
    static ɵfac = function CheckboxComponent_Factory(t) {
      return new (t || CheckboxComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CheckboxComponent,
      selectors: [["app-checkbox"]],
      viewQuery: function CheckboxComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$i, 7);
          i0.ɵɵviewQuery(_c1$b, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txt = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 17,
      consts: [["component", ""], ["txt", ""], ["checkbox", ""], [2, "width", "100%", "height", "100%", "display", "grid"], [3, "change"]],
      template: function CheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", null, 0)(2, "div", 3)(3, "div")(4, "div", null, 1)(6, "mat-checkbox", 4, 2);
          i0.ɵɵlistener("change", function CheckboxComponent_Template_mat_checkbox_change_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changeValue());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵstyleMapInterpolate2("text-align:", ctx.fontStyle.align, "; alignSelf:", ctx.fontStyle.alignSelf, ";");
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("color", ctx.color)("font-size", ctx.fontSize)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("font-size", ctx.fontSize)("color", ctx.color)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        }
      },
      dependencies: [i4.MatCheckbox],
      encapsulation: 2
    });
  }
  return CheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CollectionComponent = /*#__PURE__*/(() => {
  class CollectionComponent extends PlayerContainer {
    injector;
    pages;
    index;
    onIdle;
    useHotkeys;
    idleDuration;
    pageChange$ = new Subject();
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.pages = data.Collection[0].Page;
        this.index = 0;
        if (this.editMode) {
          if (this.pages && this.pages.length > 0) {
            return this.showPage();
          } else {
            this.showMsg(playerObject.$.label, this.PREVIEW);
          }
          return of(null);
        }
        this.onIdle = data.Collection[0].$.onIdle === '1';
        this.useHotkeys = data.Collection[0].$.useHotkeys === '1';
        this.idleDuration = Number(data.Collection[0].$.idleDuration || 60) * 1000; // Convert to milliseconds
        this.loadStat();
        // Auto select first page if there are pages
        if (this.pages && this.pages.length > 0) {
          return this.showPage();
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      const streams = [super.play()];
      // Hotkeys stream
      if (this.useHotkeys && this.pages?.length > 0) {
        const hotkeys$ = fromEvent(document, 'keydown').pipe(map(event => {
          let handled = false;
          switch (event.key) {
            case 'ArrowRight':
            case 'PageDown':
            case 'Enter':
            case ' ':
              this.index++;
              if (this.index >= this.pages.length) {
                this.index = 0;
              }
              handled = true;
              break;
            case 'ArrowLeft':
            case 'PageUp':
            case 'Backspace':
              this.index--;
              if (this.index < 0) {
                this.index = this.pages.length - 1;
              }
              handled = true;
              break;
            case 'Home':
              this.index = 0;
              handled = true;
              break;
            case 'End':
              this.index = this.pages.length - 1;
              handled = true;
              break;
          }
          if (handled) {
            event.preventDefault();
          }
          return handled;
        }), tap$1(handled => {
          if (handled) {
            this.pageChange$.next();
          }
        }), switchMap(handled => handled ? this.showPage() : of(null)), takeUntil(this.finish$));
        streams.push(hotkeys$);
      }
      // Idle detection stream
      if (this.onIdle && this.pages?.length > 0) {
        const userActivity$ = merge(fromEvent(document, 'mousemove'), fromEvent(document, 'mousedown'), fromEvent(document, 'keydown'), fromEvent(document, 'touchstart'), fromEvent(document, 'scroll'), this.pageChange$);
        const idle$ = userActivity$.pipe(switchMap(() => timer(this.idleDuration).pipe(tap$1(() => {
          if (this.index !== 0) {
            this.index = 0;
          }
        }), switchMap(() => this.showPage()))), takeUntil(this.finish$));
        streams.push(idle$);
      }
      return merge(...streams);
    }
    getPage() {
      const data = this.playerObject.Data[0];
      if (data == null) {
        return of(null);
      }
      if (this.pages == null || this.pages.length == 0) {
        return of(null);
      }
      const page = this.pages[this.index];
      let player = page.Player[0];
      return of(player);
    }
    onCommand(command, param) {
      if (this.pages.length == 0) {
        return of(null);
      }
      let pageName;
      let index;
      const cmd = command.$.command;
      switch (cmd) {
        case 'command':
          // ???  test only, to be deleted
          this.index++;
          if (this.index >= this.pages.length) {
            this.index = 0;
          }
          break;
        case 'firstPage':
          this.index = 0;
          break;
        case 'prevPage':
          this.index--;
          if (this.index < 0) {
            this.index = this.pages.length - 1;
          }
          break;
        case 'nextPage':
          this.index++;
          if (this.index >= this.pages.length) {
            this.index = 0;
          }
          break;
        case 'lastPage':
          this.index = this.pages.length - 1;
          break;
        case 'selectPage':
          pageName = command.Params[0].Page[0].$.name;
          index = 0;
          this.pages.forEach(page => {
            if (page.$.page == pageName) {
              this.index = index;
            }
            index++;
          });
          break;
        case 'paramPage':
          pageName = param;
          if (pageName == null) return;
          index = 0;
          this.pages.forEach(page => {
            if (page.$.page == pageName) {
              this.index = index;
            }
            index++;
          });
          break;
        default:
          alert(cmd);
          break;
      }
      return this.showPage();
    }
    destroy() {
      this.pageChange$.complete();
      super.destroy();
    }
    static ɵfac = function CollectionComponent_Factory(t) {
      return new (t || CollectionComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CollectionComponent,
      selectors: [["app-collection"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function CollectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return CollectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$h = ["myInput"];
let NumericStepperComponent = /*#__PURE__*/(() => {
  class NumericStepperComponent extends PlayerBase {
    injector;
    input;
    fontStyle;
    fontSize;
    color;
    bgColor = 'blue';
    fontFamily;
    num;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const stepper = data.Stepper[0];
        this.input.nativeElement.min = Number(stepper.$.minimum);
        this.input.nativeElement.max = Number(stepper.$.maximum);
        this.input.nativeElement.step = Number(stepper.$.step);
        const font = stepper.Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateData(providerData) {
      this.providerData = providerData;
      const data = this.playerObject.Data[0];
      if (this.providerData != null) {
        let value = this.providerData[data.Stepper[0].$.fieldName];
        if (value == null) {
          value = this.providerData[data.Stepper[0].$.fieldName] = Number(data.Stepper[0].$.defaultValue);
        }
        this.num = Number(value);
      } else {
        this.num = Number(data.Stepper[0].$.defaultValue);
      }
      this.validate();
      this.changeDetectorRef.detectChanges();
      return of(null);
    }
    changeValue(event) {
      this.num = Number(event.target.value);
      this.validate();
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        const fieldName = data.Stepper[0].$.fieldName;
        this.providerData[fieldName] = Number(this.num);
        this.onClick(null);
      }
    }
    validate() {
      const step = Number(this.input.nativeElement.step);
      const min = Number(this.input.nativeElement.min);
      let n = this.num - min;
      n = Math.floor(n / step) * step;
      this.num = min + n;
      this.num = Math.max(this.num, min);
      let max = Number(this.input.nativeElement.max) - min;
      max = Math.floor(max / step) * step;
      max += min;
      this.num = Math.min(this.num, max);
      this.input.nativeElement.value = this.num;
      this.changeDetectorRef.detectChanges();
    }
    static ɵfac = function NumericStepperComponent_Factory(t) {
      return new (t || NumericStepperComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: NumericStepperComponent,
      selectors: [["app-numeric-stepper"]],
      viewQuery: function NumericStepperComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$h, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 10,
      consts: [["component", ""], ["myInput", ""], [2, "width", "100%", "height", "100%", "display", "grid"], ["mdInput", "", "type", "number", 3, "change", "value"]],
      template: function NumericStepperComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", null, 0)(2, "div", 2)(3, "input", 3, 1);
          i0.ɵɵlistener("change", function NumericStepperComponent_Template_input_change_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changeValue($event));
          });
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵstyleMapInterpolate1("background: none; text-align:", ctx.fontStyle == null ? null : ctx.fontStyle.align, ";");
          i0.ɵɵstyleProp("font-size", ctx.fontSize)("color", ctx.color)("font-family", ctx.fontFamily);
          i0.ɵɵpropertyInterpolate("value", ctx.num);
        }
      },
      encapsulation: 2
    });
  }
  return NumericStepperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CountdownComponent = /*#__PURE__*/(() => {
  class CountdownComponent extends PlayerBase {
    injector;
    genericElm;
    mode;
    formatText;
    finalDate;
    duration;
    playTime;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        const font = data.Countdown[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        this.formatText = data.Countdown[0].$.formatText;
        this.mode = data.Countdown[0].$.mode;
        this.finalDate = new Date();
        const time = Number(data.Countdown[0].$.finalDate);
        if (this.mode == "Date") {
          this.finalDate.setTime(time);
        } else {
          this.duration = Number(data.Countdown[0].$.duration);
          this.playTime = new Date().getTime();
        }
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        if (this.editMode) {
          this.genericElm.setText(this.formatText);
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        return of(null);
      }
      return super.play().pipe(mergeWith(of('clock').pipe(switchMap(a => this.showTime()), delay(1000), repeat())));
    }
    showTime() {
      let time = 0;
      if (this.mode == "Date") {
        let date = new Date();
        time = Math.max(0, (this.finalDate.getTime() - date.getTime()) / 1000);
      } else {
        const running = (new Date().getTime() - this.playTime) / 1000;
        time = Math.max(0, this.duration - running);
      }
      let seconds = Math.floor(time % 60);
      time /= 60;
      let minuts = Math.floor(time % 60);
      time /= 60;
      let hours = Math.floor(time % 24);
      let days = Math.floor(time / 24);
      let str = this.formatText;
      str = str.replace(/%D/g, days.toString());
      str = str.replace(/%H/g, hours.toString());
      str = str.replace(/%M/g, (minuts < 10 ? "0" : "") + minuts.toString());
      str = str.replace(/%S/g, (seconds < 10 ? "0" : "") + seconds.toString());
      this.genericElm.setText(str);
      return of('time');
    }
    destroy() {
      if (this.genericElm != null) {
        this.genericElm.destroy();
      }
      super.destroy();
    }
    static ɵfac = function CountdownComponent_Factory(t) {
      return new (t || CountdownComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CountdownComponent,
      selectors: [["app-countdown"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function CountdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return CountdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function CustomRssPlayerComponent_app_flicking_item_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flicking-item", 5);
  }
  if (rf & 2) {
    const page_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setParentPlayer", ctx_r1)("setEditMode", ctx_r1.editMode)("setPage", page_r1);
  }
}
let CustomRssPlayerComponent = /*#__PURE__*/(() => {
  class CustomRssPlayerComponent extends PlayerList {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getConfig() {
      const data = this.playerObject.Data[0];
      let config = data.Rss[0].$;
      if (config == null) {
        config = {};
      }
      config.itemInterval = data.Rss[0].CustomRss[0].$?.itemInterval;
      config.displayMode = data.Rss[0].CustomRss[0].$?.displayMode;
      config.vertical = data.Rss[0].CustomRss[0].$?.vertical;
      config.playVideoInFull = data.Rss[0].CustomRss[0].$?.playVideoInFull;
      config.volume = data.Rss[0].CustomRss[0].$?.volume;
      return config;
    }
    getScene() {
      const data = this.playerObject.Data[0];
      return data.Rss[0].CustomRss[0].Player[0];
    }
    loadProviderData() {
      const data = this.playerObject.Data[0];
      if (data.Rss[0].rss != null) {
        return of(data.Rss[0].rss[0].channel[0].item);
      }
      this.url = data.Rss[0].$.url;
      return of('a').pipe(switchMap(a => this.playerService.caching.requestText(this.url, 'customRss', Expiration.Minute, this.playerService.getProxyUrl())), switchMap(data => {
        if (data != null) {
          xml2js.parseString(data, (err, result) => {
            this.providerData = result.rss.channel[0].item;
            this.index = 0;
            this.lastRefresh = new Date().getTime();
          });
        }
        return of(this.providerData);
      }), catchError(err => of(null)) // it happens when there is invalid url
      );
    }
    static ɵfac = function CustomRssPlayerComponent_Factory(t) {
      return new (t || CustomRssPlayerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CustomRssPlayerComponent,
      selectors: [["app-custom-rss-player"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 2,
      consts: [["component", ""], ["playercontainer", ""], ["flk", ""], [3, "options"], ["flicking-panel", "", "class", "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage", 4, "ngFor", "ngForOf"], ["flicking-panel", "", 1, "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage"]],
      template: function CustomRssPlayerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementStart(4, "ngx-flicking", 3, 2);
          i0.ɵɵtemplate(6, CustomRssPlayerComponent_app_flicking_item_6_Template, 1, 3, "app-flicking-item", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("options", ctx.options);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return CustomRssPlayerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomRssItemComponent = /*#__PURE__*/(() => {
  class CustomRssItemComponent extends ItemComponent {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.folder = 'customRss';
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        const field = data.RssItem[0].$.field;
        if (field == 'resource') {
          this.fieldType = 'resource';
          this.fieldName = "media:content.0.$.url";
          this.aspectRatio = data.RssItem[0]?.$.maintainAspectRatio == "1";
        } else {
          this.fieldType = 'text';
          this.fieldName = field;
        }
        if (data.RssItem[0].Font != null) {
          const font = data.RssItem[0].Font[0].$;
          this.genericElm.fontStyle = this.getFontStyle(font);
          return this.playerService.caching.requestFont(font);
        }
      }), switchMap(r => {
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData, false);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function CustomRssItemComponent_Factory(t) {
      return new (t || CustomRssItemComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CustomRssItemComponent,
      selectors: [["app-xml-item"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function CustomRssItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return CustomRssItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function CatalogPlayerComponent_app_flicking_item_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flicking-item", 5);
  }
  if (rf & 2) {
    const page_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setParentPlayer", ctx_r1)("setEditMode", ctx_r1.editMode)("setPage", page_r1);
  }
}
let CatalogPlayerComponent = /*#__PURE__*/(() => {
  class CatalogPlayerComponent extends PlayerList {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getConfig() {
      const data = this.playerObject.Data[0];
      return data.Catalog[0].$;
    }
    getScene() {
      const data = this.playerObject.Data[0];
      return data.Catalog[0].Player[0];
    }
    loadProviderData() {
      const categories = {};
      const data = this.playerObject.Data[0];
      data.Catalog[0].Categories[0].Category.forEach(category => {
        const categoryId = Number(category.$.id);
        categories[categoryId] = true;
      });
      return this.playerService.caching.getRecord("catalog_categories", -1).pipe(switchMap(catalog => {
        const items = [];
        catalog.items.forEach(item => {
          if (categories[item.category]) {
            items.push(item.item);
          }
        });
        const list = [];
        items.forEach(item => {
          list.push(this.playerService.caching.getRecord('catalog_items', item));
        });
        return forkJoin(list);
      }));
    }
    static ɵfac = function CatalogPlayerComponent_Factory(t) {
      return new (t || CatalogPlayerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CatalogPlayerComponent,
      selectors: [["app-xml-player"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 2,
      consts: [["component", ""], ["playercontainer", ""], ["flk", ""], [3, "options"], ["flicking-panel", "", "class", "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage", 4, "ngFor", "ngForOf"], ["flicking-panel", "", 1, "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage"]],
      template: function CatalogPlayerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementStart(4, "ngx-flicking", 3, 2);
          i0.ɵɵtemplate(6, CatalogPlayerComponent_app_flicking_item_6_Template, 1, 3, "app-flicking-item", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("options", ctx.options);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return CatalogPlayerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CatalogItemComponent = /*#__PURE__*/(() => {
  class CatalogItemComponent extends ItemComponent {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.folder = 'catalog';
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        //??? this.aspectRatio = data.CatalogItem[0]?.$.maintainAspectRatio == "1";
        this.fieldName = data.CatalogItem[0].$.field;
        if (this.fieldName == "ItemResourceMain") {
          this.fieldType = 'resource';
          return of('a');
        } else {
          this.fieldType = 'text';
          const font = data.CatalogItem[0].Font[0].$;
          this.genericElm.fontStyle = this.getFontStyle(font);
          return this.playerService.caching.requestFont(font);
        }
      }), switchMap(r => {
        return this.invalidateData(this.parentPlayer.childProviderData, false);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateResource(value) {
      let obs$ = null;
      obs$ = this.playerService.caching.getResource(value);
      return obs$.pipe(switchMap(path => {
        let volume = 1.0;
        if (this.parentPlayer?.parentPlayer != null) {
          volume = this.parentPlayer.parentPlayer.volume;
        }
        return this.genericElm.setMedia(path, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume);
      }), catchError(e => this.invalidateHtml(value, false)) // some url have CORS issue
      );
    }
    static ɵfac = function CatalogItemComponent_Factory(t) {
      return new (t || CatalogItemComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CatalogItemComponent,
      selectors: [["app-catalog-item"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function CatalogItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return CatalogItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExtAppComponent = /*#__PURE__*/(() => {
  class ExtAppComponent extends PlayerBase {
    injector;
    extApp;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.showMsg(playerObject.$.label, this.NO_PREVIEW);
        return of(null);
        const appName = atob(data.ExtApp[0].$.appName64);
        this.extApp = this.playerService.createExtApp(appName);
        if (this.extApp != null) {
          this.extApp.setPos(this.posX, this.posY, this.actualWidth, this.actualHeight);
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    destroy() {
      if (this.extApp != null) {
        this.playerService.removeExtApp(this.extApp);
      }
    }
    static ɵfac = function ExtAppComponent_Factory(t) {
      return new (t || ExtAppComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ExtAppComponent,
      selectors: [["app-ext-app"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 0,
      consts: [["component", ""]],
      template: function ExtAppComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵtext(2, "Ext");
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return ExtAppComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LabelQueueComponent = /*#__PURE__*/(() => {
  class LabelQueueComponent extends PlayerContainer {
    injector;
    index = 0;
    pages;
    defaultDuration;
    duration;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        this.index = 0;
        this.scaleX = this.parentPlayer.scaleX;
        this.scaleY = this.parentPlayer.scaleY;
        if (this.editMode) {
          return this.showPage();
        }
        return of('loop').pipe(switchMap(r1 => this.showPage()), switchMap(a => {
          return of('a').pipe(delay(this.duration));
        }), repeat());
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    getPage() {
      return new Observable(sub => {
        const data = this.playerObject.Data[0];
        this.defaultDuration = Number(data.LabelQueue[0].$.duration);
        this.pages = data.LabelQueue[0].TextList[0].Text;
        if (this.pages == null || this.pages.length == 0) {
          this.showMsg(this.playerObject.$.label, 'LabelQueue is empty');
          sub.next(null);
          sub.complete();
        } else {
          this.showMsg(null, null);
          const page = this.pages[this.index];
          let duration = page.$.duration;
          if (duration == "") {
            duration = this.defaultDuration;
          }
          this.duration = Number(duration * 1000);
          const text = page.$.text;
          const font = data.LabelQueue[0].Font[0].$;
          const layout = data.Layout[0].$;
          const player = {
            "$": {
              "player": "3241",
              "label": "Label",
              "autoScaling": "1"
            }
          };
          player.Data = [{
            "Layout": [{
              "$": {
                "rotation": "0",
                "x": "0",
                "y": "0",
                "width": layout.width,
                "height": layout.height
              }
            }],
            "Label": [{
              "Text": [text],
              "Font": [{
                "$": font
              }]
            }]
          }];
          this.index++;
          if (this.index >= this.pages.length) {
            this.index = 0;
          }
          sub.next(player);
          sub.complete();
        }
      });
    }
    static ɵfac = function LabelQueueComponent_Factory(t) {
      return new (t || LabelQueueComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: LabelQueueComponent,
      selectors: [["app-label-queue"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function LabelQueueComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return LabelQueueComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$g = ["myFrame"];
let HtmlComponent = /*#__PURE__*/(() => {
  class HtmlComponent extends PlayerBase {
    injector;
    myFrame;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW);
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        return of(null);
      }
      const data = this.playerObject.Data[0];
      const useProxy = data.HTML[0].$.useProxy == '1';
      const url = data.HTML[0].$.src;
      const play$ = super.play();
      return play$.pipe(switchMap(a => {
        if (useProxy) {
          return this.playerService.getProxySrc(url);
        } else {
          return of(url);
        }
      }), switchMap(src => {
        const data = this.playerObject.Data[0];
        if (data.HTML[0].$.staticTexture == '1') {
          this.myFrame.nativeElement.style.pointerEvents = 'none';
        }
        const showScrolls = data.HTML[0].$.showScrolls == '1';
        this.myFrame.nativeElement.style.overflow = showScrolls ? 'auto' : 'hidden';
        this.myFrame.nativeElement.setAttribute('scrolling', showScrolls ? 'yes' : 'no');
        this.myFrame.nativeElement.src = src;
        return of('play');
      }));
    }
    destroy() {
      if (this.myFrame?.nativeElement?.onload != null) {
        this.myFrame.nativeElement.onload = null;
      }
      super.destroy();
    }
    static ɵfac = function HtmlComponent_Factory(t) {
      return new (t || HtmlComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: HtmlComponent,
      selectors: [["app-html"]],
      viewQuery: function HtmlComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$g, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myFrame = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["myFrame", ""], [2, "position", "absolute", "width", "100%", "height", "100%", "border", "0px"]],
      template: function HtmlComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "iframe", 2, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return HtmlComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RichTextComponent = /*#__PURE__*/(() => {
  class RichTextComponent extends PlayerBase {
    injector;
    htmlLayer;
    divElm;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const globalPos = this.getGlobalPos();
        this.htmlLayer = document.getElementsByName('htmlLayer')[0];
        this.divElm = document.createElement('div');
        this.divElm.style.position = "absolute";
        this.divElm.style.left = globalPos.x + 'px';
        this.divElm.style.top = globalPos.y + 'px';
        this.divElm.style.width = this.actualWidth + 'px';
        this.divElm.style.height = this.actualHeight + 'px';
        this.htmlLayer.appendChild(this.divElm);
        let result = '';
        const str = data.Text[0]._;
        let fonts = {};
        let count = 0;
        let i1 = 0,
          i2 = 0,
          i3 = 0,
          i4 = 0;
        while (true) {
          i2 = str.indexOf('<FONT', i1);
          if (i2 === -1) {
            result += str.substring(i1);
            break;
          }
          i3 = str.indexOf('>', i2);
          result += str.substring(i1, i2);
          let font = str.substring(i2 + 6, i3);
          i1 = i3;
          const a1 = font.indexOf('FACE="');
          const a2 = font.indexOf('"', a1 + 6);
          const face = font.substring(a1 + 6, a2);
          const a3 = font.indexOf('SIZE="', a2);
          const a4 = font.indexOf('"', a3 + 6);
          const size = font.substring(a3 + 6, a4);
          const a5 = font.indexOf('COLOR="', a4);
          const a6 = font.indexOf('"', a5 + 7);
          const color = font.substring(a5 + 7, a6);
          const style = '<FONT style="font-family:' + face + 'normalnormal; font-size:' + size + 'px; color:' + color + ';"';
          result += style;
          if (face != '' && fonts[face] == null) {
            fonts[face] = {
              fontColor: 0,
              fontSize: '',
              fontFamily: face,
              fontWeight: 'normal',
              fontStyle: 'normal',
              autoScaling: ''
            };
            count++;
          }
        }
        for (let key in fonts) {
          const f = fonts[key];
          this.playerService.caching.requestFont(f).subscribe(() => {
            count--;
            if (count == 0) {
              this.divElm.innerHTML = result;
            }
          });
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    destroy() {
      /*
      if (this.divElm!=null) {
        this.htmlLayer.removeChild(this.divElm);
      }
        */
      super.destroy();
    }
    static ɵfac = function RichTextComponent_Factory(t) {
      return new (t || RichTextComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: RichTextComponent,
      selectors: [["app-rich-text"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function RichTextComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return RichTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let YouTubeComponent = /*#__PURE__*/(() => {
  class YouTubeComponent extends PlayerBase {
    injector;
    videoSprite;
    listType;
    quality;
    volume;
    randomOrder;
    videoList;
    youtube;
    videoId;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW);
        }
        this.loadStat();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        return of(null);
      }
      const data = this.playerObject.Data[0];
      this.listType = data.YouTube[0].$.listType;
      this.quality = data.YouTube[0].$.quality;
      this.randomOrder = data.YouTube[0].$.randomOrder == '1';
      const play$ = super.play().pipe(switchMap(a => this.playerService.initYoutube()), switchMap(r => {
        this.youtube = this.playerService.createYouTube(this.component.nativeElement);
        this.youtube.volume = 100 * Number(data.YouTube[0].$.volume);
        return this.youtube.init();
      }), shareReplay());
      return play$.pipe(switchMap(r => {
        if (this.videoList == null || this.videoList.length == 0) {
          return this.requestVideos();
        } else {
          return of('continue');
        }
      }), switchMap(r => {
        this.statStart = new Date().getTime();
        return this.playNext();
      }), switchMap(res => {
        if (res != null && this.statEnabled) {
          const duration = Number(((new Date().getTime() - this.statStart) / 1000).toFixed(2));
          this.playerService.stats.addContent(this.statTag, 2, this.videoId, duration);
        }
        return of('a');
      }), repeat());
    }
    requestVideos() {
      const data = this.playerObject.Data[0];
      if (this.listType == "manually") {
        let videoId;
        this.videoList = [];
        let i0 = 0;
        let i1;
        let inStr = true;
        const videoIdList = data.YouTube[0].VideoIdList[0];
        for (i1 = 0; i1 < videoIdList.length; i1++) {
          let ch = videoIdList.charAt(i1);
          if (ch == " " || ch == "," || ch == ";" || ch == "\t" || ch == "\n") {
            if (inStr) {
              videoId = videoIdList.substring(i0, i1);
              this.videoList.push(videoId);
              inStr = false;
            }
            i0 = i1 + 1;
          } else {
            inStr = true;
          }
        }
        if (inStr && i1 > i0) {
          videoId = videoIdList.substring(i0, i1);
          this.videoList.push(videoId);
        }
        if (this.randomOrder) {
          this.shuffleItems();
        }
        return of('ready');
      } else {
        let url = null;
        if (this.listType == "most_viewed") {
          url = DS_API_URL + "YouTube/popular/all/" + data.YouTube[0].$.listRegion;
        } else if (this.listType == "category") {
          url = DS_API_URL + "YouTube/cat/" + data.YouTube[0].$.category + "/" + data.YouTube[0].$.listRegion;
        } else if (this.listType == "channel") {
          url = DS_API_URL + "YouTube/channel/" + data.YouTube[0].$.channel + "/" + data.YouTube[0].$.listRegion;
        }
        if (url != null) {
          return this.playerService.caching.requestText(url, 'youtube', Expiration.Hour /*, this.listType + '.txt'*/).pipe(switchMap(str => {
            const data = JSON.parse(str);
            this.videoList = [];
            data.forEach(item => {
              if ((this.listType == "most_viewed" || this.listType == "category") && item.id != null) {
                this.videoList.push(item.id);
              } else if (this.listType == "channel" && item.id != null) {
                this.videoList.push(item.id.videoId);
              }
            });
            if (this.randomOrder) {
              this.shuffleItems();
            }
            return of('done');
          }));
        } else {
          return of(null);
        }
      }
    }
    shuffleItems() {
      let randomList = [];
      let videoId;
      while (this.videoList.length > 0) {
        let index = Math.floor(Math.random() * this.videoList.length);
        videoId = this.videoList[index];
        randomList.push(videoId);
        this.videoList.splice(index, 1);
      }
      this.videoList = randomList;
    }
    playNext() {
      this.videoId = this.videoList.shift();
      if (this.listType == "manually") {
        this.videoList.push(this.videoId);
      }
      if (this.videoId != null) {
        return this.youtube.loadVideoById(this.videoId);
      } else {
        return of(null);
      }
    }
    destroy() {
      if (this.youtube != null) {
        this.youtube.dispose();
      }
      this.youtube = null;
      if (this.videoList != null) {
        while (this.videoList.length > 0) {
          this.videoList.shift();
        }
        this.videoList = null;
      }
      super.destroy();
    }
    static ɵfac = function YouTubeComponent_Factory(t) {
      return new (t || YouTubeComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: YouTubeComponent,
      selectors: [["app-you-tube"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function YouTubeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return YouTubeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$f = ["txt"];
const _c1$a = ["button"];
let RadioComponent = /*#__PURE__*/(() => {
  class RadioComponent extends PlayerBase {
    injector;
    label;
    fontSize;
    color;
    fontFamily;
    fontStyle;
    txt;
    button;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const radio = data.Radio[0];
        const fieldName = radio.$.fieldName;
        this.button.name = fieldName;
        const font = radio.Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        const data = this.playerObject.Data[0];
        const radio = data.Radio[0];
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        const k = 0.04;
        const w = 20;
        const scale = k * this.fontStyle.fontSize;
        this.txt.nativeElement.style.paddingTop = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingBottom = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingRight = 0.3 * w * scale + 'px';
        const el1 = this.button._elementRef.nativeElement.children[0].children[0];
        el1.style.transform = 'scale(' + scale + ')';
        el1.style.marginLeft = -w + w * scale + 'px';
        el1.style.marginRight = -w + w * scale + 'px';
        this.label = radio.$.label;
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateData(providerData) {
      this.providerData = providerData;
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        const radio = data.Radio[0];
        this.button.checked = this.providerData[radio.$.fieldName] === radio.$.value;
      }
      this.changeDetectorRef.detectChanges();
      return of('a');
    }
    changeValue() {
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        const radio = data.Radio[0];
        this.providerData[radio.$.fieldName] = radio.$.value;
        this.onClick(null);
      }
    }
    static ɵfac = function RadioComponent_Factory(t) {
      return new (t || RadioComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: RadioComponent,
      selectors: [["app-radio"]],
      viewQuery: function RadioComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$f, 7);
          i0.ɵɵviewQuery(_c1$a, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txt = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 17,
      consts: [["component", ""], ["txt", ""], ["button", ""], [2, "width", "100%", "height", "100%", "display", "grid"], [3, "change"]],
      template: function RadioComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", null, 0)(2, "div", 3)(3, "div")(4, "div", null, 1)(6, "mat-radio-button", 4, 2);
          i0.ɵɵlistener("change", function RadioComponent_Template_mat_radio_button_change_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changeValue());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵstyleMapInterpolate2("text-align:", ctx.fontStyle.align, "; alignSelf:", ctx.fontStyle.alignSelf, ";");
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("color", ctx.color)("font-size", ctx.fontSize)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("font-size", ctx.fontSize)("color", ctx.color)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        }
      },
      dependencies: [i6.MatRadioButton],
      encapsulation: 2
    });
  }
  return RadioComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$e = ["txt"];
const _c1$9 = ["checkbox"];
let SwitchComponent = /*#__PURE__*/(() => {
  class SwitchComponent extends PlayerBase {
    injector;
    txt;
    checkbox;
    myValue = false;
    selectedValue;
    offLabel;
    onLabel;
    fontSize;
    color;
    fontFamily;
    fontStyle;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const sw = data.Switch[0];
        const font = sw.Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        const k = 0.04;
        const w = 20;
        const scale = k * this.fontStyle.fontSize;
        this.txt.nativeElement.style.paddingTop = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingBottom = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingRight = 0.3 * w * scale + 'px';
        const el1 = this.checkbox._elementRef.nativeElement.children[0].children[0];
        el1.style.transform = 'scale(' + scale + ')';
        el1.style.marginLeft = -w + w * scale + 'px';
        el1.style.marginRight = -w + w * scale + 'px';
        const data = this.playerObject.Data[0];
        const sw = data.Switch[0];
        this.offLabel = sw.$.offLabel;
        this.onLabel = sw.$.onLabel;
        this.selectedValue = this.offLabel;
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateData(providerData) {
      this.providerData = providerData;
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        let value = this.providerData[data.Switch[0].$.fieldName];
        if (value == null) {
          value = this.providerData[data.Switch[0].$.fieldName] = data.Switch[0].$.defaultValue == "true";
        }
        this.myValue = value;
      }
      this.changeDetectorRef.detectChanges();
      return of('a');
    }
    changeValue() {
      if (this.providerData != null) {
        this.myValue = this.checkbox.checked;
        this.changeDetectorRef.detectChanges();
        const data = this.playerObject.Data[0];
        const fieldName = data.Switch[0].$.fieldName;
        this.providerData[fieldName] = this.myValue;
        this.onClick(null);
      }
    }
    static ɵfac = function SwitchComponent_Factory(t) {
      return new (t || SwitchComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SwitchComponent,
      selectors: [["app-switch"]],
      viewQuery: function SwitchComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$e, 7);
          i0.ɵɵviewQuery(_c1$9, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txt = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 12,
      consts: [["component", ""], ["txt", ""], ["checkbox", ""], [2, "width", "100%", "height", "100%", "display", "grid"], [3, "change", "checked"]],
      template: function SwitchComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", null, 0)(2, "div", 3)(3, "div")(4, "div", null, 1)(6, "mat-slide-toggle", 4, 2);
          i0.ɵɵlistener("change", function SwitchComponent_Template_mat_slide_toggle_change_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changeValue());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵstyleMapInterpolate2("text-align:", ctx.fontStyle.align, "; alignSelf:", ctx.fontStyle.alignSelf, ";");
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("color", ctx.color)("font-size", ctx.fontSize)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("checked", ctx.myValue);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.myValue ? ctx.onLabel : ctx.offLabel, " ");
        }
      },
      dependencies: [i7.MatSlideToggle],
      encapsulation: 2
    });
  }
  return SwitchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$d = ["txt1"];
const _c1$8 = ["txt2"];
const _c2$6 = ["slider"];
let SliderComponent = /*#__PURE__*/(() => {
  class SliderComponent extends PlayerBase {
    injector;
    txt1;
    txt2;
    slider;
    fontStyle;
    value = 0;
    fontSize;
    color;
    fontFamily;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const sld = data.Slider[0].$;
        this.slider.min = Number(sld.minimum);
        this.slider.max = Number(sld.maximum);
        this.slider.step = Number(sld.step);
        this.value = Number(sld.defaultValue);
        const font = data.Slider[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        const k = 0.04;
        const w = 20;
        const scale = k * this.fontStyle.fontSize;
        this.txt1.nativeElement.style.marginLeft = -3 * w + 3.5 * w * scale + 'px';
        this.txt1.nativeElement.style.marginRight = -3 * w + 3.5 * w * scale + 'px';
        const el1 = this.slider._elementRef.nativeElement;
        el1.style.transform = 'scale(' + scale + ')';
        const el2 = el1.children[2].children[1];
        el2.style.display = 'none';
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateData(providerData) {
      this.providerData = providerData;
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        let value = this.providerData[data.Slider[0].$.fieldName];
        if (value == null) {
          value = this.providerData[data.Slider[0].$.fieldName] = Number(data.Slider[0].$.defaultValue);
        }
        this.value = value;
      }
      this.changeDetectorRef.detectChanges();
      return of('a');
    }
    changeValue(event) {
      if (this.providerData != null) {
        const data = this.playerObject.Data[0];
        const fieldName = data.Slider[0].$.fieldName;
        this.providerData[fieldName] = Number(event.target.value);
        this.onClick(null);
      }
    }
    static ɵfac = function SliderComponent_Factory(t) {
      return new (t || SliderComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SliderComponent,
      selectors: [["app-slider"]],
      viewQuery: function SliderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$d, 7);
          i0.ɵɵviewQuery(_c1$8, 7);
          i0.ɵɵviewQuery(_c2$6, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txt1 = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txt2 = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slider = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 11,
      consts: [["component", ""], ["txt1", ""], ["txt2", ""], ["slider", ""], [2, "width", "100%", "height", "100%", "display", "grid"], ["discrete", "", "disableRipple", "", 3, "change"], ["matSliderThumb", "", 3, "value"]],
      template: function SliderComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", null, 0)(2, "div", 4)(3, "div", null, 1)(5, "div", null, 2)(7, "mat-slider", 5, 3);
          i0.ɵɵlistener("change", function SliderComponent_Template_mat_slider_change_7_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changeValue($event));
          });
          i0.ɵɵelement(9, "input", 6);
          i0.ɵɵelementEnd()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵstyleMapInterpolate2("text-align:", ctx.fontStyle.align, "; alignSelf:", ctx.fontStyle.alignSelf, ";");
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("color", ctx.color)("font-size", ctx.fontSize)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(4);
          i0.ɵɵpropertyInterpolate("value", ctx.value);
        }
      },
      dependencies: [i3.MatSlider, i3.MatSliderThumb],
      encapsulation: 2
    });
  }
  return SliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function StockTickerComponent_app_flicking_item_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flicking-item", 5);
  }
  if (rf & 2) {
    const page_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setParentPlayer", ctx_r1)("setEditMode", ctx_r1.editMode)("setPage", page_r1);
  }
}
let StockTickerComponent = /*#__PURE__*/(() => {
  class StockTickerComponent extends PlayerList {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getConfig() {
      const data = this.playerObject.Data[0];
      const config = data.Stocks[0].$;
      if (config.displayMode == null) {
        config.displayMode = 'list';
      }
      return config;
    }
    getScene() {
      const data = this.playerObject.Data[0];
      return data.Stocks[0].Player[0];
    }
    loadProviderData() {
      const data = this.playerObject.Data[0];
      const symbols = data.Stocks[0].Symbols[0];
      let url = DS_API_URL + 'stocksv2?symbol=' + symbols;
      url = url.replace(/ /g, '');
      return of('a').pipe(switchMap(a => this.playerService.caching.requestText(url, 'stock', Expiration.Minute, this.playerService.getProxyUrl())), switchMap(data => {
        this.providerData = JSON.parse(data);
        this.index = 0;
        this.lastRefresh = new Date().getTime();
        return of(this.providerData);
      }), catchError(err => of(null)) // it happens when there is invalid url
      );
    }
    static ɵfac = function StockTickerComponent_Factory(t) {
      return new (t || StockTickerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: StockTickerComponent,
      selectors: [["app-stock-ticker"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 2,
      consts: [["component", ""], ["playercontainer", ""], ["flk", ""], [3, "options"], ["flicking-panel", "", "class", "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage", 4, "ngFor", "ngForOf"], ["flicking-panel", "", 1, "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage"]],
      template: function StockTickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementStart(4, "ngx-flicking", 3, 2);
          i0.ɵɵtemplate(6, StockTickerComponent_app_flicking_item_6_Template, 1, 3, "app-flicking-item", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("options", ctx.options);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return StockTickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RssComponent = /*#__PURE__*/(() => {
  class RssComponent extends PlayerBase {
    injector;
    myCanvas;
    ctx;
    firstIndex = 0;
    pos = 0;
    stopTimer$;
    //rss;
    rtl = false;
    fontTitleStyle;
    fontDescriptionStyle;
    items;
    vertical;
    actualSize;
    size;
    space;
    index;
    speed;
    titleDiv;
    descriptionDiv;
    filter;
    offsetY = 0;
    refreshTime = 3600 * 1000;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        /*
                        // Alon test
                        data.DataProvider =  [{
                            Ai: [{
                                $: {
                                    language: "he"
                                },
                                Description: ["Show me the most watched tv series of this year"],
                                Fields: [{
                                    Field: [
                                        {
                                            $: {
                                                name: "title",
                                                description: "title on the request"
                                            }
                                        },
                                        {
                                            $: {
                                                name: "description",
                                                description: "description of request"
                                            }
                                        }
                                    ]
                                }]
                            }]
        
                        }];
        
        
         */
        let rss$;
        this.rtl = data.Rss[0].$.rtl == '1';
        this.vertical = data.Rss[0].$.vertical == "1";
        this.speed = Number(data.Rss[0].$.speed) / 60;
        if (data.Rss[0].$.minRefreshTime != null && data.Rss[0].$.minRefreshTime != "") {
          this.refreshTime = Number(data.Rss[0].$.minRefreshTime) * 60 * 1000;
        }
        if (this.editMode == false) {
          this.myCanvas = document.createElement('canvas');
          this.component.nativeElement.appendChild(this.myCanvas);
          this.myCanvas.x = 0;
          this.myCanvas.y = 0;
          this.myCanvas.width = this.actualWidth;
          this.myCanvas.height = this.actualHeight;
          this.ctx = this.myCanvas.getContext("2d");
          this.stopTimer$ = timer(this.refreshTime);
        }
        const fontTitle = data.Rss[0].Title[0].Font[0].$;
        this.fontTitleStyle = this.getFontStyle(fontTitle);
        const obs1$ = this.playerService.caching.requestFont(fontTitle);
        if (this.vertical) {
          this.actualSize = this.actualHeight;
          const fontDescription = data.Rss[0].Description[0].Font[0].$;
          this.fontDescriptionStyle = this.getFontStyle(fontDescription);
          this.space = 0;
          const obs2$ = this.playerService.caching.requestFont(fontDescription);
          rss$ = forkJoin(obs1$, obs2$);
        } else {
          this.actualSize = this.actualWidth;
          this.space = this.fontTitleStyle.fontSize * 2;
          switch (this.fontTitleStyle.alignSelf) {
            case 'start':
              this.offsetY = this.fontTitleStyle.fontSize;
              break;
            case 'center':
              this.offsetY = 0.5 * this.actualHeight;
              break;
            case 'end':
              this.offsetY = this.actualHeight - this.fontTitleStyle.fontSize;
              break;
          }
          rss$ = obs1$;
        }
        return rss$;
      }), switchMap(fonts => {
        if (this.editMode) {
          if (this.titleDiv == null) {
            this.titleDiv = document.createElement('div');
            this.component.nativeElement.appendChild(this.titleDiv);
          }
          this.titleDiv.style.fontSize = this.fontTitleStyle.fontSize + 'px';
          this.titleDiv.style.color = this.fontTitleStyle.fill;
          this.titleDiv.style.fontFamily = this.fontTitleStyle.fontFamily;
          this.titleDiv.style.textDecoration = this.fontTitleStyle.textDecoration;
          this.titleDiv.innerHTML = "RSS Title";
          if (this.vertical) {
            if (this.descriptionDiv == null) {
              this.descriptionDiv = document.createElement('div');
              this.component.nativeElement.appendChild(this.descriptionDiv);
            }
            this.descriptionDiv.style.fontSize = this.fontDescriptionStyle.fontSize + 'px';
            this.descriptionDiv.style.color = this.fontDescriptionStyle.fill;
            this.descriptionDiv.style.fontFamily = this.fontDescriptionStyle.fontFamily;
            this.descriptionDiv.style.textDecoration = this.fontDescriptionStyle.textDecoration;
            this.descriptionDiv.innerHTML = "rss description";
          } else {
            if (this.descriptionDiv != null) {
              this.component.nativeElement.removeChild(this.descriptionDiv);
              this.descriptionDiv = null;
            }
          }
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    display(show) {}
    requestRss() {
      this.componentStatus('loading');
      const data = this.playerObject.Data[0];
      if (data.DataProvider != null) {
        debugger;
        let prompt;
        if (data.DataProvider[0]?.Ai?.[0]?.Prompt != null) {
          prompt = data.DataProvider[0]?.Ai?.[0]?.Prompt?.[0];
        } else {
          // deprecated Interface Description
          prompt = data.DataProvider[0].Ai[0].Description[0];
        }
        const language = data.DataProvider[0]?.Ai?.[0]?.$?.language || 'en';
        // Build Fields object from DataProvider.Ai.Fields
        const fields = {};
        const aiFields = data.DataProvider[0]?.Ai?.[0]?.Fields?.[0]?.Field;
        if (aiFields && aiFields.length > 0) {
          // Read fields from DataProvider
          aiFields.forEach(field => {
            const fieldName = field.$.name;
            const fieldDescription = field.$.description;
            fields[fieldName] = fieldDescription;
          });
        }
        const body = {
          dataType: 'text',
          Prompt: decodeURIComponent(prompt || ''),
          Language: language,
          Series: '',
          Fields: fields
        };
        debugger;
        const port = this.playerService.isDevOrLocal() ? ":9443" : "";
        let url = "https://ai.signage.me" + port + "/feed/request";
        // post with body - cache for 1 hour (3600000ms)
        return this.playerService.caching.postJson(url, body, 'ai-feed', 3600000).pipe(switchMap(result => {
          console.log('RSS AI Response:', result);
          debugger;
          /*
          this.componentStatus('error');
          return of(null);
            */
          // Set items from AI response
          if (result?.success && result?.items && Array.isArray(result.items)) {
            this.items = result.items;
            console.log('RSS items loaded:', this.items.length);
            console.log('First item:', this.items[0]);
            console.log('First item keys:', Object.keys(this.items[0]));
            this.componentStatus('ready');
          } else {
            console.error('RSS AI: Invalid response format', result);
            this.items = [];
            this.componentStatus('error');
          }
          return of('complete');
        }), catchError(err => {
          console.error('RSS AI Error:', err);
          this.items = [];
          this.componentStatus('error');
          return of(null);
        }));
      } else if (data.Rss[0].$.url == null) {
        this.items = data.Rss[0].rss[0].channel[0].item;
        this.componentStatus('ready');
        return of('embeded');
      } else {
        let url = data.Rss[0].$.url;
        url = url.replace(/http:/, 'https:');
        return this.playerService.caching.requestText(url, 'rss', Expiration.Minute, this.playerService.getProxyUrl()).pipe(switchMap(data => {
          if (data != null && data != "") {
            xml2js.parseString(data, (err, result) => {
              if (err) {
                console.error('RSS XML Parse Error:', err);
                this.items = [];
                this.componentStatus('error');
                return;
              }
              this.items = result.rss.channel[0].item;
              this.items = this.items.map(item => {
                const ret = {};
                ret.title = item.title?.[0];
                if (item["description"] != null) {
                  ret.description = item.description?.[0];
                }
                return ret;
              });
              /*
              console.error('remove this test !!!!!');
              for(let a=0; a<20; a++) {
                  this.items = this.items.concat(this.items);
              }
                */
            });
            this.componentStatus('ready');
            return of('complete');
          } else {
            this.componentStatus('error');
            return of(null);
          }
        }), catchError(err => {
          console.error('RSS Request Error:', err);
          this.componentStatus('error');
          return of(null);
        }));
      }
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      return of('loop').pipe(switchMap(a => {
        return this.requestRss();
      }), switchMap(a => {
        // If requestRss returned null, throw error to stop the repeat loop
        if (a === null) {
          throw new Error();
        }
        return animationFrames().pipe(tap$1(value => {
          if (this.vertical) {
            this.drawVer();
          } else {
            if (this.rtl) {
              this.drawHozRtl();
            } else {
              this.drawHozLtr();
            }
          }
        }), takeUntil(this.stopTimer$));
      }), repeat(), catchError(err => {
        return of(null);
      }));
    }
    drawHozLtr() {
      this.ctx.clearRect(0, 0, this.actualWidth, this.actualHeight);
      this.ctx.fillStyle = this.fontTitleStyle.fill;
      this.ctx.font = this.fontTitleStyle.fontSize + 'px ' + this.fontTitleStyle.fontFamily;
      this.ctx.textAlign = "left";
      let index = this.firstIndex;
      let pos = this.pos;
      let item = null;
      while (pos < this.actualWidth) {
        item = this.items[index];
        const title = item.title;
        if (item.width == null) {
          item.width = this.ctx.measureText(title).width + this.fontTitleStyle.fontSize * 2;
        }
        this.ctx.fillText(title, pos, this.offsetY);
        pos += item.width;
        index++;
        if (index == this.items.length) {
          index = 0;
        }
      }
      this.pos -= this.speed;
      const firstItem = this.items[this.firstIndex];
      if (this.pos + firstItem.width < 0) {
        this.firstIndex++;
        if (this.firstIndex == this.items.length) {
          this.firstIndex = 0;
        }
        this.pos += firstItem.width;
      }
    }
    drawHozRtl() {
      this.ctx.clearRect(0, 0, this.actualWidth, this.actualHeight);
      this.ctx.fillStyle = this.fontTitleStyle.fill;
      this.ctx.font = this.fontTitleStyle.fontSize + 'px ' + this.fontTitleStyle.fontFamily;
      this.ctx.textAlign = "right";
      let index = this.firstIndex;
      let pos = this.pos;
      let item = null;
      while (pos > 0) {
        item = this.items[index];
        const title = item.title;
        if (item.width == null) {
          item.width = this.ctx.measureText(title).width + this.fontTitleStyle.fontSize * 2;
        }
        this.ctx.fillText(title, pos, this.offsetY);
        pos -= item.width;
        index++;
        if (index == this.items.length) {
          index = 0;
        }
      }
      this.pos += this.speed;
      const firstItem = this.items[this.firstIndex];
      if (this.pos - firstItem.width > this.actualWidth) {
        this.firstIndex++;
        if (this.firstIndex == this.items.length) {
          this.firstIndex = 0;
        }
        this.pos -= firstItem.width;
      }
    }
    drawVer() {
      this.ctx.clearRect(0, 0, this.actualWidth, this.actualHeight);
      let index = this.firstIndex;
      let pos = this.pos;
      let item = null;
      while (pos < this.actualHeight) {
        item = this.items[index];
        const title = String(item.title);
        const description = String(item.description);
        this.ctx.fillStyle = this.fontTitleStyle.fill;
        this.ctx.font = this.fontTitleStyle.fontSize + 'px ' + this.fontTitleStyle.fontFamily;
        this.ctx.textAlign = this.fontTitleStyle.align;
        let height = this.wrapText(title, pos, this.fontTitleStyle.fontSize);
        if (description != null) {
          this.ctx.fillStyle = this.fontDescriptionStyle.fill;
          this.ctx.font = this.fontDescriptionStyle.fontSize + 'px ' + this.fontDescriptionStyle.fontFamily;
          this.ctx.textAlign = this.fontDescriptionStyle.align;
          height += this.wrapText(description, pos + height, this.fontDescriptionStyle.fontSize);
        }
        height += this.fontTitleStyle.fontSize * 2;
        if (item.height == null) {
          item.height = height;
        }
        pos += item.height;
        index++;
        if (index == this.items.length) {
          index = 0;
        }
      }
      this.pos -= this.speed;
      const firstItem = this.items[this.firstIndex];
      if (this.pos + firstItem.height < 0) {
        this.firstIndex++;
        if (this.firstIndex == this.items.length) {
          this.firstIndex = 0;
        }
        this.pos += firstItem.height;
      }
    }
    wrapText(text, y, fontSize) {
      const words = text.split(' ');
      let line = '';
      let lines = [];
      let testWidth;
      for (let i = 0; i < words.length; i++) {
        let testLine = line + words[i] + ' ';
        testWidth = this.ctx.measureText(testLine).width;
        if (testWidth > this.actualWidth && i > 0) {
          lines.push(line.trim());
          line = words[i] + ' ';
        } else {
          line = testLine;
        }
      }
      lines.push(line.trim()); // last line
      // Determine x anchor based on textAlign
      let x;
      switch (this.ctx.textAlign) {
        case 'center':
          x = this.actualWidth / 2;
          break;
        case 'right':
        case 'end':
          x = this.actualWidth;
          break;
        case 'left':
        case 'start':
        default:
          x = 0;
          break;
      }
      for (let i = 0; i < lines.length; i++) {
        this.ctx.fillText(lines[i], x, y + i * fontSize);
      }
      return lines.length * fontSize;
    }
    destroy() {
      if (this.myCanvas != null) {
        this.component.nativeElement.removeChild(this.myCanvas);
        this.myCanvas = null;
        this.ctx = null;
      }
      super.destroy();
    }
    static ɵfac = function RssComponent_Factory(t) {
      return new (t || RssComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: RssComponent,
      selectors: [["app-rss"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function RssComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return RssComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function XmlPlayerComponent_app_flicking_item_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flicking-item", 5);
  }
  if (rf & 2) {
    const page_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setParentPlayer", ctx_r1)("setEditMode", ctx_r1.editMode)("setPage", page_r1);
  }
}
let XmlPlayerComponent = /*#__PURE__*/(() => {
  class XmlPlayerComponent extends PlayerList {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getConfig() {
      const data = this.playerObject.Data[0];
      return data.Xml[0].$;
    }
    getScene() {
      const data = this.playerObject.Data[0];
      return data.Xml[0].Player[0];
    }
    loadProviderData() {
      const data = this.playerObject.Data[0];
      this.url = data.Xml[0].$.url;
      return of('a').pipe(switchMap(a => this.playerService.caching.requestText(this.url, 'xml', Expiration.Minute)), switchMap(data => {
        if (data != null) {
          xml2js.parseString(data, (err, result) => {
            if (result == null) {
              // result is not valid xml
              return of(null);
            }
            const itemsPath = data.Xml[0].$.itemsPath;
            let pd = result[Object.keys(result)[0]];
            itemsPath.split('.').forEach(key => {
              pd = pd[key];
            });
            this.providerData = pd;
            this.index = 0;
            this.lastRefresh = new Date().getTime();
          });
        }
        return of(this.providerData);
      }), catchError(err => of(null)) // it happens when there is invalid url
      );
    }
    static ɵfac = function XmlPlayerComponent_Factory(t) {
      return new (t || XmlPlayerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: XmlPlayerComponent,
      selectors: [["app-xml-player"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 2,
      consts: [["component", ""], ["playercontainer", ""], ["flk", ""], [3, "options"], ["flicking-panel", "", "class", "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage", 4, "ngFor", "ngForOf"], ["flicking-panel", "", 1, "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage"]],
      template: function XmlPlayerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementStart(4, "ngx-flicking", 3, 2);
          i0.ɵɵtemplate(6, XmlPlayerComponent_app_flicking_item_6_Template, 1, 3, "app-flicking-item", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("options", ctx.options);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return XmlPlayerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let XmlItemComponent = /*#__PURE__*/(() => {
  class XmlItemComponent extends ItemComponent {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.folder = 'xml';
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        this.aspectRatio = data.XmlItem[0]?.$.maintainAspectRatio == "1";
        this.fieldName = data.XmlItem[0].$.fieldName;
        this.fieldName = this.fieldName.replace(/@/, '$.');
        this.fieldType = data.XmlItem[0].$.fieldType;
        if (this.fieldType == 'resource') {
          return of('resource');
        }
        const font = data.XmlItem[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(r => {
        let childProviderData;
        if (this.parentPlayer != null) {
          childProviderData = this.parentPlayer.childProviderData;
        }
        return this.invalidateData(childProviderData, false);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function XmlItemComponent_Factory(t) {
      return new (t || XmlItemComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: XmlItemComponent,
      selectors: [["app-xml-item"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function XmlItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return XmlItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MessageComponent = /*#__PURE__*/(() => {
  class MessageComponent extends PlayerBase {
    injector;
    genericElm;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        this.genericElm.label = "";
        const font = data.Label[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    onCommand(command, param) {
      const logInfo = Log.getLogInfo("MessageComponent", "onCommand", [command, param]);
      Log.d(logInfo, LogTag.PLAYER, '');
      const cmd = command.$.command;
      let text = this.genericElm.label;
      switch (cmd) {
        case 'setParam':
          text = param + '\n';
          break;
        case 'addParamLine':
          text += param + '\n';
          break;
        case 'addParamFieldLine':
          const field = command.Params[0].Field[0].$.name;
          const data = JSON.parse(param);
          const value = data[field];
          text += value + '\n';
          break;
      }
      this.genericElm.setText(text);
      return of(null);
    }
    destroy() {
      if (this.genericElm != null) {
        this.genericElm.destroy();
      }
      super.destroy();
    }
    static ɵfac = function MessageComponent_Factory(t) {
      return new (t || MessageComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: MessageComponent,
      selectors: [["app-message"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function MessageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return MessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExtImageComponent = /*#__PURE__*/(() => {
  class ExtImageComponent extends PlayerBase {
    injector;
    genericElm;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      const logInfo = Log.getLogInfo("ExtImageComponent", "load", []);
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW);
          return of(null);
        } else {
          this.genericElm = new GenericElm(this.component);
          const url = data.LINK[0].$.src;
          return of(url);
        }
      }), switchMap(path => {
        if (path == null) {
          Log.w(logInfo, LogTag.PLAYER, "path is empty");
          return of(null);
        }
        const data = this.playerObject.Data[0];
        let aspectRatio = data.LINK[0].AspectRatio[0].$.maintain == '1'; //???
        return this.genericElm.setImage(path, aspectRatio, this.actualWidth, this.actualHeight);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    destroy() {
      if (this.genericElm != null) {
        this.genericElm.destroy();
      }
      super.destroy();
    }
    static ɵfac = function ExtImageComponent_Factory(t) {
      return new (t || ExtImageComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ExtImageComponent,
      selectors: [["app-ext-image"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""], [3, "click"]],
      template: function ExtImageComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵlistener("click", function ExtImageComponent_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return ExtImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExtVideoComponent = /*#__PURE__*/(() => {
  class ExtVideoComponent extends PlayerBase {
    injector;
    genericElm;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW);
          return of(null);
        } else {
          this.genericElm = new GenericElm(this.component);
          const url = data.LINK[0].$.src;
          return of(url);
        }
      }), switchMap(path => {
        if (path == null) {
          return of(null);
        }
        const data = this.playerObject.Data[0];
        const aspectRatio = data.LINK[0].AspectRatio[0].$.maintain == "1";
        const autoRewind = data.LINK[0].Video[0].$.autoRewind == "1";
        const volume = Number(data.LINK[0].Video[0].$.volume);
        return this.genericElm.setMedia(path, aspectRatio, this.actualWidth, this.actualHeight, autoRewind, volume).pipe(switchMap(a => this.genericElm.play(false)));
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    destroy() {
      if (this.genericElm != null) {
        this.genericElm.destroy();
      }
      super.destroy();
    }
    static ɵfac = function ExtVideoComponent_Factory(t) {
      return new (t || ExtVideoComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ExtVideoComponent,
      selectors: [["app-ext-video"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function ExtVideoComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return ExtVideoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let QrComponent = /*#__PURE__*/(() => {
  class QrComponent extends PlayerBase {
    injector;
    qrData = "";
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    qrWidth() {
      return Math.min(this.actualWidth, this.actualHeight);
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.showMsg(null, null);
        const textSource = data.Text[0].$.textSource;
        if (textSource == "static") {
          const dtx = data.Text[0]._;
          return of(dtx == null ? "" : dtx);
          //return (data==null) ? of("") : of(data);
        } else if (textSource == "dynamic") {
          const url = data.Text[0].$.url;
          if (url == "") {
            this.showMsg(this.playerObject.$.label, "URL not exist");
            return of(null);
          } else {
            return this.playerService.caching.requestText(url, 'qr', Expiration.Now, this.playerService.getProxyUrl()).pipe(switchMap(res => {
              if (res != null && res != "") {
                if (res.length < 512) {
                  return of(res);
                } else {
                  return of(res.substring(0, 511) + "...");
                }
              }
            }), catchError(err => {
              this.showMsg(this.playerObject.$.label, "Error 404: page not found");
              return of(null);
            }));
          }
        } else {
          this.showMsg(this.playerObject.$.label, "Supported only in legacy player");
          return of(null);
        }
      }), switchMap(qr => {
        if (qr != null) {
          this.qrData = qr;
          this.changeDetectorRef.detectChanges();
        }
        return of(self);
      }), takeUntil(this.finish$));
    }
    static ɵfac = function QrComponent_Factory(t) {
      return new (t || QrComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: QrComponent,
      selectors: [["app-qr"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 3,
      consts: [["component", ""], ["allowEmptyString", "true", 3, "qrdata", "width", "errorCorrectionLevel"]],
      template: function QrComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "qrcode", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("qrdata", ctx.qrData)("width", ctx.qrWidth())("errorCorrectionLevel", "M");
        }
      },
      dependencies: [i1.QRCodeComponent],
      encapsulation: 2
    });
  }
  return QrComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StockItemComponent = /*#__PURE__*/(() => {
  class StockItemComponent extends ItemComponent {
    injector;
    negativeColor;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.folder = 'stock';
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        this.fieldType = 'text';
        this.fieldName = data.StockItem[0].$.field;
        if (this.fieldName == 'Symbol') {
          this.fieldName = "symbol";
        }
        const font = data.StockItem[0].Font[0].$;
        this.negativeColor = '#' + ColorUtils.format(Number(data.StockItem[0].$.negativeColor));
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(r => {
        return this.invalidateData(this.parentPlayer.childProviderData, false);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    invalidateText(value) {
      let label = "";
      if (this.fieldName == 'Percentage') {
        const change = Number(this.providerData['Change']);
        const last = Number(this.providerData['LastTrade']);
        const value = change / (last - change) * 100;
        label = value.toFixed(2) + '%';
      } else if (this.fieldName == 'LastTrade' || this.fieldName == 'Change' || this.fieldName == 'Open' || this.fieldName == 'Max' || this.fieldName == 'Min') {
        label = this.providerData[this.fieldName].toFixed(2);
      } else {
        label = this.providerData[this.fieldName];
      }
      if (Number(this.providerData.Change) < 0) {
        this.genericElm.fontStyle.fill = this.negativeColor;
      }
      this.genericElm.setText(label);
      return of('text');
    }
    static ɵfac = function StockItemComponent_Factory(t) {
      return new (t || StockItemComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: StockItemComponent,
      selectors: [["app-stock-item"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function StockItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return StockItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KnxComponent = /*#__PURE__*/(() => {
  class KnxComponent extends PlayerBase {
    injector;
    knx;
    knxData;
    connection;
    mapIn;
    mapOut;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      const logInfo = Log.getLogInfo("KnxComponent", "load", []);
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.knxData = data.Knx[0].$;
        this.knx = window.require('knx');
        this.connection = this.knx.Connection({
          ipAddr: this.knxData.ip,
          // '192.168.14.73'
          handlers: {
            connected: () => {
              Log.d(logInfo, LogTag.PLAYER, 'Connected!');
            },
            event: (evt, src, dest, value) => {
              Log.d(logInfo, LogTag.PLAYER, 'knx' + evt + " " + " " + dest + " " + value);
              if (evt == "GroupValue_Write") {
                const params = {
                  src: src,
                  dest: dest,
                  value: value
                };
                // 'knx'
                this.playerService.eventParams.dispatch(this.knxData.sendEvent, params, false);
              }
            }
          }
        });
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    //???
    playLoop() {
      return of('loop').pipe(switchMap(r1 => {
        // 'knx_write'
        return this.playerService.eventParams.getEventParam(this.knxData.receivedEvent).pipe(switchMap(args => {
          this.connection.write(args.group, args.value, null, () => {});
          return of('write');
        }));
      }));
    }
    static ɵfac = function KnxComponent_Factory(t) {
      return new (t || KnxComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: KnxComponent,
      selectors: [["app-knx"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 0,
      consts: [["component", ""]],
      template: function KnxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵtext(2, "Knx");
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return KnxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SerialPortComponent = /*#__PURE__*/(() => {
  class SerialPortComponent extends PlayerBase {
    injector;
    serialPort;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      const logInfo = Log.getLogInfo("SerialPortComponent", "load", []);
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const SerialPort = window.require('serialport');
        Log.d(logInfo, LogTag.PLAYER, 'serialPort ' + SerialPort);
        const Readline = SerialPort.parsers.Readline;
        const com = data.SerialPort[0].$.com;
        const baudRate = Number(data.SerialPort[0].$.baudRate);
        this.serialPort = new SerialPort(com, {
          baudRate: baudRate
        });
        const parser = new Readline();
        this.serialPort.pipe(parser);
        parser.on('data', data => {
          this.playerService.eventParams.dispatch('serial_in', data, false);
        });
        this.playerService.eventParams.getEventParam('serial_out').subscribe(value => {
          this.serialPort.write(value);
        });
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function SerialPortComponent_Factory(t) {
      return new (t || SerialPortComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SerialPortComponent,
      selectors: [["app-serial-port"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function SerialPortComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return SerialPortComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AdNetComponent = /*#__PURE__*/(() => {
  class AdNetComponent extends PlayerBase {
    injector;
    genericElm;
    mode; // share, customer, package, content
    channel;
    defaultList;
    defaultMaxInterval;
    packageContents = {};
    contents = [];
    contentLength;
    contentValue;
    contentInfo;
    index = 0;
    timeOffset = 0;
    beginPlayTime = 0;
    defaultUrl;
    timeoutId;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.genericElm = new GenericElm(this.component);
        this.mode = data.AdNet[0].$.mode;
        switch (this.mode) {
          case "share":
            this.channel = Number(data.AdNet[0].$.channel);
            this.defaultList = data.AdNet[0].DefaultList[0].Default;
            this.defaultMaxInterval = Number(data.AdNet[0].$.defaultMaxInterval);
            this.defaultUrl = this.defaultList[0].$.url;
            //this.genericElm.setImage(img, false, this.actualWidth, this.actualHeight);
            break;
        }
        const url = "https://adnet.signage.me/adNetService.ashx?command=targetRequest&targetId=438267";
        return this.playerService.caching.requestText(url, 'adNet', Expiration.Minute);
      }), switchMap(str => {
        const data = JSON.parse(str);
        this.build(data);
        return of(self);
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    build(data) {
      let count = 0;
      let contentInfo;
      for (let i1 = 0; i1 < data.packages.length; ++i1) {
        const adPackage = data.packages[i1].Value;
        if (adPackage.deleted == true || adPackage.enabled == false) continue;
        if (adPackage.playMode != 0) continue;
        for (let i2 = 0; i2 < adPackage.contents.length; ++i2) {
          const content = adPackage.contents[i2];
          const contentId = content.Key;
          const contentValue = content.Value;
          if (contentValue.deleted) continue;
          this.packageContents[contentId] = contentValue;
          contentInfo = {};
          contentInfo.id = contentId;
          contentInfo.duration = contentValue.duration;
          contentInfo.max = Math.min(3600, contentValue.duration * contentValue.reparationsPerHour);
          contentInfo.actual = 0;
          this.contents.push(contentInfo);
          count++;
        }
      }
      let total = 3600;
      while (count > 0 && total > 0) {
        var cup = total / count;
        for (let i3 = 0; i3 < this.contents.length; ++i3) {
          contentInfo = this.contents[i3];
          var empty = contentInfo.max - contentInfo.actual;
          if (empty == 0) continue;
          var add = Math.min(empty, cup);
          contentInfo.actual += add;
          total -= add;
          if (contentInfo.max == contentInfo.actual) count--;
        }
      }
      for (let i3 = 0; i3 < this.contents.length; ++i3) {
        contentInfo = this.contents[i3];
        contentInfo.rep = contentInfo.actual / contentInfo.duration;
        contentInfo.interval = 3600 / contentInfo.rep;
        contentInfo.count = 0;
        contentInfo.totalTime = 0;
        contentInfo.totalTimeArea = 0;
      }
      this.contentLength = this.contents.length;
      this.nextPackageContent();
    }
    nextPackageContent() {
      this.endPlay();
      this.contentValue = null;
      if (this.contentLength > 0) {
        const date = new Date();
        const seconds = date.getTime() / 1000 - this.timeOffset;
        for (let i = 0; i < this.contentLength; ++i) {
          this.index++;
          if (this.index >= this.contentLength) {
            this.index = 0;
          }
          this.contentInfo = this.contents[this.index];
          if (this.contentInfo.count * this.contentInfo.interval < seconds) {
            this.contentInfo.count++;
            this.contentValue = this.packageContents[this.contentInfo.id];
            break;
          }
        }
      }
      if (this.contentValue != null) {
        this.playContent(this.contentValue.contentUrl);
        this.beginPlay();
        this.timeoutId = setTimeout(() => {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
          this.nextPackageContent();
        }, this.contentInfo.duration * 1000);
      } else {
        this.playContent(this.defaultUrl);
        //??? window.setTimeout(nextPackageContent, 10000);
      }
    }
    beginPlay() {
      const d1 = new Date();
      this.beginPlayTime = d1.getTime() / 1000;
    }
    endPlay() {
      if (this.contentValue != null) {
        const d2 = new Date();
        const duration = d2.getTime() / 1000 - this.beginPlayTime;
        /*???
        var url = 'https://adnet.signage.me/adNetService.ashx?command=bannerFlush&targetId=' + m_targetId +
          '&channel=' + m_channel + '&contentId=' + m_contentInfo.id + '&duration=' + duration + "&timezoneOffset=" + timezoneOffset;
        $.getJSON(url,
          function (data2) {
            alert("stat");
          });
        */
        this.contentValue = null;
      }
    }
    playContent(i_src) {
      this.genericElm.setMedia(i_src, false, this.actualWidth, this.actualHeight, null, null);
    }
    destroy() {
      if (this.timeoutId != null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      super.destroy();
    }
    static ɵfac = function AdNetComponent_Factory(t) {
      return new (t || AdNetComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: AdNetComponent,
      selectors: [["app-ad-net"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function AdNetComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return AdNetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoaderComponent = /*#__PURE__*/(() => {
  class LoaderComponent extends PlayerContainer {
    injector;
    loadType;
    loadId;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(playerObject.$.label, this.PREVIEW);
          return of(null);
        }
        this.loadStat();
        return of('load');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    onCommand(command, param) {
      const cmd = command.$.command;
      switch (cmd) {
        case 'load':
          if (param.type == "scene" || param.type == "resource") {
            this.loadType = param.type;
            return of('a').pipe(switchMap(a => {
              this.loadId = param.id;
              return this.showPage();
            }), catchError(err => {
              console.error(err);
              return of(null);
            }));
          }
        case 'clear':
          let oldChildComponent = null;
          if (this.childComponent != null) {
            oldChildComponent = this.childComponent;
            const oldLoader$ = this.childComponent.unload().pipe(finalize(() => {
              if (oldChildComponent.finish$ != null) {
                oldChildComponent.finish$.next("finish");
                oldChildComponent.finish$.complete();
                oldChildComponent.finish$ = null;
              }
              oldChildComponent.destroy();
              this.removeComponent(oldChildComponent);
            }));
            return oldLoader$;
          }
      }
      return of(null);
    }
    getPage() {
      let player = null;
      if (this.loadType == "scene") {
        player = {
          $: {
            src: this.loadId
          }
        };
        return of(player);
      }
      if (this.loadType == "resource") {
        return this.playerService.caching.getRecord("resources", Number(this.loadId)).pipe(switchMap(resource => {
          if (resource != null) {
            player = {
              $: {
                player: resource.resource_type == "mp4" ? 3100 : 3130,
                autoScaling: 1
              },
              Data: [{
                Resource: [{
                  $: {
                    resource: this.loadId
                  }
                }]
              }]
            };
            return of(player);
          } else {
            return of(null);
          }
        }));
      }
      return of(null);
    }
    destroy() {
      super.destroy();
    }
    static ɵfac = function LoaderComponent_Factory(t) {
      return new (t || LoaderComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: LoaderComponent,
      selectors: [["app-scene"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function LoaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return LoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LocationBaseComponent = /*#__PURE__*/(() => {
  class LocationBaseComponent extends PlayerBase {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        this.showMsg(playerObject.$.label, this.NO_PREVIEW);
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function LocationBaseComponent_Factory(t) {
      return new (t || LocationBaseComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: LocationBaseComponent,
      selectors: [["app-location-base"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function LocationBaseComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return LocationBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotSupportedComponent = /*#__PURE__*/(() => {
  class NotSupportedComponent extends PlayerBase {
    injector;
    genericElm;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        this.showMsg("Not Supported", "");
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function NotSupportedComponent_Factory(t) {
      return new (t || NotSupportedComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: NotSupportedComponent,
      selectors: [["app-image"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function NotSupportedComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return NotSupportedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PodcastComponent = /*#__PURE__*/(() => {
  class PodcastComponent extends PlayerBase {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        if (Log.devMode == false || this.editMode) {
          this.showMsg(playerObject.$.label, this.NO_PREVIEW);
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function PodcastComponent_Factory(t) {
      return new (t || PodcastComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PodcastComponent,
      selectors: [["app-podcast"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function PodcastComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return PodcastComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$c = ["chartContainer"];
// Register only what you use for tree shaking of charts
use([LineChart, BarChart, PieChart, ScatterChart, GaugeChart, RadarChart, FunnelChart, TreemapChart, SunburstChart, HeatmapChart, CandlestickChart, BoxplotChart, ParallelChart, SankeyChart, PictorialBarChart, GraphChart, EffectScatterChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, RadarComponent, PolarComponent, VisualMapComponent, ParallelComponent, DataZoomComponent, TimelineComponent, CanvasRenderer]);
let ChartComponent = /*#__PURE__*/(() => {
  class ChartComponent extends PlayerBase {
    injector;
    chartType = 'bar';
    showLegend = false;
    showLabel = true;
    showValue = false;
    showGrid = true;
    showTooltip = true;
    isStacked = false;
    isArea = false;
    // Chart color variables
    axisColor;
    labelFontStyle = {};
    valueFontStyle = {};
    legendPosition = {
      padding: [0, 10],
      itemGap: 20,
      bottom: 5
    };
    chartData;
    testData = [{
      name: 'Mon',
      value: ['120']
    }, {
      name: 'Tue',
      value: ['200']
    }, {
      name: 'Wed',
      value: ['150']
    }, {
      name: 'Thu',
      value: ['80']
    }, {
      name: 'Fri',
      value: ['70']
    }, {
      name: 'Sat',
      value: ['110']
    }, {
      name: 'Sun',
      value: ['130']
    }];
    chartContainer;
    chart;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const font = data.Chart[0].Label?.[0]?.Font?.[0]?.$;
        if (font) {
          const fontStyle = this.getFontStyle(font);
          this.labelFontStyle = {
            fontSize: fontStyle?.fontSize,
            fontFamily: fontStyle?.fontFamily,
            color: fontStyle?.fill
          };
          return this.playerService.caching.requestFont(font);
        }
        return of(null);
      }), switchMap(res => {
        const data = this.playerObject.Data[0];
        const valueFont = data.Chart[0].Value?.[0]?.Font?.[0]?.$;
        if (valueFont) {
          const valueFontStyle = this.getFontStyle(valueFont);
          this.valueFontStyle = {
            fontSize: valueFontStyle?.fontSize,
            fontFamily: valueFontStyle?.fontFamily,
            color: valueFontStyle?.fill
          };
          return this.playerService.caching.requestFont(valueFont);
        }
        return of(null);
      }), switchMap(res => {
        const data = this.playerObject.Data[0];
        if (data.DataProvider?.length > 0) {
          const source = data.DataProvider[0]?.$?.source;
          if (source === 'ai') {
            this.componentStatus('loading');
            const prompt = data.DataProvider[0]?.Ai?.[0]?.Prompt?.[0];
            const series = data.DataProvider[0]?.Ai?.[0]?.Series?.[0];
            const language = data.DataProvider[0]?.Ai?.[0]?.$?.language || 'en';
            // Build Fields object from DataProvider.Ai.Fields
            const fields = {};
            const fieldTitles = [];
            const aiFields = data.DataProvider[0]?.Ai?.[0]?.Fields?.[0]?.Field;
            if (!prompt || !series || prompt.trim() === '' || series.trim() === '' || !aiFields || aiFields.length === 0) {
              this.componentStatus('error', "need to be configure");
              return of(null);
            }
            aiFields.forEach(field => {
              const fieldName = field.$.name;
              const fieldDescription = field.$.description;
              fields[fieldName] = fieldDescription;
              fieldTitles.push(fieldName);
            });
            const body = {
              DataType: 'graph',
              Series: decodeURIComponent(series || ''),
              Prompt: decodeURIComponent(prompt || ''),
              Language: language,
              Fields: fields
            };
            const port = this.playerService.isDevOrLocal() ? ":9443" : "";
            let url = "https://ai.signage.me" + port + "/feed/request";
            // post with body - cache for 1 hour (3600000ms)
            return this.playerService.caching.postJson(url, body, 'ai-feed', 3600000).pipe(switchMap(result => {
              console.log('AI Response:', result);
              // Convert AI feed format to chartData format
              if (result?.success && result?.items && Array.isArray(result.items) && result.series) {
                const chartData = result.series.map((seriesName, index) => {
                  const item = result.items[index];
                  // Extract all values from the item object (name1, name2, etc.)
                  const values = item ? Object.values(item).map(v => String(v)) : [];
                  return {
                    name: seriesName,
                    value: values
                  };
                });
                // Store field titles in Legend for use in chart rendering
                if (!data.Chart[0].Legend) {
                  data.Chart[0].Legend = [{
                    colors: [],
                    titles: []
                  }];
                }
                if (fieldTitles.length > 0) {
                  data.Chart[0].Legend[0].titles = fieldTitles;
                }
                this.componentStatus('ready');
                return of(chartData);
              } else {
                this.componentStatus('error', "need to be configure");
                return of(null);
              }
            }), catchError(err => {
              console.error('RSS AI Error:', err);
              this.componentStatus('error', "need to be configure");
              return of(null);
            }));
          } else {
            // if source is 'fixed', use fixed ChartData
            return of(data.Chart[0].ChartData || []);
          }
        } else {
          // for already existing charts
          return of(data.Chart[0].ChartData || []);
        }
      }), switchMap(chartData => {
        if (chartData?.length == 0) {
          return of(null);
        }
        this.chartData = chartData;
        const data = this.playerObject.Data[0];
        // init with modular API
        this.chart = init(this.chartContainer.nativeElement);
        this.chartType = data.Chart[0].$.type || 'column';
        this.showLabel = data.Chart[0].$.showLabel == '1';
        this.showGrid = data.Chart[0].$.showGrid == '1';
        this.showLegend = data.Chart[0].$.showLegend == '1';
        this.showValue = data.Chart[0].$.showValue == '1';
        this.showTooltip = data.Chart[0].$.showTooltip == '1';
        this.isStacked = ['stackedLine', 'stackedArea', 'stackedHorizontalBar', 'stackedColumn'].includes(this.chartType);
        this.isArea = ['area', 'stackedArea'].includes(this.chartType);
        if (data.Chart[0].$.axisColor) {
          this.axisColor = '#' + ColorUtils.format(Number(data.Chart[0].$.axisColor));
        }
        // this.chartType = 'pie';
        switch (this.chartType) {
          case 'bar':
          case 'line':
          case 'column':
          case 'area':
          case 'scatter':
          case 'stackedArea':
          case 'stackedColumn':
          case 'stackedHorizontalBar':
          case 'stackedLine':
            this.loadBarLineChart(this.chartData);
            break;
          case 'pie':
            this.loadPieChart(this.chartData);
            break;
          case 'doughnut':
            this.loadDoughnutChart(this.chartData);
            break;
          case 'gauge':
            this.loadGaugeChart(this.chartData);
            break;
          case 'radar':
            this.loadRadarChart(this.chartData);
            break;
          case 'funnel':
            this.loadFunnelChart(this.chartData);
            break;
          case 'polarBar':
          case 'polarLine':
            this.loadPolarChart(this.chartData);
            break;
          case 'treemap':
            this.loadTreemapChart(this.chartData);
            break;
          case 'sunburst':
            this.loadSunburstChart(this.chartData);
            break;
          case 'heatmap':
            this.loadHeatmapChart(this.chartData);
            break;
          case 'candlestick':
            this.loadCandlestickChart(this.chartData);
            break;
          case 'boxplot':
            this.loadBoxplotChart(this.chartData);
            break;
          case 'parallel':
            this.loadParallelChart(this.chartData);
            break;
          case 'sankey':
            this.loadSankeyChart(this.chartData);
            break;
          case 'pictorialBar':
            this.loadPictorialBarChart(this.chartData);
            break;
          case 'graph':
            this.loadGraphChart(this.chartData);
            break;
          case 'steppedLine':
            this.loadSteppedLineChart(this.chartData);
            break;
          case 'waterfall':
            this.loadWaterfallChart(this.chartData);
            break;
          case 'rose':
            this.loadRoseChart(this.chartData);
            break;
          case 'effectScatter':
            this.loadEffectScatterChart(this.chartData);
            break;
          case 'smoothLine':
            this.loadSmoothLineChart(this.chartData);
            break;
          case 'dottedLine':
            this.loadDottedLineChart(this.chartData);
            break;
          case 'gradientArea':
            this.loadGradientAreaChart(this.chartData);
            break;
          case 'roundedBar':
            this.loadRoundedBarChart(this.chartData);
            break;
          case 'negativeBar':
            this.loadNegativeBarChart(this.chartData);
            break;
          case 'groupedBar':
            this.loadGroupedBarChart(this.chartData);
            break;
          case 'lineRace':
            this.loadLineRaceChart(this.chartData);
            break;
          case 'barRace':
            this.loadBarRaceChart(this.chartData);
            break;
          case 'bubble':
            this.loadBubbleChart(this.chartData);
            break;
          case 'mixedLineBar':
            this.loadMixedLineBarChart(this.chartData);
            break;
          case 'radialBar':
            this.loadRadialBarChart(this.chartData);
            break;
          case 'liquidFill':
            this.loadLiquidFillChart(this.chartData);
            break;
          default:
            console.log("not supported chart type", this.chartType);
            return of(null);
        }
        // small async resize to settle container layout
        setTimeout(() => this.chart?.resize(), 100);
        return of('ok');
      }), catchError(err => this.logError(err)), switchMap(() => of(self)), takeUntil(this.finish$));
    }
    loadBarLineChart(data) {
      const isHorizontal = this.chartType === 'bar' || this.chartType === 'stackedHorizontalBar';
      const isScatter = this.chartType === 'scatter';
      // Determine the number of series (legends) from the maximum value array length
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      // Get legend colors and titles if available
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      // Create series array for multiple legends
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = isScatter ? data.map((item, index) => [index, item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0]) : data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: this.getSeriesType(),
          name: seriesName,
          data: seriesData,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          areaStyle: this.isArea ? {} : undefined,
          stack: this.isStacked ? 'Total' : undefined,
          label: {
            show: this.showValue,
            position: isHorizontal ? 'right' : 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: isHorizontal ? 'value' : 'category',
          data: isHorizontal ? null : data.map(item => String(item.name)),
          // boundaryGap: isHorizontal ? true : [0, '30%'],
          splitLine: {
            show: isHorizontal ? this.showGrid : !this.showTooltip,
            alignWithLabel: this.getSeriesType() !== 'bar',
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          // axisTick: {
          //     show: true
          // },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: isHorizontal ? 'category' : 'value',
          data: isHorizontal ? data.map(item => String(item.name)) : null,
          // boundaryGap: isHorizontal ? [0, '30%'] : true,
          splitLine: {
            show: !isHorizontal ? this.showGrid : !this.showTooltip,
            alignWithLabel: this.getSeriesType() !== 'bar',
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          // axisTick: {
          //     show: true
          // },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor || '#E5E5E5'
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    getSeriesType() {
      switch (this.chartType) {
        case 'column':
        case 'stackedHorizontalBar':
        case 'stackedColumn':
        case 'horizontalBar':
          return 'bar';
        case 'area':
        case 'stackedLine':
        case 'stackedArea':
          return 'line';
        case 'scatter':
          return 'scatter';
        default:
          return this.chartType;
      }
    }
    loadDoughnutChart(data) {
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item'
        },
        legend: {
          show: this.showLegend,
          orient: 'vertical',
          left: 'left',
          textStyle: this.labelFontStyle
        },
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          // Inner and outer radius for doughnut effect
          data: data.map(item => ({
            name: String(item.name),
            value: item.value[0] ? Number(item.value[0]) : 0
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            show: this.showLabel,
            formatter: this.showValue ? '{b}: {c} ({d}%)' : '{b}',
            ...(this.showValue ? this.valueFontStyle : this.labelFontStyle)
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadPieChart(data) {
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item'
        },
        legend: {
          show: this.showLegend,
          orient: 'vertical',
          left: 'left',
          textStyle: this.labelFontStyle
        },
        series: [{
          type: 'pie',
          radius: '60%',
          data: data.map(item => ({
            name: String(item.name),
            value: item.value[0] ? Number(item.value[0]) : 0
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            show: this.showLabel,
            formatter: this.showValue ? '{b}: {c} ({d}%)' : '{b}',
            ...(this.showValue ? this.valueFontStyle : {
              color: this.axisColor
            })
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadGaugeChart(data) {
      // Use the first data item for gauge value
      const gaugeValue = data.length > 0 && data[0].value[0] ? Number(data[0].value[0]) : 0;
      const maxValue = 100;
      const gaugeName = data.length > 0 ? String(data[0].name) : 'Gauge';
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      let pointColor;
      let title;
      if (legendColors?.length > 0) {
        pointColor = '#' + ColorUtils.format(Number(legendColors[0]));
      }
      if (legendTitles?.length > 0) {
        title = legendTitles[0];
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [{
          name: title || gaugeName,
          type: 'gauge',
          min: 0,
          max: maxValue,
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}',
            ...this.valueFontStyle
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            lineStyle: {
              color: [[1, this.axisColor || '#E6EBF8']],
              width: 6
            }
          },
          axisTick: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor || '#999',
              width: 1
            }
          },
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor || '#E6EBF8',
              width: 2
            }
          },
          pointer: {
            itemStyle: {
              color: pointColor || '#5470C6'
            }
          },
          data: [{
            value: gaugeValue,
            name: gaugeName
          }]
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadRadarChart(data) {
      // Determine the number of series from the maximum value array length
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      // Get legend colors and titles
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      // Create radar indicators from data names
      const indicator = data.map(item => ({
        name: String(item.name),
        max: Math.max(...item.value.map(v => Number(v))) * 1.2 // Add 20% padding
      }));
      // Create series data
      const seriesData = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const values = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        seriesData.push({
          name: seriesName,
          value: values,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          areaStyle: this.chartType === 'area' ? {} : undefined
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        radar: {
          indicator: indicator,
          axisName: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: [{
          type: 'radar',
          data: seriesData,
          label: {
            show: this.showValue,
            ...this.valueFontStyle
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadFunnelChart(data) {
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        legend: {
          show: this.showLegend,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        series: [{
          name: 'Funnel',
          type: 'funnel',
          left: '10%',
          width: '80%',
          label: {
            show: this.showLabel,
            position: 'inside',
            ...this.labelFontStyle
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          emphasis: {
            label: {
              fontSize: 20
            }
          },
          data: data.map((item, index) => ({
            name: String(item.name),
            value: item.value[0] ? Number(item.value[0]) : 0,
            itemStyle: legendColors[index] ? {
              color: '#' + ColorUtils.format(Number(legendColors[index]))
            } : undefined
          }))
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadPolarChart(data) {
      const isPolarBar = this.chartType === 'polarBar';
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: isPolarBar ? 'bar' : 'line',
          name: seriesName,
          data: seriesData,
          coordinateSystem: 'polar',
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: 'middle',
            ...this.valueFontStyle
          },
          smooth: !isPolarBar
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        polar: {
          radius: ['20%', '80%']
        },
        angleAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        radiusAxis: {
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadTreemapChart(data) {
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item',
          formatter: '{b}: {c}'
        },
        series: [{
          type: 'treemap',
          data: data.map((item, index) => ({
            name: String(item.name),
            value: item.value[0] ? Number(item.value[0]) : 0,
            itemStyle: legendColors[index] ? {
              color: '#' + ColorUtils.format(Number(legendColors[index]))
            } : undefined
          })),
          label: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          breadcrumb: {
            show: false
          },
          roam: false
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadSunburstChart(data) {
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item'
        },
        series: [{
          type: 'sunburst',
          data: data.map((item, index) => ({
            name: String(item.name),
            value: item.value[0] ? Number(item.value[0]) : 0,
            itemStyle: legendColors[index] ? {
              color: '#' + ColorUtils.format(Number(legendColors[index]))
            } : undefined
          })),
          radius: ['20%', '90%'],
          label: {
            show: this.showLabel,
            ...this.labelFontStyle,
            rotate: 'radial'
          },
          emphasis: {
            focus: 'ancestor'
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadHeatmapChart(data) {
      // For heatmap, we treat columns as Y-axis categories and rows as X-axis
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      // Create Y-axis categories (series/columns)
      const yAxisData = [];
      for (let i = 0; i < maxSeriesCount; i++) {
        yAxisData.push(legendTitles[i] || `Series ${i + 1}`);
      }
      // Create heatmap data in format [xIndex, yIndex, value]
      const heatmapData = [];
      data.forEach((item, xIndex) => {
        item.value.forEach((val, yIndex) => {
          if (val) {
            heatmapData.push([xIndex, yIndex, Number(val)]);
          }
        });
      });
      // Calculate min and max for visual map
      const values = heatmapData.map(item => item[2]);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);
      const option = {
        tooltip: {
          show: this.showTooltip,
          position: 'top'
        },
        grid: {
          height: '70%',
          top: '10%'
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          splitArea: {
            show: true
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'category',
          data: yAxisData,
          splitArea: {
            show: true
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        visualMap: {
          min: minValue,
          max: maxValue,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '5%',
          textStyle: this.labelFontStyle
        },
        series: [{
          type: 'heatmap',
          data: heatmapData,
          label: {
            show: this.showValue,
            ...this.labelFontStyle
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadCandlestickChart(data) {
      // Candlestick needs 4 values: [open, close, low, high]
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const candlestickData = data.map(item => {
        const values = item.value.map(v => Number(v));
        // Ensure we have 4 values, pad with 0 if needed
        while (values.length < 4) values.push(0);
        return values.slice(0, 4); // [open, close, low, high]
      });
      const upColor = '#00da3c';
      const downColor = '#ec0000';
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          show: this.showLegend,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          scale: true,
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: [{
          type: 'candlestick',
          data: candlestickData,
          itemStyle: {
            color: upColor,
            color0: downColor,
            borderColor: upColor,
            borderColor0: downColor
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadBoxplotChart(data) {
      // Boxplot needs 5 values: [min, Q1, median, Q3, max]
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const boxplotData = data.map(item => {
        const values = item.value.map(v => Number(v));
        // Ensure we have 5 values, pad with 0 if needed
        while (values.length < 5) values.push(0);
        return values.slice(0, 5); // [min, Q1, median, Q3, max]
      });
      const boxColor = legendColors[0] ? '#' + ColorUtils.format(Number(legendColors[0])) : '#5470C6';
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: this.showLegend,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: [{
          type: 'boxplot',
          data: boxplotData,
          itemStyle: {
            color: boxColor
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadParallelChart(data) {
      // Parallel chart uses multiple values as different axes
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      // Create parallel axes from value columns
      const parallelAxis = [];
      for (let i = 0; i < maxSeriesCount; i++) {
        parallelAxis.push({
          dim: i,
          name: legendTitles[i] || `Axis ${i + 1}`,
          nameTextStyle: this.labelFontStyle,
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          }
        });
      }
      // Convert data to parallel format
      const parallelData = data.map(item => {
        return item.value.map(v => Number(v) || 0);
      });
      const lineColor = legendColors[0] ? '#' + ColorUtils.format(Number(legendColors[0])) : '#5470C6';
      const option = {
        tooltip: {
          show: this.showTooltip
        },
        parallelAxis: parallelAxis,
        parallel: {
          left: '10%',
          right: '10%',
          bottom: '10%',
          top: '10%',
          parallelAxisDefault: {
            type: 'value',
            nameLocation: 'end',
            nameGap: 20
          }
        },
        series: [{
          type: 'parallel',
          lineStyle: {
            width: 2,
            color: lineColor,
            opacity: 0.6
          },
          data: parallelData
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadSankeyChart(data) {
      // Sankey: Convert name+value to source→target flow
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      // Create nodes from data names
      const nodes = data.map((item, index) => ({
        name: String(item.name),
        itemStyle: legendColors[index] ? {
          color: '#' + ColorUtils.format(Number(legendColors[index]))
        } : undefined
      }));
      // Create links: each item connects to the next with its value
      const links = [];
      for (let i = 0; i < data.length - 1; i++) {
        links.push({
          source: String(data[i].name),
          target: String(data[i + 1].name),
          value: data[i].value[0] ? Number(data[i].value[0]) : 0
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item',
          triggerOn: 'mousemove'
        },
        series: [{
          type: 'sankey',
          data: nodes,
          links: links,
          emphasis: {
            focus: 'adjacency'
          },
          label: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          lineStyle: {
            color: 'gradient',
            curveness: 0.5
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadSteppedLineChart(data) {
      // Stepped line chart - line with steps instead of smooth curves
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'line',
          name: seriesName,
          data: seriesData,
          step: 'middle',
          // Can be 'start', 'middle', or 'end'
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadWaterfallChart(data) {
      // Waterfall chart - shows cumulative effect
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const positiveColor = legendColors[0] ? '#' + ColorUtils.format(Number(legendColors[0])) : '#5470C6';
      const negativeColor = legendColors[1] ? '#' + ColorUtils.format(Number(legendColors[1])) : '#EE6666';
      // Calculate cumulative values for waterfall
      let cumulative = 0;
      const waterfallData = data.map(item => {
        const value = item.value[0] ? Number(item.value[0]) : 0;
        const start = cumulative;
        cumulative += value;
        return {
          name: String(item.name),
          value: cumulative,
          itemStyle: {
            color: value >= 0 ? positiveColor : negativeColor
          }
        };
      });
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: this.showLegend,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: [{
          type: 'bar',
          data: waterfallData,
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadRoseChart(data) {
      // Rose (Nightingale) chart - pie with varying radii
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const roseData = data.map((item, index) => ({
        name: String(item.name),
        value: item.value[0] ? Number(item.value[0]) : 0,
        itemStyle: legendColors[index] ? {
          color: '#' + ColorUtils.format(Number(legendColors[index]))
        } : undefined
      }));
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item'
        },
        legend: {
          show: this.showLegend,
          orient: 'vertical',
          left: 'left',
          textStyle: this.labelFontStyle
        },
        series: [{
          type: 'pie',
          radius: ['20%', '70%'],
          roseType: 'area',
          // Makes it a nightingale/rose chart
          data: roseData,
          label: {
            show: this.showLabel,
            color: this.axisColor,
            formatter: this.showValue ? '{b}: {c} ({d}%)' : '{b}'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadEffectScatterChart(data) {
      // Effect scatter - animated scatter with ripple effect
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map((item, index) => [index, item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0]);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'effectScatter',
          name: seriesName,
          data: seriesData,
          symbolSize: 10,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          rippleEffect: {
            brushType: 'stroke',
            scale: 3,
            period: 4
          },
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadPictorialBarChart(data) {
      // Pictorial bar is like regular bar but with custom symbols
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'pictorialBar',
          name: seriesName,
          data: seriesData,
          symbol: 'rect',
          // Can be 'rect', 'circle', 'diamond', etc.
          symbolRepeat: true,
          symbolSize: ['80%', '60%'],
          symbolMargin: 2,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadGraphChart(data) {
      // Graph/Network chart: names become nodes, values become connections
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      // Create nodes from data
      const nodes = data.map((item, index) => ({
        name: String(item.name),
        value: item.value[0] ? Number(item.value[0]) : 10,
        symbolSize: item.value[0] ? Math.max(Number(item.value[0]) / 10, 20) : 20,
        itemStyle: legendColors[index] ? {
          color: '#' + ColorUtils.format(Number(legendColors[index]))
        } : undefined
      }));
      // Create links between consecutive nodes
      const links = [];
      for (let i = 0; i < data.length - 1; i++) {
        links.push({
          source: String(data[i].name),
          target: String(data[i + 1].name),
          value: data[i].value[1] ? Number(data[i].value[1]) : 1
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item'
        },
        legend: {
          show: this.showLegend,
          textStyle: this.labelFontStyle
        },
        series: [{
          type: 'graph',
          layout: 'force',
          data: nodes,
          links: links,
          roam: true,
          label: {
            show: this.showLabel,
            position: 'right',
            ...this.labelFontStyle
          },
          force: {
            repulsion: 100,
            edgeLength: 100
          },
          emphasis: {
            focus: 'adjacency',
            lineStyle: {
              width: 3
            }
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadSmoothLineChart(data) {
      // Smooth line chart with Bezier curves
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'line',
          name: seriesName,
          data: seriesData,
          smooth: true,
          // Always smooth for this chart type
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadDottedLineChart(data) {
      // Dotted/Dashed line chart
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      const lineStyles = ['solid', 'dashed', 'dotted'];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'line',
          name: seriesName,
          data: seriesData,
          lineStyle: {
            type: lineStyles[seriesIndex % lineStyles.length],
            width: 2
          },
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadGradientAreaChart(data) {
      // Area chart with gradient fill
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : '#5470C6';
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'line',
          name: seriesName,
          data: seriesData,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: seriesColor
              }, {
                offset: 1,
                color: 'rgba(255, 255, 255, 0.1)'
              }]
            }
          },
          itemStyle: {
            color: seriesColor
          },
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          boundaryGap: false,
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadRoundedBarChart(data) {
      // Bar chart with rounded corners
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'bar',
          name: seriesName,
          data: seriesData,
          itemStyle: {
            borderRadius: [10, 10, 0, 0],
            // Rounded top corners
            color: seriesColor
          },
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadNegativeBarChart(data) {
      // Bar chart optimized for positive/negative values
      const positiveColor = '#00da3c';
      const negativeColor = '#ec0000';
      const barData = data.map(item => {
        const value = item.value[0] ? Number(item.value[0]) : 0;
        return {
          value: value,
          itemStyle: {
            color: value >= 0 ? positiveColor : negativeColor
          }
        };
      });
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: this.showLegend,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: [{
          type: 'bar',
          data: barData,
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadGroupedBarChart(data) {
      // Grouped bar chart (multi-series side-by-side, not stacked)
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'bar',
          name: seriesName,
          data: seriesData,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadLineRaceChart(data) {
      // Line race chart - animated racing lines (uses animation)
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'line',
          name: seriesName,
          data: seriesData,
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          lineStyle: {
            width: 3
          },
          label: {
            show: this.showValue,
            position: 'top',
            ...this.valueFontStyle
          },
          animationDuration: 2000,
          animationEasing: 'cubicOut'
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis'
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadBarRaceChart(data) {
      // Bar race chart - animated racing bars
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'bar',
          name: seriesName,
          data: seriesData,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: 'right',
            ...this.valueFontStyle
          },
          animationDuration: 2000,
          animationEasing: 'elasticOut',
          realtimeSort: true
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          inverse: true,
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadBubbleChart(data) {
      // Bubble chart - scatter with varying bubble sizes
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 1 ? Math.min(maxSeriesCount, 3) : 1; // Use up to 3 values: x, y, size
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < Math.min(seriesCount, 1); seriesIndex++) {
        const seriesData = data.map((item, index) => {
          const yValue = item.value[0] ? Number(item.value[0]) : 0;
          const bubbleSize = item.value[1] ? Number(item.value[1]) : 10;
          return [index, yValue, bubbleSize];
        });
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || 'Bubble Data';
        series.push({
          type: 'scatter',
          name: seriesName,
          data: seriesData,
          symbolSize: data => {
            return Math.max(data[2] || 10, 5); // Use third value as size, min 5
          },
          itemStyle: seriesColor ? {
            color: seriesColor,
            opacity: 0.7
          } : {
            opacity: 0.7
          },
          label: {
            show: this.showValue,
            formatter: '{c}',
            position: 'top',
            ...this.valueFontStyle
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'item'
        },
        legend: {
          show: this.showLegend,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadMixedLineBarChart(data) {
      // Mixed line and bar chart
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesData = data.map(item => item.value[seriesIndex] ? Number(item.value[seriesIndex]) : 0);
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        // Alternate between bar and line types
        series.push({
          type: seriesIndex % 2 === 0 ? 'bar' : 'line',
          name: seriesName,
          data: seriesData,
          itemStyle: seriesColor ? {
            color: seriesColor
          } : undefined,
          label: {
            show: this.showValue,
            position: seriesIndex % 2 === 0 ? 'top' : 'top',
            color: this.axisColor
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          show: this.showLegend && seriesCount > 1,
          textStyle: this.labelFontStyle,
          ...this.legendPosition
        },
        xAxis: {
          type: 'category',
          data: data.map(item => String(item.name)),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: this.showGrid,
            lineStyle: {
              color: this.axisColor,
              opacity: 0.3
            }
          },
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: this.axisColor
            }
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadRadialBarChart(data) {
      if (!this.chart) return;
      // Get chart configuration
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      const legendTitles = chartConfig.Legend?.[0]?.titles || [];
      // Determine number of series
      const maxSeriesCount = Math.max(...data.map(item => item.value.length));
      const seriesCount = maxSeriesCount > 0 ? maxSeriesCount : 1;
      // Create series for each value column
      const series = [];
      for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
        const seriesColor = legendColors[seriesIndex] ? '#' + ColorUtils.format(Number(legendColors[seriesIndex])) : undefined;
        const seriesName = legendTitles[seriesIndex] || `Series ${seriesIndex + 1}`;
        series.push({
          type: 'bar',
          name: seriesName,
          data: data.map(item => Number(item.value[seriesIndex]) || 0),
          coordinateSystem: 'polar',
          itemStyle: {
            color: seriesColor
          },
          label: {
            show: this.showLabel,
            formatter: '{c}',
            ...this.labelFontStyle
          },
          emphasis: {
            focus: 'series'
          }
        });
      }
      const option = {
        tooltip: {
          show: this.showTooltip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: this.showLegend,
          data: legendTitles.slice(0, seriesCount),
          textStyle: {
            ...this.labelFontStyle
          },
          ...this.legendPosition
        },
        polar: {
          radius: ['15%', '80%']
        },
        angleAxis: {
          max: Math.max(...data.flatMap(item => item.value.map(v => Number(v) || 0))) * 1.1,
          startAngle: 90,
          axisLabel: {
            show: this.showValue,
            ...this.labelFontStyle
          }
        },
        radiusAxis: {
          type: 'category',
          data: data.map(item => item.name),
          axisLabel: {
            show: this.showLabel,
            ...this.labelFontStyle
          }
        },
        series: series
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    loadLiquidFillChart(data) {
      if (!this.chart) return;
      // Get chart configuration
      const chartConfig = this.playerObject.Data[0].Chart[0];
      const legendColors = chartConfig.Legend?.[0]?.colors || [];
      // Use first data point's first value as percentage
      const value = data.length > 0 ? Number(data[0].value[0]) || 0 : 0;
      const name = data.length > 0 ? data[0].name : '';
      const gaugeColor = legendColors[0] ? '#' + ColorUtils.format(Number(legendColors[0])) : '#5470c6';
      const option = {
        tooltip: {
          show: this.showTooltip,
          formatter: '{b}: {c}%'
        },
        series: [{
          type: 'gauge',
          name: name,
          progress: {
            show: true,
            width: 30,
            itemStyle: {
              color: gaugeColor
            }
          },
          axisLine: {
            lineStyle: {
              width: 30,
              color: [[1, 'rgba(128, 128, 128, 0.3)']]
            }
          },
          axisTick: {
            show: this.showGrid,
            distance: -35
          },
          splitLine: {
            show: this.showGrid,
            length: 15,
            distance: -38,
            lineStyle: {
              width: 2,
              color: '#999'
            }
          },
          axisLabel: {
            show: this.showValue,
            distance: 40,
            color: this.axisColor,
            ...this.labelFontStyle
          },
          anchor: {
            show: false
          },
          pointer: {
            show: false
          },
          title: {
            show: this.showLabel,
            offsetCenter: [0, '20%'],
            ...this.labelFontStyle
          },
          detail: {
            show: this.showValue,
            valueAnimation: true,
            formatter: '{value}%',
            offsetCenter: [0, '-10%'],
            ...this.valueFontStyle
          },
          data: [{
            value: value,
            name: name
          }]
        }]
      };
      this.chart.setOption(option, {
        notMerge: true
      });
    }
    destroy() {
      try {
        this.chart?.dispose();
      } catch {/* noop */
      }
      super.destroy();
    }
    static ɵfac = function ChartComponent_Factory(t) {
      return new (t || ChartComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ChartComponent,
      selectors: [["app-chart"]],
      viewQuery: function ChartComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$c, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["chartContainer", ""], [2, "width", "100%", "height", "100%"], [2, "width", "100%", "height", "100%", "min-height", "200px"]],
      template: function ChartComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵelement(2, "div", 3, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return ChartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormComponent = /*#__PURE__*/(() => {
  class FormComponent extends PlayerBase {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function FormComponent_Factory(t) {
      return new (t || FormComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormComponent,
      selectors: [["app-form"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function FormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return FormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FasterQComponent = /*#__PURE__*/(() => {
  class FasterQComponent extends PlayerBase {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        this.showMsg(playerObject.$.label, this.NO_PREVIEW);
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function FasterQComponent_Factory(t) {
      return new (t || FasterQComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FasterQComponent,
      selectors: [["app-faster-q"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function FasterQComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return FasterQComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SchedulerComponent = /*#__PURE__*/(() => {
  class SchedulerComponent extends PlayerContainer {
    injector;
    scheduleEvents;
    loadType;
    loadId;
    scheduleId = -1;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (data.Schedule[0]?.$?.id) {
          this.scheduleId = Number(data.Schedule[0].$.id);
        }
        if (this.editMode) {
          if (this.scheduleId != -1) {
            return this.playerService.caching.getRecord("schedules", this.scheduleId).pipe(switchMap(schedule => {
              this.showMsg(schedule.schedule_name, schedule.description);
              return of(null);
            }));
          } else {
            this.showMsg("Schedule", "No schedule assigned");
            return of(null);
          }
        } else {
          if (this.scheduleId != -1) {
            this.loadStat();
            this.scheduleEvents = this.playerService.createScheduleEvents(this.scheduleId);
            return this.scheduleEvents.load(this.scheduleId).pipe(switchMap(a => this.playLoop()));
          } else {
            return of(null);
          }
        }
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    playLoop() {
      const obs1$ = this.scheduleEvents.play();
      const eventName = "event_schedule_" + this.scheduleId;
      const obs2$ = this.playerService.eventParams.getEventParam(eventName).pipe(switchMap(param => {
        if (param.type == "scene" || param.type == "resource") {
          this.loadType = param.type;
          this.loadId = param.id;
          return this.showPage();
        } else {
          if (this.childComponent != null) {
            const duration = Number(((new Date().getTime() - this.statStart) / 1000).toFixed(2));
            this.childComponent.addContent(this.statTag, this.statFiled, duration);
            this.childComponent.destroy();
            this.removeComponent(this.childComponent);
          }
          this.childComponent = null;
          return of('complete');
        }
      }));
      return forkJoin([obs1$, obs2$]);
    }
    getPage() {
      let player = null;
      if (this.loadType == "scene") {
        player = {
          $: {
            src: this.loadId
          }
        };
        return of(player);
      }
      if (this.loadType == "resource") {
        return this.playerService.caching.getRecord("resources", Number(this.loadId)).pipe(switchMap(resource => {
          if (resource != null) {
            player = {
              $: {
                player: resource.resource_type == "mp4" ? 3100 : 3130,
                autoScaling: 1
              },
              Data: [{
                Resource: [{
                  $: {
                    resource: this.loadId
                  }
                }]
              }]
            };
            return of(player);
          }
        }));
      }
      return of(null);
    }
    destroy() {
      /*  will not destroy scheduleEvents cause it might be use    if (this.scheduleEvents!=null) {
        this.scheduleEvents.destroy();
        this.scheduleEvents = null;
      }
        */
      super.destroy();
    }
    static ɵfac = function SchedulerComponent_Factory(t) {
      return new (t || SchedulerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SchedulerComponent,
      selectors: [["app-scene"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function SchedulerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return SchedulerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HourlyBalancerComponent = /*#__PURE__*/(() => {
  class HourlyBalancerComponent extends PlayerContainer {
    injector;
    pages;
    index = -1;
    duration;
    startTime;
    gap = 0;
    fillGaps;
    curPlayed;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap$1(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.editMode) {
          this.showMsg(playerObject.$.label, this.PREVIEW);
          return of(null);
        }
        this.pages = data.HourlyBalancer[0].Page;
        this.fillGaps = data.HourlyBalancer[0].$.fillGaps == "1";
        let totalPlay = 0;
        let totalItems = 0;
        if (this.pages != null) {
          this.pages.forEach(page => {
            page.count = 0;
            totalPlay += Number(page.$.repetitions) * Number(page.$.duration);
            totalItems += Number(page.$.repetitions);
          });
        }
        this.gap = Math.max(0, (3600 - totalPlay) / totalItems);
        this.curPlayed = 0;
        this.index = -1;
        this.startTime = new Date().getTime();
        this.loadStat();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap$1(a => of(self)), takeUntil(this.finish$));
    }
    getIndex() {
      const time = (new Date().getTime() - this.startTime) / 1000;
      while (true) {
        this.index++;
        if (this.index == this.pages.length) {
          this.index = 0;
        }
        const page = this.pages[this.index];
        const repetitions = Number(page.$.repetitions);
        const step = 3600 / repetitions;
        const duration = Number(page.$.duration);
        const count = time / step;
        if (page.count <= count) {
          page.count++;
          this.curPlayed += duration + this.gap;
          break;
        }
      }
    }
    getPage() {
      const logInfo = Log.getLogInfo("HourlyBalancerComponent", "getPage", []);
      if (this.pages == null || this.pages.length == 0) {
        Log.d(logInfo, LogTag.PLAYER, 'no pages');
        this.showMsg(this.playerObject.$.label, 'Playlist is empty');
        return of(null);
      } else {
        this.showMsg(null, null);
        this.getIndex();
        const page = this.pages[this.index];
        let player = page.Player[0];
        this.duration = Number(page.$.duration);
        return of(player);
      }
    }
    play() {
      if (this.pages == null || this.pages.length == 0) {
        return of('a');
      }
      return of('loop').pipe(switchMap$1(r1 => this.showPage()), switchMap$1(a => of('delay').pipe(delay(this.duration * 1000))), switchMap$1(r => {
        if (this.fillGaps == false && this.childComponent != null && this.gap > 10) {
          const oldChildComponent = this.childComponent;
          this.childComponent = null;
          return oldChildComponent.unload().pipe(tap$1(child => {
            const duration = Number(((new Date().getTime() - this.statStart) / 1000).toFixed(2));
            this.unloadComplete(child, duration);
          }), finalize(() => {
            if (oldChildComponent.finish$ != null) {
              oldChildComponent.finish$.next("finish");
              oldChildComponent.finish$.complete();
              oldChildComponent.finish$ = null;
            }
            oldChildComponent.destroy();
            this.removeComponent(oldChildComponent);
          }));
        }
        return of('next');
      }), delay(this.gap * 1000), repeat());
    }
    static ɵfac = function HourlyBalancerComponent_Factory(t) {
      return new (t || HourlyBalancerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: HourlyBalancerComponent,
      selectors: [["app-playlist"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function HourlyBalancerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return HourlyBalancerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$b = ["flk"];
function FlickingComponent_app_flicking_item_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flicking-item", 5);
  }
  if (rf & 2) {
    const page_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setParentPlayer", ctx_r1)("setEditMode", ctx_r1.editMode)("setPage", page_r1);
  }
}
let FlickingComponent = /*#__PURE__*/(() => {
  class FlickingComponent extends PlayerContainer {
    injector;
    options;
    pages;
    index = 0;
    updateIndex = 0;
    flk;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    getPage() {
      const data = this.playerObject.Data[0];
      this.pages = data.Flicking[0].Page;
      const page = this.pages[0];
      let player = page.Player[0];
      return of(player);
    }
    load(playerObject) {
      let self;
      const data = this.playerObject.Data[0];
      let initialized = false;
      return super.load(playerObject).pipe(switchMap$1(playerBase => {
        self = playerBase;
        this.scaleX = this.parentPlayer.scaleX;
        this.scaleY = this.parentPlayer.scaleY;
        this.options = {
          align: 'prev'
        };
        this.options.horizontal = data.Flicking[0].$.vertical == '0';
        this.pages = data.Flicking[0].Page;
        this.updateIndex = 0;
        if (this.pages == null || this.pages.length == 0) {
          this.showMsg(this.playerObject.$.label, 'Flicking is empty');
          this.changeDetectorRef.detectChanges();
          return of('a');
        } else {
          this.showMsg(null, null);
          if (this.editMode) {
            this.display(true);
            return this.showPage();
          }
          this.changeDetectorRef.detectChanges();
          const list = [];
          this.pages.forEach(page => {
            list.push(page.$obs);
          });
          return forkJoin(list);
        }
      }), catchError(err => this.logError(err)), switchMap$1(a => of(self)), takeUntil(this.finish$));
    }
    loadAnimation() {}
    display(show) {}
    updatePanels() {
      this.updateIndex++;
      if (this.updateIndex < this.pages.length) {
        return;
      }
      this.flk.moveTo(0).catch(err => {
        if (err instanceof FlickingError) return;
        throw err;
      });
      this.flk.resize();
    }
    onCommand(command, param) {
      if (this.pages.length == 0) {
        return of(null);
      }
      const cmd = command.$.command;
      switch (cmd) {
        case 'firstPage':
          this.index = 0;
          break;
        case 'prevPage':
          if (this.index > 0) {
            this.index--;
          }
          break;
        case 'nextPage':
          if (this.index < this.pages.length - 1) {
            this.index++;
          }
          break;
        case 'lastPage':
          this.index = this.pages.length - 1;
          break;
      }
      this.flk.moveTo(this.index).catch(err => {
        if (err instanceof FlickingError) return;
        throw err;
      });
      return of('command');
    }
    destroy() {
      this.pages = null;
      super.destroy();
    }
    static ɵfac = function FlickingComponent_Factory(t) {
      return new (t || FlickingComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FlickingComponent,
      selectors: [["app-flicking"]],
      viewQuery: function FlickingComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$b, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.flk = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 2,
      consts: [["component", ""], ["playercontainer", ""], ["flk", ""], [3, "options"], ["flicking-panel", "", "class", "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage", 4, "ngFor", "ngForOf"], ["flicking-panel", "", 1, "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage"]],
      template: function FlickingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementStart(4, "ngx-flicking", 3, 2);
          i0.ɵɵtemplate(6, FlickingComponent_app_flicking_item_6_Template, 1, 3, "app-flicking-item", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("options", ctx.options);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FlickingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$a = ["btn"];
let PttMicComponent = /*#__PURE__*/(() => {
  class PttMicComponent extends PlayerBase {
    injector;
    btn;
    label;
    fontSize;
    color;
    bgColor;
    fontFamily;
    fontStyle;
    emergency = false;
    stations;
    mediaRecorder;
    mediaSource;
    downEvent;
    upEvent;
    onBtnPress;
    onBtnRelease;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        try {
          this.stations = data.Ptt[0].$.fieldName;
        } catch (e) {}
        if (this.playerService.os == 'android') {
          this.downEvent = 'touchstart';
          this.upEvent = 'touchend';
        } else {
          this.downEvent = 'mousedown';
          this.upEvent = 'mouseup';
        }
        this.onBtnPress = e => {
          this.pttStart();
        };
        this.onBtnRelease = e => {
          this.pttStop();
        };
        this.component.nativeElement.addEventListener(this.downEvent, this.onBtnPress);
        this.component.nativeElement.addEventListener(this.upEvent, this.onBtnRelease);
        const font = data.Ptt[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        const data = this.playerObject.Data[0];
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        this.label = data.Ptt[0].$.label;
        this.changeDetectorRef.detectChanges();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    createBackgroundAction() {
      const data = this.playerObject.Data[0];
      const color = Number(data.Background[0].$.color);
      const r = color & 0xff;
      const g = color >> 8 & 0xff;
      const b = color >> 16 & 0xff;
      const alpha = Number(data.Background[0].$.alpha);
      this.bgColor = 'rgba(' + b + ',' + g + ',' + r + ',' + alpha + ')';
    }
    clearEffects() {
      super.clearEffects();
      this.bgColor = '';
    }
    pttStart() {
      navigator.mediaDevices.getUserMedia({
        audio: true
      }).then(stream => {
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.ondataavailable = e => {
          const blob = e.data;
          this.playerService.sendPttBlob(this.stations, this.emergency, blob);
        };
        this.mediaRecorder.onstop = e => {
          stream.getTracks().forEach(track => {
            track.stop();
          });
        };
        this.mediaRecorder.start();
      }).catch(err => {
        alert("error");
      });
    }
    pttStop() {
      if (this.mediaRecorder != null) {
        this.mediaRecorder.stop();
      }
    }
    destroy() {
      if (this.onBtnPress != null) {
        this.component.nativeElement.removeEventListener(this.downEvent, this.onBtnPress);
        this.onBtnPress = null;
      }
      if (this.onBtnRelease != null) {
        this.component.nativeElement.removeEventListener(this.upEvent, this.onBtnRelease);
        this.onBtnRelease = null;
      }
      super.destroy();
    }
    static ɵfac = function PttMicComponent_Factory(t) {
      return new (t || PttMicComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PttMicComponent,
      selectors: [["app-ptt"]],
      viewQuery: function PttMicComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$a, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.btn = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 9,
      consts: [["component", ""], ["btn", ""], ["mat-raised-button", "", 2, "width", "100%", "height", "100%"]],
      template: function PttMicComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0)(2, "button", 2, 1);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("font-size", ctx.fontSize)("color", ctx.color)("background-color", ctx.bgColor)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.label);
        }
      },
      dependencies: [i2.MatButton],
      encapsulation: 2
    });
  }
  return PttMicComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$9 = ["txt"];
const _c1$7 = ["checkbox"];
let PttSpkComponent = /*#__PURE__*/(() => {
  class PttSpkComponent extends PlayerBase {
    injector;
    txt;
    checkbox;
    label;
    fontSize;
    color;
    fontFamily;
    fontStyle;
    doNotDisturb;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        const apk = data.Spk[0];
        try {
          this.doNotDisturb = data.Spk[0].$.fieldName == "1";
        } catch (e) {}
        const font = apk.Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(a => {
        const data = this.playerObject.Data[0];
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        const k = 0.04;
        const w = 20;
        const scale = k * this.fontStyle.fontSize;
        this.txt.nativeElement.style.paddingTop = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingBottom = 0.3 * w * scale + 'px';
        this.txt.nativeElement.style.paddingRight = 0.3 * w * scale + 'px';
        const el1 = this.checkbox._elementRef.nativeElement.children[0].children[0];
        el1.style.transform = 'scale(' + scale + ')';
        el1.style.marginLeft = -w + w * scale + 'px';
        el1.style.marginRight = -w + w * scale + 'px';
        const spk = data.Spk[0];
        this.label = spk.$.label;
        return this.playerService.caching.getRecord("stations", this.playerService.stationId);
      }), switchMap(station => {
        this.checkbox.checked = station.ptt_enabled;
        this.changeDetectorRef.detectChanges();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    changeValue() {
      const pttEnabled = this.checkbox.checked;
      this.playerService.setPtt(pttEnabled);
    }
    static ɵfac = function PttSpkComponent_Factory(t) {
      return new (t || PttSpkComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PttSpkComponent,
      selectors: [["app-spk"]],
      viewQuery: function PttSpkComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$9, 7);
          i0.ɵɵviewQuery(_c1$7, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txt = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 17,
      consts: [["component", ""], ["txt", ""], ["checkbox", ""], [2, "width", "100%", "height", "100%", "display", "grid"], [3, "change"]],
      template: function PttSpkComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", null, 0)(2, "div", 3)(3, "div")(4, "div", null, 1)(6, "mat-checkbox", 4, 2);
          i0.ɵɵlistener("change", function PttSpkComponent_Template_mat_checkbox_change_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changeValue());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵstyleMapInterpolate2("text-align:", ctx.fontStyle.align, "; alignSelf:", ctx.fontStyle.alignSelf, ";");
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("color", ctx.color)("font-size", ctx.fontSize)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("font-size", ctx.fontSize)("color", ctx.color)("font-family", ctx.fontFamily);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        }
      },
      dependencies: [i4.MatCheckbox],
      encapsulation: 2
    });
  }
  return PttSpkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GpsComponent = /*#__PURE__*/(() => {
  class GpsComponent extends PlayerBase {
    injector;
    genericElm;
    charging = false;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }
        const data = this.playerObject.Data[0];
        const radio = data.Radio[0];
        const font = radio.Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }), switchMap(font => this.getBattary()), switchMap(charging => this.getGps()), switchMap(pos => {
        const label = pos.coords.latitude + ", " + pos.coords.longitude;
        this.genericElm.setText(label, false, false);
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    getBattary() {
      return new Observable(sub => {
        navigator.getBattery().then(battery => {
          this.charging = battery.charging;
          sub.next(battery.charging);
          sub.complete();
        });
      });
    }
    getGps() {
      return new Observable(sub => {
        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        };
        navigator.geolocation.getCurrentPosition(pos => {
          sub.next(pos);
          sub.complete();
        }, error => {
          debugger;
        }, options);
      });
    }
    static ɵfac = function GpsComponent_Factory(t) {
      return new (t || GpsComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: GpsComponent,
      selectors: [["app-radio"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function GpsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return GpsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function AyreshareComponent_app_flicking_item_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flicking-item", 5);
  }
  if (rf & 2) {
    const page_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setParentPlayer", ctx_r1)("setEditMode", ctx_r1.editMode)("setPage", page_r1);
  }
}
let AyreshareComponent = /*#__PURE__*/(() => {
  class AyreshareComponent extends PlayerList {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    urlParam;
    itemsPath;
    getConfig() {
      const data = this.playerObject.Data[0];
      return data.Json[0].$;
    }
    getScene() {
      const data = this.playerObject.Data[0];
      return data.Json[0].Player[0];
    }
    load(playerObject) {
      const data = playerObject.Data[0];
      const metadata = data.DataProvider[0].$.metadata;
      switch (metadata) {
        case 'Json.facebook':
          // 6300
          this.urlParam = 'facebook';
          this.itemsPath = 'posts';
          break;
        case 'Json.facebook.groups':
          // 6305  //??? there is no data in API
          this.urlParam = 'fbg';
          this.itemsPath = 'posts';
          break;
        case 'Json.google.business':
          // 6310  not working???
          this.urlParam = 'gmb';
          this.itemsPath = 'posts';
          break;
        case 'Json.instagram':
          // 6315 not working ???
          this.urlParam = 'instagram';
          this.itemsPath = 'posts';
          break;
        case 'Json.linkedin':
          // 6320 // not working
          this.urlParam = 'linkedin';
          this.itemsPath = 'posts';
          break;
        case 'Json.pinterest':
          // 6325 // not working
          this.urlParam = 'pinterest';
          this.itemsPath = 'posts';
          break;
        case 'Json.reddit':
          //6330  // not working
          this.urlParam = 'reddit';
          this.itemsPath = 'posts';
          break;
        case 'Json.telegram':
          //6335  // not working
          this.urlParam = 'telegram';
          this.itemsPath = 'posts';
          break;
        case 'Json.tiktok':
          // 6340 works
          this.urlParam = 'tiktok';
          this.itemsPath = 'posts';
          break;
        case 'Json.x':
          // 6345 works
          this.urlParam = 'x';
          this.itemsPath = 'posts';
          break;
        case 'Json.youtube':
          // 6350
          this.urlParam = 'youtube';
          this.itemsPath = 'posts';
          break;
      }
      return super.load(playerObject);
    }
    loadProviderData() {
      return this.playerService.getAyreshareToken().pipe(switchMap(token => {
        this.url = DS_API_URL + 'socialFeed/' + token + '/' + this.urlParam;
        return this.playerService.loadProviderData(null, 'external', this.url, 'ayreshare');
      }), map(res => {
        return res[this.itemsPath];
      }));
    }
    static ɵfac = function AyreshareComponent_Factory(t) {
      return new (t || AyreshareComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: AyreshareComponent,
      selectors: [["app-json-list"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 2,
      consts: [["component", ""], ["playercontainer", ""], ["flk", ""], [3, "options"], ["flicking-panel", "", "class", "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage", 4, "ngFor", "ngForOf"], ["flicking-panel", "", 1, "flicking-panel", 3, "setParentPlayer", "setEditMode", "setPage"]],
      template: function AyreshareComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementStart(4, "ngx-flicking", 3, 2);
          i0.ɵɵtemplate(6, AyreshareComponent_app_flicking_item_6_Template, 1, 3, "app-flicking-item", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("options", ctx.options);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return AyreshareComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$8 = ["myFrame"];
let CanvaComponent = /*#__PURE__*/(() => {
  class CanvaComponent extends PlayerBase {
    injector;
    requiredCheck = false;
    myFrame;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        let url = data.Canva[0].$.embeddedLink;
        if (url == null || url == "") {
          this.showMsg(this.playerObject.$.label, 'Please set the Canva URL to embed your content');
        } else {
          this.showMsg(null, null);
          url += "?embed";
          this.myFrame.nativeElement.src = url;
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        return of(null);
      }
      const play$ = super.play();
      return play$.pipe(switchMap(a => {
        return of('play');
      }));
    }
    destroy() {
      if (this.myFrame?.nativeElement?.onload != null) {
        this.myFrame.nativeElement.onload = null;
      }
      super.destroy();
    }
    static ɵfac = function CanvaComponent_Factory(t) {
      return new (t || CanvaComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CanvaComponent,
      selectors: [["app-html"]],
      viewQuery: function CanvaComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$8, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myFrame = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["myFrame", ""], ["loading", "lazy", 2, "position", "absolute", "width", "100%", "height", "100%", "top", "0", "left", "0", "border", "none", "padding", "0", "margin", "0", "pointer-events", "none"]],
      template: function CanvaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "iframe", 2, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return CanvaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MusicListComponent = /*#__PURE__*/(() => {
  class MusicListComponent extends PlayerContainer {
    injector;
    pages;
    index = -1;
    defaultDuration;
    duration;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap$1(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        this.pages = data.Music[0].Page;
        this.index = 0;
        if (this.editMode) {
          this.showMsg("Music-playlist", "");
        }
        return of('a');
      }), catchError(err => this.logError(err)), switchMap$1(a => of(self)), takeUntil(this.finish$));
    }
    play() {
      if (this.editMode) {
        this.display(true);
        return of('play');
      }
      if (this.pages == null || this.pages.length == 0) {
        return of("end");
      }
      const loop$ = of('loop').pipe(switchMap$1(a => this.showPage()), repeat());
      return super.play().pipe(mergeWith(loop$));
    }
    getPage() {
      return new Observable(sub => {
        const data = this.playerObject.Data[0];
        this.defaultDuration = data.Music[0].$.duration;
        if (this.pages == null || this.pages.length == 0) {
          this.showMsg(this.playerObject.$.label, 'Playlist is empty');
          sub.next(null);
          sub.complete();
        } else {
          this.showMsg(null, null);
          const page = this.pages[this.index];
          let player = page.Player[0];
          let dur = page.$.duration;
          if (dur == null || dur == "") {
            dur = this.defaultDuration;
          }
          this.duration = Number(dur * 1000);
          this.index++;
          if (this.index >= this.pages.length) {
            this.index = 0;
          }
          sub.next(player);
          sub.complete();
        }
      });
    }
    static ɵfac = function MusicListComponent_Factory(t) {
      return new (t || MusicListComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: MusicListComponent,
      selectors: [["app-music-list"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function MusicListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MusicListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MusicComponent = /*#__PURE__*/(() => {
  class MusicComponent extends PlayerBase {
    injector;
    audio;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.audio = new Audio();
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap$1(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        if (this.editMode) {
          this.showMsg("Music", "");
          return of('a');
        } else {
          const resourceId = data.Resource[0].$.resource;
          return this.playerService.caching.getResource(resourceId).pipe(switchMap$1(path => {
            this.audio.src = String(path);
            this.audio.load(); // Reload the audio
            this.audio.play(); // Play the new audio
            if (!(self.parentPlayer instanceof MusicListComponent)) {
              this.audio.loop = true;
            }
            return fromEvent(this.audio, 'ended').pipe(take(1));
          }));
        }
      }), catchError(err => this.logError(err)), switchMap$1(a => of(self)), takeUntil(this.finish$), finalize(() => {
        if (this.audio) {
          this.audio.pause();
          this.audio.src = ''; // Remove source
          this.audio.load(); // Reset audio
          this.audio.onended = null; // Remove event listener
          this.audio = null; // Allow garbage collection
        }
      }));
    }
    static ɵfac = function MusicComponent_Factory(t) {
      return new (t || MusicComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: MusicComponent,
      selectors: [["app-music"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function MusicComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MusicComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconComponent = /*#__PURE__*/(() => {
  class IconComponent extends PlayerBase {
    injector;
    iconName;
    iconSize = 24;
    iconColor = 'green';
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        const data = this.playerObject.Data[0];
        // Calculate available space considering border
        let availableWidth = this.actualWidth * this.parentPlayer.scaleX;
        let availableHeight = this.actualHeight * this.parentPlayer.scaleY;
        if (data.Border != null) {
          let borderThickness = Number(data.Border[0].$.borderThickness);
          // Scale border thickness if autoScaling is enabled
          if (this.parentPlayer != null && this.playerObject.$.autoScaling == "1") {
            borderThickness *= Math.min(this.parentPlayer.scaleX, this.parentPlayer.scaleY);
          }
          borderThickness *= 2; // border on both sides
          availableWidth -= borderThickness;
          availableHeight -= borderThickness;
        }
        this.iconSize = Math.min(availableWidth, availableHeight);
        this.iconName = data.Icon[0].$.name;
        if (!this.iconName) {
          return of(null);
        }
        if (data.Icon[0].$.color) {
          this.iconColor = this.convertDecimalToHex(data.Icon[0].$.color);
        }
        this.changeDetectorRef.detectChanges();
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    /**
     Decimal to hex converter
     @method decimalToHex
     @param {Number} d
     @return {String} hex
    **/
    convertDecimalToHex(d) {
      d = String(d);
      if (d.match(/^#/)) return d;
      let hex = Number(d).toString(16);
      hex = "000000".substring(0, 6 - hex.length) + hex;
      return '#' + hex;
    }
    static ɵfac = function IconComponent_Factory(t) {
      return new (t || IconComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: IconComponent,
      selectors: [["app-button"]],
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 4,
      vars: 5,
      consts: [["component", ""], [3, "click"], [2, "display", "flex", "align-items", "center", "justify-content", "center", "width", "100%", "height", "100%"]],
      template: function IconComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵlistener("click", function IconComponent_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵelementStart(2, "mat-icon", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("font-size", ctx.iconSize, "px")("color", ctx.iconColor);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.iconName, " ");
        }
      },
      dependencies: [CommonModule, MatButtonModule, MatIcon],
      encapsulation: 2
    });
  }
  return IconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ComponentClasses {
  releaseClasses = {
    '3100': VideoComponent,
    '3130': ImageComponent,
    '3140': ImageComponent,
    '3145': MusicComponent,
    '3150': ExtVideoComponent,
    '3160': ExtImageComponent,
    '3235': HtmlComponent,
    '3240': RichTextComponent,
    '3241': LabelComponent,
    '3242': LabelQueueComponent,
    '3245': MessageComponent,
    '3270': CatalogItemComponent,
    '3280': CatalogPlayerComponent,
    '3310': NotSupportedComponent,
    '3315': NotSupportedComponent,
    '3320': ClockComponent,
    '3322': CountdownComponent,
    '3335': StockItemComponent,
    '3338': StockTickerComponent,
    '3340': PodcastComponent,
    '3345': RssComponent,
    '3346': CustomRssPlayerComponent,
    '3348': CustomRssItemComponent,
    '3350': CameraComponent,
    '3410': ExtAppComponent,
    '3415': NotSupportedComponent,
    '3420': AdNetComponent,
    '3430': QrComponent,
    '3510': SceneComponent,
    '3511': SceneComponent,
    '3600': FormComponent,
    '4100': CollectionComponent,
    '4101': FlickingComponent,
    '4102': PlaylistComponent,
    '4103': LoaderComponent,
    '4104': SchedulerComponent,
    '4105': LocationBaseComponent,
    '4110': MusicListComponent,
    '4120': HourlyBalancerComponent,
    '4200': XmlPlayerComponent,
    '4210': XmlItemComponent,
    '4300': JsonListComponent,
    '4305': JsonViewerComponent,
    '4310': JsonItemComponent,
    '4330': JsonListComponent,
    '4400': JsonListComponent,
    '4500': JsonListComponent,
    '4505': JsonItemComponent,
    '4600': YouTubeComponent,
    '5000': SerialPortComponent,
    '5010': KnxComponent,
    '5500': HtmlComponent,
    '5600': CanvaComponent,
    '6000': JsonListComponent,
    '6010': JsonViewerComponent,
    '6020': JsonListComponent,
    '6022': JsonViewerComponent,
    '6030': JsonListComponent,
    '6040': JsonListComponent,
    '6050': JsonListComponent,
    '6060': JsonListComponent,
    '6070': JsonListComponent,
    '6080': JsonListComponent,
    '6090': JsonListComponent,
    '6100': FasterQComponent,
    '6210': JsonListComponent,
    '6220': JsonListComponent,
    '6230': JsonListComponent,
    '6240': JsonListComponent,
    '6250': JsonListComponent,
    '6260': JsonListComponent,
    '6300': AyreshareComponent,
    // facebook
    '6305': AyreshareComponent,
    // fbg (facebook groups)
    '6310': AyreshareComponent,
    // gmb (google business profile)
    '6315': AyreshareComponent,
    // instagram
    '6320': AyreshareComponent,
    // linkedin
    '6325': AyreshareComponent,
    // pinterest
    '6330': AyreshareComponent,
    // reddit
    '6335': AyreshareComponent,
    // telegram
    '6340': AyreshareComponent,
    // tiktok
    '6345': AyreshareComponent,
    // twitter
    '6350': AyreshareComponent,
    // youtube
    '6500': JsonViewerComponent,
    '6510': NotSupportedComponent,
    '7000': ButtonComponent,
    '7010': CheckboxComponent,
    '7020': NumericStepperComponent,
    '7030': RadioComponent,
    '7040': SwitchComponent,
    '7050': TextInputComponent,
    '7060': SliderComponent,
    '7100': PttMicComponent,
    '7101': PttSpkComponent,
    '7200': GpsComponent,
    '8000': NotSupportedComponent,
    '8001': IconComponent,
    '8010': ChartComponent,
    '9000': NotSupportedComponent
  };
}
const libVersion = '3.6.115';
class YouTube {
  nativeElement;
  youtubeId;
  volume;
  myDiv;
  player;
  onError;
  onReady;
  onStateChange;
  constructor(nativeElement, youtubeId) {
    this.nativeElement = nativeElement;
    this.youtubeId = youtubeId;
  }
  init() {
    return new Observable(sub => {
      this.myDiv = document.createElement('div');
      this.myDiv.id = "player" + this.youtubeId;
      this.myDiv.style.position = 'absolute';
      this.myDiv.style.left = "0px";
      this.myDiv.style.top = "0px";
      this.myDiv.style.width = "100%";
      this.myDiv.style.height = "100%";
      this.myDiv.style['pointer-events'] = "none";
      this.nativeElement.appendChild(this.myDiv);
      const yt = window["YT"];
      this.player = new yt.Player(this.myDiv.id, {
        height: this.myDiv.clientHeight,
        width: this.myDiv.clientWidth,
        playerVars: {
          'playsinline': 1
        }
      });
      this.onReady = event => {
        this.player.setVolume(this.volume);
        this.myDiv.style['pointer-events'] = "";
        if (this.nativeElement != null && this.nativeElement.firstChild != null) {
          this.nativeElement.firstChild.style['pointer-events'] = "";
        }
        this.player.removeEventListener('onReady', this.onReady);
        this.onReady = null;
        sub.next('ready');
        sub.complete();
      };
      this.player.addEventListener('onReady', this.onReady);
    });
  }
  loadVideoById(videoId) {
    return of('a').pipe(switchMap(a => {
      this.player.loadVideoById(videoId);
      let state = -1;
      let notAvalible = false;
      return new Observable(sub => {
        this.onStateChange = event => {
          if (event.data == 3) {
            state = 3;
          }
          if (state == 3 && event.data == -1) {
            notAvalible = true;
            console.warn('youtube video not available');
          }
          if (event.data == 0 || notAvalible) {
            this.player.removeEventListener('onStateChange', this.onStateChange);
            this.onStateChange = null;
            sub.next('videoEnd');
            sub.complete();
          }
        };
        this.player.addEventListener('onStateChange', this.onStateChange);
      });
    }));
  }
  dispose() {
    if (this.player != null) {
      if (this.onReady != null) {
        this.player.removeEventListener('onReady', this.onReady);
        this.onReady = null;
      }
      if (this.onStateChange != null) {
        this.player.removeEventListener('onStateChange', this.onStateChange);
        this.onStateChange = null;
      }
      this.player.destroy();
      this.player = null;
    }
    if (this.nativeElement != null && this.nativeElement.firstChild != null) {
      this.nativeElement.removeChild(this.nativeElement.firstChild);
    }
    this.nativeElement = null;
    this.myDiv = null;
  }
}
var ResellerProgram = /*#__PURE__*/function (ResellerProgram) {
  ResellerProgram[ResellerProgram["Free"] = 0] = "Free";
  ResellerProgram[ResellerProgram["Plus"] = 1] = "Plus";
  ResellerProgram[ResellerProgram["Enterprise"] = 2] = "Enterprise";
  return ResellerProgram;
}(ResellerProgram || {});
class PlayerBaseService {
  injector;
  ngZone;
  resolver;
  os;
  cpu;
  osCpu;
  _os;
  _appType;
  _fpsInterval = null;
  appVersion;
  libVersion = libVersion;
  isLocalHost = false;
  circularSceneId = -1;
  deviceAdmin;
  domain = null;
  _businessId = -1;
  _businessDomain = null;
  socketDomain = null;
  resellerId = 1;
  stationId = -1;
  stationToken = "";
  webToken = "";
  registrationInfo$;
  playing$;
  serverConnection$;
  signService$;
  kioskChannel$;
  studioChannel$;
  sceneId;
  sceneName;
  httpClient; //???
  eventParams;
  data = {};
  caching;
  componentClasses;
  stats;
  initYoutube$;
  youtubeId = 0;
  domains = {};
  ruleId = 0;
  schedules = {};
  startTime;
  resellerProgram = ResellerProgram.Free;
  freeComponents = {
    4102: true,
    // Playlist
    3345: true,
    // Rss
    3241: true,
    // Label
    3242: true,
    // LabelQueue
    3320: true,
    // Clock
    3100: true,
    // Video
    3130: true,
    // Image
    3140: true,
    // Svg
    6010: true,
    // Weather
    4210: true,
    // JsonItem
    4310: true // JsonItem
  };
  plusComponents = {
    3346: true,
    // CustomRssPlayer
    3348: true,
    // CustomRssItem
    3335: true,
    // StockItem
    3338: true,
    // StockTicker
    3270: true,
    // CatalogItem
    3280: true,
    // CatalogPlayer
    4200: true,
    // XmlPlayer
    3322: true,
    // Countdown
    3430: true,
    // Qr
    3150: true,
    // ExtVideoComponent
    3160: true,
    // ExtImageComponent
    4104: true // SchedulerComponent
  };
  constructor(injector) {
    this.injector = injector;
    Log.init(this);
    const logInfo = Log.getLogInfo("PlayerBaseService", "constructor", []);
    this.ngZone = injector.get(NgZone);
    this.os = this.detectOperatingSystem();
    this.cpu = this.detectCPU();
    this.osCpu = this.getOsCpuName(this.os, this.cpu);
    if (Log.config.enabled) {
      setInterval(() => {
        this.postLog();
      }, 60000);
    }
    Log.i(logInfo, LogTag.INIT, "signPlayerLib version = " + libVersion);
    this.resolver = injector.get(ComponentFactoryResolver);
    this.httpClient = injector.get(HttpClient);
    this.eventParams = injector.get("eventParams");
    this.caching = injector.get("cachingService");
    window['rxjs'] = {
      of: of,
      Observable: Observable,
      switchMap: switchMap,
      concatMap: concatMap,
      repeat: repeat,
      delay: delay,
      forkJoin: forkJoin
    };
    this.componentClasses = this.createComponentClasses();
    this.isLocalHost = document.location.host.indexOf('localhost') != -1;
    Log.d(logInfo, LogTag.PLAYER_SERVICE, 'isLocalHost: ' + this.isLocalHost);
    this.registrationInfo$ = new ReplaySubject(1);
    this.playing$ = new BehaviorSubject('start');
    this.serverConnection$ = new ReplaySubject(1);
    this.signService$ = new ReplaySubject(1);
    this.kioskChannel$ = new Subject();
    this.studioChannel$ = new Subject();
    this.startTime = new Date().getTime();
  }
  isDevOrLocal() {
    const url = window.location.origin;
    return url.includes('dev.signage.me') || url.includes('localhost');
  }
  createComponentClasses() {
    return new ComponentClasses();
  }
  detectOperatingSystem() {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();
    const hasTouch = 'ontouchstart' in window;
    const maxTouchPoints = navigator.maxTouchPoints || 0;
    const isMobileUA = navigator.userAgentData?.mobile === true;
    console.log('userAgent:', userAgent);
    console.log('platform:', platform);
    console.log('hasTouch:', hasTouch);
    console.log('maxTouchPoints:', maxTouchPoints);
    console.log('isMobileUA:', isMobileUA);
    // Definitive Android detection
    if (userAgent.includes('android')) return 'android';
    // Definitive iOS detection
    if (userAgent.includes('iphone') || userAgent.includes('ipad')) return 'ios';
    // Windows detection
    if (userAgent.includes('windows')) return 'win';
    // macOS detection
    if (userAgent.includes('mac os x') || platform.includes('mac')) return 'osx';
    // Linux detection with Android heuristics
    if (userAgent.includes('linux') || platform.includes('linux')) {
      // Heuristics for Android disguised as Linux:
      // - High touch point count (phones usually have 10+)
      // - Explicitly marked as mobile
      // - ARM architecture
      if (maxTouchPoints >= 5 && isMobileUA || platform.includes('arm') || platform.includes('aarch64')) {
        return 'android'; // Likely Android
      }
      return 'linux'; // Likely desktop/server Linux
    }
    return 'unknown';
  }
  detectCPU() {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    if (userAgent.includes("arm64") || userAgent.includes("aarch64") || platform.includes("aarch64") || platform.includes("arm64")) return "arm64";
    if (userAgent.includes("ARM") || platform.includes("ARM")) return "arm";
    if (userAgent.includes("x86_64") || userAgent.includes("x64") || platform.includes("x86_64") || platform.includes("x64") || platform.includes("Win64")) return "x64";
    return "";
  }
  getOsCpuName(os, cpu) {
    if (os === "android") return "android";
    if (os === "win" && cpu === "x64") return "win-x64";
    if (os === "linux" && cpu === "x64") return "linux-x64";
    if (os === "linux" && cpu === "arm64") return "linux-arm64";
    if (os === "linux" && cpu === "arm") return "linux-arm";
    if (os === "osx" && cpu === "x64") return "osx-x64";
    if (os === "osx" && cpu === "arm64") return "osx-arm64";
    return "unknown";
  }
  reload() {
    location.reload();
  }
  get showFps() {
    return this._fpsInterval != null;
  }
  set showFps(value) {
    console.error('show fps not supported');
  }
  get appType() {
    return this._appType;
  }
  set appType(value) {
    const logInfo = Log.getLogInfo("PlayerBaseService", "set appType", []);
    Log.d(logInfo, LogTag.PLAYER_SERVICE, value);
    this._appType = value;
  }
  get serviceAppVersion() {
    return "";
  }
  get servicePluginVersion() {
    return "";
  }
  get businessId() {
    return this._businessId;
  }
  set businessId(value) {
    this._businessId = value;
    this.caching.businessId = this._businessId;
  }
  get businessDomain() {
    return this._businessDomain;
  }
  set businessDomain(value) {
    this._businessDomain = value;
    this.caching.businessDomain = this._businessDomain;
  }
  clearSchedules() {
    for (let scheduleId in this.schedules) {
      const scheduleEvents = this.schedules[scheduleId];
      scheduleEvents.destroy();
    }
    this.schedules = {};
  }
  clearCircular() {
    this.circularSceneId = -1;
  }
  setDevMode(mode) {
    const logInfo = Log.getLogInfo("PlayerBaseService", "setDevMode", []);
    Log.i(logInfo, LogTag.PLAYER_SERVICE, '');
    Log.devMode = mode;
  }
  getSceneId() {
    return of(null);
  }
  createScene(entry, parentPlayer, editMode) {
    this.clearCircular();
    const factory = this.resolver.resolveComponentFactory(SceneComponent);
    const componentRef = entry.createComponent(factory);
    const player = componentRef.instance;
    player.init(parentPlayer, editMode, -1);
    player.component.nativeElement.className = "root-scene";
    return player;
  }
  removeScene(entry, player) {
    const logInfo = Log.getLogInfo("PlayerBaseService", "removeScene", [player]);
    player.destroy();
    if (entry.length > 0) {
      entry.remove(0);
    }
  }
  init() {
    const logInfo = Log.getLogInfo("PlayerBaseService", "init-v2", []);
    return of('init');
  }
  stationStats() {
    return of(null);
  }
  online() {
    if (navigator.onLine) {
      return of('online');
    } else {
      return new Observable(sub => {
        let interval = setInterval(() => {
          if (navigator.onLine) {
            clearInterval(interval);
            sub.next('online');
            sub.complete();
          }
        }, 10000);
      });
    }
  }
  initYoutube() {
    if (this.initYoutube$ == null) {
      this.initYoutube$ = this.online().pipe(switchMap(a => {
        return new Observable(sub => {
          const tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          window["onYouTubeIframeAPIReady"] = () => {
            sub.next('ready');
            sub.complete();
          };
        });
      }), delay(1000), shareReplay());
    }
    return this.initYoutube$;
  }
  play() {
    this.playing$.next('start');
  }
  stop() {
    this.playing$.next('stop');
  }
  isPlaying() {
    return this.playing$.value == 'start';
  }
  updateCustomerInfo() {
    const url = 'https://' + this.domain + '/Web/getCustomerInfo.ashx?businessId=' + this.businessId + "&ver=1.5";
    return this.caching.requestJson(url, 'webservice', Expiration.Hour).pipe(map(data => {
      this.businessDomain = data.businessDomain;
      this.socketDomain = data.socketDomain;
      this.resellerId = data.resellerId;
      if (data.resellerPaying) {
        if (data.pricingMethod == 1 || data.pricingMethod == 3) {
          this.resellerProgram = ResellerProgram.Enterprise;
        } else if (data.pricingMethod == 2) {
          this.resellerProgram = ResellerProgram.Plus;
        }
      }
      return true;
    }));
  }
  getComponentBlockingTime(playerId) {
    if (this.resellerProgram == ResellerProgram.Enterprise || this.freeComponents[playerId]) {
      return -1;
    }
    if (this.resellerProgram == ResellerProgram.Plus && this.plusComponents[playerId]) {
      return -1;
    }
    console.log("playerId=" + playerId + " will be blocked");
    const runningTime = new Date().getTime() - this.startTime;
    const leftTime = Math.max(10 * 60 * 1000 - runningTime, 5000);
    return leftTime;
  }
  getComponentClasses(playerId) {
    const logInfo = Log.getLogInfo("PlayerBaseService", "getComponentClasses", [playerId]);
    let myClass = this.componentClasses.releaseClasses[playerId];
    if (myClass == null) {
      Log.e(logInfo, LogTag.PLAYER_SERVICE, 'playerId not exist in componentClasses');
    }
    return myClass;
  }
  startServerSocket() {}
  saveStationInfo() {
    return of(null);
  }
  parseString(xml, fnc) {
    xml2js.parseString(xml, fnc);
  }
  getServiceUrl() {
    const url = 'https://' + this.businessDomain + '/Web/loadData.ashx?businessId=' + this.businessId + '&stationId=' + this.stationId;
    return url;
  }
  getSceneList() {
    const url = 'https://' + this.businessDomain + '/Web/getSceneList.ashx?businessId=' + this.businessId;
    return this.caching.requestJson(url, 'webservice', Expiration.Now);
  }
  loadDb(callback) {
    /*
    const url = this.getServiceUrl();
    Log.d('loadDb: ' + url);
    this.localStorageService.getData(url).then(
      (data) => {
        this.db = JSON.parse(data);
        this.db.scenes = {};
        Log.d("loadDb time: " + this.db.time);
        this.populateTransitionPools();
        this.populateScheduleEvents();
        Log.d('loadDb success');
        callback();
      });
      */
  }
  /*
    populateTransitionPools() {
      this.transitionPools = {};
      for (let key in this.dbService.db.transitionPoolItems) {
        const item = this.dbService.db.transitionPoolItems[key];
        const poolId = item.transition_pool_id;
        let pool = this.transitionPools[poolId];
        if (pool==null) {
          pool = this.transitionPools[poolId] = [];
        }
         const xmlData = item.transition_item_data
        xml2js.parseString(xmlData, (err, result) => {
          const data = result.Transition.$;
          pool.push(data);
        });
      }
    }
  */
  createScheduleEvents(scheduleId) {
    let scheduleEvents = this.schedules[scheduleId];
    if (scheduleEvents == null) {
      this.schedules[scheduleId] = scheduleEvents = new ScheduleEvents(this, scheduleId);
    }
    return scheduleEvents;
  }
  loadScript(scriptId) {
    return this.caching.getRecord("scripts", scriptId).pipe(switchMap(code => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.text = code.script_src;
      document.getElementsByTagName('head')[0].appendChild(script);
      //document.body.appendChild(script);
      return of("script");
    }));
  }
  createScriptClass(className, params) {
    const cls = window[className];
    const instabce = Object.create(cls.prototype);
    instabce.constructor.apply(instabce, [this, JSON.parse(params)]);
    return instabce;
  }
  captureScreen(fileName, scale) {}
  // use for Text
  getProxyUrl() {
    const url = 'https://' + this.businessDomain + '/Web/getProxyRequest.ashx';
    return url;
  }
  // use for iframe
  getProxySrc(url) {
    debugger;
    return of(url);
  }
  /*
    startCapture(): Observable<any> {
      return new Observable<any>(sub => {
          const displayMediaOptions:DisplayMediaStreamConstraints = new class implements DisplayMediaStreamConstraints {
          audio: false;
          video: true;
          video: true;
        };
        navigator.mediaDevices.getDisplayMedia(displayMediaOptions).then(captureStream => {
          sub.next(true);
          sub.complete();
        }).catch((err) => {
          console.error(`Error:${err}`);
          return of(null);
        });
      })
    }
  */
  loadProviderData(eventName, source, url, folder) {
    const logInfo = Log.getLogInfo("PlayerBaseService", "loadProviderData", [eventName, url]);
    if (source == 'cloud') {
      url = 'https://' + this.businessDomain + '/Web/eventParam.ashx?command=getEvent' + '&businessId=' + this.businessId + '&eventName=' + eventName;
      return this.caching.requestText(url, 'eventparams', Expiration.Now).pipe(map(res => {
        if (res == null || res == "") {
          Log.w(logInfo, LogTag.PLAYER, "loadProviderData() res is Empty");
          return null;
        }
        try {
          return JSON.parse(res);
        } catch (e) {
          Log.w(logInfo, LogTag.PLAYER, 'JSON.parse() ' + res);
          return null;
        }
      })
      /*
      tap( res => {
        if (res!="") {
          const value = JSON.parse(res);
          this.eventParams.dispatch(eventName, value, true);
        }
      })
        */);
    } else if (source == 'external') {
      if (url == "") {
        Log.w(logInfo, LogTag.PLAYER_SERVICE, "url is empty");
        return of(null);
      }
      return this.caching.requestText(url, folder, Expiration.Now).pipe(map(res => {
        if (res == null || res == "") {
          Log.w(logInfo, LogTag.PLAYER, "res is Empty");
          return null;
        }
        try {
          return JSON.parse(res);
        } catch (e) {
          Log.w(logInfo, LogTag.PLAYER, 'JSON.parse() ' + res);
          return null;
        }
      })
      /*
      tap(res => {
        const value = JSON.parse(res);
        this.eventParams.dispatch(eventName, value, true);
      })
        */);
    } else {
      Log.e(logInfo, LogTag.PLAYER_SERVICE, source + ' not supported');
      return of(null);
    }
  }
  saveDataProvider(eventName, providerData, broadcast) {
    return new Observable(sub => {
      const url = "https://" + this.businessDomain + "/Web/eventParam.ashx?command=setEvent&stationToken=" + this.stationToken + "&businessId=" + this.businessId + "&eventName=" + eventName + "&broadcast=" + broadcast + "&fromStationId=" + this.stationId;
      const data = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(providerData)
      };
      fetch(url, data).then(response => {
        response.text().then(txt => {
          sub.next('txt');
          sub.complete();
        });
      }).catch(error => {
        Log.debug();
        sub.error(error);
      });
    });
  }
  getSettingParam(paramKey) {
    return new Observable(sub => {
      const url = "https://" + this.businessDomain + "/Web/globalSetting.ashx?command=getParam&businessId=" + this.businessId + "&paramKey=" + paramKey;
      const data = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      };
      fetch(url, data).then(response => {
        response.text().then(txt => {
          sub.next(txt);
          sub.complete();
        });
      }).catch(error => {
        Log.debug();
        sub.error(error);
      });
    });
  }
  getAyreshareToken() {
    return this.getSettingParam('ayreshare_token').pipe(map(info => JSON.parse(info).refId), shareReplay());
  }
  sendPttBlob(stations, emergency, data) {}
  setPtt(enabledPtt) {}
  createYouTube(nativeElement) {
    this.youtubeId++;
    return new YouTube(nativeElement, this.youtubeId);
  }
  getLogTags() {
    return Object.values(LogTag);
  }
  log(priority, sender, tag, message) {
    let log = localStorage["log"] != null ? JSON.parse(localStorage["log"]) : new Array();
    const data = {
      time: new Date().getTime(),
      priority: priority,
      className: sender?.className,
      fncName: sender?.fncName,
      fncArgs: sender?.fncArgs,
      tag: tag,
      message: message
    };
    log.push(data);
    localStorage["log"] = JSON.stringify(log);
  }
  postLog() {
    if (Log.config.enabled && localStorage["log"] != null && localStorage["log"] != "" && localStorage["log"] != "[]") {
      const url = "https://" + this.businessDomain + "/Web/log.ashx?businessId=" + this.businessId + "&stationId=" + this.stationId + "&stationToken=" + this.stationToken + "&command=write";
      const data = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: localStorage["log"]
      };
      fetch(url, data).then(response => {
        response.text().then(txt => {
          localStorage["log"] = "[]";
        });
      }).catch(error => {
        // ignore send if no internet and try next time
      });
    }
  }
  dispose() {
    const logInfo = Log.getLogInfo("PlayerBaseService", "dispose", []);
    Log.d(logInfo, LogTag.DISPOSE, '');
  }
}
function lastMap(fnc) {
  return function (source) {
    return source.pipe(last(), concatMap$1(fnc));
  };
}
let PlayerWebService = /*#__PURE__*/(() => {
  class PlayerWebService extends PlayerBaseService {
    injector;
    route;
    constructor(injector, /*???protected cookieService: CookieService, */route) {
      super(injector);
      this.injector = injector;
      this.route = route;
    }
    getSceneId() {
      return of(this.sceneId);
    }
    init() {
      const logInfo = Log.getLogInfo("PlayerWebService", "init", []);
      return super.init().pipe(lastMap(r1 => this.route.queryParams), take(1), switchMap(params => {
        Log.d(logInfo, LogTag.INIT, 'params=' + params);
        this.domain = params['domain'];
        this.businessId = params['businessId'];
        this.sceneId = params['sceneId'];
        this.webToken = params['token'];
        Log.devMode = params['dev'] == '1';
        return this.caching.init(false, false);
      }), switchMap(r => this.updateCustomerInfo()));
    }
    getServiceUrl() {
      return 'https://' + this.businessDomain + '/Web/loadData.ashx?businessId=' + this.businessId + '&sceneId=' + this.sceneId;
    }
    checkForUpdates() {}
    createServerSocket(fnConnect, fnData, fnClose) {}
    static ɵfac = function PlayerWebService_Factory(t) {
      return new (t || PlayerWebService)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1$1.ActivatedRoute));
    };
    static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: PlayerWebService,
      factory: PlayerWebService.ɵfac,
      providedIn: 'root'
    });
  }
  return PlayerWebService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function retryWithBackoff(delayMs = 2000, maxRetry = 4) {
  return src => {
    let retries = maxRetry;
    return src.pipe(retryWhen(errors => errors.pipe(mergeMap(error => {
      if (error.code == 'cors') {
        console.error(`retryWithBackoff CORS url: ${error.url}`);
        return throwError(`CORS`);
      } else if (error.code == '404') {
        // page not found
        Log.w(this, LogTag.CACHE, "Error: 404");
        return throwError('Error 404 ' + error.url);
      } else {
        if (retries-- > 0) {
          Log.w(this, LogTag.CACHE, `retry: ${maxRetry - retries}, url: ${error.url}`);
          const backoffTime = delayMs * Math.pow(2, maxRetry - retries);
          return of(error).pipe(delay(backoffTime));
        }
        return throwError({
          message: `retryWithBackoff exceeded: max: ${maxRetry}, url: ${error.url}`
        });
      }
    }))));
  };
}
class CacheItem {
  cachingService;
  httpClient;
  url;
  folder;
  proxyUrl;
  put;
  constructor(cachingService, httpClient, url, folder, proxyUrl) {
    this.cachingService = cachingService;
    this.httpClient = httpClient;
    this.url = url;
    this.proxyUrl = proxyUrl;
    this.folder = folder;
  }
  request(expiration) {
    this.cachingService.updateLastUsed(this.folder, this.url);
    return from(caches.match(this.url)).pipe(switchMap(cachedResponse => {
      if (cachedResponse) {
        const created = this.cachingService.foldersMap[this.folder][this.url].created;
        if (this.isExpired(created, expiration)) {
          return this.putInCached(this.url, this.folder, cachedResponse);
        } else {
          return new Observable(sub => {
            this.getBody(cachedResponse).then(body => {
              const data = this.getData(body);
              sub.next(data);
              sub.complete();
            });
          });
        }
      } else {
        return this.putInCached(this.url, this.folder);
      }
    }));
  }
  putInCached(url, folder, cachedResponse = null) {
    const logInfo = Log.getLogInfo("CacheItem", "putInCached", [url, folder]);
    Log.d(logInfo, LogTag.CACHE, 'cachedResponse=' + cachedResponse);
    if (this.put == null) {
      if (cachedResponse == null) {
        this.put = this.fetchCache(url, folder).pipe(retryWithBackoff(), shareReplay(), tap({
          complete: () => {
            this.put = null;
          }
        }));
      } else {
        this.put = this.fetchCache(url, folder).pipe(shareReplay(), tap({
          complete: () => {
            this.put = null;
          }
        }), catchError(err => {
          return new Observable(sub => {
            this.getBody(cachedResponse).then(body => {
              const data = this.getData(body);
              sub.next(data);
              sub.complete();
            });
          });
        }));
      }
    }
    return this.put;
  }
  isExpired(created, expiration) {
    let expired;
    if (expiration === Expiration.Now) {
      expired = true;
    } else if (expiration === Expiration.Never) {
      expired = false;
    } else {
      const now = new Date().getTime();
      expired = now - created > expiration;
    }
    return expired;
  }
  fetchCache(url, folder) {
    const logInfo = Log.getLogInfo("CacheItem", "fetchCache", [url, folder]);
    return new Observable(sub => {
      let fetchUrl;
      let fetchInit;
      if (this.proxyUrl != null) {
        fetchUrl = this.proxyUrl;
        fetchInit = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            url: url
          })
        };
      } else {
        fetchUrl = url + (url.indexOf('?') != -1 ? '&' : '?') + 'reload=force';
      }
      fetch(fetchUrl, fetchInit).then(response => {
        if (response.status == 200) {
          caches.open(folder).then(cache => {
            const copy = response.clone();
            const headers = new Headers(copy.headers);
            this.cachingService.updateLastUsed(folder, url);
            return this.getBody(copy).then(body => {
              const data = this.getData(body);
              return cache.put(url, new Response(body, {
                status: copy.status,
                statusText: copy.statusText,
                headers: headers
              })).then(a => {
                Log.d(logInfo, LogTag.CACHE, 'put in cache success');
                sub.next(data);
                sub.complete();
              });
            });
          });
        } else {
          Log.w(logInfo, LogTag.CACHE, 'status=' + response.status);
          sub.error({
            code: response.status,
            url: fetchUrl
          });
        }
      }).catch(error => {
        const msg = navigator.onLine ? "cors" : "offline";
        Log.w(logInfo, LogTag.CACHE, 'fetch fail cause: ' + msg);
        sub.error({
          code: msg,
          url: fetchUrl,
          message: "fetch fail"
        });
      });
    });
  }
  getBody(response) {
    return null;
  }
  getData(body) {
    return null;
  }
}
class CacheJson extends CacheItem {
  constructor(cachingService, httpClient, url, folder, proxyUrl) {
    super(cachingService, httpClient, url, folder, proxyUrl);
  }
  getBody(response) {
    return response.text();
  }
  getData(body) {
    return JSON.parse(body);
  }
}
class CacheText extends CacheItem {
  constructor(cachingService, httpClient, url, folder, proxyUrl) {
    super(cachingService, httpClient, url, folder, proxyUrl);
  }
  getBody(response) {
    return response.text();
  }
  getData(body) {
    return body;
  }
}
class CacheBlob extends CacheItem {
  constructor(cachingService, httpClient, url, folder, proxyUrl) {
    super(cachingService, httpClient, url, folder, proxyUrl);
  }
  fetchCache(url, folder) {
    return new Observable(sub => {
      //debugger;
      fetch(url).then(response => {
        if (response.status == 200) {
          const clonedResponse = response.clone();
          caches.open(folder).then(cache => {
            //debugger;
            cache.put(url, clonedResponse).then(a => {
              //debugger
              console.log('put file completed');
              sub.next(url);
              sub.complete();
            });
          });
        }
      }).catch(error => {
        //debugger;
        const msg = navigator.onLine ? "cors" : "offline";
        sub.error({
          code: msg,
          url: url,
          message: "fetch fail"
        });
      });
    });
  }
  getBody(response) {
    return response.blob();
  }
  getData(body) {
    return this.url;
  }
}
class CacheFont extends CacheBlob {
  fontKey;
  applied;
  constructor(cachingService, httpClient, url, folder, fontKey) {
    super(cachingService, httpClient, url, folder, null);
    this.fontKey = fontKey;
  }
  static getFontKey(font) {
    let fontKey = font.fontFamily;
    if (font.fontWeight != "Normal" && font.fontWeight != "none" && font.fontWeight != "normal" && font.fontWeight != "bold") {
      fontKey += font.fontWeight;
    }
    if (font.fontStyle != "Normal" && font.fontStyle != "normal" && font.fontStyle != "italic") {
      fontKey += font.fontStyle;
    }
    fontKey = fontKey.replace(/[\s\[\]\-!•™&:.,()`'?]/g, '');
    return fontKey;
  }
  request(expiration) {
    this.cachingService.updateLastUsed(this.folder, this.url);
    return from(caches.match(this.url)).pipe(switchMap(cachedResponse => {
      if (cachedResponse) {
        return of('font');
      } else {
        return this.putInCached(this.url, this.folder);
      }
    }), switchMap(url => this.applyFont()));
  }
  applyFont() {
    if (!this.applied) {
      this.applied = defer(() => {
        const style = document.createElement('style');
        style.textContent = `
                    @font-face {
                      font-family: '${this.fontKey}';
                      src: url('${this.url}') format('truetype');
                    }
                  `;
        document.head.appendChild(style);
        const fontSpec = `16px ${this.fontKey}`;
        return from(document.fonts.load(fontSpec)).pipe(switchMap(() => from(document.fonts.ready)));
      }).pipe(shareReplay(1) // cache the result for future calls
      );
    }
    return this.applied;
  }
}
class CacheDrive extends CacheItem {
  token;
  id;
  constructor(cachingService, httpClient, token, id, folder) {
    const url = DS_API_URL + "GoogleAjaxFileLink/" + token + '/' + id;
    super(cachingService, httpClient, url, folder, null);
    this.token = token;
    this.id = id;
  }
  fetchCache(url, folder) {
    return this.httpClient.post(this.url, {}, {
      headers: null,
      responseType: 'text'
    }).pipe(switchMap(driveRes => {
      const driveData = JSON.parse(driveRes);
      const accessToken = driveData.accessToken;
      const options = {
        headers: {
          'Authorization': "Bearer " + accessToken
        }
      };
      return new Observable(sub => {
        fetch(driveData.url, options).then(async function (response) {
          if (response.status == 200) {
            const clonedResponse = response.clone();
            caches.open(folder).then(cache => {
              cache.put(url, clonedResponse).then(a => {
                console.log('put file completed');
                sub.next(url);
                sub.complete();
              });
            });
          }
        }).catch(error => {
          debugger;
          const msg = navigator.onLine ? "cors" : "offline";
          sub.error({
            code: msg,
            url: url,
            message: "fetch fail"
          });
        });
      });
    }));
  }
  getBody(response) {
    return response.blob();
  }
  getData(body) {
    return this.url;
  }
}
class CacheDBPlayer extends CacheItem {
  businessDomain;
  businessId;
  table;
  id;
  data;
  modified = false;
  constructor(cachingService, httpClient, businessDomain, businessId, table, id) {
    const url1 = 'https://' + businessDomain + '/Web/loadCachedData.ashx?businessId=' + businessId + '&table=' + table + '&id=' + id;
    super(cachingService, httpClient, url1, 'db', null);
    this.businessDomain = businessDomain;
    this.businessId = businessId;
    this.table = table;
    this.id = id;
  }
  request(expiration) {
    const logInfo = Log.getLogInfo("CacheDBPlayer", "request", [this.table, this.id]);
    if (this.data != null) {
      this.data.updated = false;
      Log.d(logInfo, LogTag.CACHE, 'return this.data');
      return of(this.data);
    }
    const url1 = 'https://' + this.businessDomain + '/Web/loadCachedData.ashx?businessId=' + this.businessId + '&table=' + this.table + '&id=' + this.id;
    this.cachingService.updateLastUsed('db', url1);
    return from(caches.match(url1)).pipe(switchMap(cachedResponse => {
      if (cachedResponse) {
        // data exist in the cache
        // get record from caching
        return from(cachedResponse.json()).pipe(lastMap(data1 => {
          Log.d(logInfo, LogTag.CACHE, "data exist in the cache. data1=" + JSON.stringify(data1));
          // if changelist_id in DB is the same as the one in the cache, then it will return minimal data (not include the player_data_value)
          let url2 = 'https://' + this.businessDomain + '/Web/loadCachedData.ashx?businessId=' + this.businessId + '&table=' + this.table + '&id=' + this.id + '&changelistId=' + data1.changelist_id;
          return new Observable(sub2 => {
            fetch(url2).then(response2 => {
              if (response2.status == 200) {
                response2.json().then(data2 => {
                  Log.d(logInfo, LogTag.CACHE, "get data from server. data2: " + JSON.stringify(data2));
                  if (data1.changelist_id == data2.changelist_id) {
                    Log.d(logInfo, LogTag.CACHE, 'data was not changed');
                    caches.open('db').then(cache => {
                      const headers = new Headers(cachedResponse.headers);
                      //const now = new Date().getTime();
                      //headers.set('last-used', now.toString());
                      const body = JSON.stringify(data1);
                      cache.put(url1, new Response(body, {
                        status: 200,
                        statusText: '',
                        headers: headers
                      })).then(a => {
                        Log.d(logInfo, LogTag.CACHE, 'DB update last-used!!! ' + url1);
                        data1.updated = false;
                        sub2.next(data1);
                        sub2.complete();
                      });
                    });
                  } else {
                    Log.d(logInfo, LogTag.CACHE, 'data was changed');
                    caches.open('db').then(cache => {
                      const headers = new Headers();
                      this.cachingService.updateLastUsed(this.folder, this.url);
                      const body = JSON.stringify(data2);
                      cache.put(url1, new Response(body, {
                        status: 200,
                        statusText: '',
                        headers: headers
                      })).then(a => {
                        Log.d(logInfo, LogTag.CACHE, 'update cache data');
                        data2.updated = true;
                        sub2.next(data2);
                        sub2.complete();
                      });
                    });
                  }
                });
              } else {
                console.log('response status:' + response2.status);
                sub2.next(data1);
                sub2.complete();
              }
            }).catch(error => {
              Log.d(logInfo, LogTag.CACHE, "fetch fail");
              sub2.next(data1);
              sub2.complete();
            });
          });
        }));
      } else {
        // data not exist in the cache
        Log.d(logInfo, LogTag.CACHE, 'data not exist in the cache');
        return this.fetchDB(url1);
      }
    }), map(data => {
      if (data != null) {
        if (this.table == "scenes") {
          const myXML = data.player_data_value;
          xml2js.parseString(myXML, (err, result) => {
            data.json = result;
            delete data.player_data_value;
          });
        }
      }
      this.data = data;
      return data;
    }));
  }
  fetchDB(url) {
    const self = this;
    const logInfo = Log.getLogInfo("CacheDBPlayer", "fetchDB", [this.table, this.id]);
    return new Observable(sub3 => {
      fetch(url).then(function (response) {
        caches.open('db').then(cache => {
          const copy = response.clone();
          const headers = new Headers(copy.headers);
          self.cachingService.updateLastUsed('db', url);
          Log.d(this, LogTag.CACHE, 'DB FETCH (new) !!!!! ' + url);
          return copy.json().then(data => {
            const body = JSON.stringify(data);
            if (body == '{}') {
              Log.w(this, LogTag.CACHE, "resource was deleted from the DB");
              sub3.next(null);
              sub3.complete();
            } else {
              const newResponse = new Response(body, {
                status: copy.status,
                statusText: copy.statusText,
                headers: headers
              });
              cache.put(url, newResponse).then(a => {
                Log.w(logInfo, LogTag.CACHE, "resource was added");
                sub3.next(data);
                sub3.complete();
              });
            }
          });
        });
      }).catch(error => {
        Log.w(logInfo, LogTag.CACHE, "fetch fail");
        sub3.error('fetch fail !!');
      });
    }).pipe(retryWithBackoff(), lastMap(data3 => {
      Log.d(logInfo, LogTag.CACHE, "new data was added. data3=" + data3);
      if (data3 != null) {
        data3.updated = true;
        Log.d(logInfo, LogTag.CACHE, "changelist_id 3: " + data3.changelist_id);
      }
      return of(data3);
    }), catchError(err => {
      Log.w(logInfo, LogTag.CACHE, "fetchDB, retryWithBackoff fail");
      return of(null);
    }));
  }
}
class CacheDBStudio {
  table;
  id;
  data;
  constructor(table, id) {
    this.table = table;
    this.id = id;
  }
  getData() {
    return this.data;
  }
  setData(data) {
    this.data = data;
  }
}
class CacheDropbox extends CacheItem {
  token;
  id;
  constructor(cachingService, httpClient, token, id, folder) {
    const url = DS_API_URL + "DropboxFileLink/" + token + id;
    super(cachingService, httpClient, url, folder, null);
    this.token = token;
    this.id = id;
  }
  fetchCache(url, folder) {
    return this.httpClient.post(this.url, {}, {
      headers: null,
      responseType: 'text'
    }).pipe(lastMap(dropboxRes => {
      const dropboxData = JSON.parse(dropboxRes);
      return new Observable(sub => {
        fetch(dropboxData.url).then(res => {
          return res.blob();
        }).then(blob => {
          caches.open(folder).then(cache => {
            const headers = new Headers();
            //debugger;
            this.cachingService.updateLastUsed(this.folder, this.url);
            return cache.put(this.url, new Response(blob, {
              status: 200,
              statusText: '',
              headers: headers
            })).then(a => {
              sub.next(url);
              sub.complete();
            });
          });
        });
      });
    }));
  }
  getBody(response) {
    return response.blob();
  }
  getData(body) {
    return this.url;
  }
}
let CachingService = /*#__PURE__*/(() => {
  class CachingService {
    injector;
    httpClient;
    gpu = true;
    studio;
    _businessId;
    _businessDomain;
    cacheMap = {};
    cacheDB = {};
    abortFetch;
    cachingNow = {};
    foldersMap = {};
    lastUpdated$ = new Subject();
    worker;
    workerLoaded$ = new Subject();
    workerSaved$ = new Subject();
    constructor(injector) {
      this.injector = injector;
      this.httpClient = injector.get(HttpClient);
    }
    init(gpu, studio) {
      this.gpu = gpu;
      this.studio = studio;
      this.abortFetch = new AbortController();
      if (studio) {
        return of('init');
      }
      this.worker = new Worker('./workers/caching.worker.js', {
        type: 'module'
      });
      this.worker.onmessage = ({
        data
      }) => {
        switch (data.command) {
          case "loaded":
            this.foldersMap = data.foldersMap;
            this.workerLoaded$.next(data);
            this.workerLoaded$.complete();
            break;
          case "saved":
            for (let folder in data.deletedMap) {
              const folderList = data.deletedMap[folder];
              for (const url of folderList) {
                console.log(url);
                delete this.foldersMap[folder][url];
              }
            }
            this.workerSaved$.next(data);
            break;
        }
      };
      // every 1 hour
      this.lastUpdated$.pipe(auditTime(3600000), switchMap(a => {
        return this.save();
      })).subscribe();
      const data = {
        command: "load"
      };
      this.worker.postMessage(data);
      return this.workerLoaded$;
    }
    abort() {
      this.abortFetch.abort();
      this.abortFetch = new AbortController();
    }
    get businessId() {
      return this._businessId;
    }
    set businessId(value) {
      this._businessId = value;
    }
    get businessDomain() {
      return this._businessDomain;
    }
    set businessDomain(value) {
      this._businessDomain = value;
    }
    updateLastUsed(folder, url) {
      let folderInfo = this.foldersMap[folder];
      if (folderInfo == null) {
        this.foldersMap[folder] = folderInfo = {};
      }
      if (folderInfo[url] == null) {
        folderInfo[url] = {};
        folderInfo[url].created = new Date().getTime();
      }
      folderInfo[url].used = new Date().getTime();
      this.lastUpdated$.next('update');
    }
    request(url, folder, expiration, className, proxyUrl) {
      let cacheUrl = this.cacheMap[url];
      if (cacheUrl == null) {
        cacheUrl = this.cacheMap[url] = new className(this, this.httpClient, url, folder, proxyUrl);
      }
      return cacheUrl.request(expiration);
    }
    requestUrl(url, folder, expiration) {
      this.updateLastUsed(folder, url);
      if (this.cachingNow[url]) {
        //console.log('caching already started');
        return of(url);
      }
      this.cachingNow[url] = true;
      const obs$ = of('a');
      return obs$.pipe(switchMap(a => from(caches.match(url))), switchMap(cachedResponse => {
        if (cachedResponse) {
          //console.log('exist in cache. ' + url);
          return of(url);
        }
        //console.log('not exist in cache. ' + url);
        this.cacheUrl(folder, url);
        return of(url);
      }));
    }
    postJson(url, body, folder = 'post', expiration = 60000) {
      // Create a unique cache key by combining URL with body hash
      const bodyHash = this.hashCode(JSON.stringify(body));
      const cacheKey = `${url}/${bodyHash}`;
      return this.requestPostJson(cacheKey, url, body, folder, expiration);
    }
    requestPostJson(cacheKey, url, body, folder, expiration) {
      this.updateLastUsed(folder, cacheKey);
      return from(caches.match(cacheKey)).pipe(switchMap(cachedResponse => {
        if (cachedResponse) {
          const created = this.foldersMap[folder]?.[cacheKey]?.created;
          if (created && this.isExpired(created, expiration)) {
            // Cache expired, fetch new data
            return this.fetchPostAndCache(cacheKey, url, body, folder);
          } else {
            // Return cached data
            return from(cachedResponse.json());
          }
        } else {
          // No cache, fetch new data
          return this.fetchPostAndCache(cacheKey, url, body, folder);
        }
      }));
    }
    fetchPostAndCache(cacheKey, url, body, folder) {
      return this.httpClient.post(url, body).pipe(switchMap(data => {
        // Cache the response
        return from(caches.open(folder)).pipe(switchMap(cache => {
          const responseBody = JSON.stringify(data);
          const response = new Response(responseBody, {
            status: 200,
            statusText: 'OK',
            headers: new Headers({
              'Content-Type': 'application/json'
            })
          });
          return from(cache.put(cacheKey, response)).pipe(switchMap(() => {
            this.updateLastUsed(folder, cacheKey);
            return of(data);
          }));
        }));
      }));
    }
    isExpired(created, expiration) {
      const now = new Date().getTime();
      return now - created > expiration;
    }
    // Simple hash function to create a consistent hash from string
    hashCode(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
      }
      return Math.abs(hash).toString(36);
    }
    requestText(url, folder, expiration, proxyUrl = null) {
      return this.request(url, folder, expiration, CacheText, proxyUrl);
    }
    requestJson(url, folder, expiration, proxyUrl = null) {
      return this.request(url, folder, expiration, CacheJson, proxyUrl);
    }
    requestFont(font) {
      if (font.fontFamily == null || font.fontFamily == "") {
        console.error('font.fontFamily is empty');
        return of(null);
      }
      const fontKey = CacheFont.getFontKey(font);
      let fileName = fontKey + '.ttf';
      const url = 'https://galaxy.signage.me/TTF/' + fileName;
      let cacheUrl = this.cacheMap[url];
      if (cacheUrl == null) {
        cacheUrl = this.cacheMap[url] = new CacheFont(this, this.httpClient, url, 'fonts', fontKey);
      }
      return cacheUrl.request(Expiration.Never);
    }
    getDriveUrl(token, id, expiration) {
      let cacheUrl = this.cacheMap[id];
      if (cacheUrl == null) {
        cacheUrl = this.cacheMap[id] = new CacheDrive(this, this.httpClient, token, id, 'drive');
      }
      return cacheUrl.request(Expiration.Never);
    }
    getDropboxUrl(token, id, expiration) {
      let cacheUrl = this.cacheMap[id];
      if (cacheUrl == null) {
        cacheUrl = this.cacheMap[id] = new CacheDropbox(this, this.httpClient, token, id, 'dropbox');
      }
      return cacheUrl.request(Expiration.Never);
    }
    getRecord(table, id) {
      const key = table + '.' + id;
      let cacheDB = this.cacheDB[key];
      if (cacheDB == null) {
        if (this.studio) {
          cacheDB = new CacheDBStudio(table, id);
          cacheDB.setData(of(null));
        } else {
          cacheDB = new CacheDBPlayer(this, this.httpClient, this._businessDomain, this.businessId, table, id);
        }
        this.cacheDB[key] = cacheDB;
      }
      if (this.studio) {
        return cacheDB.getData();
      } else {
        return cacheDB.request(Expiration.Now);
      }
    }
    setRecord(table, id, data) {
      const key = table + '.' + id;
      if (this.studio) {
        let cacheDB = this.cacheDB[key];
        if (cacheDB == null) {
          cacheDB = new CacheDBStudio(table, id);
          this.cacheDB[key] = cacheDB;
        }
        cacheDB.setData(data);
      }
    }
    modifyRecords(table, ids) {
      const logInfo = Log.getLogInfo("CachingService", "modifyRecords", [table, ids]);
      Log.d(logInfo, LogTag.CACHE, '');
      if (table == 'player_data') {
        table = 'scenes';
      }
      ids.forEach(id => {
        const key = table + '.' + id;
        let cacheDB = this.cacheDB[key];
        if (cacheDB != null) {
          cacheDB.modified = true;
        }
      });
    }
    setModifyAll() {
      const logInfo = Log.getLogInfo("CachingService", "setModifyAll", []);
      Log.d(logInfo, LogTag.CACHE, '');
      for (let key in this.cacheDB) {
        let cacheDB = this.cacheDB[key];
        cacheDB.modified = true;
      }
    }
    clearModified() {
      const logInfo = Log.getLogInfo("CachingService", "clearModified", []);
      Log.d(logInfo, LogTag.CACHE, '');
      for (let key in this.cacheDB) {
        let cacheDB = this.cacheDB[key];
        if (cacheDB.modified) {
          cacheDB.modified = false;
          cacheDB.data = null;
        }
      }
    }
    deleteCachedUrl(folder, url) {
      return from(caches.open(folder)).pipe(switchMap(cache => {
        return from(cache.delete(url));
      }));
    }
    cacheUrl(folder, url) {
      //console.log('start caching...');
      fetch(url).then(response => {
        if (response.status == 200) {
          const clonedResponse = response.clone();
          caches.open(folder).then(cache => {
            cache.put(url, clonedResponse).then(a => {
              //console.log('put completed')
              delete this.cachingNow[url];
            }).catch(err => {
              delete this.cachingNow[url];
            });
          });
        } else {
          delete this.cachingNow[url];
        }
      });
    }
    getResource(resourceId) {
      const logInfo = Log.getLogInfo("CachingService", "getResource", [resourceId]);
      return this.getRecord("resources", Number(resourceId)).pipe(switchMap(resource => {
        const url = 'https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business' + this.businessId + '/resources/' + resourceId + '.' + resource.resource_type;
        if (resource == null || resource.changelist_id == null) {
          return of(null);
        }
        this.updateLastUsed('resources', url);
        const ext = url.substring(url.lastIndexOf('.') + 1);
        if (this.studio && ext == 'mp4') {
          Log.d(logInfo, LogTag.CACHE, 'Do not cache video in studio');
          return of(url);
        }
        if (this.cachingNow[url]) {
          //console.log('caching already started');
          return of(url);
        }
        this.cachingNow[url] = true;
        const obs$ = resource.updated ? this.deleteCachedUrl('resources', url) : of(true);
        return obs$.pipe(switchMap(a => from(caches.match(url))), switchMap(cachedResponse => {
          if (cachedResponse) {
            //console.log('exist in cache');
            return of(url);
          }
          //console.log('not exist in cache');
          this.cacheUrl('resources', url);
          return of(url);
        }));
      }));
    }
    getUrlParam(url, param) {
      const i0 = url.indexOf('?');
      const i1 = url.indexOf(param, i0) + 1;
      const i2 = url.indexOf("&", i1);
      const i3 = i2 == -1 ? url.length : i2;
      return url.substring(i1 + param.length, i3);
    }
    save() {
      const data = {
        command: "save",
        foldersMap: this.foldersMap
      };
      this.worker.postMessage(data); // Send data to the worker
      return this.workerSaved$.asObservable();
    }
    deleteOldCaching() {
      return of(null);
      /*
      return new Observable<any>(sub => {
          const logInfo = Log.getLogInfo("CachingService", "deleteOldCaching", []);
          const sortItems = this.allCacheItems.sort((a, b) => (a.lastUsed < b.lastUsed) ? -1 : 1);
          const now = new Date().getTime();
          let total = 0;
          let count = 0;
           let maxPeriod = 30 * 24 * 60 * 60 * 1000;
          if (localStorage['caching'] != null) {
              const caching = JSON.parse(localStorage['caching']);
              maxPeriod = caching.maxPeriod;
          }
           sortItems.forEach(item => {
              if (now - item.lastUsed > maxPeriod) {
                  Log.d(logInfo, LogTag.CACHE, "DELETE: " + item.request.url)
                  total++;
                  item.cache.delete(item.request).then(res => {
                      count++;
                      if (total == count) {
                          sub.next("finish");
                          sub.complete();
                      }
                  });
              } else {
                  Log.d(logInfo, LogTag.CACHE, "SKIP: " + item.request.url)
              }
          })
          if (total == 0) {
              sub.next("finish");
              sub.complete();
          }
      })
        */
    }
    static ɵfac = function CachingService_Factory(t) {
      return new (t || CachingService)(i0.ɵɵinject(i0.Injector));
    };
    static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: CachingService,
      factory: CachingService.ɵfac,
      providedIn: 'root'
    });
  }
  return CachingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Progress = /*#__PURE__*/(() => {
  class Progress {
    static enabled = false;
    static a = 0.1;
    static startTime;
    static totalLoading = 0;
    static leftLoading = 0;
    static loadingPercentage = 0;
    constructor() {}
    static begin() {
      this.a = 0.1;
      this.leftLoading = 0;
      this.totalLoading = 0;
      this.loadingPercentage = 0;
      this.startTime = new Date().getTime();
      this.enabled = true;
    }
    static addLoading(bytes) {
      this.totalLoading += bytes;
      this.leftLoading += bytes;
    }
    static removeLoading(bytes) {
      this.leftLoading -= bytes;
    }
    static getProgress() {
      if (this.totalLoading == 0) {
        return '';
      } else {
        if (this.a < 1.0) {
          this.a = Math.min(1, (new Date().getTime() - this.startTime) / 20000);
        }
        this.loadingPercentage = Math.max(this.loadingPercentage, Math.floor(100 * ((this.totalLoading - this.leftLoading) / this.totalLoading) * this.a));
        return this.loadingPercentage + '%';
      }
    }
    static isEnabled() {
      return this.enabled;
    }
    static end() {
      this.enabled = false;
    }
  }
  return Progress;
})();
const _c0$7 = ["component"];
const _c1$6 = ["myHome"];
const _c2$5 = ["playercontainer"];
let SignagePlayerBase = /*#__PURE__*/(() => {
  class SignagePlayerBase {
    injector;
    ngZone;
    resolver;
    changeDetectorRef;
    showProgress = false;
    sceneData;
    playerService;
    mainScene;
    geometrychange;
    virtualKeyboardActive = false;
    fnFocus;
    focusOffset = 0;
    screenHeight = 0;
    subscription;
    // @ts-ignore
    component;
    // @ts-ignore
    myHome;
    // @ts-ignore
    entry;
    constructor(injector) {
      this.injector = injector;
      this.changeDetectorRef = injector.get(ChangeDetectorRef);
      this.resolver = injector.get(ComponentFactoryResolver);
      this.ngZone = injector.get(NgZone);
      this.ngZone.runOutsideAngular(() => {
        this.playerService = injector.get('playerService');
      });
      document.addEventListener('contextmenu', event => event.preventDefault());
    }
    ngOnInit() {
      const logInfo = Log.getLogInfo("SignagePlayerBase", "ngOnInit", []);
      Log.d(logInfo, LogTag.INIT, 'NgZone: ' + NgZone.isInAngularZone());
      if (navigator['virtualKeyboard'] != null) {
        navigator['virtualKeyboard'].overlaysContent = true;
        this.fnFocus = event => {
          const rect = event.target.getBoundingClientRect();
          this.focusOffset = rect.top + rect.height * 4;
        };
        this.component.nativeElement.addEventListener("focus", this.fnFocus, true);
        this.geometrychange = event => {
          this.virtualKeyboardActive = true;
          this.component.nativeElement.offsetHeight;
          setTimeout(() => {
            const virtualKeyboardHeight = navigator['virtualKeyboard'].boundingRect.height;
            const y = -Math.max(0, this.focusOffset + virtualKeyboardHeight - this.screenHeight);
            if (y < 0) {
              this.component.nativeElement.style.top = y + 'px';
            } else if (this.component.nativeElement.style.top != "") {
              this.component.nativeElement.style.top = "";
            }
          }, 100);
        };
        navigator['virtualKeyboard'].addEventListener("geometrychange", this.geometrychange);
      }
      this.subscription = this.init().pipe(switchMap$1(r1 => {
        if (r1 == null) {
          Log.w(logInfo, LogTag.DISPOSE, 'exit browser');
          return of(null);
        }
        return this.run().pipe(mergeWith(this.playerService.stationStats()));
      })).subscribe();
    }
    init() {
      return this.playerService.init();
    }
    run() {
      const logInfo = Log.getLogInfo("SignagePlayerBase", "run", []);
      return this.playerService.playing$.pipe(switchMap$1(r => this.playerService.isPlaying() ? this.requestScene() : of('next')), mergeWith(fromEvent(window, 'resize').pipe(debounceTime(250), filter(a => {
        if (this.virtualKeyboardActive) {
          this.virtualKeyboardActive = false;
          return false;
        } else {
          return true;
        }
      }))), switchMap$1(r => this.stop()), filter(f => this.playerService.isPlaying()), switchMap$1(r => this.start().pipe(
      // when playing$ == 'stop' it will unsubscribe this.start()
      takeUntil(this.playerService.playing$.pipe(filter(v => v == 'stop'))), finalize(() => {
        Log.d(logInfo, LogTag.MAIN, 'finalize()');
      }))));
    }
    requestScene() {
      const logInfo = Log.getLogInfo("SignagePlayerBase", "requestScene", []);
      return of('load-scene').pipe(tap$1(v => this.playerService.caching.clearModified()), switchMap$1(r1 => {
        Log.d(logInfo, LogTag.MAIN, 'getSceneId()');
        return this.playerService.getSceneId();
      }), switchMap$1(sceneId => {
        this.playerService.sceneId = sceneId;
        return this.playerService.caching.getRecord("scenes", sceneId);
      }), tap$1(scene => {
        if (scene != null && scene.json != null) {
          this.sceneData = scene.json;
          this.playerService.sceneName = this.sceneData.Player.$.label;
          this.playerService.registrationInfo$.next("update");
        } else {
          Log.e(logInfo, LogTag.MAIN, 'Scene data corrupted or not exist in DB');
        }
      }));
    }
    stop() {
      const logInfo = Log.getLogInfo("SignagePlayerBase", "stop", []);
      return new Observable(sub => {
        Log.d(logInfo, LogTag.MAIN, '');
        this.playerService.caching.abort();
        this.playerService.clearCircular();
        this.playerService.clearSchedules();
        if (this.mainScene != null) {
          //??? this.mainScene.destroy();   // putting this line cause exception when resizing, but looks like it's not needed. there is no memory leak when it's comment out.
          this.mainScene = null;
        }
        if (this.entry.length > 0) {
          this.entry.remove(0);
          this.changeDetectorRef.detectChanges();
        }
        sub.next('remove-scene');
        sub.complete();
      });
    }
    start() {
      const logInfo = Log.getLogInfo("SignagePlayerBase", "start", []);
      const obs1$ = new Observable(sub => {
        Log.d(logInfo, LogTag.MAIN, '');
        if (this.sceneData) {
          const factory = this.resolver.resolveComponentFactory(SceneComponent);
          const componentRef = this.entry.createComponent(factory);
          this.mainScene = componentRef.instance;
          this.mainScene.init(null, false, -1);
          this.mainScene.usePlayerLayoutX = false;
          this.mainScene.usePlayerLayoutY = false;
          this.mainScene.originalSize = this.sceneData.Player.Data[0].Layout[0].$;
          sub.next('create-scene');
          sub.complete();
        } else {
          sub.next(null);
          sub.complete();
        }
      });
      return obs1$.pipe(switchMap$1(r1 => {
        if (this.mainScene != null) {
          Progress.begin();
          //??? this.showProgress = true;
          this.changeDetectorRef.detectChanges();
          return this.mainScene.load(this.sceneData.Player).pipe(switchMap$1(a => {
            this.mainScene.originalSize = this.sceneData.Player.Data[0].Layout[0].$;
            this.mainSceneLoaded();
            return of('a');
          }), mergeWith(this.mainScene.play()));
        } else {
          return of(null);
        }
      }));
    }
    mainSceneLoaded() {}
    get actualWidth() {
      debugger;
      return 0; //???
      //??? return (this.playerService as PlayerBaseService).pixi.view.width;
    }
    get actualHeight() {
      debugger;
      return 0; //???
      //return (this.playerService as PlayerBaseService).pixi.view.height;
    }
    getActualSize() {
      return this.component.nativeElement.getBoundingClientRect();
    }
    dispose() {
      const logInfo = Log.getLogInfo("SignagePlayerBase", "dispose", []);
      Log.d(logInfo, LogTag.DISPOSE, '');
      if (this.geometrychange != null) {
        navigator['virtualKeyboard'].removeEventListener("geometrychange", this.geometrychange);
        this.geometrychange = null;
      }
      if (this.fnFocus != null) {
        this.component.nativeElement.removeEventListener("focus", this.fnFocus, true);
        this.fnFocus = null;
      }
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = null;
      }
      if (this.mainScene != null) {
        this.mainScene.destroy();
        this.mainScene = null;
      }
      this.playerService.dispose();
    }
    static ɵfac = function SignagePlayerBase_Factory(t) {
      return new (t || SignagePlayerBase)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SignagePlayerBase,
      selectors: [["app-home-base"]],
      viewQuery: function SignagePlayerBase_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$7, 7);
          i0.ɵɵviewQuery(_c1$6, 7);
          i0.ɵɵviewQuery(_c2$5, 7, ViewContainerRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.component = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myHome = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.entry = _t.first);
        }
      },
      decls: 0,
      vars: 0,
      template: function SignagePlayerBase_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return SignagePlayerBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function SignagePlayerWeb_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "h1", 7);
    i0.ɵɵtext(3, "press ");
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵtext(5, "F11");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, " to enter full screen / audio");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵproperty("@fadeIn", undefined)("@fadeOut", undefined);
  }
}
const enterTransition = transition(':enter', [style({
  opacity: 0
}), animate('0.5s ease-in', style({
  opacity: 1
}))]);
const leaveTrans = transition(':leave', [style({
  opacity: 1
}), animate('1s ease-out', style({
  opacity: 0
}))]);
const fadeIn = trigger('fadeIn', [enterTransition]);
const fadeOut = trigger('fadeOut', [leaveTrans]);
let SignagePlayerWeb = /*#__PURE__*/(() => {
  class SignagePlayerWeb extends SignagePlayerBase {
    injector;
    httpClient;
    titleService;
    studioId;
    showF11 = false;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      this.httpClient = injector.get(HttpClient);
      this.titleService = injector.get(Title);
    }
    init() {
      const logInfo = Log.getLogInfo("SignagePlayerWeb", "init", []);
      return super.init().pipe(concatMap$1(r1 => this.isValidToken()), concatMap$1(t => {
        const token = t;
        if (token != null && token.status) {
          if (mobile.isMobile() == false) {
            this.showF11 = true;
            this.changeDetectorRef.detectChanges();
            return of('f11').pipe(delay(3000), tap(v => {
              this.showF11 = false;
              this.changeDetectorRef.detectChanges();
            }));
          } else {
            return of('completed');
          }
        } else {
          Log.w(logInfo, LogTag.SIGNAGE_PLAYER, "invalid token!!!");
          return of(null);
        }
      }));
    }
    isValidToken() {
      const url = 'https://' + this.playerService.domain + '/Web/isValidToken.ashx?businessId=' + this.playerService.businessId + '&token=' + this.playerService.webToken;
      return this.playerService.caching.requestJson(url, 'webservice', Expiration.Minute);
    }
    start() {
      const obs1$ = super.start().pipe(tap({
        complete: () => {
          if (this.sceneData) {
            const title = this.sceneData.Player.$.label;
            this.titleService.setTitle(title);
          }
        }
      }));
      return obs1$;
    }
    static ɵfac = function SignagePlayerWeb_Factory(t) {
      return new (t || SignagePlayerWeb)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SignagePlayerWeb,
      selectors: [["signage-player-web"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 1,
      consts: [["component", ""], ["playercontainer", ""], ["id", "fontLoader", 2, "position", "absolute", "visibility", "hidden"], ["name", "htmlLayer", 2, "pointer-events", "none"], ["id", "fs", "style", "position: absolute; top: 50px", 4, "ngIf"], ["id", "fs", 2, "position", "absolute", "top", "50px"], ["id", "sq"], ["id", "sl"], ["id", "sa"]],
      template: function SignagePlayerWeb_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 2);
          i0.ɵɵelementStart(1, "div", null, 0);
          i0.ɵɵelement(3, "template", null, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(5, "div", 3);
          i0.ɵɵtemplate(6, SignagePlayerWeb_div_6_Template, 7, 2, "div", 4);
        }
        if (rf & 2) {
          i0.ɵɵadvance(6);
          i0.ɵɵproperty("ngIf", ctx.showF11);
        }
      },
      dependencies: [i11.NgIf],
      styles: [".mat-ripple[_ngcontent-%COMP%]{overflow:hidden;position:relative}.mat-ripple[_ngcontent-%COMP%]:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded[_ngcontent-%COMP%]{overflow:visible}.mat-ripple-element[_ngcontent-%COMP%]{position:absolute;border-radius:50%;pointer-events:none;transition:opacity,transform 0ms cubic-bezier(0,0,.2,1);transform:scale3d(0,0,0);background-color:var(--mat-ripple-color, rgba(0, 0, 0, .1))}.cdk-high-contrast-active[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{display:none}.cdk-visually-hidden[_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none;left:0}[dir=rtl][_ngcontent-%COMP%]   .cdk-visually-hidden[_ngcontent-%COMP%]{left:auto;right:0}.cdk-overlay-container[_ngcontent-%COMP%], .cdk-global-overlay-wrapper[_ngcontent-%COMP%]{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container[_ngcontent-%COMP%]{position:fixed;z-index:1000}.cdk-overlay-container[_ngcontent-%COMP%]:empty{display:none}.cdk-global-overlay-wrapper[_ngcontent-%COMP%]{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane[_ngcontent-%COMP%]{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop[_ngcontent-%COMP%]{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]   .cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:.6}.cdk-overlay-dark-backdrop[_ngcontent-%COMP%]{background:#00000052}.cdk-overlay-transparent-backdrop[_ngcontent-%COMP%]{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:0;visibility:visible}.cdk-overlay-backdrop-noop-animation[_ngcontent-%COMP%]{transition:none}.cdk-overlay-connected-position-bounding-box[_ngcontent-%COMP%]{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock[_ngcontent-%COMP%]{position:fixed;width:100%;overflow-y:scroll}textarea.cdk-textarea-autosize[_ngcontent-%COMP%]{resize:none}textarea.cdk-textarea-autosize-measuring[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:auto!important;overflow:hidden!important}textarea.cdk-textarea-autosize-measuring-firefox[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:0!important}@keyframes _ngcontent-%COMP%_cdk-text-field-autofill-start{}@keyframes _ngcontent-%COMP%_cdk-text-field-autofill-end{}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:-webkit-autofill{animation:_ngcontent-%COMP%_cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:not(:-webkit-autofill){animation:_ngcontent-%COMP%_cdk-text-field-autofill-end 0s 1ms}.mat-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-focus-indicator-display, none);border:var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);border-radius:var(--mat-focus-indicator-border-radius, 4px)}.mat-focus-indicator[_ngcontent-%COMP%]:focus:before{content:\"\"}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-focus-indicator-display: block}.mat-mdc-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-mdc-focus-indicator-display, none);border:var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);border-radius:var(--mat-mdc-focus-indicator-border-radius, 4px)}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:focus:before{content:\"\"}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-mdc-focus-indicator-display: block}.mat-app-background[_ngcontent-%COMP%]{background-color:var(--mat-app-background-color, transparent);color:var(--mat-app-text-color, inherit)}div[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;overflow:hidden}#fs[_ngcontent-%COMP%]{display:flex;justify-content:center}#sq[_ngcontent-%COMP%]{position:absolute;top:50px;width:auto;height:auto;background-color:#212328;text-align:center;border:1px solid white;padding:10px;margin:0}#sl[_ngcontent-%COMP%]{font-family:Arial;color:#fff;font-size:16px;font-weight:400}#sa[_ngcontent-%COMP%]{border:1px solid white;padding:3px}.signPlayer[_ngcontent-%COMP%]{font-size:72px;font-weight:700;color:#fff;text-align:center;padding-top:40px}"],
      data: {
        animation: [fadeIn, fadeOut]
      },
      changeDetection: 0
    });
  }
  return SignagePlayerWeb;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class EventParams {
  subjects = {};
  constructor() {}
  getEventParam(eventName) {
    let subject = this.subjects[eventName];
    if (subject == null) {
      subject = this.subjects[eventName] = new Subject();
    }
    return subject;
  }
  dispatch(eventName, param, store) {
    let subject = this.subjects[eventName];
    if (subject == null) {
      this.subjects[eventName] = subject = new Subject();
    }
    subject.next(param);
  }
  getParam(eventName) {
    if (this.subjects[eventName]) {
      return this.subjects[eventName].value;
    } else {
      return null;
    }
  }
}
let CartComponent = /*#__PURE__*/(() => {
  class CartComponent extends PlayerBase {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function CartComponent_Factory(t) {
      return new (t || CartComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CartComponent,
      selectors: [["app-cart"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 0,
      consts: [["component", ""], ["playercontainer", ""]],
      template: function CartComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", null, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return CartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KeyboardComponent = /*#__PURE__*/(() => {
  class KeyboardComponent extends PlayerBase {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    load(playerObject) {
      let self;
      return super.load(playerObject).pipe(switchMap(playerBase => {
        self = playerBase;
        return of('a');
      }), catchError(err => this.logError(err)), switchMap(a => of(self)), takeUntil(this.finish$));
    }
    static ɵfac = function KeyboardComponent_Factory(t) {
      return new (t || KeyboardComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: KeyboardComponent,
      selectors: [["app-keyboard"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["component", ""]],
      template: function KeyboardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return KeyboardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MaterialModules = [MatIconModule, MatButtonModule, MatSliderModule, MatCheckboxModule, MatInputModule, MatRadioModule, MatSlideToggleModule, MatDialogModule, MatOptionModule, MatSelectModule];
let SafeHtmlPipe = /*#__PURE__*/(() => {
  class SafeHtmlPipe {
    sanitized;
    constructor(sanitized) {
      this.sanitized = sanitized;
    }
    transform(value) {
      return this.sanitized.bypassSecurityTrustHtml(value);
    }
    static ɵfac = function SafeHtmlPipe_Factory(t) {
      return new (t || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1$2.DomSanitizer, 16));
    };
    static ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "safeHtml",
      type: SafeHtmlPipe,
      pure: true
    });
  }
  return SafeHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$6 = ["playercontainer"];
const _c1$5 = ["item"];
let FlickingItemComponent = /*#__PURE__*/(() => {
  class FlickingItemComponent {
    injector;
    entry;
    item;
    editMode = false;
    playerService;
    resolver;
    parentPlayer;
    childComponent;
    constructor(injector) {
      this.injector = injector;
      this.resolver = injector.get(ComponentFactoryResolver);
      this.playerService = injector.get('playerService');
    }
    set setParentPlayer(parentPlayer) {
      this.parentPlayer = parentPlayer;
    }
    set setEditMode(editMode) {
      this.editMode = editMode;
    }
    set setPage(page) {
      page.$obs = this.createPage(page);
    }
    createPage(page) {
      const player = page.Player[0];
      if (player.$.src != null) {
        const sceneId = player.$.src;
        return this.playerService.caching.getRecord("scenes", sceneId).pipe(switchMap$1(scene => {
          const player2 = JSON.parse(JSON.stringify(scene.json.Player));
          this.childComponent = this.createComponent(SceneComponent, this.editMode, -1);
          this.childComponent.scaleX = this.parentPlayer.scaleX;
          this.childComponent.scaleY = this.parentPlayer.scaleY;
          const layout = player2.Data[0].Layout[0];
          const actualWidth = Math.floor(Number(layout.$.width) * this.parentPlayer.scaleX);
          const actualHeight = Math.floor(Number(layout.$.height) * this.parentPlayer.scaleY);
          const style = this.item.nativeElement.parentElement.style;
          style.width = actualWidth + 'px';
          style.height = actualHeight + 'px';
          this.parentPlayer.updatePanels();
          this.childComponent.childProviderData = page.childProviderData;
          return this.childComponent.load(player2);
        }), switchMap$1(child => {
          return of(child);
        }), catchError(err => {
          Log.debug();
          return of('a');
        }));
      } else {
        const playerId = player.$.player;
        let pixiClass = this.playerService.getComponentClasses(playerId);
        const blockingTime = this.playerService.getComponentBlockingTime(playerId);
        const childComponent = this.createComponent(pixiClass, this.editMode, blockingTime);
        //???childComponent.display(false);
        return childComponent.load(player).pipe(switchMap$1(child => {
          //???child.display(true);
          const style = this.item.nativeElement.parentElement.style;
          style.width = child.actualWidth + 'px';
          style.height = child.actualHeight + 'px';
          return of(child);
        }), catchError(err => {
          Log.debug();
          return of('a');
        }));
      }
    }
    createComponent(cmpClass, editMode, blockingTime) {
      let childComponent;
      const factory = this.resolver.resolveComponentFactory(cmpClass);
      const componentRef = this.entry.createComponent(factory);
      childComponent = componentRef.instance;
      childComponent.hostView = componentRef.hostView;
      childComponent.init(this.parentPlayer, editMode, blockingTime);
      return childComponent;
    }
    ngOnDestroy() {
      if (this.childComponent != null) {
        this.childComponent.destroy();
        this.childComponent = null;
      }
    }
    static ɵfac = function FlickingItemComponent_Factory(t) {
      return new (t || FlickingItemComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FlickingItemComponent,
      selectors: [["app-flicking-item"]],
      viewQuery: function FlickingItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$6, 7, ViewContainerRef);
          i0.ɵɵviewQuery(_c1$5, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.entry = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.item = _t.first);
        }
      },
      inputs: {
        setParentPlayer: "setParentPlayer",
        setEditMode: "setEditMode",
        setPage: "setPage"
      },
      decls: 4,
      vars: 0,
      consts: [["item", ""], ["playercontainer", ""], [2, "position", "absolute"]],
      template: function FlickingItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵelement(2, "template", null, 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FlickingItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function DialogPopComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2);
    i0.ɵɵtext(3, "Yes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 3);
    i0.ɵɵlistener("click", function DialogPopComponent_Conditional_2_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNoClick());
    });
    i0.ɵɵtext(5, "No");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("mat-dialog-close", ctx_r1.data["name"]);
  }
}
function DialogPopComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "button", 4);
    i0.ɵɵtext(2, "Ok");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("mat-dialog-close", ctx_r1.data["name"]);
  }
}
let DialogPopComponent$1 = /*#__PURE__*/(() => {
  let DialogPopComponent$1 = class DialogPopComponent {
    dialogRef;
    data;
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
    }
    onNoClick() {
      this.dialogRef.close();
    }
    static ɵfac = function DialogPopComponent_Factory(t) {
      return new (t || DialogPopComponent)(i0.ɵɵdirectiveInject(i1$3.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DialogPopComponent,
      selectors: [["app-popdiag"]],
      decls: 4,
      vars: 2,
      consts: [["mat-dialog-content", ""], ["fxFlex", "", "fxLayoutAlign", "center center", "fxLayoutGap", "32px"], ["mat-raised-button", "", 3, "mat-dialog-close"], ["mat-raised-button", "", "cdkFocusInitial", "", 3, "click"], ["mat-button", "", "cdkFocusInitial", "", 2, "width", "100% !important", 3, "mat-dialog-close"]],
      template: function DialogPopComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h1", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, DialogPopComponent_Conditional_2_Template, 6, 1, "div", 0)(3, DialogPopComponent_Conditional_3_Template, 3, 1);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.data["name"]);
          i0.ɵɵadvance();
          i0.ɵɵconditional(2, (ctx.data == null ? null : ctx.data.options == null ? null : ctx.data.options.showCancel) || ctx.data["showCancel"] ? 2 : 3);
        }
      },
      dependencies: [i2.MatButton, i1$3.MatDialogClose, i1$3.MatDialogContent],
      styles: [".box[_ngcontent-%COMP%]{align-items:center;justify-content:center}button[_ngcontent-%COMP%]{width:49%!important;padding:0!important;margin:0!important}"]
    });
  };
  return DialogPopComponent$1;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// download-sign-service.component.ts
function DownloadSignServiceComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "button", 6);
    i0.ɵɵlistener("click", function DownloadSignServiceComponent_div_7_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeDialog());
    });
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
  }
}
let DownloadSignServiceComponent = /*#__PURE__*/(() => {
  class DownloadSignServiceComponent {
    dialogRef;
    data;
    cdRef;
    downloadProgress = 0;
    downloadStatus = 'Starting download...';
    isDownloading = true;
    isCompleted = false;
    errorMessage = '';
    isCancelled = false;
    constructor(dialogRef, data, cdRef) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.cdRef = cdRef;
      // The disableClose should be set when opening the dialog, not here
      this.startDownload();
    }
    ngOnDestroy() {
      this.isCancelled = true;
    }
    async startDownload() {
      try {
        const response = await fetch(this.data.downloadUrl);
        if (!response.ok) {
          throw new Error('Download failed');
        }
        const contentLength = response.headers.get('Content-Length');
        const total = parseInt(contentLength, 10);
        const reader = response.body.getReader();
        let receivedLength = 0;
        const chunks = [];
        while (true) {
          if (this.isCancelled) return;
          const {
            done,
            value
          } = await reader.read();
          if (done) break;
          chunks.push(value);
          receivedLength += value.length;
          if (total) {
            this.downloadProgress = Math.round(receivedLength / total * 100);
            this.downloadStatus = `Downloading... ${this.downloadProgress}%`;
          } else {
            this.downloadStatus = `Downloaded ${this.formatBytes(receivedLength)}`;
          }
          this.cdRef.markForCheck();
        }
        // Create blob and download
        const chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (const chunk of chunks) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }
        const blob = new Blob([chunksAll], {
          type: 'application/vnd.android.package-archive'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.data.downloadFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.downloadProgress = 100;
        this.downloadStatus = 'Download completed!';
        this.isDownloading = false;
        this.isCompleted = true;
        this.dialogRef.disableClose = false;
        this.cdRef.markForCheck();
        // Auto-close dialog after 2 seconds
        setTimeout(() => {
          this.dialogRef.close();
        }, 2000);
      } catch (error) {
        this.errorMessage = 'Download failed. Please try again.';
        this.isDownloading = false;
        this.dialogRef.disableClose = false;
        this.cdRef.markForCheck();
      }
    }
    closeDialog() {
      this.dialogRef.close();
    }
    formatBytes(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    static ɵfac = function DownloadSignServiceComponent_Factory(t) {
      return new (t || DownloadSignServiceComponent)(i0.ɵɵdirectiveInject(i1$3.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DownloadSignServiceComponent,
      selectors: [["lib-download-sign-service"]],
      decls: 8,
      vars: 3,
      consts: [["mat-dialog-title", ""], [1, "download-content"], ["mode", "determinate", 3, "value"], [1, "status-text"], ["class", "error-message", 4, "ngIf"], [1, "error-message"], ["mat-button", "", 3, "click"]],
      template: function DownloadSignServiceComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h3", 0);
          i0.ɵɵtext(1, "Downloading...");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "mat-dialog-content")(3, "div", 1);
          i0.ɵɵelement(4, "mat-progress-bar", 2);
          i0.ɵɵelementStart(5, "div", 3);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, DownloadSignServiceComponent_div_7_Template, 4, 1, "div", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("value", ctx.downloadProgress);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.downloadStatus, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.errorMessage);
        }
      },
      dependencies: [i11.NgIf, i2.MatButton, i1$3.MatDialogTitle, i1$3.MatDialogContent, i4$1.MatProgressBar],
      styles: [".download-content[_ngcontent-%COMP%]{width:250px;padding:16px 0}.status-text[_ngcontent-%COMP%]{margin-top:12px;text-align:center;font-size:13px;color:#0009}.error-message[_ngcontent-%COMP%]{margin-top:12px;padding:8px;background:#f443361a;border:1px solid rgba(244,67,54,.3);border-radius:4px;color:#c62828;text-align:center;font-size:12px}"]
    });
  }
  return DownloadSignServiceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SignageLibsModuleCommon = /*#__PURE__*/(() => {
  class SignageLibsModuleCommon {
    static ɵfac = function SignageLibsModuleCommon_Factory(t) {
      return new (t || SignageLibsModuleCommon)();
    };
    static ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: SignageLibsModuleCommon
    });
    static ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      imports: [CommonModule, QRCodeModule, MaterialModules, MatProgressBarModule, NgxFlickingModule, i1$4.MatIconModule, i2.MatButtonModule, i3.MatSliderModule, i4.MatCheckboxModule, i5.MatInputModule, i6.MatRadioModule, i7.MatSlideToggleModule, i1$3.MatDialogModule, i9.MatOptionModule, i10.MatSelectModule, NgxFlickingModule]
    });
  }
  return SignageLibsModuleCommon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SignageLibsModuleCommon, {
    declarations: [DialogPopComponent$1, DownloadSignServiceComponent, NotSupportedComponent, AdNetComponent, ButtonComponent, PttMicComponent, PttSpkComponent, GpsComponent, CameraComponent, CartComponent, CatalogItemComponent, CatalogPlayerComponent, ChartComponent, CheckboxComponent, ClockComponent, CollectionComponent, CountdownComponent, CustomRssItemComponent, CustomRssPlayerComponent, ExtAppComponent, ExtImageComponent, ExtVideoComponent, FasterQComponent, FormComponent, HtmlComponent, CanvaComponent, ImageComponent, JsonItemComponent, JsonListComponent, JsonViewerComponent, AyreshareComponent, KeyboardComponent, KnxComponent, LabelComponent, LabelQueueComponent, LocationBaseComponent, MessageComponent, NumericStepperComponent, PlaylistComponent, MusicListComponent, MusicComponent, FlickingComponent, FlickingItemComponent, PodcastComponent, QrComponent, RadioComponent, RichTextComponent, RssComponent, SceneComponent, SerialPortComponent, SliderComponent, StockItemComponent, StockTickerComponent, SwitchComponent, TextInputComponent, VideoComponent, XmlItemComponent, XmlPlayerComponent, YouTubeComponent, LoaderComponent, SafeHtmlPipe],
    imports: [CommonModule, QRCodeModule, i1$4.MatIconModule, i2.MatButtonModule, i3.MatSliderModule, i4.MatCheckboxModule, i5.MatInputModule, i6.MatRadioModule, i7.MatSlideToggleModule, i1$3.MatDialogModule, i9.MatOptionModule, i10.MatSelectModule, MatProgressBarModule, NgxFlickingModule],
    exports: [i1$4.MatIconModule, i2.MatButtonModule, i3.MatSliderModule, i4.MatCheckboxModule, i5.MatInputModule, i6.MatRadioModule, i7.MatSlideToggleModule, i1$3.MatDialogModule, i9.MatOptionModule, i10.MatSelectModule, NgxFlickingModule]
  });
})();
i0.ɵɵsetComponentScope(CatalogPlayerComponent, [i11.NgForOf, i12.NgxFlickingComponent, i12.NgxFlickingPanel, FlickingItemComponent], []);
i0.ɵɵsetComponentScope(CustomRssPlayerComponent, [i11.NgForOf, i12.NgxFlickingComponent, i12.NgxFlickingPanel, FlickingItemComponent], []);
i0.ɵɵsetComponentScope(JsonListComponent, [i11.NgForOf, i12.NgxFlickingComponent, i12.NgxFlickingPanel, FlickingItemComponent], []);
i0.ɵɵsetComponentScope(AyreshareComponent, [i11.NgForOf, i12.NgxFlickingComponent, i12.NgxFlickingPanel, FlickingItemComponent], []);
i0.ɵɵsetComponentScope(FlickingComponent, [i11.NgForOf, i12.NgxFlickingComponent, i12.NgxFlickingPanel, FlickingItemComponent], []);
i0.ɵɵsetComponentScope(StockTickerComponent, [i11.NgForOf, i12.NgxFlickingComponent, i12.NgxFlickingPanel, FlickingItemComponent], []);
i0.ɵɵsetComponentScope(XmlPlayerComponent, [i11.NgForOf, i12.NgxFlickingComponent, i12.NgxFlickingPanel, FlickingItemComponent], []);
let GlobalErrorHandler = /*#__PURE__*/(() => {
  class GlobalErrorHandler {
    constructor() {}
    handleError(error) {
      // Remove debugger for production
      debugger;
      const logInfo = Log.getLogInfo("GlobalErrorHandler", "handleError", []);
      let msg = "";
      let errorDetails = "";
      // Handle different error types
      if (error instanceof Error) {
        msg = error.message;
        errorDetails = error.stack || "";
      } else if (error && typeof error === 'object') {
        // Handle error objects with code property
        if (error.code) {
          msg = `Error Code: ${error.code}`;
          if (error.message) msg += ` - ${error.message}`;
          if (error.url) msg += ` - URL: ${error.url}`;
        }
        try {
          errorDetails = JSON.stringify(error, null, 2);
        } catch (e) {
          errorDetails = String(error);
        }
      } else {
        msg = String(error);
        errorDetails = msg;
      }
      // Log the error with more context
      console.error('GlobalErrorHandler:', {
        message: msg,
        details: errorDetails,
        errorObject: error
      });
      Log.e(logInfo, LogTag.GLOBAL_ERROR, msg);
    }
    static ɵfac = function GlobalErrorHandler_Factory(t) {
      return new (t || GlobalErrorHandler)();
    };
    static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: GlobalErrorHandler,
      factory: GlobalErrorHandler.ɵfac,
      providedIn: "root"
    });
  }
  return GlobalErrorHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SignageLibsModuleWeb = /*#__PURE__*/(() => {
  class SignageLibsModuleWeb {
    static ɵfac = function SignageLibsModuleWeb_Factory(t) {
      return new (t || SignageLibsModuleWeb)();
    };
    static ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: SignageLibsModuleWeb
    });
    static ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [{
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
      }, {
        provide: 'cachingService',
        useClass: CachingService
      }, {
        provide: 'playerService',
        useClass: PlayerWebService
      }, {
        provide: 'eventParams',
        useClass: EventParams
      }],
      imports: [SignageLibsModuleCommon, CommonModule, BrowserAnimationsModule, QRCodeModule]
    });
  }
  return SignageLibsModuleWeb;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SignageLibsModuleWeb, {
    declarations: [SignagePlayerWeb],
    imports: [SignageLibsModuleCommon, CommonModule, BrowserAnimationsModule, QRCodeModule],
    exports: [SignagePlayerWeb]
  });
})();
let PlayerStudioService = /*#__PURE__*/(() => {
  class PlayerStudioService extends PlayerBaseService {
    injector;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    init() {
      return super.init().pipe(lastMap(r => this.caching.init(false, true)));
    }
    getServiceUrl() {
      return 'https://' + this.businessDomain + '/Web/loadData.ashx?businessId=' + this.businessId + '&sceneId=' + this.sceneId;
    }
    requestFont(i_font, onUrl) {
      const url = 'https://earth.signage.me/WebService/fonts/' + i_font;
      onUrl(url);
    }
    static ɵfac = function PlayerStudioService_Factory(t) {
      return new (t || PlayerStudioService)(i0.ɵɵinject(i0.Injector));
    };
    static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: PlayerStudioService,
      factory: PlayerStudioService.ɵfac,
      providedIn: 'root'
    });
  }
  return PlayerStudioService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SignageLibsModuleStudio = /*#__PURE__*/(() => {
  class SignageLibsModuleStudio {
    static ɵfac = function SignageLibsModuleStudio_Factory(t) {
      return new (t || SignageLibsModuleStudio)();
    };
    static ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: SignageLibsModuleStudio
    });
    static ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [{
        provide: 'cachingService',
        useClass: CachingService
      }, {
        provide: 'playerService',
        useClass: PlayerStudioService
      }, {
        provide: 'eventParams',
        useClass: EventParams
      }],
      imports: [SignageLibsModuleCommon]
    });
  }
  return SignageLibsModuleStudio;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SignageLibsModuleStudio, {
    imports: [SignageLibsModuleCommon]
  });
})();
class RegDialogComponent {
  injector;
  playerService;
  http;
  changeDetectorRef;
  click$ = new Subject();
  blockUI = false;
  constructor(injector) {
    this.injector = injector;
    this.playerService = injector.get('playerService');
    this.changeDetectorRef = this.injector.get(ChangeDetectorRef);
    this.http = this.injector.get(HttpClient);
  }
  onClick() {
    this.click$.next('click');
  }
  disableUI(value) {
    this.blockUI = value;
    this.changeDetectorRef.detectChanges();
  }
}
const _c0$5 = ["clickInstall"];
let InstallPwaComponent = /*#__PURE__*/(() => {
  class InstallPwaComponent extends RegDialogComponent {
    injector;
    clickInstall;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    ngOnInit() {}
    install() {
      const logInfo = Log.getLogInfo("InstallPwaComponent", "install", []);
      return this.click$.pipe(take(1), switchMap(r => {
        Log.d(logInfo, LogTag.REGISTRATION, 'install click');
        this.disableUI(true);
        return this.playerService.installPwa();
      }));
    }
    static ɵfac = function InstallPwaComponent_Factory(t) {
      return new (t || InstallPwaComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: InstallPwaComponent,
      selectors: [["install-pwa"]],
      viewQuery: function InstallPwaComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clickInstall = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 1,
      consts: [["container", ""], ["clickInstall", ""], [1, "frame"], [1, "container"], [2, "width", "100%", "text-align", "center", "padding-top", "80px"], ["mat-raised-button", "", "type", "button", 1, "buttonStart", 3, "click", "disabled"]],
      template: function InstallPwaComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2)(1, "div", 3, 0)(3, "div", 4)(4, "button", 5, 1);
          i0.ɵɵlistener("click", function InstallPwaComponent_Template_button_click_4_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick());
          });
          i0.ɵɵtext(6, " install ");
          i0.ɵɵelementStart(7, "mat-icon");
          i0.ɵɵtext(8, "desktop_windows");
          i0.ɵɵelementEnd()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", ctx.blockUI);
        }
      },
      dependencies: [i1$4.MatIcon, i2.MatButton],
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}", ".innerButton[_ngcontent-%COMP%]{left:calc(50vw - 110px)}"]
    });
  }
  return InstallPwaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function CheckIsInstalledComponent_mat_icon_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "hourglass_bottom");
    i0.ɵɵelementEnd();
  }
}
function CheckIsInstalledComponent_mat_icon_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "hourglass_top");
    i0.ɵɵelementEnd();
  }
}
function CheckIsInstalledComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " If installation did not start, you can install the ");
    i0.ɵɵelementStart(1, "a", 6);
    i0.ɵɵtext(2, "SignPlayer.apk");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " manually. ");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.apkUrl, i0.ɵɵsanitizeUrl);
  }
}
let CheckIsInstalledComponent = /*#__PURE__*/(() => {
  class CheckIsInstalledComponent extends RegDialogComponent {
    injector;
    installApk = false;
    apkUrl;
    waitCount = 60;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      const isAndroid = window.navigator.userAgent.indexOf("Android") != -1;
      const isStandalone = this.playerService.isStandalone();
      this.installApk = isAndroid && !isStandalone;
      this.apkUrl = window.location.origin + '/deploy/android/SignPlayer.apk';
    }
    ngOnInit() {
      setInterval(() => {
        if (this.waitCount > 0) {
          this.waitCount--;
          this.changeDetectorRef.detectChanges();
        }
      }, 1000);
    }
    static ɵfac = function CheckIsInstalledComponent_Factory(t) {
      return new (t || CheckIsInstalledComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CheckIsInstalledComponent,
      selectors: [["app-check-is-installed"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 11,
      vars: 4,
      consts: [["container", ""], [1, "frame"], [1, "container"], [1, "innerText"], [1, "iconAnim"], [4, "ngIf"], ["download", "", 3, "href"]],
      template: function CheckIsInstalledComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0)(3, "div", 3);
          i0.ɵɵtext(4, " Installation should begin in few seconds");
          i0.ɵɵelement(5, "br");
          i0.ɵɵtext(6);
          i0.ɵɵelementStart(7, "div", 4);
          i0.ɵɵtemplate(8, CheckIsInstalledComponent_mat_icon_8_Template, 2, 0, "mat-icon", 5)(9, CheckIsInstalledComponent_mat_icon_9_Template, 2, 0, "mat-icon", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, CheckIsInstalledComponent_Conditional_10_Template, 4, 1);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate1(" please wait (", ctx.waitCount, ") ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.waitCount % 2 == 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.waitCount % 2 == 1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(10, ctx.installApk ? 10 : -1);
        }
      },
      dependencies: [i1$4.MatIcon, i11.NgIf],
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}", ".innerText[_ngcontent-%COMP%]{padding-top:54px;text-align:center}.iconAnim[_ngcontent-%COMP%]{width:100%;text-align:center;padding-top:20px}mat-icon[_ngcontent-%COMP%]{font-size:40px!important;height:60px;width:60px}a[_ngcontent-%COMP%]{color:#0cf;font-weight:700;text-decoration:underline}"]
    });
  }
  return CheckIsInstalledComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InstallManuallyComponent = /*#__PURE__*/(() => {
  class InstallManuallyComponent extends RegDialogComponent {
    injector;
    installApk = false;
    apkUrl;
    waitCount = 30;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      const isAndroid = window.navigator.userAgent.indexOf("Android") != -1;
      this.installApk = isAndroid;
      this.apkUrl = window.location.origin + '/deploy/android/SignPlayer.apk';
    }
    ngOnInit() {
      setInterval(() => {
        if (this.waitCount > 0) {
          this.waitCount--;
          this.changeDetectorRef.detectChanges();
        }
      }, 1000);
    }
    static ɵfac = function InstallManuallyComponent_Factory(t) {
      return new (t || InstallManuallyComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: InstallManuallyComponent,
      selectors: [["app-install-manually"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 8,
      vars: 1,
      consts: [["container", ""], [1, "frame"], [1, "container"], [1, "innerText"], ["download", "", 3, "href"]],
      template: function InstallManuallyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0)(3, "div", 3);
          i0.ɵɵtext(4, " Please download and install ");
          i0.ɵɵelementStart(5, "a", 4);
          i0.ɵɵtext(6, "SignPlayer.apk");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(7, " manually, to complete installation. ");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("href", ctx.apkUrl, i0.ɵɵsanitizeUrl);
        }
      },
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}", ".innerText[_ngcontent-%COMP%]{padding-top:54px;text-align:center}.iconAnim[_ngcontent-%COMP%]{width:100%;text-align:center;padding-top:20px}mat-icon[_ngcontent-%COMP%]{font-size:40px!important;height:60px;width:60px}a[_ngcontent-%COMP%]{color:#0cf;font-weight:700;text-decoration:underline}"]
    });
  }
  return InstallManuallyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CloseComponent = /*#__PURE__*/(() => {
  class CloseComponent {
    injector;
    constructor(injector) {
      this.injector = injector;
    }
    ngOnInit() {}
    close() {
      const logInfo = Log.getLogInfo("CloseComponent", "close", []);
      return of(close).pipe(delay(5000), switchMap(r => {
        Log.d(logInfo, LogTag.REGISTRATION, 'window.close()');
        window.close();
        return of(null);
      }), delay(2000));
    }
    static ɵfac = function CloseComponent_Factory(t) {
      return new (t || CloseComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CloseComponent,
      selectors: [["app-close"]],
      decls: 10,
      vars: 0,
      consts: [["container", ""], [1, "frame"], [1, "container"], [2, "text-align", "center", "padding-top", "20%", "font-size", "0.9em"], [2, "text-align", "center"], [2, "font-size", "50px"]],
      template: function CloseComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0)(3, "div", 3);
          i0.ɵɵtext(4, " looks like the player is already installed, please launch it... ");
          i0.ɵɵelement(5, "br")(6, "br");
          i0.ɵɵelementStart(7, "div", 4)(8, "mat-icon", 5);
          i0.ɵɵtext(9, "restart_alt");
          i0.ɵɵelementEnd()()()()();
        }
      },
      dependencies: [i1$4.MatIcon],
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}"]
    });
  }
  return CloseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$4 = ["hostType"];
const _c1$4 = ["domain"];
const _c2$4 = ["connect"];
const _c3$3 = ["container"];
let HostServerComponent = /*#__PURE__*/(() => {
  class HostServerComponent extends RegDialogComponent {
    injector;
    hostType;
    domain;
    connect;
    container;
    selectedOption;
    showPrivateServer = false;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    ngOnInit() {
      this.selectedOption = 'defaultServer';
      this.onHost();
    }
    ngAfterViewInit() {
      // todo: remove first screen as we dont support private server, yet.and when we do it should be in side bar, as almost no clients use private server
      if (this.showPrivateServer) return;
      setTimeout(() => this.onClick());
    }
    getHost() {
      const logInfo = Log.getLogInfo("HostServerComponent", "getHost", []);
      return this.click$.pipe(concatMap(value => {
        Log.d(logInfo, LogTag.REGISTRATION, 'Host click()');
        this.playerService.domain = this.domain.nativeElement.value;
        const url = 'https://' + this.playerService.domain + '/Web/domain.ashx';
        Log.d(logInfo, LogTag.REGISTRATION, 'url=' + url);
        return this.http.get(url, {
          responseType: 'text'
        }).pipe(retryWithBackoff());
      }), filter(res => {
        return res != null;
      }), take(1));
    }
    onHost() {
      if (this.selectedOption == 'defaultServer') {
        this.domain.nativeElement.value = 'galaxy.signage.me';
        this.domain.nativeElement.hidden = true;
      } else {
        this.domain.nativeElement.value = '';
        this.domain.nativeElement.hidden = false;
      }
    }
    static ɵfac = function HostServerComponent_Factory(t) {
      return new (t || HostServerComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: HostServerComponent,
      selectors: [["app-host-server"]],
      viewQuery: function HostServerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$4, 7);
          i0.ɵɵviewQuery(_c1$4, 7);
          i0.ɵɵviewQuery(_c2$4, 7);
          i0.ɵɵviewQuery(_c3$3, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hostType = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.domain = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.connect = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 20,
      vars: 5,
      consts: [["container", ""], ["hostType", ""], ["domain", ""], ["connect", ""], [1, "frame"], [1, "container"], [1, "inner"], [3, "hidden"], [1, "head"], ["aria-label", "Select an option", 3, "disabled"], ["value", "1", 2, "display", "block", 3, "checked"], ["value", "2", 2, "display", "block"], ["type", "text", "matInput", "", 1, "item2", 3, "disabled"], ["mat-stroked-button", "", "type", "button", 1, "buttonStart", 3, "click", "disabled"]],
      template: function HostServerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 4)(1, "div", 5, 0)(3, "div", 6)(4, "div", 7)(5, "label", 8);
          i0.ɵɵtext(6, "Digital Signage network");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "hr");
          i0.ɵɵelementStart(8, "mat-radio-group", 9, 1)(10, "mat-radio-button", 10);
          i0.ɵɵtext(11, "cloud");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "mat-radio-button", 11);
          i0.ɵɵtext(13, "private server");
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(14, "input", 12, 2)(16, "br");
          i0.ɵɵelementStart(17, "button", 13, 3);
          i0.ɵɵlistener("click", function HostServerComponent_Template_button_click_17_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick());
          });
          i0.ɵɵtext(19, " connect ");
          i0.ɵɵelementEnd()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("hidden", ctx.showPrivateServer === false);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", ctx.blockUI);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("checked", true);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", ctx.blockUI);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("disabled", ctx.blockUI);
        }
      },
      dependencies: [i2.MatButton, i5.MatInput, i6.MatRadioGroup, i6.MatRadioButton],
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}"]
    });
  }
  return HostServerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$3 = ["user"];
const _c1$3 = ["password"];
const _c2$3 = ["btnLogin"];
const _c3$2 = ["popup"];
function LoginComponent_Conditional_4_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const digit_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", digit_r2, " ");
  }
}
function LoginComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1, "Register remotely");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵtext(4, "Registration code: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵtemplate(6, LoginComponent_Conditional_4_div_6_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "br");
    i0.ɵɵelementStart(8, "div", 12);
    i0.ɵɵtext(9, "In ");
    i0.ɵɵelementStart(10, "b");
    i0.ɵɵtext(11, "SignStudio");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, ", click on 'register SignPlayer', then copy the displayed registration code to complete the registration process.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "br");
    i0.ɵɵelementStart(14, "span", 13);
    i0.ɵɵlistener("click", function LoginComponent_Conditional_4_Template_span_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.userRemoteReg = false);
    });
    i0.ɵɵtext(15, "register manually");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r2.codeDigits);
  }
}
function LoginComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1, "Register manually");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "mat-form-field")(4, "input", 15, 2);
    i0.ɵɵlistener("keydown.enter", function LoginComponent_Conditional_5_Template_input_keydown_enter_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.passFocusSecondPass());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "mat-form-field")(8, "input", 16, 3);
    i0.ɵɵlistener("keydown.enter", function LoginComponent_Conditional_5_Template_input_keydown_enter_8_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClick());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(10, "br");
    i0.ɵɵelementStart(11, "div", 17)(12, "button", 18, 4);
    i0.ɵɵlistener("click", function LoginComponent_Conditional_5_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClick());
    });
    i0.ɵɵelementStart(14, "span", 19);
    i0.ɵɵtext(15, "login");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "mat-icon");
    i0.ɵɵtext(17, "login");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "span", 13);
    i0.ɵɵlistener("click", function LoginComponent_Conditional_5_Template_span_click_18_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.userRemoteReg = true);
    });
    i0.ɵɵtext(19, "register remotely");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const user_r5 = i0.ɵɵreference(5);
    const password_r6 = i0.ɵɵreference(9);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r2.blockUI);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r2.blockUI);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r2.blockUI || password_r6.value.length < 3 || user_r5.value.length < 3);
  }
}
function LoginComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h1", 20)(1, "div", 21);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 22);
    i0.ɵɵelement(3, "path", 23)(4, "path", 24);
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 25)(6, "label", 26);
    i0.ɵɵtext(7, "Wrong credentials, please try again...");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "hr")(9, "label", 26);
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelement(11, "label", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 28);
    i0.ɵɵlistener("click", function LoginComponent_ng_template_6_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClose());
    });
    i0.ɵɵelementStart(13, "mat-icon");
    i0.ɵɵtext(14, "close");
    i0.ɵɵelementEnd()()();
  }
}
let LoginComponent = /*#__PURE__*/(() => {
  class LoginComponent extends RegDialogComponent {
    injector;
    dialog;
    user;
    password;
    btnLogin;
    popup;
    popDialog;
    client;
    regCode;
    userRemoteReg = true;
    constructor(injector, dialog) {
      super(injector);
      this.injector = injector;
      this.dialog = dialog;
      this.playerService = injector.get('playerService');
      this.changeDetectorRef = this.injector.get(ChangeDetectorRef);
    }
    ngOnInit() {}
    loginFailDialog() {
      this.popDialog = this.dialog.open(this.popup, {
        width: '370px',
        height: '280px'
      });
    }
    passFocusSecondPass() {
      try {
        this.password.nativeElement.focus();
      } catch (e) {}
    }
    login() {
      return merge(this.remoteRegister(), this.localRegister()).pipe(take(1));
    }
    localRegister() {
      return this.click$.pipe(switchMap(r => {
        this.disableUI(true);
        const url1 = 'https://' + this.playerService.domain + '/WebService/html/login.ashx?user=' + this.user.nativeElement.value + '&password=' + this.password.nativeElement.value;
        return this.http.get(url1, {
          responseType: 'text'
        });
      }), map(a => JSON.parse(a)), switchMap(data => {
        this.playerService.sceneId = data.sceneId;
        this.playerService.businessId = data.businessId;
        if (this.playerService.businessId === -1) {
          this.loginFailDialog();
          this.disableUI(false);
          return of(null);
        }
        return this.playerService.updateCustomerInfo();
      }), switchMap(res => {
        if (res == true) {
          this.playerService.data['user'] = this.user.nativeElement.value;
          this.playerService.data['pass'] = this.password.nativeElement.value;
          return of('login');
        } else {
          return of(null);
        }
      }), filter(res => {
        return res != null;
      }));
    }
    get codeDigits() {
      if (this.regCode == null) {
        return [];
      }
      return this.regCode.split('');
    }
    remoteRegister() {
      const obs$ = new Observable(sub => {
        try {
          const url = 'wss://' + this.playerService.domain + '/Web/registerWebSocket.ashx';
          this.client = new websocket.w3cwebsocket(url);
        } catch (e) {
          debugger;
        }
        this.client.onopen = () => {
          if (this.client.readyState === this.client.OPEN) {
            const requestCode = {
              command: "requestCode"
            };
            this.client.send(JSON.stringify(requestCode));
          }
        };
        this.client.onerror = err => {
          debugger;
        };
        this.client.onclose = a => {
          debugger;
        };
        this.client.onmessage = e => {
          const msg = JSON.parse(e.data);
          switch (msg.command) {
            case "reqCode":
              this.regCode = msg.code;
              this.changeDetectorRef.detectChanges();
              break;
            case "register":
              sub.next(msg);
              sub.complete();
              break;
          }
        };
      });
      return obs$.pipe(switchMap(data => {
        this.playerService.stationToken = data.stationToken;
        this.playerService.stationId = data.stationId;
        this.playerService.sceneId = data.sceneId;
        this.playerService.businessId = data.businessId;
        return this.playerService.updateCustomerInfo();
      }), switchMap(myData => {
        return this.playerService.saveStationInfo();
      }));
    }
    onClose() {
      this.popDialog.close();
    }
    static ɵfac = function LoginComponent_Factory(t) {
      return new (t || LoginComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$3.MatDialog));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: LoginComponent,
      selectors: [["app-login"]],
      viewQuery: function LoginComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$3, 5);
          i0.ɵɵviewQuery(_c1$3, 5);
          i0.ɵɵviewQuery(_c2$3, 5);
          i0.ɵɵviewQuery(_c3$2, 5, TemplateRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.user = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.password = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.btnLogin = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popup = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 8,
      vars: 2,
      consts: [["container", ""], ["popup", ""], ["user", ""], ["password", ""], ["btnLogin", ""], [1, "frame"], [1, "container"], [1, "innerLogin", "fadeInClass06"], [1, "text1"], [1, "text2"], [1, "code-display"], ["class", "digit", 4, "ngFor", "ngForOf"], [1, "instructions"], [1, "clickable-text", 3, "click"], [1, "digit"], ["type", "text", "placeholder", "user", "autocomplete", "off", "matInput", "", "value", "", 1, "item", 3, "keydown.enter", "disabled"], ["placeholder", "password", "autocomplete", "off", "type", "password", "matInput", "", "value", "", 1, "item", 3, "keydown.enter", "disabled"], [2, "text-align", "center"], ["mat-raised-button", "", "type", "button", 1, "buttonStart", 3, "click", "disabled"], [2, "position", "relative", "top", "-4px"], ["mat-dialog-title", "", "cdkDrag", "", "cdkDragRootElement", ".cdk-overlay-pane", 1, "header"], ["cdkDragHandle", "", 1, "move", "labelStyle", "pull-right", "dlg-drag-handle", 2, "color", "white", "position", "relative", "top", "13px"], ["width", "24px", "fill", "currentColor", "viewBox", "0 0 24 24"], ["d", "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"], ["d", "M0 0h24v24H0z", "fill", "none"], [1, "modal-body", 2, "padding", "10px"], [1, "labelStyle", "ver"], [1, "labelStyle"], ["mat-raised-button", "", "type", "button", 1, "infoButton", "buttonStart", 3, "click"]],
      template: function LoginComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 5)(1, "div", 6, 0)(3, "div", 7);
          i0.ɵɵtemplate(4, LoginComponent_Conditional_4_Template, 16, 1)(5, LoginComponent_Conditional_5_Template, 20, 3);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(6, LoginComponent_ng_template_6_Template, 15, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(4, ctx.userRemoteReg ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(5, !ctx.userRemoteReg ? 5 : -1);
        }
      },
      dependencies: [i1$4.MatIcon, i2.MatButton, i5.MatInput, i6$1.MatFormField, i1$3.MatDialogTitle, i11.NgForOf, i7$1.CdkDrag, i7$1.CdkDragHandle],
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}", ".innerLogin[_ngcontent-%COMP%]{position:absolute;top:5%;left:calc(50vw - 150px)}mat-form-field[_ngcontent-%COMP%]{width:300px}mat-icon[_ngcontent-%COMP%]{padding-right:10px}[_nghost-%COMP%]  .mat-form-field-label{color:#646464!important}.infoButton[_ngcontent-%COMP%]{width:100%;margin-top:100px}.move[_ngcontent-%COMP%]{float:right;cursor:move}label[_ngcontent-%COMP%]{color:#fff}mat-icon[_ngcontent-%COMP%]{color:#fff}  mat-dialog-container{background-color:#262626!important}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;position:relative;color:#fff;font-size:20px;margin-bottom:0}.text1[_ngcontent-%COMP%]{font-size:18px}.text2[_ngcontent-%COMP%]{padding-top:5px;font-size:12px}.instructions[_ngcontent-%COMP%]{width:300px;font-size:12px}.regCode[_ngcontent-%COMP%]{font-size:82px;font-weight:700}hr[_ngcontent-%COMP%]{border:0;height:1px;background-color:#333;margin-bottom:10px;margin-top:0}.clickable-text[_ngcontent-%COMP%]{cursor:pointer;color:0xffffff;text-decoration:underline;font-size:12px}.code-display[_ngcontent-%COMP%]{padding-top:10px;display:flex;gap:10px}.digit[_ngcontent-%COMP%]{width:40px;height:40px;text-align:center;line-height:40px;font-size:18px;color:#000;font-weight:700;border:1px solid #ccc;border-radius:5px;background-color:#f9f9f9}"]
    });
  }
  return LoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$2 = ["stationName"];
const _c1$2 = ["btnRegister"];
const _c2$2 = ["popup"];
const _c3$1 = a0 => ({
  "opacity": a0
});
function RegistrationComponent_mat_option_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 22)(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const scene_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", scene_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", scene_r2.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ID: ", scene_r2 == null ? null : scene_r2.id, "");
  }
}
function RegistrationComponent_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h1", 25)(1, "mat-icon", 26);
    i0.ɵɵtext(2, "desktop_mac");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 28);
    i0.ɵɵelement(5, "path", 29)(6, "path", 30);
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(7, "div", 31)(8, "label", 32);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "hr")(11, "label", 32);
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵelement(13, "label", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "br")(15, "br");
    i0.ɵɵelementStart(16, "button", 34);
    i0.ɵɵlistener("click", function RegistrationComponent_ng_template_29_Template_button_click_16_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onClose());
    });
    i0.ɵɵelementStart(17, "mat-icon");
    i0.ɵɵtext(18, "close");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(ctx_r3.popupMessage);
  }
}
let RegistrationComponent = /*#__PURE__*/(() => {
  class RegistrationComponent extends RegDialogComponent {
    injector;
    fb;
    dialog;
    ngZone;
    stationName;
    btnRegister;
    popup;
    selected;
    popDialog;
    popupMessage;
    //m_scenes = [];
    m_scenes$;
    m_answers = [];
    m_contGroup;
    m_stationName = 'My Player...';
    constructor(injector, fb, dialog, ngZone) {
      super(injector);
      this.injector = injector;
      this.fb = fb;
      this.dialog = dialog;
      this.ngZone = ngZone;
      this.initForm();
    }
    ngOnInit() {
      this.disableUI(true);
      this.m_scenes$ = this.m_contGroup.controls['answerField'].valueChanges.pipe(startWith(''), map(value => {
        if (value.id) {
          this.onSelected(value);
          return this._filter(value.label);
        }
        return this._filter(value);
      }));
    }
    initForm() {
      this.m_contGroup = this.fb.group({
        answerField: ['', [Validators.required]]
      });
    }
    onSelected(value) {
      this.selected = value;
      this.m_contGroup.controls['answerField'].patchValue(value.label);
    }
    _filter(value) {
      return this.m_answers.filter(option => option.label.toLowerCase().includes(value.toLowerCase()) && option.mimeType == "mainPlayer");
    }
    cannotRegister() {
      this.popDialog = this.dialog.open(this.popup);
    }
    onClose() {
      this.popDialog.close();
    }
    clear() {
      this.selected = null;
      this.m_contGroup.controls['answerField'].setValue('');
    }
    register() {
      const logInfo = Log.getLogInfo("RegistrationComponent", "register", []);
      return of('register').pipe(delay(20), concatMap(r => this.playerService.getSceneList()), concatMap(sceneList => {
        Log.d(logInfo, LogTag.REGISTRATION, sceneList);
        //this.m_scenes = sceneList; //Array(sceneList).filter(item => item.mimeType != "mainPlayer");
        this.m_answers = sceneList;
        this.disableUI(false);
        return this.click$;
      }), concatMap(r => {
        this.disableUI(true);
        this.playerService.sceneId = this.selected.id;
        const name = this.stationName.nativeElement.value;
        this.playerService.generateToken();
        const url = 'https://' + this.playerService.businessDomain + '/Web' + '/registerStation.ashx?user=' + this.playerService.data['user'] + '&pass=' + this.playerService.data['pass'] + '&stationToken=' + this.playerService.stationToken + '&stationName=' + name + '&sceneId=' + this.playerService.sceneId;
        Log.d(logInfo, LogTag.REGISTRATION, url);
        return this.http.get(url, {
          responseType: 'text'
        });
      }), concatMap(myData => {
        let data;
        try {
          data = JSON.parse(myData);
        } catch (e) {
          this.popupMessage = "Cannot assign, be sure to select a scene first";
          this.cannotRegister();
          Log.d(logInfo, LogTag.REGISTRATION, myData);
          this.disableUI(false);
          return of(null);
        }
        if (data.status) {
          this.playerService.stationId = data.stationId;
          return this.playerService.saveStationInfo();
        } else {
          debugger;
          let msg = data.message;
          if (msg == "exceeded") {
            msg = "Number of licenses has already been reached. Please contact your admin.";
          }
          const dialogRef = this.dialog.open(DialogPopComponent$1, {
            height: '200px',
            width: '400px',
            data: {
              name: msg
            }
          });
          return of(null);
        }
      }), filter(res => {
        return res != null;
      }), switchMap(value => {
        Log.d(logInfo, LogTag.REGISTRATION, 'registration completed');
        this.playerService.data['user'] = null;
        this.playerService.data['pass'] = null;
        return of('registered');
      }), take(1));
    }
    static ɵfac = function RegistrationComponent_Factory(t) {
      return new (t || RegistrationComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$5.FormBuilder), i0.ɵɵdirectiveInject(i1$3.MatDialog), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: RegistrationComponent,
      selectors: [["app-registration"]],
      viewQuery: function RegistrationComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$2, 5);
          i0.ɵɵviewQuery(_c1$2, 5);
          i0.ɵɵviewQuery(_c2$2, 5, TemplateRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stationName = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.btnRegister = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popup = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 31,
      vars: 12,
      consts: [["container", ""], ["auto", "matAutocomplete"], ["viewport", ""], ["stationName", ""], ["btnRegister", ""], ["popup", ""], [1, "frame"], [1, "container"], [1, "innerLogin", "fadeInClass06"], ["novalidate", "", "autocomplete", "off", 3, "formGroup"], [2, "width", "300px"], [2, "color", "white"], ["matInput", "", "type", "text", "name", "answerField", "placeholder", "scene", "formControlName", "answerField", "autocomplete", "off", 3, "keydown.enter", "matAutocomplete"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "aria-label", "Clear", 3, "click"], ["autoActiveFirstOption", ""], [1, "answer-dropdown", 3, "itemSize"], ["class", "answer", 3, "value", 4, "cdkVirtualFor", "cdkVirtualForOf"], ["placeholder", "player name", "type", "text", "matInput", "", 1, "item", 3, "keydown.enter", "ngModelChange", "disabled", "ngModel"], [2, "text-align", "center"], ["mat-raised-button", "", "type", "button", 1, "buttonStart", 3, "click", "disabled"], [2, "position", "relative", "top", "-3px"], [3, "ngStyle"], [1, "answer", 3, "value"], [1, "cut-text"], [2, "opacity", "0.1"], ["mat-dialog-title", "", "cdkDrag", "", "cdkDragRootElement", ".cdk-overlay-pane", 1, "header"], [1, "labelStyle", "pull-right"], ["cdkDragHandle", "", 1, "move", "labelStyle", "pull-right", "dlg-drag-handle", 2, "color", "white"], ["width", "24px", "fill", "currentColor", "viewBox", "0 0 24 24"], ["d", "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"], ["d", "M0 0h24v24H0z", "fill", "none"], [1, "modal-body"], [1, "labelStyle", "ver"], [1, "labelStyle"], ["mat-raised-button", "", "type", "button", 1, "infoButton", "buttonStart", 3, "click"]],
      template: function RegistrationComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 6)(1, "div", 7, 0)(3, "div", 8)(4, "form", 9)(5, "mat-form-field", 10)(6, "mat-label", 11);
          i0.ɵɵtext(7, "select scene...");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "input", 12);
          i0.ɵɵlistener("keydown.enter", function RegistrationComponent_Template_input_keydown_enter_8_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "button", 13);
          i0.ɵɵlistener("click", function RegistrationComponent_Template_button_click_9_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clear());
          });
          i0.ɵɵelementStart(10, "mat-icon");
          i0.ɵɵtext(11, "more_vert");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(12, "mat-autocomplete", 14, 1)(14, "cdk-virtual-scroll-viewport", 15, 2);
          i0.ɵɵtemplate(16, RegistrationComponent_mat_option_16_Template, 5, 3, "mat-option", 16);
          i0.ɵɵpipe(17, "async");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(18, "mat-form-field", 10)(19, "input", 17, 3);
          i0.ɵɵlistener("keydown.enter", function RegistrationComponent_Template_input_keydown_enter_19_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick());
          });
          i0.ɵɵtwoWayListener("ngModelChange", function RegistrationComponent_Template_input_ngModelChange_19_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.m_stationName, $event) || (ctx.m_stationName = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(21, "br");
          i0.ɵɵelementStart(22, "div", 18)(23, "button", 19, 4);
          i0.ɵɵlistener("click", function RegistrationComponent_Template_button_click_23_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick());
          });
          i0.ɵɵelementStart(25, "span", 20);
          i0.ɵɵtext(26, "register");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(27, "mat-icon", 21);
          i0.ɵɵtext(28, "check_circle_outline");
          i0.ɵɵelementEnd()()()()()();
          i0.ɵɵtemplate(29, RegistrationComponent_ng_template_29_Template, 19, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const auto_r5 = i0.ɵɵreference(13);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("formGroup", ctx.m_contGroup);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("matAutocomplete", auto_r5);
          i0.ɵɵadvance(6);
          i0.ɵɵproperty("itemSize", 7);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cdkVirtualForOf", i0.ɵɵpipeBind1(17, 8, ctx.m_scenes$));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("disabled", ctx.blockUI);
          i0.ɵɵtwoWayProperty("ngModel", ctx.m_stationName);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", ctx.blockUI || !ctx.selected || ctx.m_stationName.length < 2);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(10, _c3$1, ctx.blockUI || !ctx.selected || ctx.m_stationName.length < 2 ? "0.2" : "1"));
        }
      },
      dependencies: [i1$4.MatIcon, i2.MatButton, i2.MatIconButton, i5.MatInput, i6$1.MatFormField, i6$1.MatLabel, i6$1.MatSuffix, i1$3.MatDialogTitle, i9.MatOption, i11.NgStyle, i1$5.ɵNgNoValidate, i1$5.DefaultValueAccessor, i1$5.NgControlStatus, i1$5.NgControlStatusGroup, i1$5.FormGroupDirective, i1$5.FormControlName, i1$5.NgModel, i7$1.CdkDrag, i7$1.CdkDragHandle, i10$1.CdkFixedSizeVirtualScroll, i10$1.CdkVirtualForOf, i10$1.CdkVirtualScrollViewport, i11$1.MatAutocomplete, i11$1.MatAutocompleteTrigger, i11.AsyncPipe],
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}", ".innerLogin[_ngcontent-%COMP%]{position:absolute;top:15%;left:calc(50vw - 150px)}[_nghost-%COMP%]  .mat-select-placeholder{color:#646464!important}[_nghost-%COMP%]  .mat-form-field-label{color:#646464!important}[_nghost-%COMP%]  .mat-select-value{color:#fff}[_nghost-%COMP%]  .mat-select-arrow{color:#fff}.infoButton[_ngcontent-%COMP%]{width:100%;margin-top:100px}.move[_ngcontent-%COMP%]{float:right;cursor:move}label[_ngcontent-%COMP%]{color:#fff}mat-icon[_ngcontent-%COMP%]{color:#fff}  mat-dialog-container{background-color:#262626!important}  .reg-panel.mat-select-panel{background:#303030}.optionColor[_ngcontent-%COMP%]{color:#fff}.space-it[_ngcontent-%COMP%]{padding:20px}.padLeft[_ngcontent-%COMP%]{padding-left:10px}.inner5[_ngcontent-%COMP%]{text-align:center}[_nghost-%COMP%]     .mat-option{width:300px}.answer-dropdown[_ngcontent-%COMP%]{height:250px;background-color:#292929}.answer[_ngcontent-%COMP%]{color:#fff}.hideScroll[_ngcontent-%COMP%]{overflow:hidden}.answer-dropdown[_ngcontent-%COMP%]::-webkit-scrollbar{-webkit-appearance:none}.answer-dropdown[_ngcontent-%COMP%]::-webkit-scrollbar:vertical{width:11px;background-color:#333}.answer-dropdown[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{border-radius:0;border:2px solid rgb(255,255,255)!important;background-color:#00000080}.cut-text[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden;width:240px;white-space:nowrap}  .mdc-menu-surface.mat-mdc-autocomplete-panel{overflow:hidden}"]
    });
  }
  return RegistrationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogPopComponent = /*#__PURE__*/(() => {
  class DialogPopComponent {
    dialogRef;
    data;
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
    }
    onNoClick() {
      this.dialogRef.close();
    }
    static ɵfac = function DialogPopComponent_Factory(t) {
      return new (t || DialogPopComponent)(i0.ɵɵdirectiveInject(i1$3.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DialogPopComponent,
      selectors: [["app-dialog-pop"]],
      decls: 11,
      vars: 4,
      consts: [[1, "dialog-container"], [1, "dialog-header"], ["mat-dialog-title", "", 1, "dialog-title"], ["mat-dialog-content", "", 1, "dialog-content"], [1, "dialog-description", 3, "innerHTML"], ["mat-dialog-actions", "", "align", "end", 1, "dialog-actions"], ["mat-button", "", 1, "dialog-button", "cancel-button", 3, "click"], ["mat-raised-button", "", "color", "primary", "mat-dialog-close", "true", "cdkFocusInitial", "", 1, "dialog-button", "confirm-button"]],
      template: function DialogPopComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 3);
          i0.ɵɵelement(5, "div", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 5)(7, "button", 6);
          i0.ɵɵlistener("click", function DialogPopComponent_Template_button_click_7_listener() {
            return ctx.onNoClick();
          });
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "button", 7);
          i0.ɵɵtext(10);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", ctx.data.title, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("innerHTML", ctx.data.description, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", ctx.data.cancelText || "Cancel", " ");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.data.confirmText || "OK", " ");
        }
      },
      dependencies: [i2.MatButton, i1$3.MatDialogClose, i1$3.MatDialogTitle, i1$3.MatDialogActions, i1$3.MatDialogContent],
      styles: [".dialog-container[_ngcontent-%COMP%]{width:100%;height:100%;box-sizing:border-box;background-color:#f9f9f9;color:#333;border-radius:6px;overflow:hidden}.dialog-header[_ngcontent-%COMP%]{background-color:#e0e0e0;padding:8px}.dialog-header[_ngcontent-%COMP%]   .dialog-title[_ngcontent-%COMP%]{font-size:18px;font-weight:600;margin:0;color:#333}.dialog-content[_ngcontent-%COMP%]{padding:12px 16px;font-size:14px;line-height:1.4}.dialog-content[_ngcontent-%COMP%]   .dialog-description[_ngcontent-%COMP%]{color:#555}.dialog-actions[_ngcontent-%COMP%]{padding:8px 16px;display:flex;justify-content:flex-end;gap:8px}.dialog-actions[_ngcontent-%COMP%]   .dialog-button[_ngcontent-%COMP%]{min-width:72px;padding:6px 12px;font-size:13px;border-radius:4px}.dialog-actions[_ngcontent-%COMP%]   .cancel-button[_ngcontent-%COMP%]{background-color:#e0e0e0;color:#333}.dialog-actions[_ngcontent-%COMP%]   .confirm-button[_ngcontent-%COMP%]{background-color:#666;color:#fff;font-weight:500}"]
    });
  }
  return DialogPopComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function SignageInfoComponent_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 21);
    i0.ɵɵtext(1, "link_off");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_mat_icon_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 22);
    i0.ɵɵtext(1, "add_link");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_mat_icon_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 22);
    i0.ɵɵtext(1, "health_and_safety");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_mat_icon_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 23);
    i0.ɵɵtext(1, "health_and_safety");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 9);
    i0.ɵɵtext(2, "App:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 9);
    i0.ɵɵtext(6, " Plugin:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.data.parent.serviceAppVersion);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.data.parent.servicePluginVersion);
  }
}
function SignageInfoComponent_Conditional_40_Conditional_1_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1, "Download and install SignService. (this replaces the Watchdog app). After downloading is complete, go to the Downloads folder and run SignService.apk");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_1_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1, "Download and install SignServiceSetup. After downloading is complete, go to the Downloads folder and run SignServiceSetup.exe");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 26);
    i0.ɵɵtext(2, "!");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SignageInfoComponent_Conditional_40_Conditional_1_Conditional_0_Conditional_3_Template, 2, 0, "span", 27)(4, SignageInfoComponent_Conditional_40_Conditional_1_Conditional_0_Conditional_4_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(3, ctx_r0.data.parent.os == "android" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(4, ctx_r0.data.parent.os == "win" ? 4 : -1);
  }
}
function SignageInfoComponent_Conditional_40_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, SignageInfoComponent_Conditional_40_Conditional_1_Conditional_0_Template, 5, 2, "div", 8);
    i0.ɵɵelementStart(1, "div", 24)(2, "button", 25);
    i0.ɵɵlistener("click", function SignageInfoComponent_Conditional_40_Conditional_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDownload());
    });
    i0.ɵɵtext(3, "Download");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(0, ctx_r0.data.parent.showWarnings ? 0 : -1);
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1, "New version of SignService is now available, Download the new installer, uninstall the older version, go to Downloads folder and open SignService.apk");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1, "New version of SignServiceSetup is now available, Download the new installer, go to Downloads folder and open SignServiceSetup.exe");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 26);
    i0.ɵɵtext(2, "!");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_0_Conditional_3_Template, 2, 0, "span", 27)(4, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_0_Conditional_4_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(3, ctx_r0.data.parent.os == "android" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(4, ctx_r0.data.parent.os == "win" ? 4 : -1);
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 26);
    i0.ɵɵtext(2, "!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 27);
    i0.ɵɵtext(4, "SignService is not running");
    i0.ɵɵelementEnd()();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 26);
    i0.ɵɵtext(2, "!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 27);
    i0.ɵɵtext(4, "SignService Settings Incomplete");
    i0.ɵɵelementEnd()();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_0_Template, 5, 2, "div", 8)(1, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_1_Template, 5, 0, "div", 8)(2, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Conditional_2_Template, 5, 0, "div", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(0, ctx_r0.data.parent.newServiceAvailable && ctx_r0.data.parent.showWarnings ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, !ctx_r0.data.parent.signServiceActive ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r0.data.parent.settingsIssue ? 2 : -1);
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "input", 30);
    i0.ɵɵtwoWayListener("ngModelChange", function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_1_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.data.parent.showWarnings, $event) || (ctx_r0.data.parent.showWarnings = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_1_Template_input_change_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onShowWarningsChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 31);
    i0.ɵɵtext(3, "Show warnings");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.data.parent.showWarnings);
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onSignServiceStart());
    });
    i0.ɵɵtext(1, "Start");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function SignageInfoComponent_Conditional_40_Conditional_2_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onSignServiceSetup());
    });
    i0.ɵɵtext(1, "Settings");
    i0.ɵɵelementEnd();
  }
}
function SignageInfoComponent_Conditional_40_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_0_Template, 3, 3)(1, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_1_Template, 4, 1, "div", 28);
    i0.ɵɵelementStart(2, "div", 24)(3, "button", 25);
    i0.ɵɵlistener("click", function SignageInfoComponent_Conditional_40_Conditional_2_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDownload());
    });
    i0.ɵɵtext(4, "Download");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_5_Template, 2, 0, "button", 29)(6, SignageInfoComponent_Conditional_40_Conditional_2_Conditional_6_Template, 2, 0, "button", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(0, ctx_r0.data.parent.showWarnings ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r0.data.parent.hasError ? 1 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(5, !ctx_r0.data.parent.signServiceActive && !ctx_r0.data.parent.settingsIssue && ctx_r0.data.parent.os == "android" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(6, ctx_r0.data.parent.os == "android" ? 6 : -1);
  }
}
function SignageInfoComponent_Conditional_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SignageInfoComponent_Conditional_40_Conditional_0_Template, 9, 2, "div", 8)(1, SignageInfoComponent_Conditional_40_Conditional_1_Template, 4, 1, "div", 24)(2, SignageInfoComponent_Conditional_40_Conditional_2_Template, 7, 4, "div", 24);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(0, ctx_r0.data.parent.signServiceActive ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, !ctx_r0.data.parent.serviceInstalled ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r0.data.parent.serviceInstalled ? 2 : -1);
  }
}
function SignageInfoComponent_Conditional_41_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 9);
    i0.ɵɵtext(2, "SignService not available");
    i0.ɵɵelementEnd()();
  }
}
let SignageInfoComponent = /*#__PURE__*/(() => {
  class SignageInfoComponent {
    ngZone;
    injector;
    cdRef;
    dialog;
    dialogRef;
    data;
    appType = 'Local';
    appVersion = 'NA';
    installLabel = '';
    downloadUrl;
    downloadFileName;
    osSupported = true;
    libVersion;
    changeDetectorRef;
    playerService;
    unregister = 'unregister';
    constructor(ngZone, injector, cdRef, dialog, dialogRef, data) {
      this.ngZone = ngZone;
      this.injector = injector;
      this.cdRef = cdRef;
      this.dialog = dialog;
      this.dialogRef = dialogRef;
      this.data = data;
    }
    ngOnInit() {
      const logInfo = Log.getLogInfo("SignageInfoComponent", "ngOnInit", []);
      this.playerService = this.injector.get('playerService');
      this.changeDetectorRef = this.injector.get(ChangeDetectorRef);
      Log.i(logInfo, LogTag.INIT, 'appType = ' + this.playerService.appType);
      this.appType = this.playerService.appType;
      this.appVersion = this.playerService.appVersion;
      this.libVersion = this.playerService.libVersion;
      this.detectSystemInfo();
    }
    onShowWarningsChange() {
      localStorage['showWarnings'] = this.data.parent.showWarnings ? "1" : "0";
      this.data.parent.cdRef.markForCheck();
    }
    update() {
      this.cdRef.markForCheck();
    }
    detectSystemInfo() {
      const urlBase = window.location.origin + '/deploy'; // win-x64/SignServiceSetup.exe';
      this.installLabel = this.playerService.os + " " + this.playerService.cpu;
      switch (this.playerService.os) {
        case "win":
          this.downloadFileName = 'SignServiceSetup.exe';
          this.downloadUrl = `${urlBase}/${this.playerService.osCpu}/SignServiceSetup.exe`;
          break;
        case "android":
          this.downloadFileName = 'SignService.apk';
          this.downloadUrl = `${urlBase}/${this.playerService.osCpu}/SignService.apk`;
          break;
        default:
          this.osSupported = false;
          break;
      }
    }
    onDownload() {
      //const newWindow = window.open(this.downloadUrl);
      //this.downloadUrl = 'http://dev.signage.me/deploy/android/signService.apk';
      const dialogRef = this.dialog.open(DownloadSignServiceComponent, {
        width: '300px',
        disableClose: true,
        data: {
          downloadUrl: this.downloadUrl,
          downloadFileName: this.downloadFileName
        }
      });
    }
    onSignServiceSetup() {
      window.location.href = "intent://pwa?cmd=setup#Intent;scheme=signservice;end;";
    }
    onSignServiceStop() {
      window.location.href = "intent://pwa?cmd=stop#Intent;scheme=signservice;end;";
    }
    onSignServiceStart() {
      window.location.href = "intent://pwa?cmd=start#Intent;scheme=signservice;end;";
    }
    onUnregister() {
      const dialogRef = this.dialog.open(DialogPopComponent, {
        height: '220px',
        width: '400px',
        data: {
          title: 'Unregister',
          description: 'Are you sure you want to remove this player? This action cannot be undone.'
        }
      });
      dialogRef.afterClosed().subscribe(r => {
        if (r === true) {
          // Changed from r != null to r === true for clarity
          this.playerService.unregister();
          this.unregister = 'player removed';
          this.changeDetectorRef.detectChanges();
        }
      });
    }
    onShowFPS() {
      this.playerService.showFps = true;
    }
    onReadLog() {
      this.playerService.watchdog.readLog();
    }
    onClearLog() {
      this.playerService.watchdog.clearLog();
    }
    onTestHung() {
      this.playerService.watchdog.testHung();
      this.dialogRef.close();
    }
    onTestSlow() {
      this.playerService.watchdog.testSlow();
      this.dialogRef.close();
    }
    onAbnormalExit() {
      this.playerService.watchdog.testAbnormalExit();
      this.dialogRef.close();
    }
    onInfiniteMemLeak() {
      this.playerService.watchdog.testInfiniteMemLeak();
      this.dialogRef.close();
    }
    onInfiniteDomLeak() {
      this.playerService.watchdog.testInfiniteDomLeak();
      this.dialogRef.close();
    }
    onLoseContext() {
      const canvases = document.getElementsByTagName("canvas");
      if (canvases.length === 1) {
        const canvas = canvases[0];
        const webgl2 = canvas.getContext("webgl2", {});
        if (webgl2 != null) {
          webgl2.getExtension('WEBGL_lose_context').loseContext();
        } else {
          const webgl = canvas.getContext("webgl", {});
          if (webgl != null) {
            webgl.getExtension('WEBGL_lose_context').loseContext();
          }
        }
      }
      this.dialogRef.close();
    }
    onClearErrors() {
      localStorage["errors"] = "[]";
    }
    onThrowErrorTest() {
      throw new Error("This is a Error test");
    }
    onShowErrors() {
      const errors = localStorage["errors"];
      if (errors == null) {
        alert("there is no errors");
      } else {
        alert(errors);
      }
    }
    onReboot() {
      this.playerService.watchdog.reboot();
      this.dialogRef.close();
    }
    onTestAndroid() {
      /*
      const socket = new WebSocket("ws://192.168.0.117:38301");
      socket.onopen = function(e) {
        //alert("Connection established");
        socket.send('{command: "getName"}');
      };
      socket.onmessage = function(event) {
        let data = event.data
        alert(data);
      }
      socket.onerror = function(error) {
        alert('error=' + JSON.stringify(error));
      };
        */
      //document.location = "intent://com.sign.watchdog/test?id=12345#Intent;scheme=myapp;package=com.sign.watchdog;action=android.intent.action.SEND;end";
      //document.location = "intent://com.sign.watchdog/restartPlayer#Intent;scheme=signplayer;package=com.sign.watchdog;action=android.intent.action.SEND;end";
      //alert(window.navigator.userAgent);
      //window.location.reload();
      //navigator.serviceWorker.controller.postMessage({"msg": "ping"});
    }
    onClose() {
      //???this.ngZone.run(() => {
      this.dialogRef.close();
      //???});
    }
    static ɵfac = function SignageInfoComponent_Factory(t) {
      return new (t || SignageInfoComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$3.MatDialog), i0.ɵɵdirectiveInject(i1$3.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SignageInfoComponent,
      selectors: [["app-signage-info"]],
      decls: 97,
      vars: 16,
      consts: [["mat-dialog-title", "", "cdkDrag", "", "cdkDragRootElement", ".cdk-overlay-pane", "cdkDragHandle", "", 1, "dialog-header"], [1, "dialog-title"], ["mat-button", "", "type", "button", 1, "buttonClose", 3, "click"], [1, "modal-body"], [3, "color"], ["label", "About"], [1, "wrapInfo"], [1, "label-title"], [1, "info-container"], [1, "label-text"], [1, "value-text"], [2, "width", "100%"], [1, "label-title", 2, "display", "flex", "gap", "8px"], ["style", "color: red; margin-top: -2px;", 4, "ngIf"], ["style", "color: green; margin-top: -2px;", 4, "ngIf"], ["style", "color: orange; margin-top: -2px;", 4, "ngIf"], ["label", "Registration"], ["mat-raised-button", "", "type", "button", 1, "buttonStart", 3, "click"], ["label", "Debug"], [1, "gridButtons"], ["mat-raised-button", "", 1, "buttonStart", 3, "click"], [2, "color", "red", "margin-top", "-2px"], [2, "color", "green", "margin-top", "-2px"], [2, "color", "orange", "margin-top", "-2px"], [1, "btn-container"], ["mat-raised-button", "", "type", "button", 1, "buttonWd", 2, "top", "-5px", 3, "click"], [1, "error-badge"], [1, "info-text"], [1, "btn-container", 2, "margin-left", "-5px", "margin-bottom", "5px"], ["mat-raised-button", "", "type", "button", 1, "buttonWd", 2, "top", "-5px"], ["type", "checkbox", "id", "showWarnings", 3, "ngModelChange", "change", "ngModel"], ["for", "showWarnings"]],
      template: function SignageInfoComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
          i0.ɵɵtext(2, " SignPlayer / SignService ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "button", 2);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_3_listener() {
            return ctx.onClose();
          });
          i0.ɵɵelementStart(4, "mat-icon");
          i0.ɵɵtext(5, "close");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(6, "div", 3)(7, "mat-tab-group", 4)(8, "mat-tab", 5)(9, "div", 6)(10, "div", 7);
          i0.ɵɵtext(11, "Device: ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "div", 8)(13, "span", 9);
          i0.ɵɵtext(14, "OS:");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "span", 10);
          i0.ɵɵtext(16);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "span", 9);
          i0.ɵɵtext(18, " Mode:");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(19, "span", 10);
          i0.ɵɵtext(20);
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(21, "hr", 11);
          i0.ɵɵelementStart(22, "div", 12);
          i0.ɵɵtext(23, "SignPlayer: ");
          i0.ɵɵtemplate(24, SignageInfoComponent_mat_icon_24_Template, 2, 0, "mat-icon", 13)(25, SignageInfoComponent_mat_icon_25_Template, 2, 0, "mat-icon", 14);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(26, "div", 8)(27, "span", 9);
          i0.ɵɵtext(28, "App:");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(29, "span", 10);
          i0.ɵɵtext(30);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(31, "span", 9);
          i0.ɵɵtext(32, " Lib:");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(33, "span", 10);
          i0.ɵɵtext(34);
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(35, "hr", 11);
          i0.ɵɵelementStart(36, "div", 12);
          i0.ɵɵtext(37, "SignService: ");
          i0.ɵɵtemplate(38, SignageInfoComponent_mat_icon_38_Template, 2, 0, "mat-icon", 14)(39, SignageInfoComponent_mat_icon_39_Template, 2, 0, "mat-icon", 15);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(40, SignageInfoComponent_Conditional_40_Template, 3, 3)(41, SignageInfoComponent_Conditional_41_Template, 3, 0, "div", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(42, "mat-tab", 16)(43, "div", 6)(44, "div", 7);
          i0.ɵɵtext(45, "Registration info:");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(46, "table")(47, "tr")(48, "td")(49, "span", 9);
          i0.ɵɵtext(50, "Business:");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(51, "td")(52, "span", 10);
          i0.ɵɵtext(53);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(54, "tr")(55, "td")(56, "span", 9);
          i0.ɵɵtext(57, "Station:");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(58, "td")(59, "span", 10);
          i0.ɵɵtext(60);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(61, "tr")(62, "td")(63, "span", 9);
          i0.ɵɵtext(64, "Scene:");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(65, "td")(66, "span", 10);
          i0.ɵɵtext(67);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(68, "td")(69, "span", 10);
          i0.ɵɵtext(70);
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelement(71, "hr", 11);
          i0.ɵɵelementStart(72, "button", 17);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_72_listener() {
            return ctx.onUnregister();
          });
          i0.ɵɵtext(73);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(74, "mat-tab", 18)(75, "div", 6)(76, "div", 19)(77, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_77_listener() {
            return ctx.onAbnormalExit();
          });
          i0.ɵɵtext(78, "abnormal exit");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(79, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_79_listener() {
            return ctx.onTestSlow();
          });
          i0.ɵɵtext(80, "slow down");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(81, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_81_listener() {
            return ctx.onTestHung();
          });
          i0.ɵɵtext(82, "freeze");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(83, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_83_listener() {
            return ctx.onInfiniteMemLeak();
          });
          i0.ɵɵtext(84, "infinite leak");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(85, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_85_listener() {
            return ctx.onInfiniteDomLeak();
          });
          i0.ɵɵtext(86, "infinite dom");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(87, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_87_listener() {
            return ctx.onLoseContext();
          });
          i0.ɵɵtext(88, "WEBGL loseContext");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(89, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_89_listener() {
            return ctx.onClearErrors();
          });
          i0.ɵɵtext(90, "Clear errors");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(91, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_91_listener() {
            return ctx.onThrowErrorTest();
          });
          i0.ɵɵtext(92, "Throw error");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(93, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_93_listener() {
            return ctx.onShowErrors();
          });
          i0.ɵɵtext(94, "Show errors");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(95, "button", 20);
          i0.ɵɵlistener("click", function SignageInfoComponent_Template_button_click_95_listener() {
            return ctx.onReboot();
          });
          i0.ɵɵtext(96, "reboot device");
          i0.ɵɵelementEnd()()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(7);
          i0.ɵɵproperty("color", "warn");
          i0.ɵɵadvance(9);
          i0.ɵɵtextInterpolate(ctx.installLabel);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx.appType);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", !ctx.data.parent.isConnected);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.data.parent.isConnected);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(ctx.appVersion);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx.libVersion);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.data.parent.signServiceActive);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.data.parent.signServiceActive);
          i0.ɵɵadvance();
          i0.ɵɵconditional(40, ctx.osSupported ? 40 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(41, !ctx.osSupported ? 41 : -1);
          i0.ɵɵadvance(12);
          i0.ɵɵtextInterpolate(ctx.data.parent.businessId);
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate(ctx.data.parent.stationId);
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate(ctx.data.parent.sceneId);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.data.parent.sceneName);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", ctx.unregister, " ");
        }
      },
      dependencies: [i1$4.MatIcon, i2.MatButton, i1$3.MatDialogTitle, i11.NgIf, i1$5.CheckboxControlValueAccessor, i1$5.NgControlStatus, i1$5.NgModel, i7$1.CdkDrag, i7$1.CdkDragHandle, i7$2.MatTab, i7$2.MatTabGroup],
      styles: ["[_nghost-%COMP%]     mat-dialog-container{background:#262626!important;border-radius:12px!important;padding:0!important;width:min(92vw,820px)!important;max-height:min(88vh,760px)!important;overflow:hidden!important;box-shadow:0 12px 28px #00000073}.dialog-header[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:12px 16px;border-bottom:1px solid rgba(255,255,255,.08);cursor:move}.dialog-title[_ngcontent-%COMP%]{color:#fff;font-size:18px;font-weight:600;margin:0;display:flex;align-items:center;gap:8px}.buttonClose[_ngcontent-%COMP%]{min-width:36px;width:36px;height:36px;line-height:36px;padding:0;border-radius:8px!important;color:#fff}.modal-body[_ngcontent-%COMP%]{padding:12px 16px 16px;overflow:auto;max-height:calc(88vh - 64px)}[_nghost-%COMP%]     .mat-tab-body-content{height:auto!important;overflow:visible!important}[_nghost-%COMP%]     .mat-mdc-tab-body-content{height:auto!important;overflow:visible!important}[_nghost-%COMP%]     .mat-tab-body, [_nghost-%COMP%]     .mat-mdc-tab-body, [_nghost-%COMP%]     .mat-mdc-tab-body.mat-mdc-tab-body-active{overflow:visible!important}[_nghost-%COMP%]     .mat-tab-header, [_nghost-%COMP%]     .mat-mdc-tab-header{border-bottom:1px solid rgba(255,255,255,.08);margin-bottom:8px}[_nghost-%COMP%]     .mat-tab-label, [_nghost-%COMP%]     .mdc-tab__text-label{color:#9aa0a6!important;font-weight:600}[_nghost-%COMP%]     .mat-tab-label.mat-tab-label-active, [_nghost-%COMP%]     .mdc-tab--active .mdc-tab__text-label{color:#fff!important}[_nghost-%COMP%]     .mat-ink-bar{background:#ef5350!important}[_nghost-%COMP%]     .mat-mdc-tab .mdc-tab-indicator__content--underline{border-color:#ef5350!important}.wrapInfo[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start;text-align:left;gap:6px;padding-top:8px}.label-title[_ngcontent-%COMP%]{color:#fff;font-size:16px;margin:0}.label-text[_ngcontent-%COMP%]{color:#fff;font-size:13px}.value-text[_ngcontent-%COMP%]{color:#b7b7b7;font-size:13px}.info-container[_ngcontent-%COMP%]{display:flex;gap:5px;padding:2px 2px 2px 0}.btn-container[_ngcontent-%COMP%]{display:flex;gap:5px;padding-top:8px}.info-text[_ngcontent-%COMP%]{color:#fff;font-size:13px}table[_ngcontent-%COMP%]{border-spacing:5px}.buttonStart[_ngcontent-%COMP%], .buttonWd[_ngcontent-%COMP%]{border-radius:10px!important;background-color:#1e1e1e;color:#fff;font-size:14px;padding:10px 14px}.infoButton[_ngcontent-%COMP%]{width:100%}.gridButtons[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:10px}.move[_ngcontent-%COMP%]{cursor:move}label[_ngcontent-%COMP%], mat-icon[_ngcontent-%COMP%]{color:#fff}.tabDiag[_ngcontent-%COMP%]{height:auto!important;max-height:none!important}.modal-body[_ngcontent-%COMP%]::-webkit-scrollbar{width:10px}.modal-body[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#ffffff2e;border-radius:8px}.modal-body[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:transparent}.error-badge[_ngcontent-%COMP%]{background-color:red;color:#fff;font-weight:700;font-size:12px;line-height:14px;width:16px;height:16px;text-align:center;border-radius:50%;border:1px solid white;box-shadow:0 0 2px #0000004d;pointer-events:none}.error-text[_ngcontent-%COMP%]{font-size:12px;font-weight:700;color:red;background-color:#fff;padding:4px}"],
      changeDetection: 0
    });
  }
  return SignageInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$1 = ["container"];
const _c1$1 = ["play"];
const _c2$1 = ["stop"];
function TaskbarComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 6);
    i0.ɵɵlistener("click", function TaskbarComponent_div_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onExit());
    });
    i0.ɵɵtext(2, "Exit");
    i0.ɵɵelementEnd()();
  }
}
function TaskbarComponent_div_1_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 18);
    i0.ɵɵtext(1, "health_and_safety");
    i0.ɵɵelementEnd();
  }
}
function TaskbarComponent_div_1_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 19);
    i0.ɵɵtext(1, "health_and_safety");
    i0.ɵɵelementEnd();
  }
}
function TaskbarComponent_div_1_mat_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 20);
    i0.ɵɵtext(1, "link_off");
    i0.ɵɵelementEnd();
  }
}
function TaskbarComponent_div_1_mat_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 21);
    i0.ɵɵtext(1, "add_link");
    i0.ɵɵelementEnd();
  }
}
function TaskbarComponent_div_1_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, "!");
    i0.ɵɵelementEnd();
  }
}
function TaskbarComponent_div_1_button_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function TaskbarComponent_div_1_button_20_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onToggleFull());
    });
    i0.ɵɵelementStart(1, "mat-icon", 13);
    i0.ɵɵtext(2, "fullscreen");
    i0.ɵɵelementEnd()();
  }
}
function TaskbarComponent_div_1_button_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function TaskbarComponent_div_1_button_21_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onToggleFull());
    });
    i0.ɵɵelementStart(1, "mat-icon", 13);
    i0.ɵɵtext(2, "fullscreen_exit");
    i0.ɵɵelementEnd()();
  }
}
function TaskbarComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7, 0);
    i0.ɵɵtemplate(2, TaskbarComponent_div_1_mat_icon_2_Template, 2, 0, "mat-icon", 8)(3, TaskbarComponent_div_1_mat_icon_3_Template, 2, 0, "mat-icon", 9)(4, TaskbarComponent_div_1_mat_icon_4_Template, 2, 0, "mat-icon", 10)(5, TaskbarComponent_div_1_mat_icon_5_Template, 2, 0, "mat-icon", 11);
    i0.ɵɵelementStart(6, "button", 12, 1);
    i0.ɵɵlistener("click", function TaskbarComponent_div_1_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onToolbarPlay());
    });
    i0.ɵɵelementStart(8, "mat-icon", 13);
    i0.ɵɵtext(9, "play_circle_outline");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "button", 12, 2);
    i0.ɵɵlistener("click", function TaskbarComponent_div_1_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onToolbarStop());
    });
    i0.ɵɵelementStart(13, "mat-icon", 13);
    i0.ɵɵtext(14, "stop_circle");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 14)(16, "button", 15);
    i0.ɵɵlistener("click", function TaskbarComponent_div_1_Template_button_click_16_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInfo());
    });
    i0.ɵɵelementStart(17, "mat-icon", 13);
    i0.ɵɵtext(18, "settings");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, TaskbarComponent_div_1_Conditional_19_Template, 2, 0, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, TaskbarComponent_div_1_button_20_Template, 3, 0, "button", 17)(21, TaskbarComponent_div_1_button_21_Template, 3, 0, "button", 17);
    i0.ɵɵelementStart(22, "button", 15, 3);
    i0.ɵɵlistener("click", function TaskbarComponent_div_1_Template_button_click_22_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onExit());
    });
    i0.ɵɵelementStart(24, "mat-icon", 13);
    i0.ɵɵtext(25, "highlight_off");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.signServiceActive);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.signServiceActive);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isConnected);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isConnected);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.isPlaying);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r1.isPlaying);
    i0.ɵɵadvance(9);
    i0.ɵɵconditional(19, ctx_r1.hasError && ctx_r1.showWarnings ? 19 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isFullScreen);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isFullScreen);
  }
}
let TaskbarComponent = /*#__PURE__*/(() => {
  class TaskbarComponent {
    document;
    injector;
    router;
    cdRef;
    ngZone;
    httpClient;
    dialog;
    playerService;
    buttonMode = false;
    show = false;
    timeoutId;
    dialogConfig;
    signageInfo;
    mousemove;
    kiosk;
    kioskKey = "";
    taskbarEnabled = false;
    isPlaying = false;
    isConnected = false;
    signServiceActive = false;
    isFullScreen;
    businessId;
    stationId;
    sceneId;
    sceneName;
    os;
    serviceInstalled = false;
    servicePluginVersion;
    serviceAppVersion;
    newServiceAvailable = false;
    settingsIssue = false;
    hasError = false;
    showWarnings = false;
    constructor(document, injector, router, cdRef, ngZone, httpClient, dialog) {
      this.document = document;
      this.injector = injector;
      this.router = router;
      this.cdRef = cdRef;
      this.ngZone = ngZone;
      this.httpClient = httpClient;
      this.dialog = dialog;
      this.playerService = injector.get('playerService');
    }
    container;
    play;
    stop;
    // @ViewChild('server', {static: false}) server: ElementRef;
    ngOnInit() {
      this.dialogConfig = new MatDialogConfig();
      this.initToolbar();
    }
    ngAfterViewInit() {
      this.playerService.playing$.subscribe(value => {
        this.updateButtons();
      });
      this.container.nativeElement.style.display = "none";
    }
    initToolbar() {
      this.os = this.playerService.os;
      this.showWarnings = localStorage.getItem('showWarnings') != "0";
      this.serviceInstalled = localStorage["service"] == "installed";
      /* test only
          this.serviceInstalled = false;
          this.newServiceAvailable = false;
          this.serviceInstalled = true;
          this.signServiceActive = true;
      */
      if (!this.serviceInstalled) {
        console.warn('SignService hasError (not installed)');
        this.hasError = true;
      }
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (event.url == '/close') {
            if (this.signageInfo != null) {
              this.signageInfo.close();
              this.signageInfo = null;
            }
          }
        }
      });
      this.playerService.registrationInfo$.subscribe(ret => {
        this.businessId = this.playerService.businessId;
        this.stationId = this.playerService.stationId;
        this.sceneId = this.playerService.sceneId;
        this.sceneName = this.playerService.sceneName;
      });
      this.playerService.serverConnection$.subscribe(ret => {
        this.isConnected = ret == 'connected';
        this.cdRef.markForCheck();
        if (this.signageInfo != null) {
          this.signageInfo.componentInstance.update();
        }
      });
      this.playerService.signService$.pipe(switchMap(ret => {
        this.serviceInstalled = localStorage["service"] == "installed";
        this.settingsIssue = localStorage["settings"] == "fail";
        if (this.settingsIssue) {
          console.warn('SignService hasError (settingsIssue)');
          this.hasError = true;
        }
        if (ret == "started") {
          this.signServiceActive = true;
          this.serviceAppVersion = this.playerService.serviceAppVersion;
          this.servicePluginVersion = this.playerService.servicePluginVersion;
          console.log("SignService serviceAppVersion=" + this.serviceAppVersion);
          const urlBase = window.location.origin + '/deploy';
          const url = `${urlBase}/${this.playerService.osCpu}/appVer.txt?v=${Math.random() * 1000}`;
          return this.httpClient.get(url, {
            responseType: 'text'
          });
        } else {
          this.signServiceActive = false;
          console.warn('SignService hasError (no started)');
          this.hasError = true;
          return of(null);
        }
      })).subscribe(appVer => {
        if (appVer != null) {
          console.log("SignService appVer=" + appVer);
          if (appVer != this.serviceAppVersion) {
            this.newServiceAvailable = true;
            this.hasError = true;
            console.warn('setting hasError (ver)');
          }
        }
        this.cdRef.markForCheck();
      });
      this.playerService.kioskChannel$.subscribe(value => {
        this.setKiosk(value.enabled, value.key);
      });
      this.mousemove = fromEvent(document, 'mousemove').subscribe(event => {
        this.showToolbar();
      });
      this.buttonMode = false;
      this.cdRef.detectChanges();
    }
    setKiosk(enabled, key) {
      if (this.kiosk != null) {
        this.kiosk.unsubscribe();
        this.kiosk = null;
      }
      if (enabled) {
        this.taskbarEnabled = false;
        this.container.nativeElement.style.display = "none";
        if (key != null) {
          this.kiosk = fromEvent(document, 'keydown').subscribe(event => {
            if (event.key == "Escape") {
              this.kioskKey = "";
              this.taskbarEnabled = false;
              this.container.nativeElement.style.display = "none";
            } else {
              this.kioskKey += event.key;
              if (this.kioskKey == key) {
                this.show = false;
                this.taskbarEnabled = true;
                this.showToolbar();
              }
            }
          });
        }
      } else {
        this.taskbarEnabled = true;
        this.showToolbar();
      }
    }
    showToolbar() {
      if (this.show == false) {
        this.show = true;
        this.cdRef.markForCheck();
        if (this.taskbarEnabled) {
          this.container.nativeElement.style.display = "flex";
        }
        document.body.style.cursor = '';
        document.exitPointerLock();
      }
      if (this.timeoutId != null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.timeoutId = setTimeout(() => {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
        this.show = false;
        if (this.taskbarEnabled) {
          this.container.nativeElement.style.display = "none";
        }
        document.body.style.cursor = 'none';
        try {
          document.body.requestPointerLock();
        } catch (e) {}
      }, 5000);
    }
    onToolbarPlay() {
      this.playerService.play();
    }
    onToolbarStop() {
      this.playerService.stop();
    }
    updateButtons() {
      this.isPlaying = this.playerService.isPlaying();
    }
    onExit() {
      if (this.mousemove != null) {
        this.mousemove.unsubscribe();
        this.mousemove = null;
      }
      this.setKiosk(false, null);
      this.playerService.watchdog.close();
    }
    onToggleFull() {
      this.isFullScreen = document.fullscreenElement;
      if (this.isFullScreen) {
        this.document.exitFullscreen();
      } else {
        this.document.getElementsByTagName('body')[0]['requestFullscreen']();
      }
      this.isFullScreen = !this.isFullScreen;
    }
    onInfo() {
      if (this.signageInfo == null) {
        this.signageInfo = this.dialog.open(SignageInfoComponent, {
          width: '700px',
          height: '480px',
          data: {
            parent: this
          }
        });
        this.signageInfo.afterClosed().subscribe(data => {
          this.signageInfo = null;
        });
      }
    }
    static ɵfac = function TaskbarComponent_Factory(t) {
      return new (t || TaskbarComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2$1.HttpClient), i0.ɵɵdirectiveInject(i1$3.MatDialog));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: TaskbarComponent,
      selectors: [["app-taskbar"]],
      viewQuery: function TaskbarComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1, 5);
          i0.ɵɵviewQuery(_c1$1, 5);
          i0.ɵɵviewQuery(_c2$1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.play = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stop = _t.first);
        }
      },
      decls: 2,
      vars: 2,
      consts: [["container", ""], ["play", ""], ["stop", "", "close", ""], ["close", ""], [4, "ngIf"], ["class", "containerSide", 4, "ngIf"], ["type", "button", 1, "containerSideButton", 3, "click"], [1, "containerSide"], ["style", "color: green", "class", "server", 4, "ngIf"], ["style", "color: orange", "class", "server", 4, "ngIf"], ["style", "color: red", "class", "server taskPadRight", 4, "ngIf"], ["style", "color: green", "class", "server taskPadRight", 4, "ngIf"], ["mat-raised-button", "", "type", "button", 1, "containerSideButton", 3, "click", "disabled"], [1, "fontSizeIcon"], [1, "button-wrapper"], ["mat-raised-button", "", "type", "button", 1, "containerSideButton", 3, "click"], [1, "error-badge"], ["mat-raised-button", "", "class", "containerSideButton", "type", "button", 3, "click", 4, "ngIf"], [1, "server", 2, "color", "green"], [1, "server", 2, "color", "orange"], [1, "server", "taskPadRight", 2, "color", "red"], [1, "server", "taskPadRight", 2, "color", "green"]],
      template: function TaskbarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TaskbarComponent_div_0_Template, 3, 0, "div", 4)(1, TaskbarComponent_div_1_Template, 26, 9, "div", 5);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.buttonMode);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.buttonMode);
        }
      },
      dependencies: [i1$4.MatIcon, i2.MatButton, i11.NgIf],
      styles: [".button-wrapper[_ngcontent-%COMP%]{position:relative;display:inline-block}.error-badge[_ngcontent-%COMP%]{position:absolute;top:1px;right:8px;background-color:red;color:#fff;font-weight:700;font-size:12px;line-height:14px;width:16px;height:16px;text-align:center;border-radius:50%;border:1px solid white;box-shadow:0 0 2px #0000004d;pointer-events:none}@media (orientation: portrait){.linkUnlink[_ngcontent-%COMP%]{width:24px;height:24px;padding-right:20px;padding-top:7px}.fontSizeIcon[_ngcontent-%COMP%]{width:30px!important;height:30px!important;font-size:22px!important;position:relative;padding:24px;margin:24px;left:-6px;top:4px}.taskPadRight[_ngcontent-%COMP%]{margin:10px}.containerSide[_ngcontent-%COMP%]{z-index:2147483647;margin:0;position:absolute;top:-50%;left:0;background:#141414;width:100vw;display:flex;flex-direction:row;justify-content:center}.containerSideButton[_ngcontent-%COMP%]{background-color:#3f3f3f!important;margin:2px;width:50px!important;min-width:50px!important}.server[_ngcontent-%COMP%]{margin-top:5px}}@media (orientation: landscape){.linkUnlink[_ngcontent-%COMP%]{width:24px;height:24px;padding-left:20px;padding-bottom:20px}.containerSide[_ngcontent-%COMP%]{z-index:2147483647;margin:0;position:absolute;top:-50%;left:0;background:#141414;height:100vh;display:flex;flex-direction:column;justify-content:center}.containerSideButton[_ngcontent-%COMP%]{margin:1px;background-color:#3f3f3f!important}.server[_ngcontent-%COMP%]{padding-bottom:20px;margin-left:20px}.fontSizeIcon[_ngcontent-%COMP%]{width:24px!important;height:24px!important;font-size:22px!important;position:relative;left:3px}}"],
      changeDetection: 0
    });
  }
  return TaskbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function CheckInternetConnectionComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵtext(4, " No internet connection ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵtext(7, " Please connect to the internet. ");
    i0.ɵɵelementEnd()()();
  }
}
let CheckInternetConnectionComponent = /*#__PURE__*/(() => {
  class CheckInternetConnectionComponent extends RegDialogComponent {
    injector;
    showMessage = false;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    ngOnInit() {}
    isConnected() {
      const logInfo = Log.getLogInfo("CheckInternetConnectionComponent", "constructor", []);
      if (window.navigator.onLine) {
        Log.d(logInfo, LogTag.REGISTRATION, 'onLine');
        return of(true);
      } else {
        Log.d(logInfo, LogTag.REGISTRATION, 'offline');
        this.showMessage = true;
        this.changeDetectorRef.detectChanges();
        return fromEvent(window, 'online').pipe(take(1));
      }
    }
    static ɵfac = function CheckInternetConnectionComponent_Factory(t) {
      return new (t || CheckInternetConnectionComponent)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CheckInternetConnectionComponent,
      selectors: [["app-check-internet-connection"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 1,
      consts: [["container", ""], [1, "frame"], [1, "container"], ["class", "centerContent", 4, "ngIf"], [1, "centerContent"], [1, "deployText", "centerContent", "headerText"], [1, "deployText", "centerContent"]],
      template: function CheckInternetConnectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0);
          i0.ɵɵtemplate(3, CheckInternetConnectionComponent_div_3_Template, 8, 0, "div", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.showMessage);
        }
      },
      dependencies: [i11.NgIf],
      styles: [".headerText[_ngcontent-%COMP%]{font-weight:700;padding-bottom:10px;font-size:20px}.centerContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:stretch}.centerContent2[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;align-items:flex-start;align-content:center}.fade-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in 2s}.frame[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#f0f0f0}.labelStyle[_ngcontent-%COMP%]{color:#b7b7b7}.buttonStart[_ngcontent-%COMP%]{border-radius:0!important;background-color:#1e1e1e;color:#fff;width:150px;font-size:20px}.deployText[_ngcontent-%COMP%]{font-size:16px}.inner[_ngcontent-%COMP%]{position:absolute;top:25%;left:calc(50vw - 100px)}.container[_ngcontent-%COMP%]{margin:0;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#252525;width:100%;height:320px;font-size:24px;justify-content:space-between;flex-direction:column}.fadeInClass06[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn ease-in .6s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#7b7b7b}mat-dialog-container[_ngcontent-%COMP%]{background-color:#222!important}.mat-select-panel[_ngcontent-%COMP%]{background:#1e1e1e}.mat-option-text[_ngcontent-%COMP%], .mat-select-min-line[_ngcontent-%COMP%]{color:#fff}.mvIcon[_ngcontent-%COMP%]{padding:15px}"]
    });
  }
  return CheckInternetConnectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0 = ["checkInstalledPage"];
const _c1 = ["installPage"];
const _c2 = ["closePage"];
const _c3 = ["checkInternetPage"];
const _c4 = ["hostPage"];
const _c5 = ["loginPage"];
const _c6 = ["registrationPage"];
function SignagePlayerPwa_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, "SignPlayer");
    i0.ɵɵelementEnd();
  }
}
function SignagePlayerPwa_app_check_is_installed_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-is-installed", null, 2);
  }
}
function SignagePlayerPwa_app_install_manually_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-install-manually", null, 3);
  }
}
function SignagePlayerPwa_install_pwa_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "install-pwa", null, 4);
  }
}
function SignagePlayerPwa_app_close_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-close", null, 5);
  }
}
function SignagePlayerPwa_app_check_internet_connection_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-internet-connection", null, 6);
  }
}
function SignagePlayerPwa_app_host_server_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-host-server", null, 7);
  }
}
function SignagePlayerPwa_app_remote_registration_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-remote-registration", null, 8);
  }
}
function SignagePlayerPwa_app_login_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-login", null, 9);
  }
}
function SignagePlayerPwa_app_registration_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-registration", null, 10);
  }
}
let SignagePlayerPwa = /*#__PURE__*/(() => {
  class SignagePlayerPwa extends SignagePlayerBase {
    injector;
    state = '';
    playerStarted = false;
    constructor(injector) {
      super(injector);
      this.injector = injector;
    }
    checkInstalledPage;
    installPage;
    closePage;
    checkInternetPage;
    hostPage;
    loginPage;
    registrationPage;
    init() {
      const logInfo = Log.getLogInfo("SignagePlayerPwa", "init", []);
      Log.d(logInfo, LogTag.SIGNAGE_PLAYER, '');
      return super.init().pipe(switchMap(a => this.playerService.pwaInstalled$), switchMap(pwaInstalled => {
        console.log("pwaInstalled=" + pwaInstalled);
        if (this.playerStarted) {
          console.warn("detect that PWA was not installed after playerStarted");
          location.reload();
        }
        switch (pwaInstalled) {
          case "installed":
            return of('next');
          case "notInstalled":
            this.state = 'checkInstalled';
            this.changeDetectorRef.detectChanges();
            return of(null);
          case "installPrompt":
            this.state = 'install';
            this.changeDetectorRef.detectChanges();
            console.log("this.state = 'install'");
            return this.installPage.install();
          case "installManually":
            this.state = 'installManually';
            this.changeDetectorRef.detectChanges();
            return of(null);
        }
      }), filter(a => a != null), switchMap(v => {
        if (this.playerService.domain === null) {
          this.state = "checkInternet";
          this.changeDetectorRef.detectChanges();
          return this.checkInternetPage.isConnected().pipe(lastMap(connected => {
            this.playerService.domain = "galaxy.signage.me";
            this.state = 'host';
            this.changeDetectorRef.detectChanges();
            return this.hostPage.getHost();
          }), lastMap(data => {
            Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'switch login');
            this.state = 'login';
            this.changeDetectorRef.detectChanges();
            return this.loginPage.login();
          }), lastMap(r => {
            Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'switch registration');
            if (this.playerService.sceneId == null) {
              this.state = 'registration';
              this.changeDetectorRef.detectChanges();
              return this.registrationPage.register();
            } else {
              if (localStorage['deployment'] != null) {
                const deployment = JSON.parse(localStorage['deployment']);
                deployment.prompt = false;
                localStorage['deployment'] = JSON.stringify(deployment);
              }
              return of('signage');
            }
          }));
        } else {
          return of('signage');
        }
      }), switchMap(r => {
        Log.d(logInfo, LogTag.SIGNAGE_PLAYER, 'switch signage');
        this.state = 'signage';
        this.changeDetectorRef.detectChanges();
        this.playerStarted = true;
        this.playerService.watchdog.start();
        this.playerService.startServerSocket();
        return of('completed');
      }));
    }
    mainSceneLoaded() {
      let key = null;
      let kiosk = false;
      if ((this.mainScene?.playerObject).Metadata != null && (this.mainScene?.playerObject).Metadata[0].Kiosk != null) {
        if ((this.mainScene?.playerObject).Metadata[0].Kiosk[0].$.mode == "1") {
          kiosk = true;
          key = (this.mainScene?.playerObject).Metadata[0].Kiosk[0].$.key;
        }
      }
      this.playerService.kioskChannel$.next({
        enabled: kiosk,
        key: key
      });
    }
    dispose() {
      super.dispose();
    }
    static ɵfac = function SignagePlayerPwa_Factory(t) {
      return new (t || SignagePlayerPwa)(i0.ɵɵdirectiveInject(i0.Injector));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SignagePlayerPwa,
      selectors: [["signage-player-pwa"]],
      viewQuery: function SignagePlayerPwa_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
          i0.ɵɵviewQuery(_c6, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkInstalledPage = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.installPage = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closePage = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkInternetPage = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hostPage = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loginPage = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.registrationPage = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 16,
      vars: 10,
      consts: [["component", ""], ["playercontainer", ""], ["checkInstalledPage", ""], ["installManuallyPage", ""], ["installPage", ""], ["closePage", ""], ["checkInternetPage", ""], ["hostPage", ""], ["remoteRegPage", ""], ["loginPage", ""], ["registrationPage", ""], ["id", "fontLoader", 2, "position", "absolute", "visibility", "hidden"], ["id", "mainDiv"], ["class", "signPlayer", 4, "ngIf"], [4, "ngIf"], [2, "position", "absolute", "left", "0", "top", "0"], [1, "signPlayer"]],
      template: function SignagePlayerPwa_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 11);
          i0.ɵɵelementStart(1, "div", 12, 0);
          i0.ɵɵelement(3, "template", null, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, SignagePlayerPwa_div_5_Template, 2, 0, "div", 13)(6, SignagePlayerPwa_app_check_is_installed_6_Template, 2, 0, "app-check-is-installed", 14)(7, SignagePlayerPwa_app_install_manually_7_Template, 2, 0, "app-install-manually", 14)(8, SignagePlayerPwa_install_pwa_8_Template, 2, 0, "install-pwa", 14)(9, SignagePlayerPwa_app_close_9_Template, 2, 0, "app-close", 14)(10, SignagePlayerPwa_app_check_internet_connection_10_Template, 2, 0, "app-check-internet-connection", 14)(11, SignagePlayerPwa_app_host_server_11_Template, 2, 0, "app-host-server", 14)(12, SignagePlayerPwa_app_remote_registration_12_Template, 2, 0, "app-remote-registration", 14)(13, SignagePlayerPwa_app_login_13_Template, 2, 0, "app-login", 14)(14, SignagePlayerPwa_app_registration_14_Template, 2, 0, "app-registration", 14);
          i0.ɵɵelement(15, "app-taskbar", 15);
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.state != "signage" && ctx.state != "");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "checkInstalled");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "installManually");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "install");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "close");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "checkInternet");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "host");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "remoteReg");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "login");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.state == "registration");
        }
      },
      dependencies: [i11.NgIf, InstallPwaComponent, CheckIsInstalledComponent, InstallManuallyComponent, CloseComponent, HostServerComponent, LoginComponent, RegistrationComponent, TaskbarComponent, CheckInternetConnectionComponent],
      styles: [".mat-ripple[_ngcontent-%COMP%]{overflow:hidden;position:relative}.mat-ripple[_ngcontent-%COMP%]:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded[_ngcontent-%COMP%]{overflow:visible}.mat-ripple-element[_ngcontent-%COMP%]{position:absolute;border-radius:50%;pointer-events:none;transition:opacity,transform 0ms cubic-bezier(0,0,.2,1);transform:scale3d(0,0,0);background-color:var(--mat-ripple-color, rgba(0, 0, 0, .1))}.cdk-high-contrast-active[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{display:none}.cdk-visually-hidden[_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none;left:0}[dir=rtl][_ngcontent-%COMP%]   .cdk-visually-hidden[_ngcontent-%COMP%]{left:auto;right:0}.cdk-overlay-container[_ngcontent-%COMP%], .cdk-global-overlay-wrapper[_ngcontent-%COMP%]{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container[_ngcontent-%COMP%]{position:fixed;z-index:1000}.cdk-overlay-container[_ngcontent-%COMP%]:empty{display:none}.cdk-global-overlay-wrapper[_ngcontent-%COMP%]{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane[_ngcontent-%COMP%]{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop[_ngcontent-%COMP%]{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]   .cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:.6}.cdk-overlay-dark-backdrop[_ngcontent-%COMP%]{background:#00000052}.cdk-overlay-transparent-backdrop[_ngcontent-%COMP%]{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:0;visibility:visible}.cdk-overlay-backdrop-noop-animation[_ngcontent-%COMP%]{transition:none}.cdk-overlay-connected-position-bounding-box[_ngcontent-%COMP%]{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock[_ngcontent-%COMP%]{position:fixed;width:100%;overflow-y:scroll}textarea.cdk-textarea-autosize[_ngcontent-%COMP%]{resize:none}textarea.cdk-textarea-autosize-measuring[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:auto!important;overflow:hidden!important}textarea.cdk-textarea-autosize-measuring-firefox[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:0!important}@keyframes _ngcontent-%COMP%_cdk-text-field-autofill-start{}@keyframes _ngcontent-%COMP%_cdk-text-field-autofill-end{}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:-webkit-autofill{animation:_ngcontent-%COMP%_cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:not(:-webkit-autofill){animation:_ngcontent-%COMP%_cdk-text-field-autofill-end 0s 1ms}.mat-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-focus-indicator-display, none);border:var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);border-radius:var(--mat-focus-indicator-border-radius, 4px)}.mat-focus-indicator[_ngcontent-%COMP%]:focus:before{content:\"\"}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-focus-indicator-display: block}.mat-mdc-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-mdc-focus-indicator-display, none);border:var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);border-radius:var(--mat-mdc-focus-indicator-border-radius, 4px)}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:focus:before{content:\"\"}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-mdc-focus-indicator-display: block}.mat-app-background[_ngcontent-%COMP%]{background-color:var(--mat-app-background-color, transparent);color:var(--mat-app-text-color, inherit)}div[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;overflow:hidden}#fs[_ngcontent-%COMP%]{display:flex;justify-content:center}#sq[_ngcontent-%COMP%]{position:absolute;top:50px;width:auto;height:auto;background-color:#212328;text-align:center;border:1px solid white;padding:10px;margin:0}#sl[_ngcontent-%COMP%]{font-family:Arial;color:#fff;font-size:16px;font-weight:400}#sa[_ngcontent-%COMP%]{border:1px solid white;padding:3px}.signPlayer[_ngcontent-%COMP%]{font-size:72px;font-weight:700;color:#fff;text-align:center;padding-top:40px}"],
      changeDetection: 0
    });
  }
  return SignagePlayerPwa;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class WebSocketWatchdog {
  client = null;
  messageMap = {};
  lastId = 0;
  constructor() {
    //this.isInstalled = document.documentElement.getAttribute('player-extension') == 'installed';
  }
  connect() {
    return new Observable(sub => {
      try {
        const url = 'ws://localhost:8090';
        const client = new websocket.w3cwebsocket(url);
        client.onopen = () => {
          console.log("websocket connected");
          this.client = client;
          // this.isInstalled = true; //???
          sub.next("connected");
          sub.complete();
        };
        client.onmessage = msg => {
          console.log("msg.data=" + msg.data);
          const message = JSON.parse(msg.data);
          const messageId = message.messageId;
          const messageData = message.result;
          console.log("webSocket message: " + message.result);
          const obs$ = this.messageMap[messageId];
          if (obs$ != null) {
            obs$.next(messageData);
            obs$.complete();
            delete this.messageMap[messageId];
          }
        };
        client.onclose = event => {
          this.client = null;
          sub.error("closed");
        };
        client.onerror = err => {
          this.client = null;
          sub.error("error");
        };
      } catch (e) {
        this.client = null;
      }
    });
  }
  sendCommand(command, args) {
    if (this.client != null && this.client.readyState === WebSocket.OPEN) {
      this.lastId++;
      const messageId = this.lastId.toString();
      const message = {
        source: "signPlayerPwa",
        messageId: messageId,
        command: command
      };
      if (args != null) {
        for (const key in args) {
          message[key] = args[key];
        }
      }
      this.client.send(JSON.stringify(message));
      const obs$ = this.messageMap[messageId] = new AsyncSubject();
      return obs$;
    } else {
      return of(null);
    }
  }
  start(appType) {
    return this.connect().pipe(switchMap(ret => this.sendCommand('start', {
      appType: appType
    })));
  }
  ping() {
    return this.sendCommand('ping', null);
  }
  close() {
    return this.sendCommand('close', null);
  }
  reboot() {
    return this.sendCommand('reboot', null);
  }
  screenCapture(businessDomain, businessId, stationId, fileName, scale) {
    const args = {
      businessDomain,
      businessId,
      stationId,
      fileName,
      scale
    };
    return this.sendCommand('reboot', args);
  }
}
class HttpWatchdog {
  httpClient;
  //baseUrl = 'https://127.0.0.1:8094/watchdog/';  // for Android
  baseUrl = 'https://localhost:8094/watchdog/'; // for Windows
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  start(appType) {
    console.log('Get: HttpWatchdog.start() v4 !!!');
    /*
            fetch('https://localhost:8094/watchdog/start', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({}),
                mode: 'cors' // <-- important for cross-origin
            })
                .then(response => {
                    console.log('PWA succeeded');
                })
                .catch(error => {
                    console.error('PWA failed', error);
                });
    
            return of(null);
    */
    return this.httpClient.post(this.baseUrl + 'start', {}, {
      withCredentials: false,
      headers: {
        'Content-Type': 'application/json'
      },
      observe: 'response'
    }).pipe(catchError(err => {
      console.log("post fail: ", err);
      return of(null);
    }));
  }
  ping() {
    return this.httpClient.post(this.baseUrl + 'ping', {});
  }
  close() {
    return this.httpClient.post(this.baseUrl + 'close', {});
  }
  reboot() {
    return this.httpClient.post(this.baseUrl + 'reboot', {});
  }
  screenCapture(businessDomain, businessId, stationId, fileName, scale) {
    return this.httpClient.post(this.baseUrl + 'screenCapture', {
      businessDomain,
      businessId,
      stationId,
      fileName,
      scale
    });
  }
}
class WatchdogService {
  injector;
  playerService;
  httpClient;
  router;
  dialog;
  appType;
  appVer = "";
  pluginVer = "";
  pingInterval = null;
  memoryLeak;
  countSlowFPS = 0;
  bridge;
  running = false;
  wdConnected;
  constructor(playerService, injector) {
    this.playerService = playerService;
    this.injector = injector;
    this.httpClient = injector.get(HttpClient);
    this.router = injector.get(Router);
    this.dialog = injector.get(MatDialog);
  }
  start() {
    let useLocalWebServer = false;
    if (this.playerService.os == "android") {
      const params = new URLSearchParams(window.location.search);
      const host = params.get("host"); // "android"
      const settingsStatus = params.get("settings"); // "android"
      console.log(window.location.search);
      console.log("host=" + host);
      console.log("settingsStatus=" + settingsStatus);
      if (settingsStatus != null) {
        localStorage["settings"] = settingsStatus;
      }
      if (host === "SignService") {
        localStorage["service"] = "installed"; // if Android and new SignService set as installed
        console.log("set service = installed (android)");
        useLocalWebServer = true;
      }
    } else {
      useLocalWebServer = true;
    }
    console.log("useLocalWebServer=" + useLocalWebServer);
    this.bridge = useLocalWebServer ? new HttpWatchdog(this.httpClient) : new WebSocketWatchdog();
    this.bridge.start(this.appType).pipe(map(ret => ret.body != null ? ret.body : ret), switchMap(ret => {
      if (ret != null) {
        const info = useLocalWebServer ? ret : JSON.parse(ret);
        console.log("info = " + info);
        this.running = true;
        if (this.playerService.os != "android") {
          localStorage["service"] = "installed"; // if not android and local connection. (only old android can use old WD)
          console.log("set service = installed (windows)");
        }
        let cmd = {
          cmd: 'watchdog',
          connected: "1"
        };
        this.wdConnected = "1";
        try {
          localStorage['deployment'] = JSON.stringify({
            prompt: false
          });
          if (info.native != null) {
            this.appVer = info.native;
            this.pluginVer = info.native;
            cmd.native = info.native;
          } else if (info.appVer != null) {
            this.appVer = info.appVer;
            this.pluginVer = info.pluginVer;
            cmd.native = info.pluginVer;
          }
        } catch (e) {}
        this.playerService.signService$.next('started');
        console.log('SignService started');
      }
      return interval(10000);
    }), switchMap(ping => {
      if (this.countSlowFPS < 5) {
        if (this.running) {
          console.log('ping');
          return this.bridge.ping();
        } else {
          return of('dummy');
        }
      } else {
        return of(null);
      }
    }), switchMap(ret => {
      console.log(ret);
      if (ret == null) {
        location.reload();
      }
      return of('a');
    }), catchError(err => {
      this.wdConnected = "0";
      this.playerService.signService$.next("stopped");
      return of(null);
    })).subscribe();
  }
  reload() {
    location.reload();
  }
  close() {
    console.log("close()");
    const isStandalone = this.playerService.isStandalone();
    console.log('PWA standalone = ', isStandalone);
    if (isStandalone) {
      // running as PWA
      if (this.playerService.os == "android") {
        this.router.navigateByUrl('/close');
      } else {
        // windows/Linux
        if (this.running) {
          this.bridge.close().subscribe();
          setTimeout(() => {
            window.close();
          }, 2000);
        } else {
          window.close();
        }
      }
    } else {
      // running from browser
      window.close();
    }
  }
  screenCapture(businessDomain, businessId, stationId, fileName, scale) {
    const logInfo = Log.getLogInfo("Watchdog", "screenCapture", []);
    if (this.running && this.playerService.os != "android") {
      this.bridge.screenCapture(businessDomain, businessId, stationId, String(fileName), Number(scale)).subscribe(value => {
        Log.d(logInfo, LogTag.CHROME_EXTENSION, 'screenCapture completed');
      });
    } else {
      var mainDiv = document.getElementById('mainDiv');
      html2canvas(mainDiv, {
        allowTaint: true,
        useCORS: false,
        backgroundColor: "rgba(0,0,0,0)"
      }).then(canvas => {
        const newWidth = canvas.width * scale;
        const newHeight = canvas.height * scale;
        const newCanvas = document.createElement('canvas');
        newCanvas.width = newWidth;
        newCanvas.height = newHeight;
        const ctx = newCanvas.getContext('2d');
        ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, newWidth, newHeight);
        newCanvas.toBlob(imageBlob => {
          Log.d(logInfo, LogTag.PLAYER, 'blob success ' + imageBlob.size);
          const uploadURL = 'https://' + businessDomain + '/WebService/ScreenCaptureUpload.aspx?businessId=' + businessId + '&stationId=' + stationId;
          let formData = new FormData();
          formData.append("image", imageBlob, fileName + ".jpg");
          fetch(uploadURL, {
            method: 'POST',
            body: formData
          });
        }, 'image/jpeg');
      });
    }
  }
  b64toBlob(b64Data, sliceSize = 512) {
    const BASE64_MARKER = ';base64,';
    if (b64Data.indexOf(BASE64_MARKER) == -1) {
      return;
    }
    const parts = b64Data.split(BASE64_MARKER);
    const contentType = parts[0].split(':')[1];
    const byteCharacters = atob(parts[1]);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
      type: contentType
    });
  }
  blobToFile = (theBlob, fileName) => {
    return new File([theBlob], fileName, {
      lastModified: new Date().getTime(),
      type: theBlob.type
    });
  };
  readLog() {}
  clearLog() {}
  testHung() {
    const logInfo = Log.getLogInfo("Watchdog", "testHung", []);
    Log.d(logInfo, LogTag.CHROME_EXTENSION, 'hung');
    while (true) {}
  }
  testSlow() {
    const logInfo = Log.getLogInfo("Watchdog", "testSlow", []);
    Log.d(logInfo, LogTag.CHROME_EXTENSION, 'slow');
    setInterval(() => {
      const t1 = new Date().getTime();
      while (true) {
        const t2 = new Date().getTime();
        if (t2 - t1 > 1000) {
          break;
        }
      }
    }, 1);
  }
  testAbnormalExit() {
    window.close();
  }
  testInfiniteMemLeak() {
    this.memoryLeak = [];
    setInterval(() => {
      this.countSlowFPS = 0; // prevent "no pings" on slow FPS
      this.memoryLeak.push(new Array(10000000));
    }, 500);
  }
  testInfiniteDomLeak() {
    setInterval(() => {
      let a = 0;
      while (a < 100) {
        this.countSlowFPS = 0; // prevent "no pings" on slow FPS
        const div = document.createElement('div');
        div.innerText = "DIV";
        div.style.position = "absolute";
        div.style.fontSize = '24px';
        div.style.left = Math.random() * 1000 + 'px';
        div.style.top = Math.random() * 1000 + 'px';
        div.style.color = 'rgb(' + Math.random() * 256 + ', ' + Math.random() * 256 + ', ' + Math.random() * 256 + ')';
        document.body.appendChild(div);
        a++;
      }
    }, 100);
  }
  reboot() {
    this.bridge.reboot().subscribe();
  }
  getProxySrc(url) {
    return this.httpClient.get('https://localhost:8094/proxy/hasXFrameOptions?url=' + encodeURIComponent(url)).pipe(map(xFrame => {
      if (xFrame.hasXFrameOptions) {
        // Site has X-Frame-Options, use proxy
        return `https://localhost:8094/proxy/getProxyData?url=${encodeURIComponent(url)}`;
      } else {
        // Site allows iframes, use direct URL
        return url;
      }
    }), catchError(e => {
      debugger;
      return of(url);
    }));
  }
}
class ServerSocket {
  playerService;
  client;
  lastStudioCommand;
  msg = {};
  $send = new Subject();
  receiveMsg = false;
  noReplayCount = 0;
  constructor(playerService) {
    const logInfo = Log.getLogInfo("ServerSocket", "constructor", []);
    this.playerService = playerService;
    this.$send.pipe(debounceTime(2000)).subscribe(r => {
      if (this.client != null) {
        try {
          const text = JSON.stringify(this.msg);
          this.client.send(text);
          Log.d(logInfo, LogTag.WEBSOCKET, 'send: ' + text);
        } catch (e) {}
      }
    });
    setInterval(() => {
      if (this.client != null) {
        const msg = {
          command: "player_ping",
          businessId: this.playerService.businessId,
          stationId: this.playerService.stationId
        };
        if (this.client != null) {
          try {
            this.noReplayCount++;
            if (this.noReplayCount < 3) {
              this.client.send(JSON.stringify(msg));
            } else {
              this.client.close();
              this.clean();
            }
          } catch (e) {}
        }
      }
    }, 5000);
  }
  create(fnConnect, fnData, fnClose) {
    const logInfo = Log.getLogInfo("ServerSocket", "create", []);
    try {
      const url = 'wss://' + this.playerService.businessDomain + '/Web/playerWebSocket.ashx';
      this.client = new websocket.w3cwebsocket(url);
    } catch (e) {
      Log.w(logInfo, LogTag.WEBSOCKET, 'websocket Exception!');
      fnClose();
      return;
    }
    this.client.onopen = () => {
      Log.d(logInfo, LogTag.WEBSOCKET, 'Connected');
      if (this.client.readyState === this.client.OPEN) {
        this.lastStudioCommand = new Date().getTime();
        this.receiveMsg = true;
        const init = {
          command: "init",
          businessId: this.playerService.businessId,
          stationId: this.playerService.stationId,
          stationToken: this.playerService.stationToken
        };
        this.client.send(JSON.stringify(init));
        this.msg = {
          command: "status",
          businessId: this.playerService.businessId,
          stationId: this.playerService.stationId
        };
        fnConnect();
      }
    };
    this.client.onerror = err => {
      Log.w(logInfo, LogTag.WEBSOCKET, 'Connection Error: ' + err);
      this.clean();
    };
    this.client.onclose = a => {
      Log.w(logInfo, LogTag.WEBSOCKET, 'echo-protocol Client Closed');
      this.clean();
      fnClose();
    };
    this.client.onmessage = e => {
      if (typeof e.data === 'string') {
        //Log.d(this, LogTag.WEBSOCKET, e.data);
        this.lastStudioCommand = new Date().getTime();
        if (this.receiveMsg == false) {
          this.receiveMsg = true;
          Log.d(logInfo, LogTag.WEBSOCKET, "start sending status");
          this.$send.next("send");
        }
        const data = JSON.parse(e.data);
        if (data.command == "player_pong") {
          this.noReplayCount = 0;
        }
        fnData(data);
      } else {
        // TEST ONLY ???
        if (this.playerService.businessId == 315462) {
          const blob = e.data;
          var url = URL.createObjectURL(blob);
          const audio = new Audio();
          audio.src = url;
          audio.play();
        }
      }
    };
  }
  sendStatus(key, value) {
    const now = new Date().getTime();
    if (now - this.lastStudioCommand > 20000) {
      this.receiveMsg = false;
    }
    if (this.msg[key] == null || this.msg[key] != value) {
      this.msg[key] = value;
      if (this.receiveMsg) {
        this.$send.next("send");
      }
    }
  }
  sendPttInfo() {
    const pttInfo = JSON.parse(localStorage['ptt']);
    const msg = {
      command: "ptt",
      businessId: this.playerService.businessId,
      stationId: this.playerService.stationId,
      info: pttInfo
    };
    this.client.send(JSON.stringify(msg));
  }
  clean() {
    this.client = null;
    this.msg = {};
  }
}
class Stats {
  businessDomain;
  businessId;
  stationId;
  stationToken;
  statMap = {};
  constructor(businessDomain, businessId, stationId, stationToken) {
    this.businessDomain = businessDomain;
    this.businessId = businessId;
    this.stationId = stationId;
    this.stationToken = stationToken;
    if (localStorage['stats'] == null) {
      localStorage['stats'] = "{}";
    } else {
      this.statMap = JSON.parse(localStorage['stats']);
    }
  }
  addContent(tag, contentType, contentId, duration) {
    console.log(tag, contentType, contentId, duration);
    const date = new Date();
    let time = date.getTime() % 3600000 / 1000;
    let d1 = duration;
    let stat = null;
    while (d1 > 1.0)
    // 1.0 sec min
    {
      const dur = Math.min(d1, time);
      const key = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate() + '.' + date.getHours() + '.' + tag + '.' + contentType + '.' + contentId;
      stat = this.statMap[key];
      if (stat == null) {
        this.statMap[key] = stat = {
          count: 0,
          duration: 0.0
        };
      }
      stat.duration += dur;
      console.log("key=" + key + ", dur=" + dur);
      d1 -= dur;
      time = 3600;
      date.setTime(date.getTime() - 3600000);
    }
    if (stat != null) {
      stat.count++;
    }
  }
  start() {
    return interval(2 * 60 * 1000).pipe(switchMap(a => this.posStats()));
  }
  posStats() {
    if (this.statMap != null && Object.keys(this.statMap).length > 0) {
      return new Observable(sub => {
        const url = "https://pop.signage.me/stationStats.ashx?businessId=" + this.businessId + "&stationId=" + this.stationId + "&stationToken=" + this.stationToken + "&command=write";
        const data = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.statMap)
        };
        fetch(url, data).then(response => {
          response.text().then(txt => {
            this.statMap = {};
            localStorage['stats'] = JSON.stringify(this.statMap);
            sub.next('stats');
            sub.complete();
          });
        }).catch(error => {
          // ignore send if no internet and try next time
          localStorage['stats'] = JSON.stringify(this.statMap);
          sub.next('stats');
          sub.complete();
        });
      });
    } else {
      return of('a');
    }
  }
}
let PlayerPwaService = /*#__PURE__*/(() => {
  class PlayerPwaService extends PlayerBaseService {
    injector;
    pwaInstalled$;
    deferredPrompt;
    first = true;
    timeoutId;
    broadcast;
    watchdog;
    instanceId;
    serverSocket;
    statusInterval;
    count = 0;
    constructor(injector) {
      super(injector);
      this.injector = injector;
      const logInfo = Log.getLogInfo("PlayerPwaService", "constructor", []);
      const pwaSupported = 'serviceWorker' in navigator && 'PushManager' in window;
      console.log('pwaSupported=' + pwaSupported);
      let installValue;
      if (this.isPwaInstalled()) {
        installValue = "installed";
      } else {
        if (pwaSupported) {
          installValue = "notInstalled";
        } else {
          installValue = "installManually";
        }
      }
      this.pwaInstalled$ = new BehaviorSubject(installValue);
      window.addEventListener('beforeinstallprompt', deferredPrompt => {
        console.log('beforeinstallprompt');
        this.deferredPrompt = deferredPrompt;
        deferredPrompt.preventDefault(); //???
        console.error('need to remove the setTimeout() in the beforeinstallprompt. it is used for testing only!!!');
        //setTimeout( () => {
        delete localStorage["pwa"];
        if (pwaSupported) {
          this.pwaInstalled$.next("installPrompt");
        } else {
          this.pwaInstalled$.next("installManually");
        }
        //}, 5000)
      });
      this.broadcast = new BroadcastChannel('signagePlayer');
      this.watchdog = new WatchdogService(this, injector);
      this.playing$.subscribe(value => {
        if (this.serverSocket != null) {
          this.serverSocket.sendStatus("playing", this.isPlaying() ? "1" : "0");
        }
      });
      /*
              this.serverConnection$.subscribe(ret => {
                  debugger;
              })
      */
      this.signService$.subscribe(ret => {
        this.serverSocket.sendStatus("wdConnected", ret == "started" ? "1" : "0");
        this.serverSocket.sendStatus("wdExtension", this.watchdog.appVer);
        this.serverSocket.sendStatus("wdNative", this.watchdog.pluginVer);
      });
    }
    isStandalone() {
      const standalone = window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches || window.navigator.standalone === true;
      console.log('PWA standalone = ', standalone);
      return standalone;
    }
    isPwaInstalled() {
      if (this.isLocalHost) {
        return true;
      }
      // if pwa is installed and starting player from install url it will not trigger beforeinstallprompt, so we need indication to know if pwa was installed.
      if (this.isStandalone()) {
        localStorage["pwa"] = "installed";
      }
      const installed = localStorage["pwa"] == "installed";
      console.log("pwa installed=" + installed);
      return installed;
    }
    get appType() {
      return this._appType;
    }
    set appType(value) {
      this._appType = value;
      this.watchdog.appType = value;
    }
    reload() {
      this.watchdog.reload();
    }
    get serviceAppVersion() {
      return this.watchdog.appVer;
    }
    get servicePluginVersion() {
      return this.watchdog.pluginVer;
    }
    runSingleInstances() {
      const logInfo = Log.getLogInfo("PlayerPwaService", "runSingleInstances", []);
      return new Observable(sub => {
        this.instanceId = String(new Date().getTime());
        this.broadcast.onmessage = event => {
          const instanceId = event.data.instanceId;
          if (instanceId != this.instanceId) {
            this.broadcast.postMessage({
              command: 'close',
              instanceId: instanceId
            });
          }
          if (event.data.command == 'close') {
            window.close();
          }
        };
        Log.d(logInfo, LogTag.PLAYER_SERVICE, 'postMessage');
        this.broadcast.postMessage({
          command: 'new',
          instanceId: this.instanceId
        });
        sub.next(true);
        sub.complete();
      });
    }
    installPwa() {
      const logInfo = Log.getLogInfo("PlayerPwaService", "installPwa", []);
      Log.d(logInfo, LogTag.SERVICE_WORKER, '');
      return new Observable(sub => {
        // Wait for the user to respond to the prompt
        if (this.deferredPrompt != null) {
          this.deferredPrompt.userChoice.then(choiceResult => {
            if (choiceResult.outcome === 'accepted') {
              Log.d(logInfo, LogTag.SERVICE_WORKER, 'User accepted the A2HS prompt');
              sub.next(true);
              sub.complete();
            } else {
              Log.w(logInfo, LogTag.SERVICE_WORKER, 'Install canceled');
              window.close();
            }
            this.deferredPrompt = null;
          });
          this.deferredPrompt.prompt();
        } else {
          window.close();
        }
      });
    }
    init() {
      const logInfo = Log.getLogInfo("PlayerPwaService", "init", []);
      return super.init().pipe(lastMap(r => this.runSingleInstances()), switchMap(r => {
        const data = localStorage['registration'];
        if (data != null) {
          const info = JSON.parse(data);
          this.domain = info.domain;
          this.businessId = info.businessId;
          this.stationId = info.stationId;
          this.stationToken = info.stationToken;
          Log.devMode = info.dev == '1';
          Log.d(logInfo, LogTag.INIT, 'domain=' + this.domain);
          Log.d(logInfo, LogTag.INIT, 'businessId=' + this.businessId);
          Log.d(logInfo, LogTag.INIT, 'stationId=' + this.stationId);
          Log.d(logInfo, LogTag.INIT, 'stationToken=' + this.stationToken);
          return this.caching.init(false, false).pipe(switchMap(r => this.updateCustomerInfo()));
        } else {
          return this.caching.init(false, false);
        }
      }));
    }
    generateToken() {
      this.stationToken = uuid.v4();
    }
    stationStats() {
      return of('a').pipe(switchMap(a => {
        this.stats = new Stats(this.businessDomain, this.businessId, this.stationId, this.stationToken);
        return this.stats.start();
      }));
    }
    saveStationInfo() {
      const value = {};
      value.domain = this.domain;
      value.businessId = this.businessId;
      value.stationId = this.stationId;
      value.stationToken = this.stationToken;
      const info = JSON.stringify(value);
      localStorage['registration'] = info;
      if (localStorage['deployment'] == null) {
        const deployment = {
          prompt: true
        };
        localStorage['deployment'] = JSON.stringify(deployment);
      }
      return of('save');
    }
    unregister() {
      delete localStorage['registration'];
      if (localStorage['deployment'] != null) {
        const deployment = JSON.parse(localStorage['deployment']);
        if (deployment.prompt != null && deployment.prompt == false) {
          deployment.prompt = true;
          localStorage['deployment'] = JSON.stringify(deployment);
        }
      }
      window.close();
    }
    getSceneId() {
      return this.caching.getRecord("stations", this.stationId).pipe(map(station => {
        const tags = station.log_tags.split(',');
        Log.updateConfig(station.log_enabled, station.log_priority, tags);
        return station.changelist_id != null ? station.player_data_id : -1;
      }));
    }
    onData(data) {
      const logInfo = Log.getLogInfo("PlayerPwaService", "onData", [data]);
      Log.d(logInfo, LogTag.WEBSOCKET, '');
      switch (data.command) {
        case 'stop':
          this.stop();
          break;
        case 'start':
          this.play();
          break;
        case 'captureScreen':
          this.captureScreen(data.fileName, data.scale);
          break;
        case 'checkUpdates':
          break;
        case 'modifyRecords':
          this.caching.modifyRecords(data.table, data.ids);
          if (data.replay == true) {
            this.play();
          }
          break;
        case 'event':
          this.eventParams.dispatch(data.eventName, JSON.parse(data.eventParam), false);
          break;
        case 'configLog':
          Log.config = {
            untilTime: data.untilTime,
            maxPriority: data.maxPriority,
            debugTags: []
          };
          break;
        case 'rebootStation':
          this.reboot();
          break;
        case 'ping':
          break;
      }
    }
    captureScreen(fileName, scale) {
      this.watchdog.screenCapture(this.businessDomain, this.businessId, this.stationId, fileName, scale);
    }
    getProxySrc(url) {
      return this.watchdog.getProxySrc(url);
    }
    reboot() {
      this.watchdog.reboot();
    }
    startServerSocket() {
      const logInfo = Log.getLogInfo("PlayerPwaService", "startServerSocket", []);
      Log.d(logInfo, LogTag.SERVICE_WORKER, '');
      this.serverSocket = new ServerSocket(this);
      this.serverSocket.create(() => {
        this.serverConnection$.next('connected'); // new???
        this.serverSocket.sendStatus("startTime", this.startTime);
        this.serverSocket.sendStatus("appVersion", this.appVersion);
        this.serverSocket.sendStatus("libVersion", this.libVersion);
        this.serverSocket.sendStatus("platform", this.os);
        this.serverSocket.sendStatus("playing", this.isPlaying() ? "1" : "0");
        if (this.watchdog != null) {
          this.serverSocket.sendStatus("wdConnected", this.watchdog.wdConnected);
          this.serverSocket.sendStatus("wdExtension", this.watchdog.appVer);
          this.serverSocket.sendStatus("wdNative", this.watchdog.pluginVer);
        }
        // TEST ONLY ???
        if (this.businessId == 315462) {
          this.serverSocket.sendPttInfo();
        }
      }, args => {
        Log.d(logInfo, LogTag.WEBSOCKET, 'onData: ' + JSON.stringify(args));
        this.onData(args);
      }, () => {
        Log.w(logInfo, LogTag.WEBSOCKET, 'ServerSocket was closed');
        if (this.statusInterval != null) {
          clearInterval(this.statusInterval);
          this.statusInterval = null;
        }
        this.caching.setModifyAll();
        this.serverConnection$.next('closed'); // new???
        this.timeoutId = setTimeout(() => {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
          this.startServerSocket();
        }, 10000);
      });
    }
    sendPttBlob(stations, emergency, data) {
      const url = "https://" + this.businessDomain + "/Web/ptt.ashx?command=blob&stationToken=" + this.stationToken + "&businessId=" + this.businessId + "&fromStationId=" + this.stationId + "&stations=" + stations + "&emergency=" + emergency;
      const post = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: data
      };
      fetch(url, post).then(response => {
        response.text().then(txt => {});
      }).catch(error => {
        Log.debug();
      });
    }
    setPtt(pttEnabled) {
      const url = "https://" + this.businessDomain + "/Web/ptt.ashx?command=set&stationToken=" + this.stationToken + "&businessId=" + this.businessId + "&fromStationId=" + this.stationId + "&pttEnabled=" + pttEnabled;
      const post = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: ""
      };
      fetch(url, post).then(response => {
        response.text().then(txt => {});
      }).catch(error => {
        Log.debug();
      });
    }
    dispose() {
      super.dispose();
    }
    static ɵfac = function PlayerPwaService_Factory(t) {
      return new (t || PlayerPwaService)(i0.ɵɵinject(i0.Injector));
    };
    static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: PlayerPwaService,
      factory: PlayerPwaService.ɵfac,
      providedIn: 'root'
    });
  }
  return PlayerPwaService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExitComponent = /*#__PURE__*/(() => {
  class ExitComponent {
    router;
    cdr;
    ngZone;
    visibilityChangeListener;
    constructor(router, cdr, ngZone) {
      this.router = router;
      this.cdr = cdr;
      this.ngZone = ngZone;
    }
    ngOnInit() {
      setTimeout(() => {
        window.location.href = "intent://pwa?cmd=stop#Intent;scheme=signservice;end;";
      }, 2000);
      this.visibilityChangeListener = () => {
        if (!document.hidden) {
          console.log('Window is visible again');
          document.removeEventListener('visibilitychange', this.visibilityChangeListener);
          this.visibilityChangeListener = undefined;
          // Run inside Angular zone to ensure proper change detection
          this.ngZone.run(() => {
            setTimeout(() => {
              console.log('Before navigation - Current route:', this.router.url);
              console.log('Document body content length:', document.body.innerHTML.length);
              this.router.navigateByUrl('/signagePlayer').then(success => {
                console.log('Navigation success:', success);
                if (success) {
                  // Force change detection
                  this.cdr.detectChanges();
                  // Check for blank screen after a brief delay
                  setTimeout(() => {
                    const hasContent = document.body.innerHTML.length > 1000;
                    const hasAppRoot = !!document.querySelector('app-root');
                    console.log('After navigation - Has content:', hasContent, 'Has app root:', hasAppRoot);
                    if (!hasContent || !hasAppRoot) {
                      console.log('Blank screen detected, forcing reload');
                      window.location.reload();
                    }
                  }, 500);
                } else {
                  console.log('Navigation failed, trying reload');
                  window.location.reload();
                }
              }).catch(error => {
                console.error('Navigation error:', error);
                window.location.reload();
              });
            }, 500); // Increased delay for better PWA recovery
          });
        }
      };
      document.addEventListener('visibilitychange', this.visibilityChangeListener);
    }
    ngOnDestroy() {
      if (this.visibilityChangeListener) {
        document.removeEventListener('visibilitychange', this.visibilityChangeListener);
      }
    }
    static ɵfac = function ExitComponent_Factory(t) {
      return new (t || ExitComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ExitComponent,
      selectors: [["lib-exit"]],
      decls: 3,
      vars: 0,
      consts: [[1, "container1"]],
      template: function ExitComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h1");
          i0.ɵɵtext(2, "Thank you for using SignPlayer.");
          i0.ɵɵelementEnd()();
        }
      },
      styles: [".container1[_ngcontent-%COMP%]{color:#fff;padding-left:20px}"],
      changeDetection: 0
    });
  }
  return ExitComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SignageLibsModulePwa = /*#__PURE__*/(() => {
  class SignageLibsModulePwa {
    static ɵfac = function SignageLibsModulePwa_Factory(t) {
      return new (t || SignageLibsModulePwa)();
    };
    static ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: SignageLibsModulePwa
    });
    static ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [{
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
      }, {
        provide: 'cachingService',
        useClass: CachingService
      }, {
        provide: 'playerService',
        useClass: PlayerPwaService
      }, {
        provide: 'eventParams',
        useClass: EventParams
      }, {
        provide: MatDialogRef,
        useValue: {}
      }],
      imports: [SignageLibsModuleCommon, CommonModule, ReactiveFormsModule, QRCodeModule, FormsModule, DragDropModule, MatTabsModule, ScrollingModule, MatAutocompleteModule]
    });
  }
  return SignageLibsModulePwa;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SignageLibsModulePwa, {
    declarations: [SignagePlayerPwa, ExitComponent, InstallPwaComponent, CheckIsInstalledComponent, InstallManuallyComponent, CloseComponent, HostServerComponent, LoginComponent, RegistrationComponent, SignageInfoComponent, DialogPopComponent, TaskbarComponent, CheckInternetConnectionComponent],
    imports: [SignageLibsModuleCommon, CommonModule, ReactiveFormsModule, QRCodeModule, FormsModule, DragDropModule, MatTabsModule, ScrollingModule, MatAutocompleteModule],
    exports: [InstallPwaComponent, CheckIsInstalledComponent, InstallManuallyComponent, CloseComponent, HostServerComponent, LoginComponent, RegistrationComponent, TaskbarComponent]
  });
})();

/* Rules
1. IObject["$"] & {...} means: Take ALL properties from IObject.$, then ADD {...} properties. Include everything from both sides.
   Example: IPlayerLabel.$ has all from IObject.$ (id, player, autoScaling) PLUS IPlayerObject.$ additions (label, clickEventName?, clickEventParam?) PLUS its own (player: "3241")

2. Data: IObject["Data"] & [...] means: Data is an array that merges all elements from IObject.Data with all elements of [...].
   Example: Data: IObject["Data"] & [IDataEventCommands & IDataAnimation & IDataStat] means:
   Data: [IDataLayout, IDataEffects & IDataEventCommands & IDataAnimation & IDataStat]

   For IPlayerLabel extending IPlayerObject:
   Data: [IDataLayout, IDataEffects & IDataEventCommands & IDataAnimation & IDataStat, {Label: [...]}]

3. Font: [{ $: IFont }] means: Font is an array with one element. That element is an object with a $ property containing all IFont properties.
   Example JSON: "Font": [{ "$": { "fontColor": "16777215", "fontSize": "24", "fontFamily": "Arial", "fontWeight": "normal", "fontStyle": "normal", "alignSelf": "center", "textAlign": "center", "textDecoration": "none", "wrap": "1", "autoScaling": "1" } }]


4. When building Json from the Interfaces, you Must make sure that the Json is Valid, and it follows interfaces rules!
*/

;
;

/*
 * Public API Surface of signage-libs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CachingService, CheckIsInstalledComponent, CloseComponent, ColorUtils, ComponentClasses, DateUtils, ExitComponent, GenericElm, HostServerComponent, InstallManuallyComponent, InstallPwaComponent, Log, LogPriority, LogTag, LoginComponent, PlayerBase, PlayerBaseService, PlayerContainer, PlayerPwaService, PlayerWebService, RegistrationComponent, SignageLibsComponent, SignageLibsModulePwa, SignageLibsModuleStudio, SignageLibsModuleWeb, SignageLibsService, SignagePlayerPwa, SignagePlayerWeb, TaskbarComponent };
